// Auto-generated by scripts/generate_types.sh -- do not edit
import type { CreatePythonMetricDraftRequest } from './create_python_metric_draft_request';
import type { PythonMetricDraftResponse } from './python_metric_draft_response';
import type { GetPythonMetricDraftRequest } from './get_python_metric_draft_request';
import type { PreviewPythonMetricRequest } from './preview_python_metric_request';
import type { PythonMetricPreviewsResponse } from './python_metric_previews_response';
import type { GetPythonMetricPreviewRequest } from './get_python_metric_preview_request';
import type { CancelPythonMetricPreviewRequest } from './cancel_python_metric_preview_request';
import type { PublishPythonMetricRequest } from './publish_python_metric_request';
import type { PublishPythonMetricResponse } from './publish_python_metric_response';
import type { ListIvrTreesRequest } from './list_ivr_trees_request';
import type { ListIvrTreesResponse } from './list_ivr_trees_response';
import type { CreateIvrTreeRequest } from './create_ivr_tree_request';
import type { IvrTreeResponse } from './ivr_tree_response';
import type { UpdateIvrTreeRequest } from './update_ivr_tree_request';
import type { DeleteIvrTreeResponse } from './delete_ivr_tree_response';
import type { TransportHealthResponse } from './health_response';
import type { GetHealthStatusResponse } from './get_health_status_response';
import type { GetSystemStatusResponse } from './get_system_status_response';
import type { GetFdeSupportStatusResponse } from './get_fde_support_status_response';
import type { PageFdeSupportRequest } from './page_fde_support_request';
import type { PageFdeSupportResponse } from './page_fde_support_response';
import type { TransportBootstrapResponse } from './bootstrap_response';
import type { GetAccountDeletionImpactResponse } from './get_account_deletion_impact_response';
import type { DeleteAccountRequest } from './delete_account_request';
import type { DeleteAccountResponse } from './delete_account_response';
import type { AdminListOrganizationsRequest } from './admin_list_organizations_request';
import type { AdminListOrganizationsResponse } from './admin_list_organizations_response';
import type { AdminListDataFramesRequest } from './admin_list_data_frames_request';
import type { AdminListDataFramesResponse } from './admin_list_data_frames_response';
import type { AdminListSimulationDataFramesRequest } from './admin_list_simulation_data_frames_request';
import type { AdminListSimulationDataFramesResponse } from './admin_list_simulation_data_frames_response';
import type { ListSimulationDataFramesRequest } from './list_simulation_data_frames_request';
import type { ListSimulationDataFramesResponse } from './list_simulation_data_frames_response';
import type { AdminListOrganizationPlansResponse } from './admin_list_organization_plans_response';
import type { AdminGetOrganizationRequest } from './admin_get_organization_request';
import type { AdminGetOrganizationResponse } from './admin_get_organization_response';
import type { AdminGetOrganizationUsageRequest } from './admin_get_organization_usage_request';
import type { AdminGetOrganizationUsageResponse } from './admin_get_organization_usage_response';
import type { AdminCustomerHealthOverviewRequest } from './admin_customer_health_overview_request';
import type { AdminCustomerHealthOverviewResponse } from './admin_customer_health_overview_response';
import type { AdminGetCustomerHealthDetailRequest } from './admin_get_customer_health_detail_request';
import type { AdminGetCustomerHealthDetailResponse } from './admin_get_customer_health_detail_response';
import type { AdminGetCustomerHealthExternalSignalsRequest } from './admin_get_customer_health_external_signals_request';
import type { AdminGetCustomerHealthExternalSignalsResponse } from './admin_get_customer_health_external_signals_response';
import type { AdminGetCustomerHealthSlackSummaryRequest } from './admin_get_customer_health_slack_summary_request';
import type { AdminGetCustomerHealthSlackSummaryResponse } from './admin_get_customer_health_slack_summary_response';
import type { AdminListCustomerHealthAccountsRequest } from './admin_list_customer_health_accounts_request';
import type { AdminListCustomerHealthAccountsResponse } from './admin_list_customer_health_accounts_response';
import type { AdminSelfServeUsageRoundupRequest } from './admin_self_serve_usage_roundup_request';
import type { AdminSelfServeUsageRoundupResponse } from './admin_self_serve_usage_roundup_response';
import type { AdminListOrganizationApiKeysRequest } from './admin_list_organization_api_keys_request';
import type { AdminListOrganizationApiKeysResponse } from './admin_list_organization_api_keys_response';
import type { AdminCreateOrganizationApiKeyRequest } from './admin_create_organization_api_key_request';
import type { AdminCreateOrganizationApiKeyResponse } from './admin_create_organization_api_key_response';
import type { AdminUpdateOrganizationApiKeyStatusRequest } from './admin_update_organization_api_key_status_request';
import type { AdminUpdateOrganizationApiKeyStatusResponse } from './admin_update_organization_api_key_status_response';
import type { AdminDeleteOrganizationApiKeyRequest } from './admin_delete_organization_api_key_request';
import type { AdminDeleteOrganizationApiKeyResponse } from './admin_delete_organization_api_key_response';
import type { AdminProvisionOrganizationRequest } from './admin_provision_organization_request';
import type { AdminProvisionOrganizationResponse } from './admin_provision_organization_response';
import type { AdminPreviewOrganizationReconciliationResponse } from './admin_preview_organization_reconciliation_response';
import type { AdminUpdateSimulationTimeoutRequest } from './admin_update_simulation_timeout_request';
import type { AdminMutationResponse } from './admin_mutation_response';
import type { AdminGetEmailRecipientAllowlistRequest } from './admin_get_email_recipient_allowlist_request';
import type { AdminEmailRecipientAllowlistResponse } from './admin_email_recipient_allowlist_response';
import type { AdminUpdateEmailRecipientAllowlistRequest } from './admin_update_email_recipient_allowlist_request';
import type { AdminUpdateTelephonyProviderRequest } from './admin_update_telephony_provider_request';
import type { AdminUpdateSofiaModelRequest } from './admin_update_sofia_model_request';
import type { AdminUpdateMaxSimulationAttemptsRequest } from './admin_update_max_simulation_attempts_request';
import type { AdminUpdatePipelinePriorityRequest } from './admin_update_pipeline_priority_request';
import type { AdminUpdateOrganizationWideConcurrencyRequest } from './admin_update_organization_wide_concurrency_request';
import type { AdminUpdateMaxJobConcurrencyRequest } from './admin_update_max_job_concurrency_request';
import type { WorkOSSetupInfoResponse } from './workos_setup_info_response';
import type { ConfigureWorkOSMappingRequest } from './configure_workos_mapping_request';
import type { ConfigureWorkOSMappingResponse } from './configure_workos_mapping_response';
import type { ListAgentsRequest } from './list_agents_request';
import type { ListAgentsResponse } from './list_agents_response';
import type { GetAgentRequest } from './get_agent_request';
import type { GetAgentResponse } from './get_agent_response';
import type { AgentNamesRequest } from './agent_names_request';
import type { AgentNamesResponse } from './agent_names_response';
import type { GetAgentVersionsRequest } from './get_agent_versions_request';
import type { GetAgentVersionsResponse } from './get_agent_versions_response';
import type { RevertAgentVersionRequest } from './revert_agent_version_request';
import type { RevertAgentVersionResponse } from './revert_agent_version_response';
import type { CreateAgentRequest } from './create_agent_request';
import type { CreateAgentResponse } from './create_agent_response';
import type { DuplicateAgentRequest } from './duplicate_agent_request';
import type { DuplicateAgentResponse } from './duplicate_agent_response';
import type { TestAgentConnectionRequest } from './test_agent_connection_request';
import type { TestAgentConnectionResponse } from './test_agent_connection_response';
import type { UpdateAgentRequest } from './update_agent_request';
import type { UpdateAgentResponse } from './update_agent_response';
import type { DeleteAgentRequest } from './delete_agent_request';
import type { DeleteAgentResponse } from './delete_agent_response';
import type { DeleteAgentsRequest } from './delete_agents_request';
import type { DeleteAgentsResponse } from './delete_agents_response';
import type { AddAgentMetricsRequest } from './add_agent_metrics_request';
import type { AgentMutationResponse } from './agent_mutation_response';
import type { RemoveAgentMetricRequest } from './remove_agent_metric_request';
import type { SetAgentMetricsRequest } from './set_agent_metrics_request';
import type { AddAgentWorkflowRequest } from './add_agent_workflow_request';
import type { RemoveAgentWorkflowRequest } from './remove_agent_workflow_request';
import type { ListRecentlyDeletedAgentsResponse } from './list_recently_deleted_agents_response';
import type { RestoreAgentRequest } from './restore_agent_request';
import type { RestoreAgentResponse } from './restore_agent_response';
import type { ListAgentMutationsRequest } from './list_agent_mutations_request';
import type { ListAgentMutationsResponse } from './list_agent_mutations_response';
import type { ListAllAgentMutationsResponse } from './list_all_agent_mutations_response';
import type { GetAgentMutationRequest } from './get_agent_mutation_request';
import type { GetAgentMutationResponse } from './get_agent_mutation_response';
import type { CreateAgentMutationRequest } from './create_agent_mutation_request';
import type { CreateAgentMutationResponse } from './create_agent_mutation_response';
import type { UpdateAgentMutationRequest } from './update_agent_mutation_request';
import type { UpdateAgentMutationResponse } from './update_agent_mutation_response';
import type { ArchiveAgentMutationRequest } from './archive_agent_mutation_request';
import type { ArchiveAgentMutationResponse } from './archive_agent_mutation_response';
import type { ListBaselinesRequest } from './list_baselines_request';
import type { ListBaselinesResponse } from './list_baselines_response';
import type { GetBaselineRequest } from './get_baseline_request';
import type { GetBaselineResponse } from './get_baseline_response';
import type { CreateBaselineRequest } from './create_baseline_request';
import type { CreateBaselineResponse } from './create_baseline_response';
import type { UpdateBaselineRequest } from './update_baseline_request';
import type { UpdateBaselineResponse } from './update_baseline_response';
import type { ArchiveBaselineRequest } from './archive_baseline_request';
import type { ArchiveBaselineResponse } from './archive_baseline_response';
import type { BaselineHistoryRequest } from './baseline_history_request';
import type { BaselineHistoryResponse } from './baseline_history_response';
import type { BaselineDeviationsBySimulationRequest } from './baseline_deviations_by_simulation_request';
import type { BaselineDeviationsBySimulationResponse } from './baseline_deviations_by_simulation_response';
import type { ListBenchmarkDatasetsRequest } from './list_benchmark_datasets_request';
import type { ListBenchmarkDatasetsResponse } from './list_benchmark_datasets_response';
import type { GetBenchmarkDatasetRequest } from './get_benchmark_dataset_request';
import type { BenchmarkDatasetResponse } from './benchmark_dataset_response';
import type { CreateBenchmarkDatasetRequest } from './create_benchmark_dataset_request';
import type { UpdateBenchmarkDatasetRequest } from './update_benchmark_dataset_request';
import type { DeleteBenchmarkDatasetRequest } from './delete_benchmark_dataset_request';
import type { BenchmarkDatasetMutationResponse } from './benchmark_dataset_mutation_response';
import type { BenchmarkDatasetUploadUrlRequest } from './benchmark_dataset_upload_url_request';
import type { BenchmarkDatasetUploadUrlResponse } from './benchmark_dataset_upload_url_response';
import type { ListBenchmarkDatasetItemsRequest } from './list_benchmark_dataset_items_request';
import type { ListBenchmarkDatasetItemsResponse } from './list_benchmark_dataset_items_response';
import type { GetBenchmarkDatasetItemRequest } from './get_benchmark_dataset_item_request';
import type { BenchmarkDatasetItemResponse } from './benchmark_dataset_item_response';
import type { AddBenchmarkDatasetItemRequest } from './add_benchmark_dataset_item_request';
import type { UpdateBenchmarkDatasetItemRequest } from './update_benchmark_dataset_item_request';
import type { DeleteBenchmarkDatasetItemRequest } from './delete_benchmark_dataset_item_request';
import type { BenchmarkDatasetItemMutationResponse } from './benchmark_dataset_item_mutation_response';
import type { ListBenchmarkEndpointsRequest } from './list_benchmark_endpoints_request';
import type { ListBenchmarkEndpointsResponse } from './list_benchmark_endpoints_response';
import type { GetBenchmarkEndpointRequest } from './get_benchmark_endpoint_request';
import type { BenchmarkEndpointResponse } from './benchmark_endpoint_response';
import type { GetBenchmarkEndpointsByIdsRequest } from './get_benchmark_endpoints_by_ids_request';
import type { BenchmarkEndpointsByIdsResponse } from './benchmark_endpoints_by_ids_response';
import type { CreateBenchmarkEndpointRequest } from './create_benchmark_endpoint_request';
import type { UpdateBenchmarkEndpointRequest } from './update_benchmark_endpoint_request';
import type { DeleteBenchmarkEndpointRequest } from './delete_benchmark_endpoint_request';
import type { BenchmarkEndpointMutationResponse } from './benchmark_endpoint_mutation_response';
import type { BenchmarkEndpointTestResponse } from './benchmark_endpoint_test_response';
import type { ListBenchmarkRunsRequest } from './list_benchmark_runs_request';
import type { ListBenchmarkRunsResponse } from './list_benchmark_runs_response';
import type { GetBenchmarkRunRequest } from './get_benchmark_run_request';
import type { BenchmarkRunResponse } from './benchmark_run_response';
import type { CreateBenchmarkRunRequest } from './create_benchmark_run_request';
import type { CancelBenchmarkRunRequest } from './cancel_benchmark_run_request';
import type { ListBenchmarkResultsRequest } from './list_benchmark_results_request';
import type { ListBenchmarkResultsResponse } from './list_benchmark_results_response';
import type { BenchmarkAudioSignedUrlRequest } from './benchmark_audio_signed_url_request';
import type { BenchmarkAudioSignedUrlResponse } from './benchmark_audio_signed_url_response';
import type { ListApiKeysRequest } from './list_api_keys_transport_request';
import type { ListApiKeysResponse } from './list_api_keys_transport_response';
import type { CreateApiKeyRequest } from './create_api_key_transport_request';
import type { CreateApiKeyResponse } from './create_api_key_transport_response';
import type { CreateGithubFixIntentRequest } from './create_github_fix_intent_transport_request';
import type { CreateGithubFixIntentResponse } from './create_github_fix_intent_transport_response';
import type { UpdateApiKeyStatusRequest } from './update_api_key_status_transport_request';
import type { UpdateApiKeyStatusResponse } from './update_api_key_status_transport_response';
import type { DeleteApiKeyRequest } from './delete_api_key_transport_request';
import type { DeleteApiKeyResponse } from './delete_api_key_transport_response';
import type { AudioSignedUrlRequest } from './audio_signed_url_request';
import type { AudioSignedUrlResponse } from './audio_signed_url_response';
import type { PublicAudioSignedUrlRequest } from './public_audio_signed_url_request';
import type { UploadAudioRequest } from './upload_audio_request';
import type { UploadAudioResponse } from './upload_audio_response';
import type { ProcessAudioRequest } from './process_audio_request';
import type { ProcessAudioResponse } from './process_audio_response';
import type { CreateOnboardingAudioJobRequest } from './create_onboarding_audio_job_request';
import type { CreateOnboardingAudioJobResponse } from './create_onboarding_audio_job_response';
import type { OnboardingAudioJobRequest } from './onboarding_audio_job_request';
import type { OnboardingAudioJobResponse } from './onboarding_audio_job_response';
import type { SubmitUploadedConversationRequest } from './submit_uploaded_conversation_request';
import type { SubmitUploadedConversationResponse } from './submit_uploaded_conversation_response';
import type { UploadTracesForUploadedConversationRequest } from './upload_traces_for_uploaded_conversation_request';
import type { UploadTracesForUploadedConversationResponse } from './upload_traces_for_uploaded_conversation_response';
import type { UploadedConversationKeysetRequest } from './uploaded_conversation_keyset_request';
import type { UploadedConversationKeysetResponse } from './uploaded_conversation_keyset_response';
import type { UploadedConversationMetadataResponse } from './uploaded_conversation_metadata_response';
import type { UploadedConversationMetricStringValuesRequest } from './uploaded_conversation_metric_string_values_request';
import type { UploadedConversationMetricStringValuesResponse } from './uploaded_conversation_metric_string_values_response';
import type { UploadedConversationNavigationRequest } from './uploaded_conversation_navigation_request';
import type { UploadedConversationNavigationResponse } from './uploaded_conversation_navigation_response';
import type { UploadedConversationReportRowsRequest } from './uploaded_conversation_report_rows_request';
import type { UploadedConversationReportRowsResponse } from './uploaded_conversation_report_rows_response';
import type { FindUploadedConversationRecordingFileRequest } from './find_uploaded_conversation_recording_file_request';
import type { FindUploadedConversationRecordingFileResponse } from './find_uploaded_conversation_recording_file_response';
import type { GetAudioUploadUrlRequest } from './get_audio_upload_url_request';
import type { GetAudioUploadUrlResponse } from './get_audio_upload_url_response';
import type { HomeActivationResponse } from './home_activation_response';
import type { HomeDigestResponse } from './home_digest_response';
import type { ListKnowledgeBaseEntriesRequest } from './list_knowledge_base_entries_request';
import type { ListKnowledgeBaseEntriesResponse } from './list_knowledge_base_entries_response';
import type { ListKnowledgeBaseEntriesByTestSetRequest } from './list_knowledge_base_entries_by_test_set_request';
import type { KnowledgeBaseEntryRequest } from './knowledge_base_entry_request';
import type { KnowledgeBaseMutationResponse } from './knowledge_base_mutation_response';
import type { CreateTestSetFromKnowledgeBaseScenariosRequest } from './create_test_set_from_knowledge_base_scenarios_request';
import type { CreateTestSetFromKnowledgeBaseScenariosResponse } from './create_test_set_from_knowledge_base_scenarios_response';
import type { KnowledgeBaseEntryUpdateRequest } from './knowledge_base_entry_update_request';
import type { DeleteKnowledgeBaseEntryRequest } from './delete_knowledge_base_entry_request';
import type { KnowledgeBaseUploadUrlRequest } from './knowledge_base_upload_url_request';
import type { KnowledgeBaseUploadUrlResponse } from './knowledge_base_upload_url_response';
import type { KnowledgeBaseS3ObjectRequest } from './knowledge_base_s3_object_request';
import type { KnowledgeBaseSignedUrlResponse } from './knowledge_base_signed_url_response';
import type { KnowledgeBaseFileContentResponse } from './knowledge_base_file_content_response';
import type { GetOrganizationSettingsResponse } from './get_organization_settings_response';
import type { OverageSettingsResponse } from './overage_settings_response';
import type { OverageSettingsUpdate } from './overage_settings_update';
import type { OverageAcceptanceReceiptRequest } from './overage_acceptance_receipt_request';
import type { OverageAcceptanceReceiptResponse } from './overage_acceptance_receipt_response';
import type { OverageAcceptanceOfferResponse } from './overage_acceptance_offer_response';
import type { OverageAcceptanceRequest } from './overage_acceptance_request';
import type { OverageAcceptanceResponse } from './overage_acceptance_response';
import type { GetOrganizationRecordRequest } from './get_organization_record_request';
import type { GetOrganizationRecordResponse } from './get_organization_record_response';
import type { GetOrganizationUsersResponse } from './get_organization_users_response';
import type { UpdateOrganizationSettingsRequest } from './update_organization_settings_request';
import type { UpdateOrganizationSettingsResponse } from './update_organization_settings_response';
import type { ListWorkspacesResponse } from './list_workspaces_response';
import type { GetWorkspaceSettingsRequest } from './get_workspace_settings_request';
import type { WorkspaceSettings } from './workspace_settings';
import type { UpdateWorkspaceSettingsRequest } from './update_workspace_settings_request';
import type { CreateWorkspaceRequest } from './create_workspace_request';
import type { WorkspaceResponse } from './workspace_response';
import type { UpdateWorkspaceRequest } from './update_workspace_request';
import type { ArchiveWorkspaceRequest } from './archive_workspace_request';
import type { DeleteWorkspaceRequest } from './delete_workspace_request';
import type { ListWorkspaceMembersRequest } from './list_workspace_members_request';
import type { ListWorkspaceMembersResponse } from './list_workspace_members_response';
import type { AddWorkspaceMemberRequest } from './add_workspace_member_request';
import type { AddWorkspaceMemberResponse } from './add_workspace_member_response';
import type { RemoveWorkspaceMemberRequest } from './remove_workspace_member_request';
import type { RemoveWorkspaceMemberResponse } from './remove_workspace_member_response';
import type { LinearIntegrationStatusResponse } from './linear_integration_status_response';
import type { LinearAuthorizationUrlResponse } from './linear_authorization_url_response';
import type { ConnectLinearIntegrationRequest } from './connect_linear_integration_request';
import type { ConnectLinearIntegrationResponse } from './connect_linear_integration_response';
import type { DisconnectLinearIntegrationResponse } from './disconnect_linear_integration_response';
import type { ListLinearTeamsResponse } from './list_linear_teams_response';
import type { ListLinearProjectsRequest } from './list_linear_projects_request';
import type { ListLinearProjectsResponse } from './list_linear_projects_response';
import type { CreateLinearIssueRequest } from './create_linear_issue_request';
import type { CreateLinearIssueResponse } from './create_linear_issue_response';
import type { SimulationRoomRequest } from './simulation_room_request';
import type { SimulationRoomResponse } from './simulation_room_response';
import type { SlackStatusResponse } from './slack_status_response';
import type { ConnectSlackRequest } from './connect_slack_transport_request';
import type { ConnectSlackResponse } from './connect_slack_transport_response';
import type { DisconnectSlackResponse } from './disconnect_slack_transport_response';
import type { ListDashboardMetadataResponse } from './list_dashboard_metadata_response';
import type { GetDashboardLayoutRequest } from './get_dashboard_layout_request';
import type { DashboardLayoutResponse } from './dashboard_layout_response';
import type { QueryDashboardBatchRequest } from './query_dashboard_batch_request';
import type { QueryDashboardBatchResponse } from './query_dashboard_batch_response';
import type { FlexibleDashboardDrilldownRequest } from './flexible_dashboard_drilldown_request';
import type { FlexibleDashboardDrilldownResponse } from './flexible_dashboard_drilldown_response';
import type { HumanReviewDrilldownRequest } from './human_review_drilldown_request';
import type { HumanReviewDashboardDrilldownResponse } from './human_review_dashboard_drilldown_response';
import type { MetricValuesBySimulationRequest } from './metric_values_by_simulation_request';
import type { MetricValuesBySimulationResponse } from './metric_values_by_simulation_response';
import type { CreateDashboardRequest } from './create_dashboard_transport_request';
import type { CreateDashboardResponse } from './create_dashboard_transport_response';
import type { UpdateDashboardRequest } from './update_dashboard_transport_request';
import type { UpdateDashboardResponse } from './update_dashboard_transport_response';
import type { DeleteDashboardRequest } from './delete_dashboard_transport_request';
import type { DeleteDashboardResponse } from './delete_dashboard_transport_response';
import type { ReplaceDashboardWidgetsRequest } from './replace_dashboard_widgets_request';
import type { ReplaceDashboardWidgetsResponse } from './replace_dashboard_widgets_response';
import type { ClearDashboardWidgetsRequest } from './clear_dashboard_widgets_request';
import type { ClearDashboardWidgetsResponse } from './clear_dashboard_widgets_response';
import type { DuplicateDashboardWidgetRequest } from './duplicate_dashboard_widget_request';
import type { DuplicateDashboardWidgetResponse } from './duplicate_dashboard_widget_response';
import type { ListMetricCatalogEntriesResponse } from './list_metric_catalog_entries_response';
import type { CopyMetricCatalogEntryRequest } from './copy_metric_catalog_entry_request';
import type { CreateMetricResponse } from './create_metric_response';
import type { ListAdminMetricCatalogEntriesRequest } from './list_admin_metric_catalog_entries_request';
import type { ListAdminMetricCatalogEntriesResponse } from './list_admin_metric_catalog_entries_response';
import type { GetAdminMetricCatalogEntryRequest } from './get_admin_metric_catalog_entry_request';
import type { GetAdminMetricCatalogEntryResponse } from './get_admin_metric_catalog_entry_response';
import type { CreateAdminMetricCatalogEntryRequest } from './create_admin_metric_catalog_entry_request';
import type { MetricCatalogEntryResource } from './metric_catalog_entry_resource';
import type { UpdateAdminMetricCatalogEntryRequest } from './update_admin_metric_catalog_entry_request';
import type { DeleteAdminMetricCatalogEntryRequest } from './delete_admin_metric_catalog_entry_request';
import type { DeleteAdminMetricCatalogEntryResponse } from './delete_admin_metric_catalog_entry_response';
import type { ListPersonaCatalogEntriesResponse } from './list_persona_catalog_entries_response';
import type { CopyPersonaCatalogEntryRequest } from './copy_persona_catalog_entry_request';
import type { CreatePersonaResponse } from './create_persona_transport_response';
import type { ListAdminPersonaCatalogEntriesRequest } from './list_admin_persona_catalog_entries_request';
import type { ListAdminPersonaCatalogEntriesResponse } from './list_admin_persona_catalog_entries_response';
import type { GetAdminPersonaCatalogEntryRequest } from './get_admin_persona_catalog_entry_request';
import type { GetAdminPersonaCatalogEntryResponse } from './get_admin_persona_catalog_entry_response';
import type { CreateAdminPersonaCatalogEntryRequest } from './create_admin_persona_catalog_entry_request';
import type { PersonaCatalogEntryResource } from './persona_catalog_entry_resource';
import type { UpdateAdminPersonaCatalogEntryRequest } from './update_admin_persona_catalog_entry_request';
import type { DeleteAdminPersonaCatalogEntryRequest } from './delete_admin_persona_catalog_entry_request';
import type { DeleteAdminPersonaCatalogEntryResponse } from './delete_admin_persona_catalog_entry_response';
import type { ListMetricDirectoryResponse } from './list_metric_directory_response';
import type { CreateMetricAuditRequest } from './create_metric_audit_request';
import type { CreateMetricAuditResponse } from './create_metric_audit_response';
import type { GetMetricAuditRequest } from './get_metric_audit_request';
import type { GetMetricAuditResponse } from './get_metric_audit_response';
import type { CancelMetricAuditRequest } from './cancel_metric_audit_request';
import type { CancelMetricAuditResponse } from './cancel_metric_audit_response';
import type { ListMetricAuditGroupsRequest } from './list_metric_audit_groups_request';
import type { ListMetricAuditGroupsResponse } from './list_metric_audit_groups_response';
import type { GetMetricAuditPairRequest } from './get_metric_audit_pair_request';
import type { GetMetricAuditPairResponse } from './get_metric_audit_pair_response';
import type { GetMetricAuditPromptProposalRequest } from './get_metric_audit_prompt_proposal_request';
import type { GetMetricAuditPromptProposalResponse } from './get_metric_audit_prompt_proposal_response';
import type { SimulationDataFramesSchemaResponse } from './simulation_data_frames_schema_response';
import type { TestSqlMetricRequest } from './test_sql_metric_request';
import type { TestRecentSqlMetricResponse } from './test_recent_sql_metric_response';
import type { GetMetricThresholdRequest } from './get_metric_threshold_request';
import type { GetMetricThresholdResponse } from './get_metric_threshold_response';
import type { UpdateMetricThresholdRequest } from './update_metric_threshold_request';
import type { UpdateMetricThresholdResponse } from './update_metric_threshold_response';
import type { ListCommentsRequest } from './list_comments_request';
import type { ListCommentsResponse } from './list_comments_response';
import type { CreateCommentRequest } from './create_comment_transport_request';
import type { CreateCommentResponse } from './create_comment_transport_response';
import type { UpdateCommentRequest } from './update_comment_transport_request';
import type { UpdateCommentResponse } from './update_comment_transport_response';
import type { DeleteCommentRequest } from './delete_comment_transport_request';
import type { DeleteCommentResponse } from './delete_comment_transport_response';
import type { SettingsCredentialIntegrationsResponse } from './settings_credential_integrations_response';
import type { UpdateLangfuseIntegrationRequest } from './update_langfuse_integration_request';
import type { UpdateLangfuseIntegrationResponse } from './update_langfuse_integration_response';
import type { UpdateArizeIntegrationRequest } from './update_arize_integration_request';
import type { UpdateArizeIntegrationResponse } from './update_arize_integration_response';
import type { UpdateZendeskIntegrationRequest } from './update_zendesk_integration_request';
import type { UpdateZendeskIntegrationResponse } from './update_zendesk_integration_response';
import type { UpdateShelfIntegrationRequest } from './update_shelf_integration_request';
import type { UpdateShelfIntegrationResponse } from './update_shelf_integration_response';
import type { TelnyxIntegrationResource } from './telnyx_integration_status_response';
import type { UpdateTelnyxApiKeyRequest } from './update_telnyx_api_key_request';
import type { UpdateTelnyxApiKeyResponse } from './update_telnyx_api_key_response';
import type { RemoveTelnyxApiKeyResponse } from './remove_telnyx_api_key_response';
import type { DiscoverGenesysQueuesRequest } from './discover_genesys_queues_request';
import type { DiscoverGenesysQueuesResponse } from './discover_genesys_queues_response';
import type { ListConversationImportConnectionsRequest } from './list_conversation_import_connections_request';
import type { ListConversationImportConnectionsResponse } from './list_conversation_import_connections_response';
import type { CreateGenesysConnectionRequest } from './create_genesys_connection_request';
import type { CreateGenesysConnectionResponse } from './create_genesys_connection_response';
import type { ConversationImportConnectionActionRequest } from './conversation_import_connection_action_request';
import type { ConversationImportConnectionActionResponse } from './conversation_import_connection_action_response';
import type { ListAdminMetricsRequest } from './list_admin_metrics_request';
import type { ListAdminMetricsResponse } from './list_admin_metrics_response';
import type { ListMetricAdminOrganizationsResponse } from './list_metric_admin_organizations_response';
import type { CreateAdminMetricRequest } from './create_admin_metric_request';
import type { CreateAdminMetricResponse } from './create_admin_metric_response';
import type { UpdateAdminMetricRequest } from './update_admin_metric_request';
import type { UpdateAdminMetricResponse } from './update_admin_metric_response';
import type { UpdateMetricActiveStatusRequest } from './update_metric_active_status_request';
import type { MetricAdminMutationResponse } from './metric_admin_mutation_response';
import type { ListMetricsRequest } from './list_metrics_request';
import type { ListMetricsResponse } from './list_metrics_response';
import type { ListMetricTagsResponse } from './list_metric_tags_response';
import type { GetMetricLabelsRequest } from './get_metric_labels_request';
import type { GetMetricLabelsResponse } from './get_metric_labels_response';
import type { QueryMetricAuthorsRequest } from './query_metric_authors_request';
import type { QueryMetricAuthorsResponse } from './query_metric_authors_response';
import type { GetMetricRequest } from './get_metric_request';
import type { GetMetricResponse } from './get_metric_response';
import type { GetMetricVersionsRequest } from './get_metric_versions_request';
import type { GetMetricVersionsResponse } from './get_metric_versions_response';
import type { RevertMetricVersionRequest } from './revert_metric_version_request';
import type { RevertMetricVersionResponse } from './revert_metric_version_response';
import type { MetricsMetadataRequest } from './metrics_metadata_request';
import type { MetricsMetadataResponse } from './metrics_metadata_response';
import type { MetricsMetadataKeysResponse } from './metrics_metadata_keys_response';
import type { MetricMetadataValuesRequest } from './metric_metadata_values_request';
import type { MetricMetadataValuesResponse } from './metric_metadata_values_response';
import type { ListMetricFlowsRequest } from './list_metric_flows_request';
import type { ListMetricFlowsResponse } from './list_metric_flows_response';
import type { CreateMetricFlowRequest } from './create_metric_flow_request';
import type { MetricFlowMutationResponse } from './metric_flow_mutation_response';
import type { UpdateMetricFlowRequest } from './update_metric_flow_request';
import type { DeleteMetricFlowRequest } from './delete_metric_flow_request';
import type { GetMetricOutputsByUlidsRequest } from './get_metric_outputs_by_ulids_request';
import type { GetMetricOutputsByUlidsResponse } from './get_metric_outputs_by_ulids_response';
import type { GetAgentJudgeEvidenceRequest } from './get_agent_judge_evidence_request';
import type { GetAgentJudgeEvidenceResponse } from './get_agent_judge_evidence_response';
import type { RunTestMetricRequest } from './run_test_metric_request';
import type { RunTestMetricResponse } from './run_test_metric_response';
import type { CreateMetricRequest } from './create_metric_request';
import type { DuplicateMetricRequest } from './duplicate_metric_request';
import type { DuplicateMetricResponse } from './duplicate_metric_response';
import type { UpdateMetricRequest } from './update_metric_request';
import type { UpdateMetricResponse } from './update_metric_response';
import type { ArchiveMetricRequest } from './archive_metric_request';
import type { ArchiveMetricResponse } from './archive_metric_response';
import type { ListRecentlyDeletedMetricsResponse } from './list_recently_deleted_metrics_response';
import type { RestoreMetricRequest } from './restore_metric_request';
import type { RestoreMetricResponse } from './restore_metric_response';
import type { ListAlertsRequest } from './list_alerts_request';
import type { ListAlertsResponse } from './list_alerts_response';
import type { GetAlertRequest } from './get_alert_request';
import type { AlertMutationResponse } from './alert_mutation_response';
import type { CreateAlertRequest } from './create_alert_request';
import type { UpdateAlertRequest } from './update_alert_request';
import type { DeleteAlertRequest } from './delete_alert_request';
import type { DeleteAlertResponse } from './delete_alert_response';
import type { ListAlertEventsRequest } from './list_alert_events_request';
import type { ListAlertEventsResponse } from './list_alert_events_response';
import type { TestEvaluateAlertRequest } from './test_evaluate_alert_request';
import type { TestEvaluateAlertResponse } from './test_evaluate_alert_response';
import type { ListScheduledRunsRequest } from './list_scheduled_runs_request';
import type { ListScheduledRunsResponse } from './list_scheduled_runs_transport_response';
import type { GetScheduledRunRequest } from './get_scheduled_run_transport_request';
import type { GetScheduledRunTransportResponse } from './get_scheduled_run_transport_response';
import type { ListScheduledRunHistoryRequest } from './list_scheduled_run_history_request';
import type { ListScheduledRunHistoryResponse } from './list_scheduled_run_history_response';
import type { CreateScheduledRunTransportRequest } from './create_scheduled_run_transport_request';
import type { CreateScheduledRunTransportResponse } from './create_scheduled_run_transport_response';
import type { UpdateScheduledRunTransportRequest } from './update_scheduled_run_transport_request';
import type { UpdateScheduledRunTransportResponse } from './update_scheduled_run_transport_response';
import type { DeleteScheduledRunRequest } from './delete_scheduled_run_transport_request';
import type { DeleteScheduledRunTransportResponse } from './delete_scheduled_run_transport_response';
import type { TestSetMetadataRequest } from './test_set_metadata_request';
import type { TestSetMetadataResponse } from './test_set_metadata_response';
import type { TestSetRecordsRequest } from './test_set_records_request';
import type { TestSetRecordsResponse } from './test_set_records_response';
import type { ListTestSetsTransportResponse } from './list_test_sets_transport_response';
import type { GetTestSetVersionsRequest } from './get_test_set_versions_request';
import type { GetTestSetVersionsResponse } from './get_test_set_versions_response';
import type { RevertTestSetVersionRequest } from './revert_test_set_version_request';
import type { RevertTestSetVersionResponse } from './revert_test_set_version_response';
import type { ListTestSetTagsResponse } from './list_test_set_tags_response';
import type { TestSetMetadataKeysRequest } from './test_set_metadata_keys_request';
import type { TestSetMetadataKeysResponse } from './test_set_metadata_keys_response';
import type { ListTestCasesTransportRequest } from './list_test_cases_transport_request';
import type { ListTestCasesTransportResponse } from './list_test_cases_transport_response';
import type { CreateTestSetTransportRequest } from './create_test_set_transport_request';
import type { CreateTestSetTransportResponse } from './create_test_set_transport_response';
import type { UpdateTestCaseRowTransportRequest } from './update_test_case_row_transport_request';
import type { SuccessTransportResponse } from './success_transport_response';
import type { AddTestSetRowsTransportRequest } from './add_test_set_rows_transport_request';
import type { AddTestSetRowsTransportResponse } from './add_test_set_rows_transport_response';
import type { DeleteTestSetRowTransportRequest } from './delete_test_set_row_transport_request';
import type { DeleteTestSetTransportRequest } from './delete_test_set_transport_request';
import type { DeleteTestSetsRequest } from './delete_test_sets_request';
import type { DeleteTestSetsResponse } from './delete_test_sets_response';
import type { UpdateTestSetTransportRequest } from './update_test_set_transport_request';
import type { SaveTestSetEditorStateTransportRequest } from './save_test_set_editor_state_transport_request';
import type { SaveTestSetEditorStateTransportResponse } from './save_test_set_editor_state_transport_response';
import type { GetMediaUploadUrlTransportRequest } from './get_media_upload_url_transport_request';
import type { MediaUploadUrlTransportResponse } from './media_upload_url_transport_response';
import type { GetMediaPreviewUrlTransportRequest } from './get_media_preview_url_transport_request';
import type { MediaPreviewUrlTransportResponse } from './media_preview_url_transport_response';
import type { DuplicateTestSetTransportRequest } from './duplicate_test_set_transport_request';
import type { DuplicateTestSetTransportResponse } from './duplicate_test_set_transport_response';
import type { GetTestSetAgentAssociationsTransportRequest } from './get_test_set_agent_associations_transport_request';
import type { GetTestSetAgentAssociationsTransportResponse } from './get_test_set_agent_associations_transport_response';
import type { AddTestSetAgentAssociationsTransportRequest } from './add_test_set_agent_associations_transport_request';
import type { RemoveTestSetAgentAssociationTransportRequest } from './remove_test_set_agent_association_transport_request';
import type { ListRecentlyDeletedTestSetsTransportResponse } from './list_recently_deleted_test_sets_transport_response';
import type { GetTestSetAutoAddRuleRequest } from './get_test_set_auto_add_rule_request';
import type { GetTestSetAutoAddRuleResponse } from './get_test_set_auto_add_rule_response';
import type { SaveTestSetAutoAddRuleRequest } from './save_test_set_auto_add_rule_request';
import type { SaveTestSetAutoAddRuleResponse } from './save_test_set_auto_add_rule_response';
import type { DeleteTestSetAutoAddRuleRequest } from './delete_test_set_auto_add_rule_request';
import type { TestSetAutoAddMutationResponse } from './test_set_auto_add_mutation_response';
import type { ListTestSetAutoAddPendingRequest } from './list_test_set_auto_add_pending_request';
import type { ListTestSetAutoAddPendingResponse } from './list_test_set_auto_add_pending_response';
import type { AcceptTestSetAutoAddSuggestionRequest } from './accept_test_set_auto_add_suggestion_request';
import type { AcceptTestSetAutoAddSuggestionResponse } from './accept_test_set_auto_add_suggestion_response';
import type { RejectTestSetAutoAddSuggestionRequest } from './reject_test_set_auto_add_suggestion_request';
import type { GetTestSetAutoAddSummaryRequest } from './get_test_set_auto_add_summary_request';
import type { GetTestSetAutoAddSummaryResponse } from './get_test_set_auto_add_summary_response';
import type { ListTestSetAutoAddPendingCountsRequest } from './list_test_set_auto_add_pending_counts_request';
import type { ListTestSetAutoAddPendingCountsResponse } from './list_test_set_auto_add_pending_counts_response';
import type { RestoreTestSetTransportRequest } from './restore_test_set_transport_request';
import type { RestoreTestSetTransportResponse } from './restore_test_set_transport_response';
import type { ListPersonasRequest } from './list_personas_request';
import type { ListPersonasResponse } from './list_personas_response';
import type { ListPersonaTagsResponse } from './list_persona_tags_response';
import type { ListRecentlyDeletedPersonasResponse } from './list_recently_deleted_personas_response';
import type { ListBackgroundSoundsRequest } from './list_background_sounds_request';
import type { ListBackgroundSoundsResponse } from './list_background_sounds_response';
import type { ListRunTemplatesResponse } from './list_run_templates_transport_response';
import type { GetRunTemplateTransportRequest } from './get_run_template_transport_request';
import type { GetRunTemplateTransportResponse } from './get_run_template_transport_response';
import type { CreateRunTemplateTransportRequest } from './create_run_template_transport_request';
import type { CreateRunTemplateTransportResponse } from './create_run_template_transport_response';
import type { UpdateRunTemplateTransportRequest } from './update_run_template_transport_request';
import type { UpdateRunTemplateTransportResponse } from './update_run_template_transport_response';
import type { DeleteRunTemplateTransportRequest } from './delete_run_template_transport_request';
import type { DeleteRunTemplateTransportResponse } from './delete_run_template_transport_response';
import type { DuplicateRunTemplateRequest } from './duplicate_run_template_request';
import type { DuplicateRunTemplateResponse } from './duplicate_run_template_response';
import type { ListReportsRequest } from './list_reports_request';
import type { ListReportsResponse } from './list_reports_response';
import type { GetReportRequest } from './get_report_transport_request';
import type { GetReportResponse } from './get_report_transport_response';
import type { GetPublicReportRequest } from './get_public_report_transport_request';
import type { GetPublicReportResponse } from './get_public_report_transport_response';
import type { ReportRowsRequest } from './report_rows_request';
import type { ReportRowsResponse } from './report_rows_response';
import type { GetPublicReportRowsRequest } from './get_public_report_rows_request';
import type { CohortOutliersRequest } from './cohort_outliers_request';
import type { CohortOutliersResponse } from './cohort_outliers_response';
import type { SaveReportRequest } from './save_report_transport_request';
import type { SaveReportResponse } from './save_report_transport_response';
import type { UpdateReportRequest } from './update_report_transport_request';
import type { UpdateReportResponse } from './update_report_transport_response';
import type { SetReportVisibilityRequest } from './set_report_visibility_transport_request';
import type { SetReportVisibilityResponse } from './set_report_visibility_transport_response';
import type { DeleteReportRequest } from './delete_report_transport_request';
import type { DeleteReportResponse } from './delete_report_transport_response';
import type { GetReviewOverviewRequest } from './get_review_overview_request';
import type { GetReviewOverviewResponse } from './get_review_overview_response';
import type { GetReviewOverviewV2Request } from './get_review_overview_v2_request';
import type { QueryHumanReviewProjectAnnotationsTableRequest } from './query_human_review_project_annotations_table_request';
import type { QueryHumanReviewProjectAnnotationsTableResponse } from './query_human_review_project_annotations_table_response';
import type { QueryHumanReviewProjectTriageMembershipRequest } from './query_human_review_project_triage_membership_request';
import type { QueryHumanReviewProjectTriageMembershipResponse } from './query_human_review_project_triage_membership_response';
import type { ListReviewMetricSkipsRequest } from './list_review_metric_skips_request';
import type { ListReviewMetricSkipsResponse } from './list_review_metric_skips_response';
import type { SkipReviewMetricRequest } from './skip_review_metric_request';
import type { SkipReviewMetricResponse } from './skip_review_metric_response';
import type { UnskipReviewMetricRequest } from './unskip_review_metric_request';
import type { UnskipReviewMetricResponse } from './unskip_review_metric_response';
import type { GetHumanReviewProjectAnnotationDetailsRequest } from './get_human_review_project_annotation_details_request';
import type { GetHumanReviewProjectAnnotationDetailsResponse } from './get_human_review_project_annotation_details_response';
import type { GetReviewProjectSimulationCompletionsRequest } from './get_review_project_simulation_completions_request';
import type { GetReviewProjectSimulationCompletionsResponse } from './get_review_project_simulation_completions_response';
import type { BatchGetReviewProjectConversationStatesRequest } from './batch_get_review_project_conversation_states_request';
import type { BatchGetReviewProjectConversationStatesResponse } from './batch_get_review_project_conversation_states_response';
import type { GetMetricHealthStatsRequest } from './get_metric_health_stats_request';
import type { GetMetricHealthStatsResponse } from './get_metric_health_stats_response';
import type { GetMetricAgreementHistoryRequest } from './get_metric_agreement_history_request';
import type { GetMetricAgreementHistoryResponse } from './get_metric_agreement_history_response';
import type { GetHumanReviewProjectInsightsRequest } from './get_human_review_project_insights_request';
import type { GetHumanReviewProjectInsightsResponse } from './get_human_review_project_insights_response';
import type { GetHumanReviewProjectInsightSliceRequest } from './get_human_review_project_insight_slice_request';
import type { GetHumanReviewProjectInsightSliceResponse } from './get_human_review_project_insight_slice_response';
import type { GetHumanReviewProjectDateDensityRequest } from './get_human_review_project_date_density_request';
import type { GetHumanReviewProjectDateDensityResponse } from './get_human_review_project_date_density_response';
import type { GetHumanReviewProjectLayoutRequest } from './get_human_review_project_layout_request';
import type { GetHumanReviewProjectLayoutResponse } from './get_human_review_project_layout_response';
import type { SaveHumanReviewProjectLayoutRequest } from './save_human_review_project_layout_request';
import type { SaveHumanReviewProjectLayoutResponse } from './save_human_review_project_layout_response';
import type { GetReviewDisagreementStateRequest } from './get_review_disagreement_state_request';
import type { GetReviewDisagreementStateResponse } from './get_review_disagreement_state_response';
import type { GetAnnotationsWithMetricOutputsRequest } from './get_annotations_with_metric_outputs_request';
import type { GetAnnotationsWithMetricOutputsResponse } from './get_annotations_with_metric_outputs_response';
import type { GetFeedbackForSimulationOutputRequest } from './get_feedback_for_simulation_output_request';
import type { ReviewAnnotationsByMetricResponse } from './review_annotations_by_metric_response';
import type { GetAllAnnotationsByOrgRequest } from './get_all_annotations_by_org_request';
import type { ListHumanReviewAlertsResponse } from './list_human_review_alerts_response';
import type { DeleteHumanReviewAlertRequest } from './delete_human_review_alert_request';
import type { HumanReviewAlertMutationResponse } from './human_review_alert_mutation_response';
import type { GetReviewLabelsForSimulationRequest } from './get_review_labels_for_simulation_request';
import type { ReviewLabelsForSimulationResponse } from './review_labels_for_simulation_response';
import type { SaveReviewLabelsForSimulationRequest } from './save_review_labels_for_simulation_request';
import type { ListReviewProjectsRequest } from './list_review_projects_request';
import type { ListReviewProjectsResponse } from './list_review_projects_response';
import type { GetReviewProjectRequest } from './get_review_project_request';
import type { GetReviewProjectResponse } from './get_review_project_response';
import type { CreateReviewProjectRequest } from './create_review_project_request';
import type { CreateReviewProjectResponse } from './create_review_project_response';
import type { DuplicateReviewProjectRequest } from './duplicate_review_project_request';
import type { DuplicateReviewProjectResponse } from './duplicate_review_project_response';
import type { GetProjectMetricAgreementRequest } from './get_project_metric_agreement_request';
import type { GetProjectMetricAgreementResponse } from './get_project_metric_agreement_response';
import type { GetReviewProjectRerunContextRequest } from './get_review_project_rerun_context_request';
import type { GetReviewProjectRerunContextResponse } from './get_review_project_rerun_context_response';
import type { ListReviewProjectMembershipLogsRequest } from './list_review_project_membership_logs_request';
import type { ListReviewProjectMembershipLogsResponse } from './list_review_project_membership_logs_response';
import type { ListReviewProjectMembersRequest } from './list_review_project_members_request';
import type { ListReviewProjectMembersResponse } from './list_review_project_members_response';
import type { SetReviewProjectMemberRoleRequest } from './set_review_project_member_role_request';
import type { SetReviewProjectMemberRoleResponse } from './set_review_project_member_role_response';
import type { SendProjectAssignmentEmailRequest } from './send_project_assignment_email_request';
import type { SendProjectAssignmentEmailResponse } from './send_project_assignment_email_response';
import type { CompleteReviewConversationRequest } from './complete_review_conversation_request';
import type { CompleteReviewConversationResponse } from './complete_review_conversation_response';
import type { ClaimConversationRequest } from './claim_conversation_request';
import type { ClaimConversationResponse } from './claim_conversation_response';
import type { ReleaseConversationRequest } from './release_conversation_request';
import type { ReleaseConversationResponse } from './release_conversation_response';
import type { ForceReleaseConversationRequest } from './force_release_conversation_request';
import type { ForceReleaseConversationResponse } from './force_release_conversation_response';
import type { StartReviewBatchRequest } from './start_review_batch_request';
import type { StartReviewBatchResponse } from './start_review_batch_response';
import type { GetCurrentReviewBatchRequest } from './get_current_review_batch_request';
import type { GetCurrentReviewBatchResponse } from './get_current_review_batch_response';
import type { StopReviewBatchRequest } from './stop_review_batch_request';
import type { StopReviewBatchResponse } from './stop_review_batch_response';
import type { AssignReviewBatchesRequest } from './assign_review_batches_request';
import type { AssignReviewBatchesResponse } from './assign_review_batches_response';
import type { ReleaseReviewBatchRequest } from './release_review_batch_request';
import type { ReleaseReviewBatchResponse } from './release_review_batch_response';
import type { ListReviewBatchesRequest } from './list_review_batches_request';
import type { ListReviewBatchesResponse } from './list_review_batches_response';
import type { UpdateReviewProjectRequest } from './update_review_project_request';
import type { UpdateReviewProjectResponse } from './update_review_project_response';
import type { DeleteReviewProjectRequest } from './delete_review_project_request';
import type { ReviewProjectMutationResponse } from './review_project_mutation_response';
import type { ListReviewAnnotationsRequest } from './list_review_annotations_request';
import type { ListReviewAnnotationsResponse } from './list_review_annotations_response';
import type { GetReviewAnnotationRequest } from './get_review_annotation_request';
import type { GetReviewAnnotationResponse } from './get_review_annotation_response';
import type { CreateReviewAnnotationRequest } from './create_review_annotation_request';
import type { CreateReviewAnnotationResponse } from './create_review_annotation_response';
import type { UpdateReviewAnnotationRequest } from './update_review_annotation_request';
import type { UpdateReviewAnnotationResponse } from './update_review_annotation_response';
import type { DeleteReviewAnnotationRequest } from './delete_review_annotation_request';
import type { ReviewAnnotationMutationResponse } from './review_annotation_mutation_response';
import type { UpdateProjectReviewAnnotationRequest } from './update_project_review_annotation_request';
import type { DeleteProjectReviewAnnotationRequest } from './delete_project_review_annotation_request';
import type { LaunchRunRequest } from './launch_run_request';
import type { LaunchRunResponse } from './launch_run_response';
import type { RerunMetricsRequest } from './rerun_metrics_request';
import type { RerunMetricsResponse } from './rerun_metrics_response';
import type { RunsKeysetRequest } from './runs_keyset_request';
import type { RunsKeysetResponse } from './runs_keyset_response';
import type { SimulatedConversationsKeysetRequest } from './simulated_conversations_keyset_request';
import type { SimulatedConversationsKeysetResponse } from './simulated_conversations_keyset_response';
import type { RunsPageInsightsRequest } from './runs_page_insights_request';
import type { RunsPageInsightsResponse } from './runs_page_insights_response';
import type { RunMetadataRequest } from './run_metadata_request';
import type { RunMetadataResponse } from './run_metadata_response';
import type { MultiRunMetadataRequest } from './multi_run_metadata_request';
import type { MultiRunMetadataResponse } from './multi_run_metadata_response';
import type { RunRowsRequest } from './run_rows_request';
import type { RunRowsResponse } from './run_rows_response';
import type { RunOutliersRequest } from './run_outliers_request';
import type { RunOutliersResponse } from './run_outliers_response';
import type { MultiRunRowsRequest } from './multi_run_rows_request';
import type { MultiRunRowsResponse } from './multi_run_rows_response';
import type { LatestRunResponse } from './latest_run_response';
import type { ImportSessionMappingRequest } from './import_session_mapping_request';
import type { ImportSessionMappingResponse } from './import_session_mapping_response';
import type { UpdateRunNotesRequest } from './update_run_notes_request';
import type { UpdateRunNotesResponse } from './update_run_notes_response';
import type { DeleteRunRequest } from './delete_run_request';
import type { DeleteRunResponse } from './delete_run_response';
import type { SetRunPublicRequest } from './set_run_public_request';
import type { SetRunPublicResponse } from './set_run_public_response';
import type { UpdateRunDisplayNameRequest } from './update_run_display_name_request';
import type { UpdateRunDisplayNameResponse } from './update_run_display_name_response';
import type { CancelRunRequest } from './cancel_run_request';
import type { CancelRunResponse } from './cancel_run_response';
import type { GetLatestFailurePatternRunOutputRequest } from './get_latest_failure_pattern_run_output_request';
import type { GetLatestFailurePatternRunOutputResponse } from './get_latest_failure_pattern_run_output_response';
import type { GetLatestConversationClusteringRunOutputRequest } from './get_latest_conversation_clustering_run_output_request';
import type { GetLatestConversationClusteringRunOutputResponse } from './get_latest_conversation_clustering_run_output_response';
import type { ListRunTagsResponse } from './list_run_tags_response';
import type { UpdateRunTagsRequest } from './update_run_tags_request';
import type { UpdateRunTagsResponse } from './update_run_tags_response';
import type { SimulationOutputIdRequest } from './simulation_output_id_request';
import type { SimulationOutputResponse } from './simulation_output_response';
import type { RunSimulationOutputIdsRequest } from './run_simulation_output_ids_request';
import type { SimulationOutputIdsResponse } from './simulation_output_ids_response';
import type { SimulationOutputTimeWindowResponse } from './simulation_output_time_window_response';
import type { SpeakingSegmentsResponse } from './speaking_segments_response';
import type { SetSimulationOutputPublicRequest } from './set_simulation_output_public_request';
import type { SimulationOutputMutationResponse } from './simulation_output_mutation_response';
import type { ResimulateSimulationOutputsRequest } from './resimulate_simulation_outputs_request';
import type { ResimulateSimulationOutputsResponse } from './resimulate_simulation_outputs_response';
import type { SharedRunPasswordRequest } from './shared_run_password_request';
import type { SharedRunRecordResponse } from './shared_run_record_response';
import type { VerifySharedRunPasswordRequest } from './verify_shared_run_password_request';
import type { VerifySharedRunPasswordResponse } from './verify_shared_run_password_response';
import type { SharedRunRowsRequest } from './shared_run_rows_request';
import type { SharedRunRowsResponse } from './shared_run_rows_response';
import type { SharedTestSetRequest } from './shared_test_set_request';
import type { SharedTestSetResponse } from './shared_test_set_response';
import type { SharedMetricsRequest } from './shared_metrics_request';
import type { SharedMetricsResponse } from './shared_metrics_response';
import type { SharedRunIdsRequest } from './shared_run_ids_request';
import type { SharedMultiRunMetadataResponse } from './shared_multi_run_metadata_response';
import type { SharedSimulationOutputRowRequest } from './shared_simulation_output_row_request';
import type { SharedSimulationOutputRowResponse } from './shared_simulation_output_row_response';
import type { SharedSimulationTracesRequest } from './shared_simulation_traces_request';
import type { SimulationTracesResponse } from './simulation_traces_response';
import type { MaestroSimulationOutputCountRequest } from './maestro_simulation_output_count_request';
import type { MaestroSimulationOutputCountResponse } from './maestro_simulation_output_count_response';
import type { MaestroSimulationOutputIdsRequest } from './maestro_simulation_output_ids_request';
import type { MaestroSimulationOutputIdsResponse } from './maestro_simulation_output_ids_response';
import type { MaestroBaseFilterRequest } from './maestro_base_filter_request';
import type { MaestroExistingMetricsResponse } from './maestro_existing_metrics_response';
import type { MaestroMetadataKeysResponse } from './maestro_metadata_keys_response';
import type { MaestroMetadataValuesRequest } from './maestro_metadata_values_request';
import type { MaestroMetadataValuesResponse } from './maestro_metadata_values_response';
import type { SimulationTraceRequest } from './simulation_trace_request';
import type { SimulationTracePresenceResponse } from './simulation_trace_presence_response';
import type { SimulationTraceDetailResponse } from './simulation_trace_detail_response';
import type { RunTracePresenceRequest } from './run_trace_presence_request';
import type { RunTracePresenceResponse } from './run_trace_presence_response';
import type { TraceAudioContextResponse } from './trace_audio_context_response';
import type { TraceSearchRequest } from './trace_search_request';
import type { TraceSearchResponse } from './trace_search_response';
import type { RunTransitionHotspotsRequest } from './run_transition_hotspots_request';
import type { TraceTransitionMatrixResponse } from './trace_transition_matrix_response';
import type { SearchTransitionHotspotsRequest } from './search_transition_hotspots_request';
import type { TraceFilterSuggestionsRequest } from './trace_filter_suggestions_request';
import type { TraceFilterSuggestionsResponse } from './trace_filter_suggestions_response';
import type { CustomTraceMetricPreviewRequest } from './custom_trace_metric_preview_request';
import type { CustomTraceMetricPreviewResponse } from './custom_trace_metric_preview_response';
import type { GetPersonaRequest } from './get_persona_request';
import type { GetPersonaResponse } from './get_persona_response';
import type { GetPersonaVersionsRequest } from './get_persona_versions_request';
import type { GetPersonaVersionsResponse } from './get_persona_versions_response';
import type { RevertPersonaVersionRequest } from './revert_persona_version_request';
import type { RevertPersonaVersionResponse } from './revert_persona_version_response';
import type { CreatePersonaRequest } from './create_persona_transport_request';
import type { CreateBackgroundSoundRequest } from './create_background_sound_transport_request';
import type { CreateBackgroundSoundResponse } from './create_background_sound_transport_response';
import type { CompleteBackgroundSoundRequest } from './complete_background_sound_transport_request';
import type { CompleteBackgroundSoundResponse } from './complete_background_sound_transport_response';
import type { UpdatePersonaRequest } from './update_persona_transport_request';
import type { UpdatePersonaResponse } from './update_persona_transport_response';
import type { UpdateBackgroundSoundRequest } from './update_background_sound_transport_request';
import type { UpdateBackgroundSoundResponse } from './update_background_sound_transport_response';
import type { DeletePersonaRequest } from './delete_persona_transport_request';
import type { DeletePersonaResponse } from './delete_persona_transport_response';
import type { DeletePersonasRequest } from './delete_personas_request';
import type { DeletePersonasResponse } from './delete_personas_response';
import type { DuplicatePersonaRequest } from './duplicate_persona_transport_request';
import type { DuplicatePersonaResponse } from './duplicate_persona_transport_response';
import type { RestorePersonaRequest } from './restore_persona_request';
import type { RestorePersonaResponse } from './restore_persona_response';
import type { GeneratePersonaVoiceCandidatesRequest } from './generate_persona_voice_candidates_transport_request';
import type { GeneratePersonaVoiceCandidatesResponse } from './generate_persona_voice_candidates_transport_response';
import type { PreviewPersonaVoiceCandidateRequest } from './preview_persona_voice_candidate_transport_request';
import type { PreviewPersonaVoiceCandidateResponse } from './preview_persona_voice_candidate_transport_response';
import type { KeepPersonaVoiceCandidateRequest } from './keep_persona_voice_candidate_transport_request';
import type { KeepPersonaVoiceCandidateResponse } from './keep_persona_voice_candidate_transport_response';
import type { ListWebhooksResponse } from './list_webhooks_response';
import type { CreateWebhookRequest } from './create_webhook_transport_request';
import type { CreateWebhookResponse } from './create_webhook_transport_response';
import type { UpdateWebhookRequest } from './update_webhook_transport_request';
import type { UpdateWebhookResponse } from './update_webhook_transport_response';
import type { DeleteWebhookRequest } from './delete_webhook_transport_request';
import type { DeleteWebhookResponse } from './delete_webhook_transport_response';
import type { ListExternalAgentCandidatesRequest } from './list_external_agent_candidates_request';
import type { ListExternalAgentCandidatesResponse } from './list_external_agent_candidates_response';
import type { ImportExternalAgentsRequest } from './import_external_agents_request';
import type { ImportExternalAgentsResponse } from './import_external_agents_response';
import type { ListSavedViewsRequest } from './list_saved_views_request';
import type { ListSavedViewsResponse } from './list_saved_views_response';
import type { GetSavedViewRequest } from './get_saved_view_request';
import type { GetSavedViewResponse } from './get_saved_view_response';
import type { CreateSavedViewRequest } from './create_saved_view_request';
import type { CreateSavedViewResponse } from './create_saved_view_response';
import type { UpdateSavedViewRequest } from './update_saved_view_request';
import type { UpdateSavedViewResponse } from './update_saved_view_response';
import type { DeleteSavedViewRequest } from './delete_saved_view_request';
import type { SavedViewMutationResponse } from './saved_view_mutation_response';
import type { GetUserDefaultSavedViewRequest } from './get_user_default_saved_view_request';
import type { UserDefaultSavedViewResponse } from './user_default_saved_view_response';
import type { SetUserDefaultSavedViewRequest } from './set_user_default_saved_view_request';
import type { ClearUserDefaultSavedViewRequest } from './clear_user_default_saved_view_request';
import type { ListOrganizationTagsResponse } from './list_organization_tags_response';
import type { ListOrganizationTagsRequest } from './list_organization_tags_request';
import type { CreateOrganizationTagRequest } from './create_organization_tag_request';
import type { CreateOrganizationTagResponse } from './create_organization_tag_response';
import type { UpdateOrganizationTagRequest } from './update_organization_tag_request';
import type { UpdateOrganizationTagResponse } from './update_organization_tag_response';
import type { DeleteOrganizationTagRequest } from './delete_organization_tag_request';
import type { DeleteOrganizationTagResponse } from './delete_organization_tag_response';

export type TransportAuthMode = 'none' | 'session';
export type TransportDatabaseAccess = 'none' | 'read' | 'write';
export type TransportRequestLocation = 'none' | 'query' | 'json_body' | 'path';
export type TransportMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
export type TransportOperationAction = "list" | "get" | "create" | "update" | "delete" | "archive" | "duplicate" | "set" | "connect" | "disconnect" | "run" | "upload" | "download" | "query" | "custom";

export interface TransportPaginationDefinition {
  itemKey: string | null;
  requestTokenKey: string;
  responseTokenKey: string;
}

export interface TransportOperationDefinition {
  method: TransportMethod;
  path: string;
  auth: TransportAuthMode;
  databaseAccess: TransportDatabaseAccess;
  organizationRequired: boolean;
  requestLocation: TransportRequestLocation;
  requestSchema: string | null;
  responseSchema: string;
  requestByAlias: boolean;
  responseByAlias: boolean;
  pathParams: readonly string[];
  summary: string;
  resource: string | null;
  cacheTags: readonly string[];
  pagination: TransportPaginationDefinition | null;
  action: TransportOperationAction;
  versionGroup: string;
  version: number;
  isDefaultVersion: boolean;
  canonicalOperation: string;
  deprecationMessage: string | null;
  replacementOperation: string | null;
}

export const transportOperations = {
  "createPythonMetricDraft": {
    method: 'POST',
    path: '/transport/python-metric-drafts',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_python_metric_draft_request',
    responseSchema: 'python_metric_draft_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Save an immutable Python metric draft.",
    resource: "python-metrics",
    cacheTags: ["python-metrics", "metrics"],
    pagination: null,
    action: 'create',
    versionGroup: "createPythonMetricDraft",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createPythonMetricDraft",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getPythonMetricDraft": {
    method: 'GET',
    path: '/transport/python-metric-drafts/{draft_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'get_python_metric_draft_request',
    responseSchema: 'python_metric_draft_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['draft_id'],
    summary: "Get a Python metric draft.",
    resource: "python-metrics",
    cacheTags: ["python-metrics", "metrics"],
    pagination: null,
    action: 'get',
    versionGroup: "getPythonMetricDraft",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getPythonMetricDraft",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "previewPythonMetric": {
    method: 'POST',
    path: '/transport/python-metric-drafts/{draft_id}/previews',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'preview_python_metric_request',
    responseSchema: 'python_metric_previews_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['draft_id'],
    summary: "Evaluate a draft on a historical conversation.",
    resource: "python-metrics-preview-python-metric",
    cacheTags: ["python-metrics", "metrics"],
    pagination: null,
    action: 'create',
    versionGroup: "previewPythonMetric",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "previewPythonMetric",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getPythonMetricPreview": {
    method: 'GET',
    path: '/transport/python-metric-drafts/{draft_id}/previews/{preview_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'get_python_metric_preview_request',
    responseSchema: 'python_metric_previews_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['draft_id', 'preview_id'],
    summary: "Get a historical preview result.",
    resource: "python-metrics-get-python-metric-preview",
    cacheTags: ["python-metrics", "metrics"],
    pagination: null,
    action: 'get',
    versionGroup: "getPythonMetricPreview",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getPythonMetricPreview",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "cancelPythonMetricPreview": {
    method: 'POST',
    path: '/transport/python-metric-drafts/{draft_id}/previews/{preview_id}/cancel',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'cancel_python_metric_preview_request',
    responseSchema: 'python_metric_previews_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['draft_id', 'preview_id'],
    summary: "Cancel a pending preview.",
    resource: "python-metrics",
    cacheTags: ["python-metrics", "metrics"],
    pagination: null,
    action: 'update',
    versionGroup: "cancelPythonMetricPreview",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "cancelPythonMetricPreview",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "publishPythonMetric": {
    method: 'POST',
    path: '/transport/python-metric-drafts/{draft_id}/publish',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'publish_python_metric_request',
    responseSchema: 'publish_python_metric_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['draft_id'],
    summary: "Publish the exact approved and tested draft.",
    resource: "python-metrics-publish-python-metric",
    cacheTags: ["python-metrics", "metrics"],
    pagination: null,
    action: 'create',
    versionGroup: "publishPythonMetric",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "publishPythonMetric",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listIvrTrees": {
    method: 'GET',
    path: '/transport/ivr-trees',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_ivr_trees_request',
    responseSchema: 'list_ivr_trees_response',
    requestByAlias: true,
    responseByAlias: true,
    pathParams: [],
    summary: "List IVR flows.",
    resource: "ivr_trees",
    cacheTags: ["ivr_trees"],
    pagination: { itemKey: "trees", requestTokenKey: "page_token", responseTokenKey: "next_page_token" },
    action: 'list',
    versionGroup: "listIvrTrees",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listIvrTrees",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createIvrTree": {
    method: 'POST',
    path: '/transport/ivr-trees',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_ivr_tree_request',
    responseSchema: 'ivr_tree_response',
    requestByAlias: true,
    responseByAlias: true,
    pathParams: [],
    summary: "Create an IVR flow.",
    resource: "ivr_trees",
    cacheTags: ["ivr_trees"],
    pagination: null,
    action: 'create',
    versionGroup: "createIvrTree",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createIvrTree",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getIvrTree": {
    method: 'GET',
    path: '/transport/ivr-trees/{tree_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'ivr_tree_response',
    requestByAlias: false,
    responseByAlias: true,
    pathParams: ['tree_id'],
    summary: "Read an IVR flow.",
    resource: "ivr_trees",
    cacheTags: ["ivr_trees"],
    pagination: null,
    action: 'get',
    versionGroup: "getIvrTree",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getIvrTree",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateIvrTree": {
    method: 'PUT',
    path: '/transport/ivr-trees/{tree_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_ivr_tree_request',
    responseSchema: 'ivr_tree_response',
    requestByAlias: true,
    responseByAlias: true,
    pathParams: ['tree_id'],
    summary: "Replace the stored IVR graph.",
    resource: "ivr_trees",
    cacheTags: ["ivr_trees"],
    pagination: null,
    action: 'update',
    versionGroup: "updateIvrTree",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateIvrTree",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteIvrTree": {
    method: 'DELETE',
    path: '/transport/ivr-trees/{tree_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'delete_ivr_tree_response',
    requestByAlias: false,
    responseByAlias: true,
    pathParams: ['tree_id'],
    summary: "Soft-delete an IVR flow.",
    resource: "ivr_trees",
    cacheTags: ["ivr_trees"],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteIvrTree",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteIvrTree",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "health": {
    method: 'GET',
    path: '/transport/healthz',
    auth: 'none',
    databaseAccess: 'none',
    organizationRequired: false,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'health_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Liveness probe for the transport service.",
    resource: "healthz",
    cacheTags: [],
    pagination: null,
    action: 'query',
    versionGroup: "health",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "health",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getHealthStatus": {
    method: 'GET',
    path: '/transport/health/status',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'get_health_status_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch recent simulation and monitoring queue health for the current organization.",
    resource: "health",
    cacheTags: ["health"],
    pagination: null,
    action: 'get',
    versionGroup: "getHealthStatus",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getHealthStatus",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getSystemStatus": {
    method: 'GET',
    path: '/transport/system/status',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'get_system_status_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch customer-facing service status from the incident.io status-page source of truth.",
    resource: "system-status",
    cacheTags: ["system-status"],
    pagination: null,
    action: 'get',
    versionGroup: "getSystemStatus",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getSystemStatus",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getFdeSupportStatus": {
    method: 'GET',
    path: '/transport/health/support',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'get_fde_support_status_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Report whether the current organization can page FDE support.",
    resource: "fde-support",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getFdeSupportStatus",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getFdeSupportStatus",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "pageFdeSupport": {
    method: 'POST',
    path: '/transport/health/support/page',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'page_fde_support_request',
    responseSchema: 'page_fde_support_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Page the customer-facing FDE rotation for an allowlisted organization.",
    resource: "fde-support",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "pageFdeSupport",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "pageFdeSupport",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "bootstrap": {
    method: 'GET',
    path: '/transport/bootstrap',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'bootstrap_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Bootstrap authenticated transport context for the current user.",
    resource: "bootstrap",
    cacheTags: [],
    pagination: null,
    action: 'query',
    versionGroup: "bootstrap",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "bootstrap",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getAccountDeletionImpact": {
    method: 'GET',
    path: '/transport/account/deletion-impact',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'get_account_deletion_impact_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Evaluate organization billing effects before deleting the authenticated account.",
    resource: "account",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getAccountDeletionImpact",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getAccountDeletionImpact",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteAccount": {
    method: 'POST',
    path: '/transport/account/delete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'delete_account_request',
    responseSchema: 'delete_account_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Delete the authenticated account after revalidating its confirmed billing effects.",
    resource: "account",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteAccount",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteAccount",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminListOrganizations": {
    method: 'GET',
    path: '/transport/admin/organizations',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'query',
    requestSchema: 'admin_list_organizations_request',
    responseSchema: 'admin_list_organizations_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List organizations for Coval admin organization management.",
    resource: "admin-organizations",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "adminListOrganizations",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminListOrganizations",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listAdminDataFrames": {
    method: 'GET',
    path: '/transport/admin/data-frames',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'admin_list_data_frames_request',
    responseSchema: 'admin_list_data_frames_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List one bounded Data Frame table for a particular simulation run. Coval-admin access required.",
    resource: "admin-data-frames",
    cacheTags: [],
    pagination: { itemKey: "rows", requestTokenKey: "cursor", responseTokenKey: "next_cursor" },
    action: 'list',
    versionGroup: "listAdminDataFrames",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listAdminDataFrames",
    deprecationMessage: null,
    replacementOperation: null,
  },
  /** @deprecated Use listSimulationDataFrames; this compatibility alias remains supported. Use listSimulationDataFrames instead. */
  "listAdminSimulationDataFrames": {
    method: 'GET',
    path: '/transport/admin/simulation-data-frames',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'admin_list_simulation_data_frames_request',
    responseSchema: 'admin_list_simulation_data_frames_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Compatibility alias for listSimulationDataFrames. Conversation access in the selected workspace is required.",
    resource: "admin-data-frames-list-admin-simulation-data-frames",
    cacheTags: [],
    pagination: { itemKey: "tables", requestTokenKey: "cursor", responseTokenKey: "next_cursor" },
    action: 'list',
    versionGroup: "listAdminSimulationDataFrames",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listAdminSimulationDataFrames",
    deprecationMessage: "Use listSimulationDataFrames; this compatibility alias remains supported.",
    replacementOperation: "listSimulationDataFrames",
  },
  "listSimulationDataFrames": {
    method: 'GET',
    path: '/transport/simulation-data-frames',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_simulation_data_frames_request',
    responseSchema: 'list_simulation_data_frames_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List Data Frame tables for a conversation accessible in the selected workspace.",
    resource: "simulation-data-frames",
    cacheTags: [],
    pagination: { itemKey: "tables", requestTokenKey: "cursor", responseTokenKey: "next_cursor" },
    action: 'list',
    versionGroup: "listSimulationDataFrames",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listSimulationDataFrames",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminListOrganizationPlans": {
    method: 'GET',
    path: '/transport/admin/organizations/plans',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'admin_list_organization_plans_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List distinct organization plan values for Coval admin filters.",
    resource: "admin-organization-plans",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "adminListOrganizationPlans",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminListOrganizationPlans",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminGetOrganization": {
    method: 'GET',
    path: '/transport/admin/organizations/get',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'query',
    requestSchema: 'admin_get_organization_request',
    responseSchema: 'admin_get_organization_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch an organization record for Coval admin organization management.",
    resource: "admin-organizations",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "adminGetOrganization",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminGetOrganization",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminGetOrganizationUsage": {
    method: 'GET',
    path: '/transport/admin/organizations/usage',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'query',
    requestSchema: 'admin_get_organization_usage_request',
    responseSchema: 'admin_get_organization_usage_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch current and historical billing usage for an organization as a Coval admin.",
    resource: "admin-organization-usage",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "adminGetOrganizationUsage",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminGetOrganizationUsage",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminGetCustomerHealthOverview": {
    method: 'GET',
    path: '/transport/admin/customer-health',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'query',
    requestSchema: 'admin_customer_health_overview_request',
    responseSchema: 'admin_customer_health_overview_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch a bounded customer health overview as a Coval admin.",
    resource: "admin-customer-health",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "adminGetCustomerHealthOverview",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminGetCustomerHealthOverview",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminGetCustomerHealthDetail": {
    method: 'GET',
    path: '/transport/admin/customer-health/{organization_id}',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'path',
    requestSchema: 'admin_get_customer_health_detail_request',
    responseSchema: 'admin_get_customer_health_detail_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['organization_id'],
    summary: "Fetch simulation activity and failure detail for an organization as a Coval admin.",
    resource: "admin-customer-health-detail",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "adminGetCustomerHealthDetail",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminGetCustomerHealthDetail",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminGetCustomerHealthExternalSignals": {
    method: 'GET',
    path: '/transport/admin/customer-health/accounts/{account_id}/external-signals',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'path',
    requestSchema: 'admin_get_customer_health_external_signals_request',
    responseSchema: 'admin_get_customer_health_external_signals_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['account_id'],
    summary: "Read external provider signals for one HubSpot-managed Customer Health account.",
    resource: "admin-customer-health-external-signals",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "adminGetCustomerHealthExternalSignals",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminGetCustomerHealthExternalSignals",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminGetCustomerHealthSlackSummary": {
    method: 'GET',
    path: '/transport/admin/customer-health/slack-summary',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'query',
    requestSchema: 'admin_get_customer_health_slack_summary_request',
    responseSchema: 'admin_get_customer_health_slack_summary_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Read unanswered Slack messages across mapped HubSpot-managed accounts.",
    resource: "admin-customer-health-slack-summary",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "adminGetCustomerHealthSlackSummary",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminGetCustomerHealthSlackSummary",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminListCustomerHealthAccounts": {
    method: 'GET',
    path: '/transport/admin/customer-health/accounts',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'query',
    requestSchema: 'admin_list_customer_health_accounts_request',
    responseSchema: 'admin_list_customer_health_accounts_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List HubSpot-managed Customer Health accounts with Coval platform activity.",
    resource: "admin-customer-health-account",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "adminListCustomerHealthAccounts",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminListCustomerHealthAccounts",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminGetSelfServeUsageRoundup": {
    method: 'GET',
    path: '/transport/admin/organizations/self-serve-usage-roundup',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'query',
    requestSchema: 'admin_self_serve_usage_roundup_request',
    responseSchema: 'admin_self_serve_usage_roundup_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch the internal self-serve usage reporting snapshot as a Coval admin.",
    resource: "admin-self-serve-usage-roundup",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "adminGetSelfServeUsageRoundup",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminGetSelfServeUsageRoundup",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminListOrganizationApiKeys": {
    method: 'GET',
    path: '/transport/admin/organizations/api-keys',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'query',
    requestSchema: 'admin_list_organization_api_keys_request',
    responseSchema: 'admin_list_organization_api_keys_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List masked API keys for an organization as a Coval admin.",
    resource: "admin-organization-api-keys",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "adminListOrganizationApiKeys",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminListOrganizationApiKeys",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminCreateOrganizationApiKey": {
    method: 'POST',
    path: '/transport/admin/organizations/api-keys/create',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'admin_create_organization_api_key_request',
    responseSchema: 'admin_create_organization_api_key_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a service API key for an organization as a Coval admin.",
    resource: "admin-organization-api-keys",
    cacheTags: ["admin-organization-api-keys"],
    pagination: null,
    action: 'create',
    versionGroup: "adminCreateOrganizationApiKey",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminCreateOrganizationApiKey",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminUpdateOrganizationApiKeyStatus": {
    method: 'PATCH',
    path: '/transport/admin/organizations/api-keys/update-status',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'admin_update_organization_api_key_status_request',
    responseSchema: 'admin_update_organization_api_key_status_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update an organization API key status as a Coval admin.",
    resource: "admin-organization-api-keys",
    cacheTags: ["admin-organization-api-keys"],
    pagination: null,
    action: 'update',
    versionGroup: "adminUpdateOrganizationApiKeyStatus",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminUpdateOrganizationApiKeyStatus",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminDeleteOrganizationApiKey": {
    method: 'POST',
    path: '/transport/admin/organizations/api-keys/delete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'admin_delete_organization_api_key_request',
    responseSchema: 'admin_delete_organization_api_key_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Permanently delete an organization API key as a Coval admin.",
    resource: "admin-organization-api-keys",
    cacheTags: ["admin-organization-api-keys"],
    pagination: null,
    action: 'delete',
    versionGroup: "adminDeleteOrganizationApiKey",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminDeleteOrganizationApiKey",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminProvisionOrganization": {
    method: 'POST',
    path: '/transport/admin/organizations/provision',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'admin_provision_organization_request',
    responseSchema: 'admin_provision_organization_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create or update an organization's billing subscription as a Coval admin.",
    resource: "admin-organization-provisioning",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "adminProvisionOrganization",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminProvisionOrganization",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminPreviewOrganizationReconciliation": {
    method: 'POST',
    path: '/transport/admin/organizations/reconciliation-preview',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'admin_provision_organization_request',
    responseSchema: 'admin_preview_organization_reconciliation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Preview Stripe-owned values that conflict with an admin subscription update.",
    resource: "admin-organization-provisioning",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "adminPreviewOrganizationReconciliation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminPreviewOrganizationReconciliation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminUpdateSimulationTimeout": {
    method: 'POST',
    path: '/transport/admin/organizations/simulation-timeout',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'admin_update_simulation_timeout_request',
    responseSchema: 'admin_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update an organization's simulation timeout for Coval admin organization management.",
    resource: "admin-organization-simulation-timeout",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "adminUpdateSimulationTimeout",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminUpdateSimulationTimeout",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminGetEmailRecipientAllowlist": {
    method: 'GET',
    path: '/transport/admin/organizations/{organization_id}/email-recipient-allowlist',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: false,
    requestLocation: 'path',
    requestSchema: 'admin_get_email_recipient_allowlist_request',
    responseSchema: 'admin_email_recipient_allowlist_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['organization_id'],
    summary: "Read email simulator recipient approvals as a Coval admin.",
    resource: "admin-email-recipient-allowlist",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "adminGetEmailRecipientAllowlist",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminGetEmailRecipientAllowlist",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminUpdateEmailRecipientAllowlist": {
    method: 'POST',
    path: '/transport/admin/organizations/email-recipient-allowlist',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'admin_update_email_recipient_allowlist_request',
    responseSchema: 'admin_email_recipient_allowlist_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Replace email simulator recipient approvals as a Coval admin.",
    resource: "admin-email-recipient-allowlist",
    cacheTags: ["admin-email-recipient-allowlist"],
    pagination: null,
    action: 'update',
    versionGroup: "adminUpdateEmailRecipientAllowlist",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminUpdateEmailRecipientAllowlist",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminUpdateTelephonyProvider": {
    method: 'POST',
    path: '/transport/admin/organizations/telephony-provider',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'admin_update_telephony_provider_request',
    responseSchema: 'admin_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update an organization's telephony provider for Coval admin organization management.",
    resource: "admin-organization-telephony-provider",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "adminUpdateTelephonyProvider",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminUpdateTelephonyProvider",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminUpdateSofiaModel": {
    method: 'POST',
    path: '/transport/admin/organizations/sofia-model',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'admin_update_sofia_model_request',
    responseSchema: 'admin_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Pin the Sofia model and reasoning effort for Coval admin organization management.",
    resource: "admin-organization-sofia-model",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "adminUpdateSofiaModel",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminUpdateSofiaModel",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminUpdateMaxSimulationAttempts": {
    method: 'POST',
    path: '/transport/admin/organizations/max-simulation-attempts',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'admin_update_max_simulation_attempts_request',
    responseSchema: 'admin_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update an organization's max simulation attempts for Coval admin organization management.",
    resource: "admin-organization-max-simulation-attempts",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "adminUpdateMaxSimulationAttempts",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminUpdateMaxSimulationAttempts",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminUpdatePipelinePriority": {
    method: 'POST',
    path: '/transport/admin/organizations/pipeline-priority',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'admin_update_pipeline_priority_request',
    responseSchema: 'admin_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update an organization's pipeline priority for Coval admin organization management.",
    resource: "admin-organization-pipeline-priority",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "adminUpdatePipelinePriority",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminUpdatePipelinePriority",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminUpdateOrganizationWideConcurrency": {
    method: 'POST',
    path: '/transport/admin/organizations/organization-wide-concurrency',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'admin_update_organization_wide_concurrency_request',
    responseSchema: 'admin_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update an organization's global concurrency for Coval admin organization management.",
    resource: "admin-organization-wide-concurrency",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "adminUpdateOrganizationWideConcurrency",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminUpdateOrganizationWideConcurrency",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "adminUpdateMaxJobConcurrency": {
    method: 'POST',
    path: '/transport/admin/organizations/max-job-concurrency',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'admin_update_max_job_concurrency_request',
    responseSchema: 'admin_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update an organization's max job concurrency for Coval admin organization management.",
    resource: "admin-organization-max-job-concurrency",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "adminUpdateMaxJobConcurrency",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "adminUpdateMaxJobConcurrency",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getWorkOSSetupInfo": {
    method: 'GET',
    path: '/transport/workos/setup',
    auth: 'session',
    databaseAccess: 'none',
    organizationRequired: false,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'workos_setup_info_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch WorkOS setup status and configured Clerk organization mappings.",
    resource: "workos-setup",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getWorkOSSetupInfo",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getWorkOSSetupInfo",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "configureWorkOSMapping": {
    method: 'POST',
    path: '/transport/workos/setup/configure',
    auth: 'session',
    databaseAccess: 'none',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'configure_workos_mapping_request',
    responseSchema: 'configure_workos_mapping_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Configure a WorkOS organization mapping in Clerk private metadata.",
    resource: "workos-mapping",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "configureWorkOSMapping",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "configureWorkOSMapping",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listAgents": {
    method: 'GET',
    path: '/transport/agents',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_agents_request',
    responseSchema: 'list_agents_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List active agents for the current organization.",
    resource: "agents",
    cacheTags: ["agents"],
    pagination: { itemKey: "agents", requestTokenKey: "page_token", responseTokenKey: "next_page_token" },
    action: 'list',
    versionGroup: "listAgents",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listAgents",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listAllAgents": {
    method: 'GET',
    path: '/transport/agents/all',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_agents_request',
    responseSchema: 'list_agents_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List agents for the current organization, including inactive rows when requested.",
    resource: "agents-all",
    cacheTags: ["agents"],
    pagination: { itemKey: "agents", requestTokenKey: "page_token", responseTokenKey: "next_page_token" },
    action: 'list',
    versionGroup: "listAllAgents",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listAllAgents",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getAgent": {
    method: 'GET',
    path: '/transport/agents/get',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_agent_request',
    responseSchema: 'get_agent_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch an active agent in the current organization.",
    resource: "agents",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getAgent",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getAgent",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getAgentNames": {
    method: 'GET',
    path: '/transport/agents/names',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'agent_names_request',
    responseSchema: 'agent_names_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Resolve agent ids and customer agent ids to display names for the current organization.",
    resource: "agents-names",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getAgentNames",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getAgentNames",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getAgentVersions": {
    method: 'GET',
    path: '/transport/agents/versions',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_agent_versions_request',
    responseSchema: 'get_agent_versions_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List the version history for an agent visible to the current organization.",
    resource: "agent-versions",
    cacheTags: ["agents"],
    pagination: null,
    action: 'list',
    versionGroup: "getAgentVersions",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getAgentVersions",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "revertAgentVersion": {
    method: 'POST',
    path: '/transport/agents/versions/revert',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'revert_agent_version_request',
    responseSchema: 'revert_agent_version_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Revert an agent to one of its prior versions.",
    resource: "agents",
    cacheTags: ["agents"],
    pagination: null,
    action: 'update',
    versionGroup: "revertAgentVersion",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "revertAgentVersion",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createAgent": {
    method: 'POST',
    path: '/transport/agents/create',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_agent_request',
    responseSchema: 'create_agent_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create an agent for the current organization.",
    resource: "agents",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "createAgent",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createAgent",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "duplicateAgent": {
    method: 'POST',
    path: '/transport/agents/duplicate',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'duplicate_agent_request',
    responseSchema: 'duplicate_agent_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Duplicate an agent for the current organization.",
    resource: "agents",
    cacheTags: ["agents"],
    pagination: null,
    action: 'duplicate',
    versionGroup: "duplicateAgent",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "duplicateAgent",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "testAgentConnection": {
    method: 'POST',
    path: '/transport/agents/test-connection',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'test_agent_connection_request',
    responseSchema: 'test_agent_connection_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Probe an agent endpoint connection for the current organization.",
    resource: "agents",
    cacheTags: [],
    pagination: null,
    action: 'run',
    versionGroup: "testAgentConnection",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "testAgentConnection",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateAgent": {
    method: 'PATCH',
    path: '/transport/agents/update',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_agent_request',
    responseSchema: 'update_agent_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update an agent in the current organization.",
    resource: "agents-update-agent",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateAgent",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateAgent",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteAgent": {
    method: 'POST',
    path: '/transport/agents/delete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'delete_agent_request',
    responseSchema: 'delete_agent_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Soft-delete an agent in the current organization.",
    resource: "agents",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteAgent",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteAgent",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteAgents": {
    method: 'POST',
    path: '/transport/agents:batchDelete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'delete_agents_request',
    responseSchema: 'delete_agents_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Delete up to 100 agents independently and return per-ID outcomes.",
    resource: "agents-batch",
    cacheTags: ["agents"],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteAgents",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteAgents",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "addAgentMetrics": {
    method: 'POST',
    path: '/transport/agents/metrics/add',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'add_agent_metrics_request',
    responseSchema: 'agent_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Add metric associations to an agent.",
    resource: "agents-metrics",
    cacheTags: [],
    pagination: null,
    action: 'set',
    versionGroup: "addAgentMetrics",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "addAgentMetrics",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "removeAgentMetric": {
    method: 'POST',
    path: '/transport/agents/metrics/remove',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'remove_agent_metric_request',
    responseSchema: 'agent_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Remove a metric association from an agent.",
    resource: "agents-metrics",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "removeAgentMetric",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "removeAgentMetric",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "setAgentMetrics": {
    method: 'POST',
    path: '/transport/agents/metrics/set',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'set_agent_metrics_request',
    responseSchema: 'agent_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Replace an agent's metric associations.",
    resource: "agents-metrics-set-agent-metrics",
    cacheTags: [],
    pagination: null,
    action: 'set',
    versionGroup: "setAgentMetrics",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "setAgentMetrics",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "addAgentWorkflow": {
    method: 'POST',
    path: '/transport/agents/workflows/add',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'add_agent_workflow_request',
    responseSchema: 'agent_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Add or replace a workflow on an agent.",
    resource: "agents-workflows",
    cacheTags: [],
    pagination: null,
    action: 'set',
    versionGroup: "addAgentWorkflow",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "addAgentWorkflow",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "removeAgentWorkflow": {
    method: 'POST',
    path: '/transport/agents/workflows/remove',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'remove_agent_workflow_request',
    responseSchema: 'agent_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Remove a workflow from an agent.",
    resource: "agents-workflows",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "removeAgentWorkflow",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "removeAgentWorkflow",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listRecentlyDeletedAgents": {
    method: 'GET',
    path: '/transport/agents/recently-deleted',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'list_recently_deleted_agents_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List Recently Deleted agents by workspace; default includes legacy NULL rows; unresolved is empty.",
    resource: "agents-list-recently-deleted-agents",
    cacheTags: ["agents"],
    pagination: null,
    action: 'list',
    versionGroup: "listRecentlyDeletedAgents",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listRecentlyDeletedAgents",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "restoreAgent": {
    method: 'POST',
    path: '/transport/agents/restore',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'restore_agent_request',
    responseSchema: 'restore_agent_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Restore a workspace agent; default includes legacy NULL-workspace rows; unresolved returns 404.",
    resource: "agents-restore-agent",
    cacheTags: ["agents"],
    pagination: null,
    action: 'update',
    versionGroup: "restoreAgent",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "restoreAgent",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listAgentMutations": {
    method: 'GET',
    path: '/transport/agent-mutations',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_agent_mutations_request',
    responseSchema: 'list_agent_mutations_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List active agent mutations for an agent in the current organization.",
    resource: "agent-mutations",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listAgentMutations",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listAgentMutations",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listAllAgentMutations": {
    method: 'GET',
    path: '/transport/agent-mutations/all',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'list_all_agent_mutations_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List active agent mutations across the current organization.",
    resource: "agent-mutations-all",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listAllAgentMutations",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listAllAgentMutations",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getAgentMutation": {
    method: 'GET',
    path: '/transport/agent-mutations/get',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_agent_mutation_request',
    responseSchema: 'get_agent_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch active agent mutation rows by agent and mutation id.",
    resource: "agent-mutations",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getAgentMutation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getAgentMutation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createAgentMutation": {
    method: 'POST',
    path: '/transport/agent-mutations/create',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_agent_mutation_request',
    responseSchema: 'create_agent_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create an agent mutation for the current organization.",
    resource: "agent-mutations",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "createAgentMutation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createAgentMutation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateAgentMutation": {
    method: 'PATCH',
    path: '/transport/agent-mutations/update',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_agent_mutation_request',
    responseSchema: 'update_agent_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update an agent mutation for the current organization.",
    resource: "agent-mutations",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateAgentMutation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateAgentMutation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "archiveAgentMutation": {
    method: 'POST',
    path: '/transport/agent-mutations/archive',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'archive_agent_mutation_request',
    responseSchema: 'archive_agent_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Archive an agent mutation for the current organization.",
    resource: "agent-mutations",
    cacheTags: [],
    pagination: null,
    action: 'archive',
    versionGroup: "archiveAgentMutation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "archiveAgentMutation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listBaselines": {
    method: 'GET',
    path: '/transport/baselines',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_baselines_request',
    responseSchema: 'list_baselines_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List baselines for a metric in the current organization.",
    resource: "baselines",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listBaselines",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listBaselines",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getBaseline": {
    method: 'GET',
    path: '/transport/baselines/get',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_baseline_request',
    responseSchema: 'get_baseline_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Retrieve a baseline by metric and ULID for the current organization.",
    resource: "baselines",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getBaseline",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getBaseline",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createBaseline": {
    method: 'POST',
    path: '/transport/baselines/create',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_baseline_request',
    responseSchema: 'create_baseline_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a baseline for a metric in the current organization.",
    resource: "baselines",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "createBaseline",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createBaseline",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateBaseline": {
    method: 'PATCH',
    path: '/transport/baselines/update',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_baseline_request',
    responseSchema: 'update_baseline_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update a baseline for a metric in the current organization.",
    resource: "baselines",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateBaseline",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateBaseline",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "archiveBaseline": {
    method: 'POST',
    path: '/transport/baselines/archive',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'archive_baseline_request',
    responseSchema: 'archive_baseline_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Archive a baseline for a metric in the current organization.",
    resource: "baselines",
    cacheTags: [],
    pagination: null,
    action: 'archive',
    versionGroup: "archiveBaseline",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "archiveBaseline",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getBaselineHistory": {
    method: 'GET',
    path: '/transport/baselines/history',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'baseline_history_request',
    responseSchema: 'baseline_history_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch baseline mean and sigma history for dashboard overlays.",
    resource: "baselines-history",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getBaselineHistory",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getBaselineHistory",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getBaselineDeviationsBySimulation": {
    method: 'POST',
    path: '/transport/baselines/deviations-by-simulation',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'baseline_deviations_by_simulation_request',
    responseSchema: 'baseline_deviations_by_simulation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch processed baseline deviation sigmas for dashboard drilldowns.",
    resource: "baselines-deviations-by-simulation",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getBaselineDeviationsBySimulation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getBaselineDeviationsBySimulation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listBenchmarkDatasets": {
    method: 'GET',
    path: '/transport/benchmarks/datasets',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_benchmark_datasets_request',
    responseSchema: 'list_benchmark_datasets_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List benchmark datasets for the current organization.",
    resource: "benchmarks-datasets",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listBenchmarkDatasets",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listBenchmarkDatasets",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getBenchmarkDataset": {
    method: 'GET',
    path: '/transport/benchmarks/datasets/{dataset_id}',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'get_benchmark_dataset_request',
    responseSchema: 'benchmark_dataset_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['dataset_id'],
    summary: "Fetch a benchmark dataset for the current organization.",
    resource: "benchmarks-datasets",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getBenchmarkDataset",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getBenchmarkDataset",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createBenchmarkDataset": {
    method: 'POST',
    path: '/transport/benchmarks/datasets',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_benchmark_dataset_request',
    responseSchema: 'benchmark_dataset_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a benchmark dataset for the current organization.",
    resource: "benchmarks-datasets",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "createBenchmarkDataset",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createBenchmarkDataset",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateBenchmarkDataset": {
    method: 'PATCH',
    path: '/transport/benchmarks/datasets/{dataset_id}/update',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_benchmark_dataset_request',
    responseSchema: 'benchmark_dataset_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['dataset_id'],
    summary: "Update a benchmark dataset for the current organization.",
    resource: "benchmarks-datasets",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateBenchmarkDataset",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateBenchmarkDataset",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteBenchmarkDataset": {
    method: 'DELETE',
    path: '/transport/benchmarks/datasets/{dataset_id}/delete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'delete_benchmark_dataset_request',
    responseSchema: 'benchmark_dataset_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['dataset_id'],
    summary: "Archive a benchmark dataset for the current organization.",
    resource: "benchmarks-datasets",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteBenchmarkDataset",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteBenchmarkDataset",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getBenchmarkDatasetUploadUrl": {
    method: 'POST',
    path: '/transport/benchmarks/datasets/{dataset_id}/items/upload',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'benchmark_dataset_upload_url_request',
    responseSchema: 'benchmark_dataset_upload_url_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['dataset_id'],
    summary: "Generate a signed upload URL for a benchmark dataset item audio file.",
    resource: "benchmarks-datasets-items",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getBenchmarkDatasetUploadUrl",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getBenchmarkDatasetUploadUrl",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listBenchmarkDatasetItems": {
    method: 'GET',
    path: '/transport/benchmarks/datasets/{dataset_id}/items',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_benchmark_dataset_items_request',
    responseSchema: 'list_benchmark_dataset_items_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['dataset_id'],
    summary: "List benchmark dataset items for the current organization.",
    resource: "benchmarks-datasets-items",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listBenchmarkDatasetItems",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listBenchmarkDatasetItems",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getBenchmarkDatasetItem": {
    method: 'GET',
    path: '/transport/benchmarks/dataset-items/{item_id}',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'get_benchmark_dataset_item_request',
    responseSchema: 'benchmark_dataset_item_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['item_id'],
    summary: "Fetch a benchmark dataset item for the current organization.",
    resource: "benchmarks-dataset-items",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getBenchmarkDatasetItem",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getBenchmarkDatasetItem",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "addBenchmarkDatasetItem": {
    method: 'POST',
    path: '/transport/benchmarks/datasets/{dataset_id}/items/add',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'add_benchmark_dataset_item_request',
    responseSchema: 'benchmark_dataset_item_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['dataset_id'],
    summary: "Add an item to a benchmark dataset for the current organization.",
    resource: "benchmarks-datasets-items",
    cacheTags: [],
    pagination: null,
    action: 'set',
    versionGroup: "addBenchmarkDatasetItem",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "addBenchmarkDatasetItem",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateBenchmarkDatasetItem": {
    method: 'PATCH',
    path: '/transport/benchmarks/dataset-items/{item_id}/update',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_benchmark_dataset_item_request',
    responseSchema: 'benchmark_dataset_item_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['item_id'],
    summary: "Update a benchmark dataset item for the current organization.",
    resource: "benchmarks-dataset-items",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateBenchmarkDatasetItem",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateBenchmarkDatasetItem",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteBenchmarkDatasetItem": {
    method: 'DELETE',
    path: '/transport/benchmarks/datasets/{dataset_id}/items/{item_id}/delete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'delete_benchmark_dataset_item_request',
    responseSchema: 'benchmark_dataset_item_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['dataset_id', 'item_id'],
    summary: "Archive a benchmark dataset item for the current organization.",
    resource: "benchmarks-datasets-items",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteBenchmarkDatasetItem",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteBenchmarkDatasetItem",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listBenchmarkEndpoints": {
    method: 'GET',
    path: '/transport/benchmarks/provider-endpoints',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_benchmark_endpoints_request',
    responseSchema: 'list_benchmark_endpoints_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List benchmark provider endpoints for the current organization.",
    resource: "benchmarks-provider-endpoints",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listBenchmarkEndpoints",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listBenchmarkEndpoints",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getBenchmarkEndpoint": {
    method: 'GET',
    path: '/transport/benchmarks/provider-endpoints/{endpoint_id}',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'get_benchmark_endpoint_request',
    responseSchema: 'benchmark_endpoint_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['endpoint_id'],
    summary: "Fetch a benchmark provider endpoint for the current organization.",
    resource: "benchmarks-provider-endpoints",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getBenchmarkEndpoint",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getBenchmarkEndpoint",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getBenchmarkEndpointsByIds": {
    method: 'POST',
    path: '/transport/benchmarks/provider-endpoints/by-ids',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'get_benchmark_endpoints_by_ids_request',
    responseSchema: 'benchmark_endpoints_by_ids_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch benchmark provider endpoints by ID for the current organization.",
    resource: "benchmarks-provider-endpoints-by-ids",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getBenchmarkEndpointsByIds",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getBenchmarkEndpointsByIds",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createBenchmarkEndpoint": {
    method: 'POST',
    path: '/transport/benchmarks/provider-endpoints',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_benchmark_endpoint_request',
    responseSchema: 'benchmark_endpoint_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a benchmark provider endpoint for the current organization.",
    resource: "benchmarks-provider-endpoints",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "createBenchmarkEndpoint",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createBenchmarkEndpoint",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateBenchmarkEndpoint": {
    method: 'PATCH',
    path: '/transport/benchmarks/provider-endpoints/{endpoint_id}/update',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_benchmark_endpoint_request',
    responseSchema: 'benchmark_endpoint_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['endpoint_id'],
    summary: "Update a benchmark provider endpoint for the current organization.",
    resource: "benchmarks-provider-endpoints",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateBenchmarkEndpoint",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateBenchmarkEndpoint",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteBenchmarkEndpoint": {
    method: 'DELETE',
    path: '/transport/benchmarks/provider-endpoints/{endpoint_id}/delete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'delete_benchmark_endpoint_request',
    responseSchema: 'benchmark_endpoint_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['endpoint_id'],
    summary: "Archive a benchmark provider endpoint for the current organization.",
    resource: "benchmarks-provider-endpoints",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteBenchmarkEndpoint",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteBenchmarkEndpoint",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "testBenchmarkEndpoint": {
    method: 'POST',
    path: '/transport/benchmarks/provider-endpoints/{endpoint_id}/test',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'get_benchmark_endpoint_request',
    responseSchema: 'benchmark_endpoint_test_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['endpoint_id'],
    summary: "Smoke-test a benchmark provider endpoint for the current organization.",
    resource: "benchmarks-provider-endpoints",
    cacheTags: [],
    pagination: null,
    action: 'run',
    versionGroup: "testBenchmarkEndpoint",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "testBenchmarkEndpoint",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listBenchmarkRuns": {
    method: 'GET',
    path: '/transport/benchmarks/runs',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_benchmark_runs_request',
    responseSchema: 'list_benchmark_runs_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List benchmark runs for the current organization.",
    resource: "benchmarks-runs",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listBenchmarkRuns",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listBenchmarkRuns",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getBenchmarkRun": {
    method: 'GET',
    path: '/transport/benchmarks/runs/{run_id}',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'get_benchmark_run_request',
    responseSchema: 'benchmark_run_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['run_id'],
    summary: "Fetch a benchmark run for the current organization.",
    resource: "benchmarks-runs",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getBenchmarkRun",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getBenchmarkRun",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createBenchmarkRun": {
    method: 'POST',
    path: '/transport/benchmarks/runs',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_benchmark_run_request',
    responseSchema: 'benchmark_run_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create and enqueue a benchmark run for the current organization.",
    resource: "benchmarks-runs",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "createBenchmarkRun",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createBenchmarkRun",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "cancelBenchmarkRun": {
    method: 'POST',
    path: '/transport/benchmarks/runs/{run_id}/cancel',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'cancel_benchmark_run_request',
    responseSchema: 'benchmark_run_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['run_id'],
    summary: "Cancel a pending, queued, or running benchmark run for the current organization.",
    resource: "benchmarks-runs",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "cancelBenchmarkRun",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "cancelBenchmarkRun",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listBenchmarkResults": {
    method: 'GET',
    path: '/transport/benchmarks/runs/{run_id}/results',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_benchmark_results_request',
    responseSchema: 'list_benchmark_results_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['run_id'],
    summary: "List benchmark run results for the current organization.",
    resource: "benchmarks-runs-results",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listBenchmarkResults",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listBenchmarkResults",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getBenchmarkAudioSignedUrl": {
    method: 'GET',
    path: '/transport/benchmarks/audio/signed-url',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'benchmark_audio_signed_url_request',
    responseSchema: 'benchmark_audio_signed_url_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Generate a signed read URL for an organization-owned benchmark result audio object.",
    resource: "benchmarks-audio-signed-url",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getBenchmarkAudioSignedUrl",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getBenchmarkAudioSignedUrl",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listApiKeys": {
    method: 'GET',
    path: '/transport/api-keys',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_api_keys_transport_request',
    responseSchema: 'list_api_keys_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List API keys for the current organization.",
    resource: "api-keys",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listApiKeys",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listApiKeys",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createApiKey": {
    method: 'POST',
    path: '/transport/api-keys/create',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_api_key_transport_request',
    responseSchema: 'create_api_key_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create an API key for the current organization.",
    resource: "api-keys",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "createApiKey",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createApiKey",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createGithubFixIntent": {
    method: 'POST',
    path: '/transport/github-fix-intents',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_github_fix_intent_transport_request',
    responseSchema: 'create_github_fix_intent_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Confirm an exact customer GitHub fix with a fresh human administrator session.",
    resource: "github-fix-intents",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "createGithubFixIntent",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createGithubFixIntent",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateApiKeyStatus": {
    method: 'PATCH',
    path: '/transport/api-keys/update-status',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_api_key_status_transport_request',
    responseSchema: 'update_api_key_status_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update an API key status for the current organization.",
    resource: "api-keys-update-status",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateApiKeyStatus",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateApiKeyStatus",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteApiKey": {
    method: 'POST',
    path: '/transport/api-keys/delete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'delete_api_key_transport_request',
    responseSchema: 'delete_api_key_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Delete an API key for the current organization.",
    resource: "api-keys",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteApiKey",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteApiKey",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getAudioSignedUrl": {
    method: 'GET',
    path: '/transport/audio/signed-url',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'audio_signed_url_request',
    responseSchema: 'audio_signed_url_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Generate a signed read URL for an organization-visible audio object.",
    resource: "audio-signed-url",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getAudioSignedUrl",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getAudioSignedUrl",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getPublicAudioSignedUrl": {
    method: 'POST',
    path: '/transport/audio/public-signed-url',
    auth: 'none',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'public_audio_signed_url_request',
    responseSchema: 'audio_signed_url_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Generate a signed read URL for public or Coval benchmark audio.",
    resource: "audio-public-signed-url",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getPublicAudioSignedUrl",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getPublicAudioSignedUrl",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "uploadAudio": {
    method: 'POST',
    path: '/transport/audio/upload',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'upload_audio_request',
    responseSchema: 'upload_audio_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Upload audio bytes or fetched URL content into org-scoped audio storage.",
    resource: "audio",
    cacheTags: [],
    pagination: null,
    action: 'upload',
    versionGroup: "uploadAudio",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "uploadAudio",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "processAudio": {
    method: 'POST',
    path: '/transport/audio/process',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'process_audio_request',
    responseSchema: 'process_audio_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Submit an uploaded audio object to the eval audio processing API.",
    resource: "audio-process",
    cacheTags: [],
    pagination: null,
    action: 'run',
    versionGroup: "processAudio",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "processAudio",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createOnboardingAudioJob": {
    method: 'POST',
    path: '/transport/onboarding/audio-jobs',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_onboarding_audio_job_request',
    responseSchema: 'create_onboarding_audio_job_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a workspace-owned recording upload intent.",
    resource: "onboarding-audio-job",
    cacheTags: ["onboarding-audio-job"],
    pagination: null,
    action: 'create',
    versionGroup: "createOnboardingAudioJob",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createOnboardingAudioJob",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "startOnboardingAudioJob": {
    method: 'POST',
    path: '/transport/onboarding/audio-jobs:start',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'onboarding_audio_job_request',
    responseSchema: 'onboarding_audio_job_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Start or redrive one uploaded recording.",
    resource: "onboarding-audio-job",
    cacheTags: ["onboarding-audio-job", "uploaded-conversation", "test-set"],
    pagination: null,
    action: 'run',
    versionGroup: "startOnboardingAudioJob",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "startOnboardingAudioJob",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getOnboardingAudioJob": {
    method: 'GET',
    path: '/transport/onboarding/audio-jobs/status',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'onboarding_audio_job_request',
    responseSchema: 'onboarding_audio_job_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Read processing progress and persisted result identities.",
    resource: "onboarding-audio-job",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getOnboardingAudioJob",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getOnboardingAudioJob",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "submitUploadedConversation": {
    method: 'POST',
    path: '/transport/uploaded-conversations/submit',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'submit_uploaded_conversation_request',
    responseSchema: 'submit_uploaded_conversation_response',
    requestByAlias: true,
    responseByAlias: false,
    pathParams: [],
    summary: "Submit an uploaded conversation.",
    resource: "uploaded-conversation",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "submitUploadedConversation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "submitUploadedConversation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "uploadTracesForUploadedConversation": {
    method: 'POST',
    path: '/transport/uploaded-conversations/traces',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'upload_traces_for_uploaded_conversation_request',
    responseSchema: 'upload_traces_for_uploaded_conversation_response',
    requestByAlias: true,
    responseByAlias: false,
    pathParams: [],
    summary: "Upload Otel traces for an uploaded conversation.",
    resource: "uploaded-conversation-traces",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "uploadTracesForUploadedConversation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "uploadTracesForUploadedConversation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "queryUploadedConversationKeyset": {
    method: 'POST',
    path: '/transport/uploaded-conversations/keyset',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'uploaded_conversation_keyset_request',
    responseSchema: 'uploaded_conversation_keyset_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List uploaded conversation result rows with keyset pagination.",
    resource: "uploaded-conversation-results",
    cacheTags: ["conversation-results"],
    pagination: { itemKey: "items", requestTokenKey: "cursor", responseTokenKey: "next_cursor" },
    action: 'list',
    versionGroup: "queryUploadedConversationKeyset",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "queryUploadedConversationKeyset",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getUploadedConversationMetadata": {
    method: 'GET',
    path: '/transport/uploaded-conversations/metadata',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'uploaded_conversation_metadata_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch available uploaded conversation metadata keys and values.",
    resource: "uploaded-conversations-metadata",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getUploadedConversationMetadata",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getUploadedConversationMetadata",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getUploadedConversationMetricStringValues": {
    method: 'GET',
    path: '/transport/uploaded-conversations/metric-string-values',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'uploaded_conversation_metric_string_values_request',
    responseSchema: 'uploaded_conversation_metric_string_values_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch distinct string metric values for uploaded conversations.",
    resource: "uploaded-conversations-metric-string-values",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getUploadedConversationMetricStringValues",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getUploadedConversationMetricStringValues",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getUploadedConversationNavigationContext": {
    method: 'POST',
    path: '/transport/uploaded-conversations/navigation-context',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'uploaded_conversation_navigation_request',
    responseSchema: 'uploaded_conversation_navigation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch adjacent uploaded conversation ids for a result.",
    resource: "uploaded-conversations-navigation-context",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getUploadedConversationNavigationContext",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getUploadedConversationNavigationContext",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getUploadedConversationReportRows": {
    method: 'POST',
    path: '/transport/uploaded-conversations/report-rows',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'uploaded_conversation_report_rows_request',
    responseSchema: 'uploaded_conversation_report_rows_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch uploaded conversation rows in report-compatible shape.",
    resource: "uploaded-conversations-report-rows",
    cacheTags: [],
    pagination: { itemKey: "rows", requestTokenKey: "cursor", responseTokenKey: "next_cursor" },
    action: 'get',
    versionGroup: "getUploadedConversationReportRows",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getUploadedConversationReportRows",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "findUploadedConversationRecordingFile": {
    method: 'POST',
    path: '/transport/uploaded-conversations/recording-file',
    auth: 'session',
    databaseAccess: 'none',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'find_uploaded_conversation_recording_file_request',
    responseSchema: 'find_uploaded_conversation_recording_file_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Find the completed stereo recording file for an uploaded conversation call.",
    resource: "uploaded-conversation-recordings",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "findUploadedConversationRecordingFile",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "findUploadedConversationRecordingFile",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getAudioPeaksUrl": {
    method: 'GET',
    path: '/transport/audio/peaks-url',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'audio_signed_url_request',
    responseSchema: 'audio_signed_url_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Generate a signed read URL for precomputed audio peaks.",
    resource: "audio-peaks-url",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getAudioPeaksUrl",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getAudioPeaksUrl",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getAudioUploadUrl": {
    method: 'POST',
    path: '/transport/audio/upload-url',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'get_audio_upload_url_request',
    responseSchema: 'get_audio_upload_url_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Generate a short-lived signed PUT URL for direct audio upload.",
    resource: "audio-upload-url",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getAudioUploadUrl",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getAudioUploadUrl",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "homeActivation": {
    method: 'GET',
    path: '/transport/home/activation',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'home_activation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch workspace-scoped Home setup counts and evaluation activity.",
    resource: "home-activation",
    cacheTags: [],
    pagination: null,
    action: 'query',
    versionGroup: "homeActivation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "homeActivation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "homeDigest": {
    method: 'GET',
    path: '/transport/home/digest',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'home_digest_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch the deprecated Home digest compatibility response.",
    resource: "home-digest",
    cacheTags: [],
    pagination: null,
    action: 'query',
    versionGroup: "homeDigest",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "homeDigest",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listKnowledgeBaseEntries": {
    method: 'GET',
    path: '/transport/knowledge-base',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_knowledge_base_entries_request',
    responseSchema: 'list_knowledge_base_entries_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List knowledge base entries for an agent.",
    resource: "knowledge-base",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listKnowledgeBaseEntries",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listKnowledgeBaseEntries",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listKnowledgeBaseEntriesByTestSet": {
    method: 'GET',
    path: '/transport/knowledge-base/by-test-set',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_knowledge_base_entries_by_test_set_request',
    responseSchema: 'list_knowledge_base_entries_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List knowledge base entries attached to a test set.",
    resource: "knowledge-base-by-test-set",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listKnowledgeBaseEntriesByTestSet",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listKnowledgeBaseEntriesByTestSet",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createKnowledgeBaseEntry": {
    method: 'POST',
    path: '/transport/knowledge-base/create',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'knowledge_base_entry_request',
    responseSchema: 'knowledge_base_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a knowledge base entry.",
    resource: "knowledge-base",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "createKnowledgeBaseEntry",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createKnowledgeBaseEntry",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createTestSetFromKnowledgeBaseScenarios": {
    method: 'POST',
    path: '/transport/knowledge-base/create-test-set-from-scenarios',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_test_set_from_knowledge_base_scenarios_request',
    responseSchema: 'create_test_set_from_knowledge_base_scenarios_response',
    requestByAlias: true,
    responseByAlias: true,
    pathParams: [],
    summary: "Create a scenario test set from extracted knowledge base scenarios.",
    resource: "knowledge-base-create-test-set-from-scenarios",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "createTestSetFromKnowledgeBaseScenarios",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createTestSetFromKnowledgeBaseScenarios",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateKnowledgeBaseEntry": {
    method: 'PATCH',
    path: '/transport/knowledge-base/update',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'knowledge_base_entry_update_request',
    responseSchema: 'knowledge_base_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update a knowledge base entry.",
    resource: "knowledge-base",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateKnowledgeBaseEntry",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateKnowledgeBaseEntry",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteKnowledgeBaseEntry": {
    method: 'POST',
    path: '/transport/knowledge-base/delete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'delete_knowledge_base_entry_request',
    responseSchema: 'knowledge_base_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Delete a knowledge base entry.",
    resource: "knowledge-base",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteKnowledgeBaseEntry",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteKnowledgeBaseEntry",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getKnowledgeBaseUploadUrl": {
    method: 'POST',
    path: '/transport/knowledge-base/upload-url',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'knowledge_base_upload_url_request',
    responseSchema: 'knowledge_base_upload_url_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Generate a signed upload URL for a knowledge base file.",
    resource: "knowledge-base-upload-url",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getKnowledgeBaseUploadUrl",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getKnowledgeBaseUploadUrl",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getKnowledgeBaseSignedUrl": {
    method: 'GET',
    path: '/transport/knowledge-base/signed-url',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'knowledge_base_s3_object_request',
    responseSchema: 'knowledge_base_signed_url_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Generate a signed read URL for a knowledge base file.",
    resource: "knowledge-base-signed-url",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getKnowledgeBaseSignedUrl",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getKnowledgeBaseSignedUrl",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getKnowledgeBaseFileContent": {
    method: 'GET',
    path: '/transport/knowledge-base/file-content',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'knowledge_base_s3_object_request',
    responseSchema: 'knowledge_base_file_content_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch text content for a knowledge base file.",
    resource: "knowledge-base-file-content",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getKnowledgeBaseFileContent",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getKnowledgeBaseFileContent",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getOrganizationSettings": {
    method: 'GET',
    path: '/transport/organization/settings',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'get_organization_settings_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch product settings for the current organization.",
    resource: "organization-settings",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getOrganizationSettings",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getOrganizationSettings",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getBillingOverageSettings": {
    method: 'GET',
    path: '/transport/billing/overage-settings',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'overage_settings_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Read enrolled overage settings for the authenticated organization.",
    resource: "billing-overage-settings",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getBillingOverageSettings",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getBillingOverageSettings",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateBillingOverageSettings": {
    method: 'PATCH',
    path: '/transport/billing/overage-settings',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'overage_settings_update',
    responseSchema: 'overage_settings_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Replace enrolled overage controls using an audited request ID and current revision.",
    resource: "billing-overage-settings",
    cacheTags: ["billing-overage-settings"],
    pagination: null,
    action: 'update',
    versionGroup: "updateBillingOverageSettings",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateBillingOverageSettings",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getBillingOverageAcceptanceReceipt": {
    method: 'GET',
    path: '/transport/billing/overage-acceptances/{request_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'overage_acceptance_receipt_request',
    responseSchema: 'overage_acceptance_receipt_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['request_id'],
    summary: "Verify an original member decision without replaying or modifying controls.",
    resource: "billing-overage-acceptance-receipt",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getBillingOverageAcceptanceReceipt",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getBillingOverageAcceptanceReceipt",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getBillingOverageAcceptanceOffer": {
    method: 'GET',
    path: '/transport/billing/overage-acceptance-offer',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'overage_acceptance_offer_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Read a versioned approved offer; unavailable until explicitly launched.",
    resource: "billing-overage-acceptance",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getBillingOverageAcceptanceOffer",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getBillingOverageAcceptanceOffer",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createBillingOverageAcceptance": {
    method: 'POST',
    path: '/transport/billing/overage-acceptances',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'overage_acceptance_request',
    responseSchema: 'overage_acceptance_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Atomically retain explicit consent and controls; no charging or enforcement activation.",
    resource: "billing-overage-acceptance",
    cacheTags: ["billing-overage-settings", "billing-overage-acceptance"],
    pagination: null,
    action: 'create',
    versionGroup: "createBillingOverageAcceptance",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createBillingOverageAcceptance",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getOrganizationRecord": {
    method: 'GET',
    path: '/transport/organization/current',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_organization_record_request',
    responseSchema: 'get_organization_record_response',
    requestByAlias: false,
    responseByAlias: true,
    pathParams: [],
    summary: "Fetch the current organization record.",
    resource: "organization-current",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getOrganizationRecord",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getOrganizationRecord",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getOrganizationUsers": {
    method: 'GET',
    path: '/transport/organization/users',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'get_organization_users_response',
    requestByAlias: false,
    responseByAlias: true,
    pathParams: [],
    summary: "Fetch current organization members with matching internal user records.",
    resource: "organization-users",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getOrganizationUsers",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getOrganizationUsers",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateOrganizationSettings": {
    method: 'PATCH',
    path: '/transport/organization/settings',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_organization_settings_request',
    responseSchema: 'update_organization_settings_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update product settings for the current organization.",
    resource: "organization-settings",
    cacheTags: ["organization-settings"],
    pagination: null,
    action: 'update',
    versionGroup: "updateOrganizationSettings",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateOrganizationSettings",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listWorkspaces": {
    method: 'GET',
    path: '/transport/workspaces',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'list_workspaces_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List active and archived workspaces for the current organization.",
    resource: "workspaces",
    cacheTags: ["workspaces"],
    pagination: null,
    action: 'list',
    versionGroup: "listWorkspaces",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listWorkspaces",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getWorkspaceSettings": {
    method: 'GET',
    path: '/transport/workspace/settings',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_workspace_settings_request',
    responseSchema: 'workspace_settings',
    requestByAlias: false,
    responseByAlias: true,
    pathParams: [],
    summary: "Fetch settings for the current workspace.",
    resource: "workspace-settings",
    cacheTags: ["workspace-settings"],
    pagination: null,
    action: 'get',
    versionGroup: "getWorkspaceSettings",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getWorkspaceSettings",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateWorkspaceSettings": {
    method: 'PATCH',
    path: '/transport/workspace/settings',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_workspace_settings_request',
    responseSchema: 'workspace_settings',
    requestByAlias: false,
    responseByAlias: true,
    pathParams: [],
    summary: "Update settings for the current workspace.",
    resource: "workspace-settings",
    cacheTags: ["workspace-settings"],
    pagination: null,
    action: 'update',
    versionGroup: "updateWorkspaceSettings",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateWorkspaceSettings",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createWorkspace": {
    method: 'POST',
    path: '/transport/workspaces',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_workspace_request',
    responseSchema: 'workspace_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a custom workspace for the current organization.",
    resource: "workspaces",
    cacheTags: ["workspaces"],
    pagination: null,
    action: 'create',
    versionGroup: "createWorkspace",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createWorkspace",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateWorkspace": {
    method: 'PATCH',
    path: '/transport/workspaces/{workspace_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_workspace_request',
    responseSchema: 'workspace_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['workspace_id'],
    summary: "Update a custom workspace display name.",
    resource: "workspaces",
    cacheTags: ["workspaces"],
    pagination: null,
    action: 'update',
    versionGroup: "updateWorkspace",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateWorkspace",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "archiveWorkspace": {
    method: 'POST',
    path: '/transport/workspaces/{workspace_id}/archive',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'archive_workspace_request',
    responseSchema: 'workspace_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['workspace_id'],
    summary: "Archive a custom workspace.",
    resource: "workspaces",
    cacheTags: ["workspaces"],
    pagination: null,
    action: 'archive',
    versionGroup: "archiveWorkspace",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "archiveWorkspace",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteWorkspace": {
    method: 'DELETE',
    path: '/transport/workspaces/{workspace_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'delete_workspace_request',
    responseSchema: 'workspace_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['workspace_id'],
    summary: "Soft-delete a custom workspace.",
    resource: "workspaces",
    cacheTags: ["workspaces"],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteWorkspace",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteWorkspace",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listWorkspaceMembers": {
    method: 'GET',
    path: '/transport/workspaces/{workspace_id}/members',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'list_workspace_members_request',
    responseSchema: 'list_workspace_members_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['workspace_id'],
    summary: "List members of a custom workspace.",
    resource: "workspace-members",
    cacheTags: ["workspace-members"],
    pagination: null,
    action: 'list',
    versionGroup: "listWorkspaceMembers",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listWorkspaceMembers",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "addWorkspaceMember": {
    method: 'POST',
    path: '/transport/workspaces/{workspace_id}/members',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'add_workspace_member_request',
    responseSchema: 'add_workspace_member_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['workspace_id'],
    summary: "Add a member to a custom workspace.",
    resource: "workspace-members",
    cacheTags: ["workspace-members"],
    pagination: null,
    action: 'create',
    versionGroup: "addWorkspaceMember",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "addWorkspaceMember",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "removeWorkspaceMember": {
    method: 'DELETE',
    path: '/transport/workspaces/{workspace_id}/members/{user_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'remove_workspace_member_request',
    responseSchema: 'remove_workspace_member_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['workspace_id', 'user_id'],
    summary: "Remove a member from a custom workspace.",
    resource: "workspace-members",
    cacheTags: ["workspace-members"],
    pagination: null,
    action: 'delete',
    versionGroup: "removeWorkspaceMember",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "removeWorkspaceMember",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getLinearIntegrationStatus": {
    method: 'GET',
    path: '/transport/linear/status',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'linear_integration_status_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch the current user's Linear connection status without exposing stored OAuth secrets.",
    resource: "linear-status",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getLinearIntegrationStatus",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getLinearIntegrationStatus",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getLinearAuthorizationUrl": {
    method: 'GET',
    path: '/transport/linear/authorization-url',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'linear_authorization_url_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Build a signed Linear OAuth authorization URL for the current user.",
    resource: "linear-authorization-url",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getLinearAuthorizationUrl",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getLinearAuthorizationUrl",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "connectLinearIntegration": {
    method: 'POST',
    path: '/transport/linear/connect',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'connect_linear_integration_request',
    responseSchema: 'connect_linear_integration_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Exchange a Linear OAuth code and persist the integration for the current user.",
    resource: "linear",
    cacheTags: [],
    pagination: null,
    action: 'connect',
    versionGroup: "connectLinearIntegration",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "connectLinearIntegration",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "disconnectLinearIntegration": {
    method: 'POST',
    path: '/transport/linear/disconnect',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'disconnect_linear_integration_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Disconnect Linear for the current user and revoke the token best-effort.",
    resource: "linear",
    cacheTags: [],
    pagination: null,
    action: 'disconnect',
    versionGroup: "disconnectLinearIntegration",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "disconnectLinearIntegration",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listLinearTeams": {
    method: 'GET',
    path: '/transport/linear/teams',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'list_linear_teams_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List Linear teams visible to the current user's Linear account.",
    resource: "linear-teams",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listLinearTeams",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listLinearTeams",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listLinearProjects": {
    method: 'GET',
    path: '/transport/linear/projects',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_linear_projects_request',
    responseSchema: 'list_linear_projects_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List Linear projects for a selected team visible to the current user's Linear account.",
    resource: "linear-projects",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listLinearProjects",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listLinearProjects",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createLinearIssue": {
    method: 'POST',
    path: '/transport/linear/issues/create',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_linear_issue_request',
    responseSchema: 'create_linear_issue_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a Linear issue from product surfaces such as DeepDive.",
    resource: "linear-issues",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "createLinearIssue",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createLinearIssue",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "requestSimulationRoom": {
    method: 'POST',
    path: '/transport/simulation-rooms/request',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'simulation_room_request',
    responseSchema: 'simulation_room_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Open a simulation room for a running simulation and return a room-scoped listen token.",
    resource: "simulation-rooms-request",
    cacheTags: [],
    pagination: null,
    action: 'run',
    versionGroup: "requestSimulationRoom",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "requestSimulationRoom",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getSlackStatus": {
    method: 'GET',
    path: '/transport/slack/status',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'slack_status_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch Slack workspace connection status for the current organization.",
    resource: "slack-status",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getSlackStatus",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getSlackStatus",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "connectSlack": {
    method: 'POST',
    path: '/transport/slack/connect',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'connect_slack_transport_request',
    responseSchema: 'connect_slack_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Connect Slack for the current organization by exchanging an OAuth code.",
    resource: "slack",
    cacheTags: [],
    pagination: null,
    action: 'connect',
    versionGroup: "connectSlack",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "connectSlack",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "disconnectSlack": {
    method: 'POST',
    path: '/transport/slack/disconnect',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'disconnect_slack_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Disconnect Slack for the current organization.",
    resource: "slack",
    cacheTags: [],
    pagination: null,
    action: 'disconnect',
    versionGroup: "disconnectSlack",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "disconnectSlack",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listDashboardMetadata": {
    method: 'GET',
    path: '/transport/dashboards/metadata',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'list_dashboard_metadata_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List dashboard metadata for the current organization.",
    resource: "dashboards-metadata",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listDashboardMetadata",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listDashboardMetadata",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getDashboardLayout": {
    method: 'GET',
    path: '/transport/dashboards/layout',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_dashboard_layout_request',
    responseSchema: 'dashboard_layout_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch dashboard metadata and widget layout for a selected or default dashboard.",
    resource: "dashboards-layout",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getDashboardLayout",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getDashboardLayout",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "queryDashboardBatch": {
    method: 'POST',
    path: '/transport/dashboards/query-batch',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'query_dashboard_batch_request',
    responseSchema: 'query_dashboard_batch_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Execute transport-backed dashboard widget queries for the current organization.",
    resource: "dashboards",
    cacheTags: [],
    pagination: null,
    action: 'query',
    versionGroup: "queryDashboardBatch",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "queryDashboardBatch",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "flexibleDashboardDrilldown": {
    method: 'POST',
    path: '/transport/dashboards/drilldown/flexible',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'flexible_dashboard_drilldown_request',
    responseSchema: 'flexible_dashboard_drilldown_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch drilldown rows for dashboard metric widgets using the current organization context.",
    resource: "dashboards-drilldown-flexible",
    cacheTags: [],
    pagination: null,
    action: 'query',
    versionGroup: "flexibleDashboardDrilldown",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "flexibleDashboardDrilldown",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "humanReviewDashboardDrilldown": {
    method: 'POST',
    path: '/transport/dashboards/drilldown/human-review',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'human_review_drilldown_request',
    responseSchema: 'human_review_dashboard_drilldown_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch human-review drilldown rows for the current organization.",
    resource: "dashboards-drilldown-human-review",
    cacheTags: [],
    pagination: null,
    action: 'query',
    versionGroup: "humanReviewDashboardDrilldown",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "humanReviewDashboardDrilldown",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "metricValuesBySimulation": {
    method: 'POST',
    path: '/transport/dashboards/drilldown/metric-values',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'metric_values_by_simulation_request',
    responseSchema: 'metric_values_by_simulation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch metric values for drilldown table enrichment in the current organization.",
    resource: "dashboards-drilldown-metric-values",
    cacheTags: [],
    pagination: null,
    action: 'query',
    versionGroup: "metricValuesBySimulation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "metricValuesBySimulation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createDashboard": {
    method: 'POST',
    path: '/transport/dashboards/create',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_dashboard_transport_request',
    responseSchema: 'create_dashboard_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a dashboard for the current organization.",
    resource: "dashboards",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "createDashboard",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createDashboard",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateDashboard": {
    method: 'PATCH',
    path: '/transport/dashboards/update',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_dashboard_transport_request',
    responseSchema: 'update_dashboard_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update dashboard metadata or config for the current organization.",
    resource: "dashboards",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateDashboard",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateDashboard",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteDashboard": {
    method: 'POST',
    path: '/transport/dashboards/delete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'delete_dashboard_transport_request',
    responseSchema: 'delete_dashboard_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Soft-delete a dashboard for the current organization.",
    resource: "dashboards",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteDashboard",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteDashboard",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "replaceDashboardWidgets": {
    method: 'PUT',
    path: '/transport/dashboards/widgets',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'replace_dashboard_widgets_request',
    responseSchema: 'replace_dashboard_widgets_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Replace the active widget set for a dashboard.",
    resource: "dashboards-widgets",
    cacheTags: [],
    pagination: null,
    action: 'set',
    versionGroup: "replaceDashboardWidgets",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "replaceDashboardWidgets",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "clearDashboardWidgets": {
    method: 'POST',
    path: '/transport/dashboards/widgets/clear',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'clear_dashboard_widgets_request',
    responseSchema: 'clear_dashboard_widgets_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Soft-delete all widgets for a dashboard.",
    resource: "dashboards-widgets-clear",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "clearDashboardWidgets",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "clearDashboardWidgets",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "duplicateDashboardWidget": {
    method: 'POST',
    path: '/transport/dashboards/{dashboard_id}/widgets/{widget_id}/duplicate',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'duplicate_dashboard_widget_request',
    responseSchema: 'duplicate_dashboard_widget_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['dashboard_id', 'widget_id'],
    summary: "Duplicate saved widget configuration in the authenticated scope.",
    resource: "dashboards",
    cacheTags: ["dashboards"],
    pagination: null,
    action: 'duplicate',
    versionGroup: "duplicateDashboardWidget",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "duplicateDashboardWidget",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listMetricCatalogEntries": {
    method: 'GET',
    path: '/transport/metric-catalog',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'list_metric_catalog_entries_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List centrally managed metric catalog entries available to the current workspace.",
    resource: "metric-catalog",
    cacheTags: ["metric-catalog"],
    pagination: null,
    action: 'list',
    versionGroup: "listMetricCatalogEntries",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listMetricCatalogEntries",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "copyMetricCatalogEntry": {
    method: 'POST',
    path: '/transport/metric-catalog/copy',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'copy_metric_catalog_entry_request',
    responseSchema: 'create_metric_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Copy one centrally managed metric catalog entry into the current workspace.",
    resource: "metric-catalog",
    cacheTags: ["metrics"],
    pagination: null,
    action: 'create',
    versionGroup: "copyMetricCatalogEntry",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "copyMetricCatalogEntry",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listAdminMetricCatalogEntries": {
    method: 'GET',
    path: '/transport/admin/metric-catalog',
    auth: 'session',
    databaseAccess: 'none',
    organizationRequired: false,
    requestLocation: 'query',
    requestSchema: 'list_admin_metric_catalog_entries_request',
    responseSchema: 'list_admin_metric_catalog_entries_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List centrally managed metric catalog entries as a Coval admin.",
    resource: "admin-metric-catalog",
    cacheTags: [],
    pagination: { itemKey: "entries", requestTokenKey: "page_token", responseTokenKey: "next_page_token" },
    action: 'list',
    versionGroup: "listAdminMetricCatalogEntries",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listAdminMetricCatalogEntries",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getAdminMetricCatalogEntry": {
    method: 'GET',
    path: '/transport/admin/metric-catalog/get',
    auth: 'session',
    databaseAccess: 'none',
    organizationRequired: false,
    requestLocation: 'query',
    requestSchema: 'get_admin_metric_catalog_entry_request',
    responseSchema: 'get_admin_metric_catalog_entry_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Get one centrally managed metric catalog entry as a Coval admin.",
    resource: "admin-metric-catalog",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getAdminMetricCatalogEntry",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getAdminMetricCatalogEntry",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createAdminMetricCatalogEntry": {
    method: 'POST',
    path: '/transport/admin/metric-catalog/create',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_admin_metric_catalog_entry_request',
    responseSchema: 'metric_catalog_entry_resource',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a centrally managed metric catalog entry as a Coval admin.",
    resource: "admin-metric-catalog",
    cacheTags: ["metric-catalog"],
    pagination: null,
    action: 'create',
    versionGroup: "createAdminMetricCatalogEntry",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createAdminMetricCatalogEntry",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateAdminMetricCatalogEntry": {
    method: 'PATCH',
    path: '/transport/admin/metric-catalog/update',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_admin_metric_catalog_entry_request',
    responseSchema: 'metric_catalog_entry_resource',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update a centrally managed metric catalog entry as a Coval admin.",
    resource: "admin-metric-catalog",
    cacheTags: ["metric-catalog"],
    pagination: null,
    action: 'update',
    versionGroup: "updateAdminMetricCatalogEntry",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateAdminMetricCatalogEntry",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteAdminMetricCatalogEntry": {
    method: 'POST',
    path: '/transport/admin/metric-catalog/delete',
    auth: 'session',
    databaseAccess: 'none',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'delete_admin_metric_catalog_entry_request',
    responseSchema: 'delete_admin_metric_catalog_entry_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Permanently delete a centrally managed metric catalog entry as a Coval admin.",
    resource: "admin-metric-catalog",
    cacheTags: ["metric-catalog"],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteAdminMetricCatalogEntry",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteAdminMetricCatalogEntry",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listPersonaCatalogEntries": {
    method: 'GET',
    path: '/transport/persona-catalog',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'list_persona_catalog_entries_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List centrally managed persona catalog entries available to the current workspace.",
    resource: "persona-catalog",
    cacheTags: ["persona-catalog"],
    pagination: null,
    action: 'list',
    versionGroup: "listPersonaCatalogEntries",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listPersonaCatalogEntries",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "copyPersonaCatalogEntry": {
    method: 'POST',
    path: '/transport/persona-catalog/copy',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'copy_persona_catalog_entry_request',
    responseSchema: 'create_persona_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Copy one centrally managed persona catalog entry into the current workspace.",
    resource: "persona-catalog",
    cacheTags: ["personas"],
    pagination: null,
    action: 'create',
    versionGroup: "copyPersonaCatalogEntry",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "copyPersonaCatalogEntry",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listAdminPersonaCatalogEntries": {
    method: 'GET',
    path: '/transport/admin/persona-catalog',
    auth: 'session',
    databaseAccess: 'none',
    organizationRequired: false,
    requestLocation: 'query',
    requestSchema: 'list_admin_persona_catalog_entries_request',
    responseSchema: 'list_admin_persona_catalog_entries_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List centrally managed persona catalog entries as a Coval admin.",
    resource: "admin-persona-catalog",
    cacheTags: [],
    pagination: { itemKey: "entries", requestTokenKey: "page_token", responseTokenKey: "next_page_token" },
    action: 'list',
    versionGroup: "listAdminPersonaCatalogEntries",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listAdminPersonaCatalogEntries",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getAdminPersonaCatalogEntry": {
    method: 'GET',
    path: '/transport/admin/persona-catalog/get',
    auth: 'session',
    databaseAccess: 'none',
    organizationRequired: false,
    requestLocation: 'query',
    requestSchema: 'get_admin_persona_catalog_entry_request',
    responseSchema: 'get_admin_persona_catalog_entry_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Get one centrally managed persona catalog entry as a Coval admin.",
    resource: "admin-persona-catalog",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getAdminPersonaCatalogEntry",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getAdminPersonaCatalogEntry",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createAdminPersonaCatalogEntry": {
    method: 'POST',
    path: '/transport/admin/persona-catalog/create',
    auth: 'session',
    databaseAccess: 'none',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'create_admin_persona_catalog_entry_request',
    responseSchema: 'persona_catalog_entry_resource',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a centrally managed persona catalog entry as a Coval admin.",
    resource: "admin-persona-catalog",
    cacheTags: ["persona-catalog"],
    pagination: null,
    action: 'create',
    versionGroup: "createAdminPersonaCatalogEntry",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createAdminPersonaCatalogEntry",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateAdminPersonaCatalogEntry": {
    method: 'PATCH',
    path: '/transport/admin/persona-catalog/update',
    auth: 'session',
    databaseAccess: 'none',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'update_admin_persona_catalog_entry_request',
    responseSchema: 'persona_catalog_entry_resource',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update a centrally managed persona catalog entry as a Coval admin.",
    resource: "admin-persona-catalog",
    cacheTags: ["persona-catalog"],
    pagination: null,
    action: 'update',
    versionGroup: "updateAdminPersonaCatalogEntry",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateAdminPersonaCatalogEntry",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteAdminPersonaCatalogEntry": {
    method: 'POST',
    path: '/transport/admin/persona-catalog/delete',
    auth: 'session',
    databaseAccess: 'none',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'delete_admin_persona_catalog_entry_request',
    responseSchema: 'delete_admin_persona_catalog_entry_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Permanently delete a centrally managed persona catalog entry as a Coval admin.",
    resource: "admin-persona-catalog",
    cacheTags: ["persona-catalog"],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteAdminPersonaCatalogEntry",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteAdminPersonaCatalogEntry",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listMetricDirectory": {
    method: 'GET',
    path: '/transport/metric-directory',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'list_metric_directory_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List the MetricDirectory catalog (org-agnostic metric class facts).",
    resource: "metric-directory",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listMetricDirectory",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listMetricDirectory",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createMetricAudit": {
    method: 'POST',
    path: '/transport/metric-audits/create',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_metric_audit_request',
    responseSchema: 'create_metric_audit_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a queued metric audit for the current organization.",
    resource: "metric-audits",
    cacheTags: ["metric-audits"],
    pagination: null,
    action: 'create',
    versionGroup: "createMetricAudit",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createMetricAudit",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getMetricAudit": {
    method: 'GET',
    path: '/transport/metric-audits/status',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_metric_audit_request',
    responseSchema: 'get_metric_audit_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Get one metric-audit lifecycle status for the current organization.",
    resource: "metric-audits",
    cacheTags: ["metric-audits"],
    pagination: null,
    action: 'get',
    versionGroup: "getMetricAudit",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getMetricAudit",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "cancelMetricAudit": {
    method: 'POST',
    path: '/transport/metric-audits/cancel',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'cancel_metric_audit_request',
    responseSchema: 'cancel_metric_audit_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Request cancellation of one metric audit for the current organization.",
    resource: "metric-audits",
    cacheTags: ["metric-audits"],
    pagination: null,
    action: 'update',
    versionGroup: "cancelMetricAudit",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "cancelMetricAudit",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listMetricAuditGroups": {
    method: 'GET',
    path: '/transport/metric-audits/groups',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_metric_audit_groups_request',
    responseSchema: 'list_metric_audit_groups_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List persisted evidence groups for one metric audit.",
    resource: "metric-audits",
    cacheTags: ["metric-audits"],
    pagination: { itemKey: "groups", requestTokenKey: "cursor", responseTokenKey: "next_cursor" },
    action: 'list',
    versionGroup: "listMetricAuditGroups",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listMetricAuditGroups",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getMetricAuditPair": {
    method: 'GET',
    path: '/transport/metric-audits/pair',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_metric_audit_pair_request',
    responseSchema: 'get_metric_audit_pair_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Get persisted evidence for one metric-audit pair.",
    resource: "metric-audits-get-metric-audit-pair",
    cacheTags: ["metric-audits"],
    pagination: null,
    action: 'get',
    versionGroup: "getMetricAuditPair",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getMetricAuditPair",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getMetricAuditPromptProposal": {
    method: 'GET',
    path: '/transport/metric-audits/prompt-proposal',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_metric_audit_prompt_proposal_request',
    responseSchema: 'get_metric_audit_prompt_proposal_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Get the final scored judging-question candidate and evidence within its retention window.",
    resource: "metric-audits-get-metric-audit-prompt-proposal",
    cacheTags: ["metric-audits"],
    pagination: null,
    action: 'get',
    versionGroup: "getMetricAuditPromptProposal",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getMetricAuditPromptProposal",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getSimulationDataFramesSchema": {
    method: 'GET',
    path: '/transport/simulation-data-frames-schema',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'simulation_data_frames_schema_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Get the SimulationDataFrames materialization schema (tables, columns, enums) a SQL metric runs against.",
    resource: "simulation-data-frames-schema",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getSimulationDataFramesSchema",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getSimulationDataFramesSchema",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "testSqlMetric": {
    method: 'POST',
    path: '/transport/sql-metric/test',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'test_sql_metric_request',
    responseSchema: 'test_recent_sql_metric_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Test a draft Custom SQL metric query against selected or recent simulations in the active workspace.",
    resource: "sql-metric",
    cacheTags: [],
    pagination: null,
    action: 'run',
    versionGroup: "testSqlMetric",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "testSqlMetric",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getMetricThreshold": {
    method: 'GET',
    path: '/transport/metric-thresholds',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_metric_threshold_request',
    responseSchema: 'get_metric_threshold_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch the current organization's threshold for a metric.",
    resource: "metric-thresholds",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getMetricThreshold",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getMetricThreshold",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateMetricThreshold": {
    method: 'PATCH',
    path: '/transport/metric-thresholds/update',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_metric_threshold_request',
    responseSchema: 'update_metric_threshold_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update or clear the current organization's threshold for a metric.",
    resource: "metric-thresholds",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateMetricThreshold",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateMetricThreshold",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listComments": {
    method: 'GET',
    path: '/transport/comments',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_comments_request',
    responseSchema: 'list_comments_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List comments for an entity in the current organization.",
    resource: "comments",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listComments",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listComments",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createComment": {
    method: 'POST',
    path: '/transport/comments',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_comment_transport_request',
    responseSchema: 'create_comment_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a comment for an entity in the current organization.",
    resource: "comments",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "createComment",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createComment",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateComment": {
    method: 'PATCH',
    path: '/transport/comments/{comment_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_comment_transport_request',
    responseSchema: 'update_comment_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['comment_id'],
    summary: "Update a comment in the current organization.",
    resource: "comments",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateComment",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateComment",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteComment": {
    method: 'DELETE',
    path: '/transport/comments/{comment_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'delete_comment_transport_request',
    responseSchema: 'delete_comment_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['comment_id'],
    summary: "Delete a comment in the current organization.",
    resource: "comments",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteComment",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteComment",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getSettingsCredentialIntegrations": {
    method: 'GET',
    path: '/transport/settings/integrations',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'settings_credential_integrations_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch masked credential integration settings for the current organization.",
    resource: "settings-integrations",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getSettingsCredentialIntegrations",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getSettingsCredentialIntegrations",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateLangfuseIntegration": {
    method: 'PATCH',
    path: '/transport/settings/integrations/langfuse',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_langfuse_integration_request',
    responseSchema: 'update_langfuse_integration_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update Langfuse credentials for the current organization.",
    resource: "settings-integrations-langfuse",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateLangfuseIntegration",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateLangfuseIntegration",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateArizeIntegration": {
    method: 'PATCH',
    path: '/transport/settings/integrations/arize',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_arize_integration_request',
    responseSchema: 'update_arize_integration_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update Arize credentials for the current organization.",
    resource: "settings-integrations-arize",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateArizeIntegration",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateArizeIntegration",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateZendeskIntegration": {
    method: 'PATCH',
    path: '/transport/settings/integrations/zendesk',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_zendesk_integration_request',
    responseSchema: 'update_zendesk_integration_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update Zendesk credentials for the current organization.",
    resource: "settings-integrations-zendesk",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateZendeskIntegration",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateZendeskIntegration",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateShelfIntegration": {
    method: 'PATCH',
    path: '/transport/settings/integrations/shelf',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_shelf_integration_request',
    responseSchema: 'update_shelf_integration_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update Shelf credentials for the current organization.",
    resource: "settings-integrations-shelf",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateShelfIntegration",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateShelfIntegration",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getTelnyxIntegrationStatus": {
    method: 'GET',
    path: '/transport/settings/integrations/telnyx',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'telnyx_integration_status_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch Telnyx integration status for the current organization.",
    resource: "settings-integrations-telnyx",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getTelnyxIntegrationStatus",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getTelnyxIntegrationStatus",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateTelnyxApiKey": {
    method: 'PATCH',
    path: '/transport/settings/integrations/telnyx/api-key',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_telnyx_api_key_request',
    responseSchema: 'update_telnyx_api_key_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update Telnyx API key for the current organization.",
    resource: "settings-integrations-telnyx-api-key",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateTelnyxApiKey",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateTelnyxApiKey",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "removeTelnyxApiKey": {
    method: 'POST',
    path: '/transport/settings/integrations/telnyx/remove',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'remove_telnyx_api_key_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Remove the saved Telnyx API key for the current organization.",
    resource: "settings-integrations-telnyx",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "removeTelnyxApiKey",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "removeTelnyxApiKey",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "discoverGenesysQueues": {
    method: 'POST',
    path: '/transport/settings/integrations/genesys/queues:discover',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'discover_genesys_queues_request',
    responseSchema: 'discover_genesys_queues_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Validate Genesys OAuth credentials and list visible queues.",
    resource: "conversation_import_connection",
    cacheTags: ["conversation-import-connections"],
    pagination: null,
    action: 'connect',
    versionGroup: "discoverGenesysQueues",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "discoverGenesysQueues",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listConversationImportConnections": {
    method: 'GET',
    path: '/transport/settings/integrations/conversation-imports',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_conversation_import_connections_request',
    responseSchema: 'list_conversation_import_connections_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List managed conversation import connections for the current workspace.",
    resource: "conversation_import_connection",
    cacheTags: ["conversation-import-connections"],
    pagination: { itemKey: "connections", requestTokenKey: "page_token", responseTokenKey: "next_page_token" },
    action: 'list',
    versionGroup: "listConversationImportConnections",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listConversationImportConnections",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createGenesysConnection": {
    method: 'POST',
    path: '/transport/settings/integrations/genesys/connections',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_genesys_connection_request',
    responseSchema: 'create_genesys_connection_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a managed Genesys conversation import connection.",
    resource: "conversation_import_connection",
    cacheTags: ["conversation-import-connections"],
    pagination: null,
    action: 'create',
    versionGroup: "createGenesysConnection",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createGenesysConnection",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "pauseConversationImportConnection": {
    method: 'POST',
    path: '/transport/settings/integrations/conversation-imports/pause',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'conversation_import_connection_action_request',
    responseSchema: 'conversation_import_connection_action_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Pause a managed conversation import connection.",
    resource: "conversation_import_connection",
    cacheTags: ["conversation-import-connections"],
    pagination: null,
    action: 'update',
    versionGroup: "pauseConversationImportConnection",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "pauseConversationImportConnection",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "resumeConversationImportConnection": {
    method: 'POST',
    path: '/transport/settings/integrations/conversation-imports/resume',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'conversation_import_connection_action_request',
    responseSchema: 'conversation_import_connection_action_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Resume a paused conversation import connection or retry one needing attention.",
    resource: "conversation_import_connection-resume-conversation-import-connection",
    cacheTags: ["conversation-import-connections"],
    pagination: null,
    action: 'update',
    versionGroup: "resumeConversationImportConnection",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "resumeConversationImportConnection",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "disconnectConversationImportConnection": {
    method: 'POST',
    path: '/transport/settings/integrations/conversation-imports/disconnect',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'conversation_import_connection_action_request',
    responseSchema: 'conversation_import_connection_action_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Disconnect a managed conversation import connection and retire its credentials.",
    resource: "conversation_import_connection",
    cacheTags: ["conversation-import-connections"],
    pagination: null,
    action: 'disconnect',
    versionGroup: "disconnectConversationImportConnection",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "disconnectConversationImportConnection",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listAdminMetrics": {
    method: 'GET',
    path: '/transport/metrics/admin',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'query',
    requestSchema: 'list_admin_metrics_request',
    responseSchema: 'list_admin_metrics_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List metric definitions across organizations for Coval admin users.",
    resource: "metrics-admin",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listAdminMetrics",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listAdminMetrics",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listMetricAdminOrganizations": {
    method: 'GET',
    path: '/transport/metrics/admin/organizations',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'list_metric_admin_organizations_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List organizations with metric definitions for Coval admin filters.",
    resource: "metrics-admin-organizations",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listMetricAdminOrganizations",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listMetricAdminOrganizations",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createAdminMetric": {
    method: 'POST',
    path: '/transport/metrics/admin/create',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'create_admin_metric_request',
    responseSchema: 'create_admin_metric_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a metric definition for any organization as a Coval admin.",
    resource: "metrics-admin",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "createAdminMetric",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createAdminMetric",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateAdminMetric": {
    method: 'PATCH',
    path: '/transport/metrics/admin/update',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'update_admin_metric_request',
    responseSchema: 'update_admin_metric_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update a metric definition for any organization as a Coval admin.",
    resource: "metrics-admin",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateAdminMetric",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateAdminMetric",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateMetricActiveStatus": {
    method: 'PATCH',
    path: '/transport/metrics/admin/active-status',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'update_metric_active_status_request',
    responseSchema: 'metric_admin_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Toggle a metric definition's active status as a Coval admin.",
    resource: "metrics-admin-active-status",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateMetricActiveStatus",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateMetricActiveStatus",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listMetrics": {
    method: 'GET',
    path: '/transport/metrics',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_metrics_request',
    responseSchema: 'list_metrics_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List active metric definitions for the current organization.",
    resource: "metrics",
    cacheTags: ["metrics"],
    pagination: { itemKey: "metrics", requestTokenKey: "page_token", responseTokenKey: "next_page_token" },
    action: 'list',
    versionGroup: "listMetrics",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listMetrics",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listMetricTags": {
    method: 'GET',
    path: '/transport/metrics/tags',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'list_metric_tags_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List active metric tags for the current organization.",
    resource: "metrics-tags",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listMetricTags",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listMetricTags",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getMetricLabels": {
    method: 'POST',
    path: '/transport/metrics/labels',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'get_metric_labels_request',
    responseSchema: 'get_metric_labels_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch compact labels for requested metric definitions by id.",
    resource: "metric-labels",
    cacheTags: ["metrics"],
    pagination: null,
    action: 'list',
    versionGroup: "getMetricLabels",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getMetricLabels",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "queryMetricAuthors": {
    method: 'POST',
    path: '/transport/metrics/authors:query',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'query_metric_authors_request',
    responseSchema: 'query_metric_authors_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Resolve canonical metric author names for metrics visible in the current organization workspace.",
    resource: "metric-authors",
    cacheTags: ["metrics"],
    pagination: null,
    action: 'query',
    versionGroup: "queryMetricAuthors",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "queryMetricAuthors",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "queryAdminMetricAuthors": {
    method: 'POST',
    path: '/transport/metrics/admin/authors:query',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'query_metric_authors_request',
    responseSchema: 'query_metric_authors_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Resolve canonical metric author names for authorized cross-organization Admin metrics.",
    resource: "metric-authors-query-admin-metric-authors",
    cacheTags: ["metrics"],
    pagination: null,
    action: 'query',
    versionGroup: "queryAdminMetricAuthors",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "queryAdminMetricAuthors",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getMetric": {
    method: 'GET',
    path: '/transport/metrics/get',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_metric_request',
    responseSchema: 'get_metric_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch a metric definition visible to the current organization.",
    resource: "metrics",
    cacheTags: ["metrics"],
    pagination: null,
    action: 'get',
    versionGroup: "getMetric",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getMetric",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getMetricVersions": {
    method: 'GET',
    path: '/transport/metrics/versions',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_metric_versions_request',
    responseSchema: 'get_metric_versions_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List the prior-version history for a metric visible to the current organization.",
    resource: "metric-versions",
    cacheTags: ["metrics"],
    pagination: null,
    action: 'list',
    versionGroup: "getMetricVersions",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getMetricVersions",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "revertMetricVersion": {
    method: 'POST',
    path: '/transport/metrics/versions/revert',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'revert_metric_version_request',
    responseSchema: 'revert_metric_version_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Revert a metric to one of its prior versions.",
    resource: "metric-versions",
    cacheTags: ["metrics"],
    pagination: null,
    action: 'update',
    versionGroup: "revertMetricVersion",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "revertMetricVersion",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getMetricsMetadata": {
    method: 'GET',
    path: '/transport/metrics/metadata',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'metrics_metadata_request',
    responseSchema: 'metrics_metadata_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch run customer metadata keys and values from flattened metric rows.",
    resource: "metrics-metadata",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getMetricsMetadata",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getMetricsMetadata",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getMetricMetadataKeys": {
    method: 'GET',
    path: '/transport/metrics/metadata-keys',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'metrics_metadata_request',
    responseSchema: 'metrics_metadata_keys_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch distinct run customer metadata keys from flattened metric rows.",
    resource: "metrics-metadata-keys",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getMetricMetadataKeys",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getMetricMetadataKeys",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getMetricMetadataValues": {
    method: 'GET',
    path: '/transport/metrics/metadata-values',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'metric_metadata_values_request',
    responseSchema: 'metric_metadata_values_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch distinct run customer metadata values for one flattened metric metadata key.",
    resource: "metrics-metadata-values",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getMetricMetadataValues",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getMetricMetadataValues",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listMetricFlows": {
    method: 'GET',
    path: '/transport/metrics/flows',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_metric_flows_request',
    responseSchema: 'list_metric_flows_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List metric automation flows for the current organization.",
    resource: "metric-flows",
    cacheTags: ["metric-flows"],
    pagination: null,
    action: 'list',
    versionGroup: "listMetricFlows",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listMetricFlows",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createMetricFlow": {
    method: 'POST',
    path: '/transport/metrics/flows/create',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_metric_flow_request',
    responseSchema: 'metric_flow_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a metric automation flow for the current organization.",
    resource: "metric-flows",
    cacheTags: ["metric-flows"],
    pagination: null,
    action: 'create',
    versionGroup: "createMetricFlow",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createMetricFlow",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateMetricFlow": {
    method: 'PATCH',
    path: '/transport/metrics/flows/update',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_metric_flow_request',
    responseSchema: 'metric_flow_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update a metric automation flow for the current organization.",
    resource: "metric-flows",
    cacheTags: ["metric-flows"],
    pagination: null,
    action: 'update',
    versionGroup: "updateMetricFlow",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateMetricFlow",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteMetricFlow": {
    method: 'POST',
    path: '/transport/metrics/flows/delete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'delete_metric_flow_request',
    responseSchema: 'metric_flow_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Soft-delete a metric automation flow for the current organization.",
    resource: "metric-flows",
    cacheTags: ["metric-flows"],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteMetricFlow",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteMetricFlow",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getMetricOutputsByUlids": {
    method: 'POST',
    path: '/transport/metrics/outputs/by-ulids',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'get_metric_outputs_by_ulids_request',
    responseSchema: 'get_metric_outputs_by_ulids_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch metric output rows by ULID for the current organization.",
    resource: "metrics-outputs-by-ulids",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getMetricOutputsByUlids",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getMetricOutputsByUlids",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getAgentJudgeEvidence": {
    method: 'POST',
    path: '/transport/metrics/outputs/evidence',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'get_agent_judge_evidence_request',
    responseSchema: 'get_agent_judge_evidence_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Resolve display projections for citations stored on one Agent Judge metric output.",
    resource: "metrics-outputs-evidence",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getAgentJudgeEvidence",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getAgentJudgeEvidence",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "runTestMetric": {
    method: 'POST',
    path: '/transport/metrics/test',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'run_test_metric_request',
    responseSchema: 'run_test_metric_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create and enqueue a one-off test metric evaluation.",
    resource: "metrics",
    cacheTags: [],
    pagination: null,
    action: 'run',
    versionGroup: "runTestMetric",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "runTestMetric",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createMetric": {
    method: 'POST',
    path: '/transport/metrics/create',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_metric_request',
    responseSchema: 'create_metric_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a metric definition for the current organization.",
    resource: "metrics",
    cacheTags: ["metrics"],
    pagination: null,
    action: 'create',
    versionGroup: "createMetric",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createMetric",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "duplicateMetric": {
    method: 'POST',
    path: '/transport/metrics/duplicate',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'duplicate_metric_request',
    responseSchema: 'duplicate_metric_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Duplicate a metric definition for the current organization.",
    resource: "metrics",
    cacheTags: ["metrics"],
    pagination: null,
    action: 'duplicate',
    versionGroup: "duplicateMetric",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "duplicateMetric",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateMetric": {
    method: 'PATCH',
    path: '/transport/metrics/update',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_metric_request',
    responseSchema: 'update_metric_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update a metric definition for the current organization.",
    resource: "metrics",
    cacheTags: ["metrics"],
    pagination: null,
    action: 'update',
    versionGroup: "updateMetric",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateMetric",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "archiveMetric": {
    method: 'POST',
    path: '/transport/metrics/archive',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'archive_metric_request',
    responseSchema: 'archive_metric_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Archive a workspace metric; default also includes legacy NULL-workspace rows; unresolved is limited to legacy NULL-workspace rows; out-of-scope rows are an idempotent no-op.",
    resource: "metrics",
    cacheTags: ["metrics"],
    pagination: null,
    action: 'archive',
    versionGroup: "archiveMetric",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "archiveMetric",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listRecentlyDeletedMetrics": {
    method: 'GET',
    path: '/transport/metrics/recently-deleted',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'list_recently_deleted_metrics_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List Recently Deleted metrics by workspace; default includes legacy NULL rows; unresolved is empty.",
    resource: "metrics-list-recently-deleted-metrics",
    cacheTags: ["metrics"],
    pagination: null,
    action: 'list',
    versionGroup: "listRecentlyDeletedMetrics",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listRecentlyDeletedMetrics",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "restoreMetric": {
    method: 'POST',
    path: '/transport/metrics/restore',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'restore_metric_request',
    responseSchema: 'restore_metric_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Restore a workspace metric; default includes legacy NULL-workspace rows; unresolved returns 404.",
    resource: "metrics-restore-metric",
    cacheTags: ["metrics"],
    pagination: null,
    action: 'update',
    versionGroup: "restoreMetric",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "restoreMetric",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listAlerts": {
    method: 'GET',
    path: '/transport/alerts',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_alerts_request',
    responseSchema: 'list_alerts_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List active alerts for the current organization.",
    resource: "alerts",
    cacheTags: ["alerts"],
    pagination: { itemKey: "alerts", requestTokenKey: "page_token", responseTokenKey: "next_page_token" },
    action: 'list',
    versionGroup: "listAlerts",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listAlerts",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getAlert": {
    method: 'GET',
    path: '/transport/alerts/{alert_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'get_alert_request',
    responseSchema: 'alert_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['alert_id'],
    summary: "Fetch an active alert in the current organization.",
    resource: "alerts",
    cacheTags: ["alerts"],
    pagination: null,
    action: 'get',
    versionGroup: "getAlert",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getAlert",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createAlert": {
    method: 'POST',
    path: '/transport/alerts',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_alert_request',
    responseSchema: 'alert_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create an alert for the current organization.",
    resource: "alerts",
    cacheTags: ["alerts"],
    pagination: null,
    action: 'create',
    versionGroup: "createAlert",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createAlert",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateAlert": {
    method: 'PATCH',
    path: '/transport/alerts/{alert_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_alert_request',
    responseSchema: 'alert_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['alert_id'],
    summary: "Update an alert for the current organization.",
    resource: "alerts",
    cacheTags: ["alerts"],
    pagination: null,
    action: 'update',
    versionGroup: "updateAlert",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateAlert",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteAlert": {
    method: 'DELETE',
    path: '/transport/alerts/{alert_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'delete_alert_request',
    responseSchema: 'delete_alert_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['alert_id'],
    summary: "Delete an alert in the current organization.",
    resource: "alerts",
    cacheTags: ["alerts"],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteAlert",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteAlert",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listAlertEvents": {
    method: 'GET',
    path: '/transport/alerts/{alert_id}/events',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_alert_events_request',
    responseSchema: 'list_alert_events_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['alert_id'],
    summary: "List evaluation events for an alert.",
    resource: "alerts-events",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listAlertEvents",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listAlertEvents",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "testEvaluateAlert": {
    method: 'POST',
    path: '/transport/alerts/{alert_id}/test-evaluate',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'test_evaluate_alert_request',
    responseSchema: 'test_evaluate_alert_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['alert_id'],
    summary: "Dry-run an alert against a run without dispatching notifications.",
    resource: "alerts-test-evaluate",
    cacheTags: [],
    pagination: null,
    action: 'run',
    versionGroup: "testEvaluateAlert",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "testEvaluateAlert",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listScheduledRuns": {
    method: 'GET',
    path: '/transport/scheduled-runs',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_scheduled_runs_request',
    responseSchema: 'list_scheduled_runs_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List active scheduled runs with template metadata for the current organization.",
    resource: "scheduled-runs",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listScheduledRuns",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listScheduledRuns",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getScheduledRun": {
    method: 'GET',
    path: '/transport/scheduled-runs/{scheduled_run_id}',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'get_scheduled_run_transport_request',
    responseSchema: 'get_scheduled_run_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['scheduled_run_id'],
    summary: "Fetch an active scheduled run with template metadata for the current organization.",
    resource: "scheduled-runs",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getScheduledRun",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getScheduledRun",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listScheduledRunHistory": {
    method: 'GET',
    path: '/transport/scheduled-runs/{scheduled_run_id}/runs',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'list_scheduled_run_history_request',
    responseSchema: 'list_scheduled_run_history_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['scheduled_run_id'],
    summary: "List runs created by a scheduled run.",
    resource: "scheduled-runs-runs",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listScheduledRunHistory",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listScheduledRunHistory",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createScheduledRun": {
    method: 'POST',
    path: '/transport/scheduled-runs',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_scheduled_run_transport_request',
    responseSchema: 'create_scheduled_run_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a scheduled run for the current organization.",
    resource: "scheduled-runs",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "createScheduledRun",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createScheduledRun",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateScheduledRun": {
    method: 'PATCH',
    path: '/transport/scheduled-runs/{scheduled_run_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_scheduled_run_transport_request',
    responseSchema: 'update_scheduled_run_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['scheduled_run_id'],
    summary: "Update a scheduled run for the current organization.",
    resource: "scheduled-runs",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateScheduledRun",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateScheduledRun",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteScheduledRun": {
    method: 'DELETE',
    path: '/transport/scheduled-runs/{scheduled_run_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'delete_scheduled_run_transport_request',
    responseSchema: 'delete_scheduled_run_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['scheduled_run_id'],
    summary: "Delete a scheduled run for the current organization.",
    resource: "scheduled-runs",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteScheduledRun",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteScheduledRun",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "testSetMetadata": {
    method: 'GET',
    path: '/transport/test-sets/metadata',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'test_set_metadata_request',
    responseSchema: 'test_set_metadata_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch one test set metadata record or a paginated test-set metadata index.",
    resource: "test-sets-metadata",
    cacheTags: [],
    pagination: null,
    action: 'run',
    versionGroup: "testSetMetadata",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "testSetMetadata",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "testSetRecords": {
    method: 'GET',
    path: '/transport/test-sets/records',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'test_set_records_request',
    responseSchema: 'test_set_records_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List active test-case records for a test set in the current organization.",
    resource: "test-sets-records",
    cacheTags: [],
    pagination: null,
    action: 'run',
    versionGroup: "testSetRecords",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "testSetRecords",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listTestSets": {
    method: 'GET',
    path: '/transport/test-sets/list',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_test_sets_transport_request',
    responseSchema: 'list_test_sets_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List test sets for simple selectors in the current organization.",
    resource: "test-sets-list",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listTestSets",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listTestSets",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getTestSetVersions": {
    method: 'GET',
    path: '/transport/test-sets/versions',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_test_set_versions_request',
    responseSchema: 'get_test_set_versions_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List the prior-version history for a test set visible to the current organization.",
    resource: "test-sets-versions",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getTestSetVersions",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getTestSetVersions",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "revertTestSetVersion": {
    method: 'POST',
    path: '/transport/test-sets/versions/revert',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'revert_test_set_version_request',
    responseSchema: 'revert_test_set_version_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Revert a test set to one of its prior versions.",
    resource: "test-set-versions",
    cacheTags: ["test-sets"],
    pagination: null,
    action: 'update',
    versionGroup: "revertTestSetVersion",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "revertTestSetVersion",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listTestSetTags": {
    method: 'GET',
    path: '/transport/test-sets/tags',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'list_test_set_tags_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List active test-set tags for the current organization.",
    resource: "test-sets-tags",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listTestSetTags",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listTestSetTags",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "testSetMetadataKeys": {
    method: 'GET',
    path: '/transport/test-sets/metadata-keys',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'test_set_metadata_keys_request',
    responseSchema: 'test_set_metadata_keys_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List distinct expected-output metadata keys for active test cases.",
    resource: "test-sets-metadata-keys",
    cacheTags: [],
    pagination: null,
    action: 'run',
    versionGroup: "testSetMetadataKeys",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "testSetMetadataKeys",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listTestCases": {
    method: 'GET',
    path: '/transport/test-sets/test-cases',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_test_cases_transport_request',
    responseSchema: 'list_test_cases_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List active test cases with test-set names for filter option pickers.",
    resource: "test-sets-test-cases",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listTestCases",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listTestCases",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createTestSet": {
    method: 'POST',
    path: '/transport/test-sets/create',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_test_set_transport_request',
    responseSchema: 'create_test_set_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a test set with optional initial test cases.",
    resource: "test-sets",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "createTestSet",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createTestSet",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateTestCaseRow": {
    method: 'PATCH',
    path: '/transport/test-sets/rows/update',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_test_case_row_transport_request',
    responseSchema: 'success_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update one active test-case row.",
    resource: "test-sets-rows",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateTestCaseRow",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateTestCaseRow",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "addTestSetRows": {
    method: 'POST',
    path: '/transport/test-sets/rows/add',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'add_test_set_rows_transport_request',
    responseSchema: 'add_test_set_rows_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Append rows to an existing test set.",
    resource: "test-sets-rows",
    cacheTags: [],
    pagination: null,
    action: 'set',
    versionGroup: "addTestSetRows",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "addTestSetRows",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteTestSetRow": {
    method: 'POST',
    path: '/transport/test-sets/rows/delete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'delete_test_set_row_transport_request',
    responseSchema: 'success_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Soft-delete one test-case row.",
    resource: "test-sets-rows",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteTestSetRow",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteTestSetRow",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteTestSet": {
    method: 'POST',
    path: '/transport/test-sets/delete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'delete_test_set_transport_request',
    responseSchema: 'success_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Delete a test set, recoverable for the retention window.",
    resource: "test-sets",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteTestSet",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteTestSet",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteTestSets": {
    method: 'POST',
    path: '/transport/test-sets:batchDelete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'delete_test_sets_request',
    responseSchema: 'delete_test_sets_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Delete up to 100 test sets independently and return per-ID outcomes.",
    resource: "test-sets-batch",
    cacheTags: ["test-sets"],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteTestSets",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteTestSets",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateTestSet": {
    method: 'PATCH',
    path: '/transport/test-sets/update',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_test_set_transport_request',
    responseSchema: 'success_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update test-set metadata.",
    resource: "test-sets",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateTestSet",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateTestSet",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "saveTestSetEditorState": {
    method: 'POST',
    path: '/transport/test-sets/editor/save',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'save_test_set_editor_state_transport_request',
    responseSchema: 'save_test_set_editor_state_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Persist the full test-set editor state transactionally.",
    resource: "test-sets-editor",
    cacheTags: [],
    pagination: null,
    action: 'set',
    versionGroup: "saveTestSetEditorState",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "saveTestSetEditorState",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getTestCaseMediaUploadUrl": {
    method: 'POST',
    path: '/transport/test-sets/media/upload-url',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'get_media_upload_url_transport_request',
    responseSchema: 'media_upload_url_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a presigned media upload URL for a test case.",
    resource: "test-sets-media-upload-url",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getTestCaseMediaUploadUrl",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getTestCaseMediaUploadUrl",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getTestCaseMediaPreviewUrl": {
    method: 'GET',
    path: '/transport/test-sets/media/preview-url',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_media_preview_url_transport_request',
    responseSchema: 'media_preview_url_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a presigned media preview URL for a test case.",
    resource: "test-sets-media-preview-url",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getTestCaseMediaPreviewUrl",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getTestCaseMediaPreviewUrl",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "duplicateTestSet": {
    method: 'POST',
    path: '/transport/test-sets/duplicate',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'duplicate_test_set_transport_request',
    responseSchema: 'duplicate_test_set_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Duplicate a test set and its active rows.",
    resource: "test-sets",
    cacheTags: [],
    pagination: null,
    action: 'duplicate',
    versionGroup: "duplicateTestSet",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "duplicateTestSet",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getTestSetAgentAssociations": {
    method: 'GET',
    path: '/transport/test-sets/agent-associations',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_test_set_agent_associations_transport_request',
    responseSchema: 'get_test_set_agent_associations_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List agents associated to a test set.",
    resource: "test-sets-agent-associations",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getTestSetAgentAssociations",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getTestSetAgentAssociations",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "addTestSetAgentAssociations": {
    method: 'POST',
    path: '/transport/test-sets/agent-associations/add',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'add_test_set_agent_associations_transport_request',
    responseSchema: 'success_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Associate agents to a test set.",
    resource: "test-sets-agent-associations",
    cacheTags: [],
    pagination: null,
    action: 'set',
    versionGroup: "addTestSetAgentAssociations",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "addTestSetAgentAssociations",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "removeTestSetAgentAssociation": {
    method: 'POST',
    path: '/transport/test-sets/agent-associations/remove',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'remove_test_set_agent_association_transport_request',
    responseSchema: 'success_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Remove one agent association from a test set.",
    resource: "test-sets-agent-associations",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "removeTestSetAgentAssociation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "removeTestSetAgentAssociation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listRecentlyDeletedTestSets": {
    method: 'GET',
    path: '/transport/test-sets/recently-deleted',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'list_recently_deleted_test_sets_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List Recently Deleted test sets by workspace; default includes legacy NULL rows; unresolved is empty.",
    resource: "test-sets",
    cacheTags: ["test-sets"],
    pagination: null,
    action: 'list',
    versionGroup: "listRecentlyDeletedTestSets",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listRecentlyDeletedTestSets",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getTestSetAutoAddRule": {
    method: 'GET',
    path: '/transport/test-sets/auto-add/rule',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_test_set_auto_add_rule_request',
    responseSchema: 'get_test_set_auto_add_rule_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Read the auto-add rule on a test set, if one exists.",
    resource: "test-sets-auto-add-rule",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getTestSetAutoAddRule",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getTestSetAutoAddRule",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "saveTestSetAutoAddRule": {
    method: 'POST',
    path: '/transport/test-sets/auto-add/rule/save',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'save_test_set_auto_add_rule_request',
    responseSchema: 'save_test_set_auto_add_rule_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create or replace the auto-add rule on a test set.",
    resource: "test-sets-auto-add-rule",
    cacheTags: ["test_sets", "test_set_auto_add"],
    pagination: null,
    action: 'set',
    versionGroup: "saveTestSetAutoAddRule",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "saveTestSetAutoAddRule",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteTestSetAutoAddRule": {
    method: 'POST',
    path: '/transport/test-sets/auto-add/rule/delete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'delete_test_set_auto_add_rule_request',
    responseSchema: 'test_set_auto_add_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Remove the auto-add rule from a test set.",
    resource: "test-sets-auto-add-rule",
    cacheTags: ["test_sets", "test_set_auto_add"],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteTestSetAutoAddRule",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteTestSetAutoAddRule",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listTestSetAutoAddPending": {
    method: 'GET',
    path: '/transport/test-sets/auto-add/pending',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_test_set_auto_add_pending_request',
    responseSchema: 'list_test_set_auto_add_pending_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List auto-added test cases on a test set that are waiting for review.",
    resource: "test-sets-auto-add-pending",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listTestSetAutoAddPending",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listTestSetAutoAddPending",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "acceptTestSetAutoAddSuggestion": {
    method: 'POST',
    path: '/transport/test-sets/auto-add/pending/accept',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'accept_test_set_auto_add_suggestion_request',
    responseSchema: 'accept_test_set_auto_add_suggestion_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Accept an auto-added test case with its reviewed expected behaviors and activate it.",
    resource: "test-sets-auto-add-pending-accept",
    cacheTags: ["test_sets", "test_set_auto_add"],
    pagination: null,
    action: 'run',
    versionGroup: "acceptTestSetAutoAddSuggestion",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "acceptTestSetAutoAddSuggestion",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "rejectTestSetAutoAddSuggestion": {
    method: 'POST',
    path: '/transport/test-sets/auto-add/pending/reject',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'reject_test_set_auto_add_suggestion_request',
    responseSchema: 'test_set_auto_add_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Reject an auto-added test case and remove it from the test set.",
    resource: "test-sets-auto-add-pending-reject",
    cacheTags: ["test_sets", "test_set_auto_add"],
    pagination: null,
    action: 'run',
    versionGroup: "rejectTestSetAutoAddSuggestion",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "rejectTestSetAutoAddSuggestion",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getTestSetAutoAddSummary": {
    method: 'GET',
    path: '/transport/test-sets/auto-add/summary',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_test_set_auto_add_summary_request',
    responseSchema: 'get_test_set_auto_add_summary_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Auto-add evaluation counts for a test set.",
    resource: "test-sets-auto-add-summary",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getTestSetAutoAddSummary",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getTestSetAutoAddSummary",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listTestSetAutoAddPendingCounts": {
    method: 'GET',
    path: '/transport/test-sets/auto-add/pending-counts',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_test_set_auto_add_pending_counts_request',
    responseSchema: 'list_test_set_auto_add_pending_counts_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Pending review counts by test set for the current organization.",
    resource: "test-sets-auto-add-pending-counts",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listTestSetAutoAddPendingCounts",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listTestSetAutoAddPendingCounts",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "restoreTestSet": {
    method: 'POST',
    path: '/transport/test-sets/restore',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'restore_test_set_transport_request',
    responseSchema: 'restore_test_set_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Restore a workspace test set; default includes legacy NULL-workspace rows; unresolved returns 404.",
    resource: "test-sets-restore-test-set",
    cacheTags: ["test-sets"],
    pagination: null,
    action: 'update',
    versionGroup: "restoreTestSet",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "restoreTestSet",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listPersonas": {
    method: 'GET',
    path: '/transport/personas',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_personas_request',
    responseSchema: 'list_personas_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List personas available to the current organization.",
    resource: "personas",
    cacheTags: ["personas"],
    pagination: { itemKey: "personas", requestTokenKey: "page_token", responseTokenKey: "next_page_token" },
    action: 'list',
    versionGroup: "listPersonas",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listPersonas",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listPersonaTags": {
    method: 'GET',
    path: '/transport/personas/tags',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'list_persona_tags_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List active persona tags for the current organization.",
    resource: "personas-tags",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listPersonaTags",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listPersonaTags",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listRecentlyDeletedPersonas": {
    method: 'GET',
    path: '/transport/personas/recently-deleted',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'list_recently_deleted_personas_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List Recently Deleted personas by workspace; default includes legacy NULL rows; unresolved is empty.",
    resource: "personas-list-recently-deleted-personas",
    cacheTags: ["personas"],
    pagination: null,
    action: 'list',
    versionGroup: "listRecentlyDeletedPersonas",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listRecentlyDeletedPersonas",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listBackgroundSounds": {
    method: 'GET',
    path: '/transport/personas/background-sounds',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_background_sounds_request',
    responseSchema: 'list_background_sounds_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List built-in and custom background sounds for the current organization.",
    resource: "background-sounds",
    cacheTags: ["background-sounds", "personas"],
    pagination: null,
    action: 'list',
    versionGroup: "listBackgroundSounds",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listBackgroundSounds",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listRunTemplates": {
    method: 'GET',
    path: '/transport/run-templates',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_run_templates_transport_request',
    responseSchema: 'list_run_templates_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List active run templates and lightweight template options for the current organization.",
    resource: "run-templates",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listRunTemplates",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listRunTemplates",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getRunTemplate": {
    method: 'GET',
    path: '/transport/run-templates/{run_template_id}',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'get_run_template_transport_request',
    responseSchema: 'get_run_template_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['run_template_id'],
    summary: "Retrieve a run template for the current organization.",
    resource: "run-templates",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getRunTemplate",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getRunTemplate",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createRunTemplate": {
    method: 'POST',
    path: '/transport/run-templates',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_run_template_transport_request',
    responseSchema: 'create_run_template_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a run template for the current organization.",
    resource: "run-templates",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "createRunTemplate",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createRunTemplate",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateRunTemplate": {
    method: 'PATCH',
    path: '/transport/run-templates/{run_template_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_run_template_transport_request',
    responseSchema: 'update_run_template_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['run_template_id'],
    summary: "Update a run template for the current organization.",
    resource: "run-templates",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateRunTemplate",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateRunTemplate",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteRunTemplate": {
    method: 'DELETE',
    path: '/transport/run-templates/{run_template_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'delete_run_template_transport_request',
    responseSchema: 'delete_run_template_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['run_template_id'],
    summary: "Delete a run template for the current organization.",
    resource: "run-templates",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteRunTemplate",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteRunTemplate",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "duplicateRunTemplate": {
    method: 'POST',
    path: '/transport/run-templates/{run_template_id}/duplicate',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'duplicate_run_template_request',
    responseSchema: 'duplicate_run_template_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['run_template_id'],
    summary: "Duplicate saved template configuration in the authenticated scope.",
    resource: "run-templates",
    cacheTags: ["run-templates"],
    pagination: null,
    action: 'duplicate',
    versionGroup: "duplicateRunTemplate",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "duplicateRunTemplate",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listReports": {
    method: 'GET',
    path: '/transport/reports',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_reports_request',
    responseSchema: 'list_reports_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List active multi-run reports for the current organization.",
    resource: "reports",
    cacheTags: ["reports"],
    pagination: { itemKey: "reports", requestTokenKey: "cursor", responseTokenKey: "next_cursor" },
    action: 'list',
    versionGroup: "listReports",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listReports",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getReport": {
    method: 'GET',
    path: '/transport/reports/{report_id}',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'get_report_transport_request',
    responseSchema: 'get_report_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['report_id'],
    summary: "Retrieve a multi-run report for the current organization.",
    resource: "reports",
    cacheTags: ["reports"],
    pagination: null,
    action: 'get',
    versionGroup: "getReport",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getReport",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getPublicReport": {
    method: 'GET',
    path: '/transport/reports/public',
    auth: 'none',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'query',
    requestSchema: 'get_public_report_transport_request',
    responseSchema: 'get_public_report_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Retrieve a public multi-run report.",
    resource: "reports-public",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getPublicReport",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getPublicReport",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getReportRows": {
    method: 'POST',
    path: '/transport/reports/{report_id}/rows',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'report_rows_request',
    responseSchema: 'report_rows_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['report_id'],
    summary: "Fetch lean report rows for the current organization.",
    resource: "reports-rows",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getReportRows",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getReportRows",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getPublicReportRows": {
    method: 'POST',
    path: '/transport/reports/public/rows',
    auth: 'none',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'get_public_report_rows_request',
    responseSchema: 'report_rows_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch lean rows for a public multi-run report.",
    resource: "reports-public-rows",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getPublicReportRows",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getPublicReportRows",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getCohortOutliers": {
    method: 'POST',
    path: '/transport/reports/outliers',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'cohort_outliers_request',
    responseSchema: 'cohort_outliers_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Analyze potential Tukey-IQR metric outliers across a report, simulation, or run cohort.",
    resource: "reports-outliers",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getCohortOutliers",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getCohortOutliers",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "saveReport": {
    method: 'POST',
    path: '/transport/reports',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'save_report_transport_request',
    responseSchema: 'save_report_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a multi-run report for the current organization.",
    resource: "reports",
    cacheTags: ["reports"],
    pagination: null,
    action: 'create',
    versionGroup: "saveReport",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "saveReport",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateReport": {
    method: 'PATCH',
    path: '/transport/reports/{report_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_report_transport_request',
    responseSchema: 'update_report_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['report_id'],
    summary: "Update a multi-run report for the current organization.",
    resource: "reports",
    cacheTags: ["reports"],
    pagination: null,
    action: 'update',
    versionGroup: "updateReport",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateReport",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "setReportVisibility": {
    method: 'POST',
    path: '/transport/reports/visibility',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'set_report_visibility_transport_request',
    responseSchema: 'set_report_visibility_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Set report and run public visibility for the current organization.",
    resource: "reports",
    cacheTags: ["reports"],
    pagination: null,
    action: 'set',
    versionGroup: "setReportVisibility",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "setReportVisibility",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteReport": {
    method: 'DELETE',
    path: '/transport/reports/{report_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'delete_report_transport_request',
    responseSchema: 'delete_report_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['report_id'],
    summary: "Soft-delete a multi-run report for the current organization.",
    resource: "reports",
    cacheTags: ["reports"],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteReport",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteReport",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getReviewOverview": {
    method: 'GET',
    path: '/transport/reviews/overview/v2',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_review_overview_v2_request',
    responseSchema: 'get_review_overview_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch a lightweight human review assignments overview with explicit map opt-ins.",
    resource: "reviews-overview-v2",
    cacheTags: ["review-overview"],
    pagination: null,
    action: 'get',
    versionGroup: "getReviewOverview",
    version: 2,
    isDefaultVersion: true,
    canonicalOperation: "getReviewOverview.v2",
    deprecationMessage: null,
    replacementOperation: null,
  },
  /** @deprecated Use getReviewOverview.v2 for explicit lightweight payload controls. Use getReviewOverview.v2 instead. */
  "getReviewOverview.v1": {
    method: 'GET',
    path: '/transport/reviews/overview',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_review_overview_request',
    responseSchema: 'get_review_overview_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch the human review assignments overview for the current user.",
    resource: "reviews-overview",
    cacheTags: ["review-overview"],
    pagination: null,
    action: 'get',
    versionGroup: "getReviewOverview",
    version: 1,
    isDefaultVersion: false,
    canonicalOperation: "getReviewOverview.v1",
    deprecationMessage: "Use getReviewOverview.v2 for explicit lightweight payload controls.",
    replacementOperation: "getReviewOverview.v2",
  },
  "getReviewOverview.v2": {
    method: 'GET',
    path: '/transport/reviews/overview/v2',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_review_overview_v2_request',
    responseSchema: 'get_review_overview_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch a lightweight human review assignments overview with explicit map opt-ins.",
    resource: "reviews-overview-v2",
    cacheTags: ["review-overview"],
    pagination: null,
    action: 'get',
    versionGroup: "getReviewOverview",
    version: 2,
    isDefaultVersion: true,
    canonicalOperation: "getReviewOverview.v2",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "queryHumanReviewProjectAnnotationsTable": {
    method: 'POST',
    path: '/transport/reviews/projects/annotations-table',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'query_human_review_project_annotations_table_request',
    responseSchema: 'query_human_review_project_annotations_table_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch one bounded page of human review project annotation rows.",
    resource: "review-project-annotations-table",
    cacheTags: ["review-projects", "review-annotations", "review-metric-outputs", "review-labels"],
    pagination: { itemKey: "items", requestTokenKey: "cursor", responseTokenKey: "next_cursor" },
    action: 'list',
    versionGroup: "queryHumanReviewProjectAnnotationsTable",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "queryHumanReviewProjectAnnotationsTable",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "queryHumanReviewProjectTriageMembership": {
    method: 'POST',
    path: '/transport/reviews/projects/{project_id}/triage-memberships:query',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'query_human_review_project_triage_membership_request',
    responseSchema: 'query_human_review_project_triage_membership_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Fetch one bounded page of effective Human Review triage membership.",
    resource: "review-project-triage-membership",
    cacheTags: ["review-projects", "review-labels"],
    pagination: { itemKey: "items", requestTokenKey: "cursor", responseTokenKey: "next_cursor" },
    action: 'query',
    versionGroup: "queryHumanReviewProjectTriageMembership",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "queryHumanReviewProjectTriageMembership",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listReviewMetricSkips": {
    method: 'GET',
    path: '/transport/reviews/projects/{project_id}/metric-skips',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_review_metric_skips_request',
    responseSchema: 'list_review_metric_skips_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "List current metric skips for one review conversation.",
    resource: "review-metric-skips",
    cacheTags: ["review-metric-skips", "review-projects"],
    pagination: null,
    action: 'list',
    versionGroup: "listReviewMetricSkips",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listReviewMetricSkips",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "skipReviewMetric": {
    method: 'POST',
    path: '/transport/reviews/projects/{project_id}/metric-skips:skip',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'skip_review_metric_request',
    responseSchema: 'skip_review_metric_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Skip one linked metric for the authenticated reviewer.",
    resource: "review-metric-skips",
    cacheTags: ["review-metric-skips", "review-projects", "review-overview", "review-annotations", "review-metric-agreements", "review-project-rerun-context"],
    pagination: null,
    action: 'create',
    versionGroup: "skipReviewMetric",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "skipReviewMetric",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "unskipReviewMetric": {
    method: 'POST',
    path: '/transport/reviews/projects/{project_id}/metric-skips:unskip',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'unskip_review_metric_request',
    responseSchema: 'unskip_review_metric_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Clear one metric skip for the authenticated reviewer.",
    resource: "review-metric-skips",
    cacheTags: ["review-metric-skips", "review-projects", "review-overview", "review-annotations", "review-metric-agreements", "review-project-rerun-context"],
    pagination: null,
    action: 'update',
    versionGroup: "unskipReviewMetric",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "unskipReviewMetric",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getHumanReviewProjectAnnotationDetails": {
    method: 'GET',
    path: '/transport/reviews/projects/annotation-details',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_human_review_project_annotation_details_request',
    responseSchema: 'get_human_review_project_annotation_details_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch one project conversation's complete, read-only label detail.",
    resource: "review-project-annotation-details",
    cacheTags: ["review-projects", "review-annotations", "review-metric-outputs", "review-labels"],
    pagination: null,
    action: 'get',
    versionGroup: "getHumanReviewProjectAnnotationDetails",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getHumanReviewProjectAnnotationDetails",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getReviewProjectSimulationCompletions": {
    method: 'GET',
    path: '/transport/reviews/projects/simulation-completions',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_review_project_simulation_completions_request',
    responseSchema: 'get_review_project_simulation_completions_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch ordered completion status and optional upload timestamps for a human review project.",
    resource: "review-project-simulation-completions",
    cacheTags: ["review-overview", "review-projects", "review-annotations", "review-labels"],
    pagination: null,
    action: 'get',
    versionGroup: "getReviewProjectSimulationCompletions",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getReviewProjectSimulationCompletions",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "batchGetReviewProjectConversationStates": {
    method: 'POST',
    path: '/transport/reviews/projects/{project_id}/conversation-states:batchGet',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'batch_get_review_project_conversation_states_request',
    responseSchema: 'batch_get_review_project_conversation_states_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Fetch bounded queue state for linked review project conversations.",
    resource: "review-project-conversation-states",
    cacheTags: ["review-projects", "review-overview", "review-annotations", "review-labels"],
    pagination: null,
    action: 'run',
    versionGroup: "batchGetReviewProjectConversationStates",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "batchGetReviewProjectConversationStates",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getMetricHealthStats": {
    method: 'GET',
    path: '/transport/reviews/metric-health-stats',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_metric_health_stats_request',
    responseSchema: 'get_metric_health_stats_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch compact machine and human agreement health stats for a metric.",
    resource: "review-metric-health",
    cacheTags: ["review-metric-health", "review-annotations"],
    pagination: null,
    action: 'get',
    versionGroup: "getMetricHealthStats",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getMetricHealthStats",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getMetricAgreementHistory": {
    method: 'GET',
    path: '/transport/reviews/metric-agreement-history',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_metric_agreement_history_request',
    responseSchema: 'get_metric_agreement_history_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch machine-vs-human agreement for a metric, broken out by the versions that scored it.",
    resource: "review-metric-agreement-history",
    cacheTags: ["review-metric-agreement-history", "review-annotations"],
    pagination: null,
    action: 'get',
    versionGroup: "getMetricAgreementHistory",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getMetricAgreementHistory",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getHumanReviewProjectInsights": {
    method: 'GET',
    path: '/transport/reviews/projects/insights',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_human_review_project_insights_request',
    responseSchema: 'get_human_review_project_insights_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch project-level human review insights for a human review project.",
    resource: "review-project-insights",
    cacheTags: ["review-projects", "review-annotations", "review-labels"],
    pagination: null,
    action: 'get',
    versionGroup: "getHumanReviewProjectInsights",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getHumanReviewProjectInsights",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getHumanReviewProjectInsightSlice": {
    method: 'GET',
    path: '/transport/reviews/projects/insight-slice',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_human_review_project_insight_slice_request',
    responseSchema: 'get_human_review_project_insight_slice_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch one bounded project-level human review insight dependency.",
    resource: "review-project-insight-slice",
    cacheTags: ["review-projects", "review-annotations", "review-labels"],
    pagination: null,
    action: 'get',
    versionGroup: "getHumanReviewProjectInsightSlice",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getHumanReviewProjectInsightSlice",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getHumanReviewProjectDateDensity": {
    method: 'GET',
    path: '/transport/reviews/projects/date-density',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_human_review_project_date_density_request',
    responseSchema: 'get_human_review_project_date_density_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch zero-filled daily project density for the Insights date picker.",
    resource: "review-project-date-density",
    cacheTags: ["review-projects", "review-annotations", "review-labels"],
    pagination: null,
    action: 'get',
    versionGroup: "getHumanReviewProjectDateDensity",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getHumanReviewProjectDateDensity",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getHumanReviewProjectLayout": {
    method: 'GET',
    path: '/transport/reviews/projects/{project_id}/layouts/{layout_key}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'get_human_review_project_layout_request',
    responseSchema: 'get_human_review_project_layout_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id', 'layout_key'],
    summary: "Fetch a shared Human Review project layout.",
    resource: "review-project-layout",
    cacheTags: ["review-project-layout"],
    pagination: null,
    action: 'get',
    versionGroup: "getHumanReviewProjectLayout",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getHumanReviewProjectLayout",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "saveHumanReviewProjectLayout": {
    method: 'PUT',
    path: '/transport/reviews/projects/{project_id}/layouts/{layout_key}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'save_human_review_project_layout_request',
    responseSchema: 'save_human_review_project_layout_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id', 'layout_key'],
    summary: "Save a shared Human Review project layout.",
    resource: "review-project-layout",
    cacheTags: ["review-project-layout"],
    pagination: null,
    action: 'update',
    versionGroup: "saveHumanReviewProjectLayout",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "saveHumanReviewProjectLayout",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getReviewDisagreementState": {
    method: 'POST',
    path: '/transport/reviews/disagreement-state',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'get_review_disagreement_state_request',
    responseSchema: 'get_review_disagreement_state_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch compact unresolved review disagreement state for note enforcement.",
    resource: "review-disagreement-state",
    cacheTags: ["review-metric-outputs"],
    pagination: null,
    action: 'get',
    versionGroup: "getReviewDisagreementState",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getReviewDisagreementState",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getAnnotationsWithMetricOutputs": {
    method: 'POST',
    path: '/transport/reviews/annotations/with-metric-outputs',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'get_annotations_with_metric_outputs_request',
    responseSchema: 'get_annotations_with_metric_outputs_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch review annotations with latest pipeline metric outputs grouped for review UIs.",
    resource: "review-annotations",
    cacheTags: ["review-annotations", "review-metric-outputs"],
    pagination: { itemKey: "annotations", requestTokenKey: "page_token", responseTokenKey: "next_page_token" },
    action: 'get',
    versionGroup: "getAnnotationsWithMetricOutputs",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getAnnotationsWithMetricOutputs",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getFeedbackForSimulationOutput": {
    method: 'GET',
    path: '/transport/reviews/annotations/by-simulation-output',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_feedback_for_simulation_output_request',
    responseSchema: 'review_annotations_by_metric_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch human review annotations for one simulation output grouped by metric.",
    resource: "reviews-annotations-by-simulation-output",
    cacheTags: ["review-annotations"],
    pagination: null,
    action: 'get',
    versionGroup: "getFeedbackForSimulationOutput",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getFeedbackForSimulationOutput",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getAllAnnotationsByOrg": {
    method: 'GET',
    path: '/transport/reviews/annotations/by-org',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_all_annotations_by_org_request',
    responseSchema: 'review_annotations_by_metric_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch human review annotations in the current organization grouped by metric.",
    resource: "reviews-annotations-by-org",
    cacheTags: ["review-annotations"],
    pagination: null,
    action: 'get',
    versionGroup: "getAllAnnotationsByOrg",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getAllAnnotationsByOrg",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listHumanReviewAlerts": {
    method: 'GET',
    path: '/transport/reviews/alerts',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'list_human_review_alerts_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List legacy human-review auto-add alerts for the current organization.",
    resource: "review-alerts",
    cacheTags: ["review-alerts"],
    pagination: null,
    action: 'list',
    versionGroup: "listHumanReviewAlerts",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listHumanReviewAlerts",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteHumanReviewAlert": {
    method: 'DELETE',
    path: '/transport/reviews/alerts/{alert_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'delete_human_review_alert_request',
    responseSchema: 'human_review_alert_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['alert_id'],
    summary: "Delete a legacy human-review auto-add alert for the current organization.",
    resource: "review-alerts",
    cacheTags: ["review-alerts"],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteHumanReviewAlert",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteHumanReviewAlert",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getReviewLabelsForSimulation": {
    method: 'GET',
    path: '/transport/reviews/labels/simulation',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_review_labels_for_simulation_request',
    responseSchema: 'review_labels_for_simulation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch the current user's human-review labels for one project simulation.",
    resource: "review-labels",
    cacheTags: ["review-labels", "review-projects"],
    pagination: null,
    action: 'get',
    versionGroup: "getReviewLabelsForSimulation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getReviewLabelsForSimulation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "saveReviewLabelsForSimulation": {
    method: 'POST',
    path: '/transport/reviews/labels/simulation',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'save_review_labels_for_simulation_request',
    responseSchema: 'review_labels_for_simulation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Replace the current user's human-review labels for one project simulation.",
    resource: "review-labels",
    cacheTags: ["review-labels", "review-projects", "review-overview"],
    pagination: null,
    action: 'set',
    versionGroup: "saveReviewLabelsForSimulation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "saveReviewLabelsForSimulation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listReviewProjects": {
    method: 'GET',
    path: '/transport/reviews/projects',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_review_projects_request',
    responseSchema: 'list_review_projects_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List human review projects for the current organization.",
    resource: "review-projects",
    cacheTags: ["review-projects"],
    pagination: { itemKey: "review_projects", requestTokenKey: "page_token", responseTokenKey: "next_page_token" },
    action: 'list',
    versionGroup: "listReviewProjects",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listReviewProjects",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getReviewProject": {
    method: 'GET',
    path: '/transport/reviews/projects/{project_id}',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'get_review_project_request',
    responseSchema: 'get_review_project_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Retrieve a human review project for the current organization.",
    resource: "review-projects",
    cacheTags: ["review-projects"],
    pagination: null,
    action: 'get',
    versionGroup: "getReviewProject",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getReviewProject",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createReviewProject": {
    method: 'POST',
    path: '/transport/reviews/projects',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_review_project_request',
    responseSchema: 'create_review_project_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a human review project for the current organization.",
    resource: "review-projects",
    cacheTags: ["review-projects", "review-overview"],
    pagination: null,
    action: 'create',
    versionGroup: "createReviewProject",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createReviewProject",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "duplicateReviewProject": {
    method: 'POST',
    path: '/transport/reviews/projects/{project_id}/duplicate',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'duplicate_review_project_request',
    responseSchema: 'duplicate_review_project_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Duplicate a human review project for the current organization.",
    resource: "review-projects",
    cacheTags: ["review-projects", "review-overview"],
    pagination: null,
    action: 'duplicate',
    versionGroup: "duplicateReviewProject",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "duplicateReviewProject",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getProjectMetricAgreement": {
    method: 'GET',
    path: '/transport/reviews/projects/{project_id}/metric-agreement',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'get_project_metric_agreement_request',
    responseSchema: 'get_project_metric_agreement_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Fetch machine-vs-human agreement by metric for a human review project.",
    resource: "review-metric-agreements",
    cacheTags: ["review-metric-agreements"],
    pagination: null,
    action: 'get',
    versionGroup: "getProjectMetricAgreement",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getProjectMetricAgreement",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getReviewProjectRerunContext": {
    method: 'GET',
    path: '/transport/reviews/projects/{project_id}/rerun-context',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_review_project_rerun_context_request',
    responseSchema: 'get_review_project_rerun_context_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Resolve run ids, labeled sims, and per-metric missing sims for a human review project.",
    resource: "review-project-rerun-context",
    cacheTags: ["review-project-rerun-context"],
    pagination: null,
    action: 'get',
    versionGroup: "getReviewProjectRerunContext",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getReviewProjectRerunContext",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listReviewProjectMembershipLogs": {
    method: 'GET',
    path: '/transport/reviews/projects/{project_id}/membership-logs',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'list_review_project_membership_logs_request',
    responseSchema: 'list_review_project_membership_logs_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "List a human review project's conversation-add audit log.",
    resource: "review-project-membership-logs",
    cacheTags: ["review-project-membership-logs", "review-projects"],
    pagination: null,
    action: 'list',
    versionGroup: "listReviewProjectMembershipLogs",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listReviewProjectMembershipLogs",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listReviewProjectMembers": {
    method: 'GET',
    path: '/transport/reviews/projects/{project_id}/members',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'list_review_project_members_request',
    responseSchema: 'list_review_project_members_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "List a human review project's members with their effective role.",
    resource: "review-project-members",
    cacheTags: ["review-project-members", "review-projects"],
    pagination: null,
    action: 'list',
    versionGroup: "listReviewProjectMembers",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listReviewProjectMembers",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "setReviewProjectMemberRole": {
    method: 'PATCH',
    path: '/transport/reviews/projects/{project_id}/members',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'set_review_project_member_role_request',
    responseSchema: 'set_review_project_member_role_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Set a member's role on a human review project.",
    resource: "review-project-members",
    cacheTags: ["review-project-members"],
    pagination: null,
    action: 'update',
    versionGroup: "setReviewProjectMemberRole",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "setReviewProjectMemberRole",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "sendProjectAssignmentEmail": {
    method: 'POST',
    path: '/transport/reviews/projects/{project_id}/assignment-email',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'send_project_assignment_email_request',
    responseSchema: 'send_project_assignment_email_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Send human-review project assignment notifications for the current organization.",
    resource: "review-projects",
    cacheTags: ["review-projects", "review-overview"],
    pagination: null,
    action: 'run',
    versionGroup: "sendProjectAssignmentEmail",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "sendProjectAssignmentEmail",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "completeReviewConversation": {
    method: 'POST',
    path: '/transport/reviews/projects/{project_id}/complete-conversation',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'complete_review_conversation_request',
    responseSchema: 'complete_review_conversation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Verify one assignee's project-scoped review conversation completion.",
    resource: "reviews-projects-complete-conversation",
    cacheTags: ["review-projects", "review-overview"],
    pagination: null,
    action: 'run',
    versionGroup: "completeReviewConversation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "completeReviewConversation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "claimConversation": {
    method: 'POST',
    path: '/transport/reviews/projects/{project_id}/claim',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'claim_conversation_request',
    responseSchema: 'claim_conversation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Record that the calling reviewer is in a conversation (advisory only).",
    resource: "reviews-projects-claim",
    cacheTags: ["review-projects", "review-overview"],
    pagination: null,
    action: 'run',
    versionGroup: "claimConversation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "claimConversation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "releaseConversation": {
    method: 'POST',
    path: '/transport/reviews/projects/{project_id}/release',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'release_conversation_request',
    responseSchema: 'release_conversation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Release the calling reviewer's own conversation claim (advisory only).",
    resource: "reviews-projects-release",
    cacheTags: ["review-projects", "review-overview"],
    pagination: null,
    action: 'run',
    versionGroup: "releaseConversation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "releaseConversation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "forceReleaseConversation": {
    method: 'POST',
    path: '/transport/reviews/projects/{project_id}/force-release',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'force_release_conversation_request',
    responseSchema: 'force_release_conversation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Force-release every claim on a conversation (project managers only).",
    resource: "reviews-projects-force-release",
    cacheTags: ["review-projects", "review-overview"],
    pagination: null,
    action: 'run',
    versionGroup: "forceReleaseConversation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "forceReleaseConversation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "startReviewBatch": {
    method: 'POST',
    path: '/transport/reviews/projects/{project_id}/batches:start',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'start_review_batch_request',
    responseSchema: 'start_review_batch_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Start or resume the calling reviewer's batch of conversations.",
    resource: "reviews-projects-batches:start",
    cacheTags: ["review-projects", "review-overview"],
    pagination: null,
    action: 'run',
    versionGroup: "startReviewBatch",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "startReviewBatch",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getCurrentReviewBatch": {
    method: 'POST',
    path: '/transport/reviews/projects/{project_id}/batches:current',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'get_current_review_batch_request',
    responseSchema: 'get_current_review_batch_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Read the conversations the calling reviewer holds in their batch.",
    resource: "reviews-projects-batches:current",
    cacheTags: ["review-projects", "review-overview"],
    pagination: null,
    action: 'get',
    versionGroup: "getCurrentReviewBatch",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getCurrentReviewBatch",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "stopReviewBatch": {
    method: 'POST',
    path: '/transport/reviews/projects/{project_id}/batches:stop',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'stop_review_batch_request',
    responseSchema: 'stop_review_batch_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Release the calling reviewer's self-claimed conversations; assigned ones stay held.",
    resource: "reviews-projects-batches:stop",
    cacheTags: ["review-projects", "review-overview"],
    pagination: null,
    action: 'run',
    versionGroup: "stopReviewBatch",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "stopReviewBatch",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "assignReviewBatches": {
    method: 'POST',
    path: '/transport/reviews/projects/{project_id}/batches:assign',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'assign_review_batches_request',
    responseSchema: 'assign_review_batches_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Assign batches of conversations to reviewers (project managers only).",
    resource: "review-projects",
    cacheTags: ["review-projects", "review-overview"],
    pagination: null,
    action: 'set',
    versionGroup: "assignReviewBatches",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "assignReviewBatches",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "releaseReviewBatch": {
    method: 'POST',
    path: '/transport/reviews/projects/{project_id}/batches:release',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'release_review_batch_request',
    responseSchema: 'release_review_batch_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Release one batch or one held conversation (project managers only).",
    resource: "reviews-projects-batches:release",
    cacheTags: ["review-projects", "review-overview"],
    pagination: null,
    action: 'run',
    versionGroup: "releaseReviewBatch",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "releaseReviewBatch",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listReviewBatches": {
    method: 'GET',
    path: '/transport/reviews/projects/{project_id}/batches',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'list_review_batches_request',
    responseSchema: 'list_review_batches_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "List the progress of held reviewer batches (project managers only).",
    resource: "reviews-projects-batches",
    cacheTags: ["review-projects", "review-overview"],
    pagination: null,
    action: 'list',
    versionGroup: "listReviewBatches",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listReviewBatches",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateReviewProject": {
    method: 'PATCH',
    path: '/transport/reviews/projects/{project_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_review_project_request',
    responseSchema: 'update_review_project_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Update a human review project for the current organization.",
    resource: "review-projects",
    cacheTags: ["review-projects", "review-overview"],
    pagination: null,
    action: 'update',
    versionGroup: "updateReviewProject",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateReviewProject",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteReviewProject": {
    method: 'DELETE',
    path: '/transport/reviews/projects/{project_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'delete_review_project_request',
    responseSchema: 'review_project_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id'],
    summary: "Delete a human review project for the current organization.",
    resource: "review-projects",
    cacheTags: ["review-projects", "review-overview"],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteReviewProject",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteReviewProject",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listReviewAnnotations": {
    method: 'GET',
    path: '/transport/reviews/annotations',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_review_annotations_request',
    responseSchema: 'list_review_annotations_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List human review annotations for the current organization.",
    resource: "review-annotations",
    cacheTags: ["review-annotations"],
    pagination: { itemKey: "review_annotations", requestTokenKey: "page_token", responseTokenKey: "next_page_token" },
    action: 'list',
    versionGroup: "listReviewAnnotations",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listReviewAnnotations",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getReviewAnnotation": {
    method: 'GET',
    path: '/transport/reviews/annotations/{annotation_id}',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_review_annotation_request',
    responseSchema: 'get_review_annotation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['annotation_id'],
    summary: "Retrieve a human review annotation for the current organization.",
    resource: "review-annotations-get-review-annotation",
    cacheTags: ["review-annotations"],
    pagination: null,
    action: 'get',
    versionGroup: "getReviewAnnotation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getReviewAnnotation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createReviewAnnotation": {
    method: 'POST',
    path: '/transport/reviews/annotations',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_review_annotation_request',
    responseSchema: 'create_review_annotation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a human review annotation for the current organization.",
    resource: "review-annotations",
    cacheTags: ["review-annotations"],
    pagination: null,
    action: 'create',
    versionGroup: "createReviewAnnotation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createReviewAnnotation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateReviewAnnotation": {
    method: 'PATCH',
    path: '/transport/reviews/annotations/{annotation_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_review_annotation_request',
    responseSchema: 'update_review_annotation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['annotation_id'],
    summary: "Update a human review annotation for the current organization.",
    resource: "review-annotations",
    cacheTags: ["review-annotations"],
    pagination: null,
    action: 'update',
    versionGroup: "updateReviewAnnotation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateReviewAnnotation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteReviewAnnotation": {
    method: 'DELETE',
    path: '/transport/reviews/annotations/{annotation_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'delete_review_annotation_request',
    responseSchema: 'review_annotation_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['annotation_id'],
    summary: "Delete a human review annotation for the current organization.",
    resource: "review-annotations",
    cacheTags: ["review-annotations"],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteReviewAnnotation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteReviewAnnotation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateProjectReviewAnnotation": {
    method: 'PATCH',
    path: '/transport/reviews/projects/{project_id}/annotations/{project_annotation_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_project_review_annotation_request',
    responseSchema: 'update_review_annotation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id', 'project_annotation_id'],
    summary: "Update a project-scoped human review annotation for the current organization.",
    resource: "review-annotations-update-project-review-annotation",
    cacheTags: ["review-annotations", "review-projects", "review-overview"],
    pagination: null,
    action: 'update',
    versionGroup: "updateProjectReviewAnnotation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateProjectReviewAnnotation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteProjectReviewAnnotation": {
    method: 'DELETE',
    path: '/transport/reviews/projects/{project_id}/annotations/{project_annotation_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'delete_project_review_annotation_request',
    responseSchema: 'review_annotation_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['project_id', 'project_annotation_id'],
    summary: "Delete a project-scoped human review annotation for the current organization.",
    resource: "review-annotations-delete-project-review-annotation",
    cacheTags: ["review-annotations", "review-projects", "review-overview"],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteProjectReviewAnnotation",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteProjectReviewAnnotation",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "launchRun": {
    method: 'POST',
    path: '/transport/runs/launch',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'launch_run_request',
    responseSchema: 'launch_run_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Launch a v1 simulation run for the current organization.",
    resource: "runs",
    cacheTags: ["runs"],
    pagination: null,
    action: 'run',
    versionGroup: "launchRun",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "launchRun",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "rerunMetrics": {
    method: 'POST',
    path: '/transport/runs/rerun-metrics',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'rerun_metrics_request',
    responseSchema: 'rerun_metrics_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Re-score existing simulations against a set of metrics for the current organization.",
    resource: "runs-rerun-metrics",
    cacheTags: ["runs"],
    pagination: null,
    action: 'run',
    versionGroup: "rerunMetrics",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "rerunMetrics",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listRunsKeyset": {
    method: 'POST',
    path: '/transport/runs/keyset',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'runs_keyset_request',
    responseSchema: 'runs_keyset_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List simulation runs with keyset pagination for the current organization.",
    resource: "runs",
    cacheTags: ["runs"],
    pagination: { itemKey: "items", requestTokenKey: "cursor", responseTokenKey: "next_cursor" },
    action: 'list',
    versionGroup: "listRunsKeyset",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listRunsKeyset",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listSimulatedConversationsKeyset": {
    method: 'POST',
    path: '/transport/simulated-conversations/keyset',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'simulated_conversations_keyset_request',
    responseSchema: 'simulated_conversations_keyset_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List simulated conversation rows with keyset pagination.",
    resource: "simulated-conversations",
    cacheTags: ["run-simulations"],
    pagination: { itemKey: "items", requestTokenKey: "cursor", responseTokenKey: "next_cursor" },
    action: 'list',
    versionGroup: "listSimulatedConversationsKeyset",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listSimulatedConversationsKeyset",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getRunsPageInsights": {
    method: 'POST',
    path: '/transport/runs/insights',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'runs_page_insights_request',
    responseSchema: 'runs_page_insights_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch runs page sparkline and total stats for the current organization.",
    resource: "runs-insights",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getRunsPageInsights",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getRunsPageInsights",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getRunMetadata": {
    method: 'GET',
    path: '/transport/runs/metadata',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'run_metadata_request',
    responseSchema: 'run_metadata_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch run metadata for the current organization.",
    resource: "runs-metadata",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getRunMetadata",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getRunMetadata",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getMultiRunMetadata": {
    method: 'POST',
    path: '/transport/runs/metadata/batch',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'multi_run_metadata_request',
    responseSchema: 'multi_run_metadata_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch metadata for multiple runs in the current organization.",
    resource: "runs-metadata-batch",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getMultiRunMetadata",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getMultiRunMetadata",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getRunRows": {
    method: 'GET',
    path: '/transport/runs/rows',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'run_rows_request',
    responseSchema: 'run_rows_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch simulation rows for a run in the current organization.",
    resource: "runs-rows",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getRunRows",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getRunRows",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getRunOutliers": {
    method: 'GET',
    path: '/transport/runs/outliers',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'run_outliers_request',
    responseSchema: 'run_outliers_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Analyze potential Tukey-IQR metric outliers within a run.",
    resource: "runs",
    cacheTags: ["runs"],
    pagination: null,
    action: 'get',
    versionGroup: "getRunOutliers",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getRunOutliers",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getMultiRunRows": {
    method: 'POST',
    path: '/transport/runs/rows/batch',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'multi_run_rows_request',
    responseSchema: 'multi_run_rows_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch simulation rows for multiple runs in the current organization.",
    resource: "runs-rows-batch",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getMultiRunRows",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getMultiRunRows",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getLatestRun": {
    method: 'GET',
    path: '/transport/runs/latest',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'latest_run_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch the latest non-monitoring run for the current organization.",
    resource: "runs-latest",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getLatestRun",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getLatestRun",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "importSessionMappingFromCsv": {
    method: 'POST',
    path: '/transport/runs/session-mapping/import',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'import_session_mapping_request',
    responseSchema: 'import_session_mapping_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Import uploaded session mapping CSV data into simulation output integrations.",
    resource: "runs-session-mapping-import",
    cacheTags: [],
    pagination: null,
    action: 'run',
    versionGroup: "importSessionMappingFromCsv",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "importSessionMappingFromCsv",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateRunNotes": {
    method: 'PATCH',
    path: '/transport/runs/notes',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_run_notes_request',
    responseSchema: 'update_run_notes_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update notes on a simulation output in the current organization.",
    resource: "runs-notes",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateRunNotes",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateRunNotes",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteRun": {
    method: 'POST',
    path: '/transport/runs/delete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'delete_run_request',
    responseSchema: 'delete_run_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Soft-delete a run in the current organization.",
    resource: "runs",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteRun",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteRun",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "setRunPublic": {
    method: 'PATCH',
    path: '/transport/runs/public',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'set_run_public_request',
    responseSchema: 'set_run_public_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Set run and simulation output public visibility.",
    resource: "runs-public",
    cacheTags: [],
    pagination: null,
    action: 'set',
    versionGroup: "setRunPublic",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "setRunPublic",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateRunDisplayName": {
    method: 'PATCH',
    path: '/transport/runs/display-name',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_run_display_name_request',
    responseSchema: 'update_run_display_name_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update a run display name in the current organization.",
    resource: "runs-display-name",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateRunDisplayName",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateRunDisplayName",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "cancelRun": {
    method: 'POST',
    path: '/transport/runs/cancel',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'cancel_run_request',
    responseSchema: 'cancel_run_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Cancel a run in the current organization.",
    resource: "runs",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "cancelRun",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "cancelRun",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getLatestFailurePatternRunOutput": {
    method: 'GET',
    path: '/transport/conversation-clustering-runs/failure-patterns/output/latest',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_latest_failure_pattern_run_output_request',
    responseSchema: 'get_latest_failure_pattern_run_output_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch the most recent completed failure-pattern run output for the current organization.",
    resource: "conversation-clustering-runs-failure-patterns-output-latest",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getLatestFailurePatternRunOutput",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getLatestFailurePatternRunOutput",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getLatestConversationClusteringRunOutput": {
    method: 'GET',
    path: '/transport/conversation-clustering-runs/output/latest',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_latest_conversation_clustering_run_output_request',
    responseSchema: 'get_latest_conversation_clustering_run_output_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch the most recent completed conversation-clustering run output for the current organization.",
    resource: "conversation-clustering-runs-output-latest",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getLatestConversationClusteringRunOutput",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getLatestConversationClusteringRunOutput",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listRunTags": {
    method: 'GET',
    path: '/transport/runs/tags',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'list_run_tags_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List active run tags for the current organization.",
    resource: "runs-tags",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listRunTags",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listRunTags",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateRunTags": {
    method: 'PATCH',
    path: '/transport/runs/tags',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_run_tags_request',
    responseSchema: 'update_run_tags_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Replace tags on a run in the current organization.",
    resource: "runs-update-run-tags",
    cacheTags: ["runs"],
    pagination: null,
    action: 'update',
    versionGroup: "updateRunTags",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateRunTags",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getSimulationOutput": {
    method: 'GET',
    path: '/transport/simulation-outputs/get',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'simulation_output_id_request',
    responseSchema: 'simulation_output_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch one simulation output row for the current organization.",
    resource: "simulation-outputs",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getSimulationOutput",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getSimulationOutput",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listSimulationOutputIds": {
    method: 'GET',
    path: '/transport/simulation-outputs/ids',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'run_simulation_output_ids_request',
    responseSchema: 'simulation_output_ids_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List simulation output ids for one run in the current organization.",
    resource: "simulation-outputs-ids",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listSimulationOutputIds",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listSimulationOutputIds",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getSimulationOutputTimeWindow": {
    method: 'GET',
    path: '/transport/simulation-outputs/time-window',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'simulation_output_id_request',
    responseSchema: 'simulation_output_time_window_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch simulation start and end timestamps for one simulation output.",
    resource: "simulation-outputs-time-window",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getSimulationOutputTimeWindow",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getSimulationOutputTimeWindow",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getSimulationOutputSpeakingSegments": {
    method: 'GET',
    path: '/transport/simulation-outputs/speaking-segments',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'simulation_output_id_request',
    responseSchema: 'speaking_segments_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch audio speaking segments for one simulation output.",
    resource: "simulation-outputs-speaking-segments",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getSimulationOutputSpeakingSegments",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getSimulationOutputSpeakingSegments",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "setSimulationOutputPublic": {
    method: 'PATCH',
    path: '/transport/simulation-outputs/public',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'set_simulation_output_public_request',
    responseSchema: 'simulation_output_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Set public visibility for one simulation output.",
    resource: "simulation-outputs-public",
    cacheTags: [],
    pagination: null,
    action: 'set',
    versionGroup: "setSimulationOutputPublic",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "setSimulationOutputPublic",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteSimulationOutput": {
    method: 'POST',
    path: '/transport/simulation-outputs/delete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'simulation_output_id_request',
    responseSchema: 'simulation_output_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Hard-delete one simulation output and delete its run when it was the last output.",
    resource: "simulation-outputs",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteSimulationOutput",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteSimulationOutput",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "resimulateSimulationOutputs": {
    method: 'POST',
    path: '/transport/simulation-outputs/resimulate',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'resimulate_simulation_outputs_request',
    responseSchema: 'resimulate_simulation_outputs_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Queue one or more simulation outputs for resimulation.",
    resource: "simulation-outputs-resimulate",
    cacheTags: [],
    pagination: null,
    action: 'run',
    versionGroup: "resimulateSimulationOutputs",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "resimulateSimulationOutputs",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getSharedRunRecord": {
    method: 'POST',
    path: '/transport/shared-runs/run-record',
    auth: 'none',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'shared_run_password_request',
    responseSchema: 'shared_run_record_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Retrieve a public run record, enforcing its optional share password.",
    resource: "shared-runs-run-record",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getSharedRunRecord",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getSharedRunRecord",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "verifySharedRunPassword": {
    method: 'POST',
    path: '/transport/shared-runs/verify-password',
    auth: 'none',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'verify_shared_run_password_request',
    responseSchema: 'verify_shared_run_password_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Verify a public run share password.",
    resource: "shared-runs-verify-password",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "verifySharedRunPassword",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "verifySharedRunPassword",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getSharedRunRows": {
    method: 'POST',
    path: '/transport/shared-runs/run-rows',
    auth: 'none',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'shared_run_rows_request',
    responseSchema: 'shared_run_rows_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Retrieve rows for a public run, enforcing its optional share password.",
    resource: "shared-runs-run-rows",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getSharedRunRows",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getSharedRunRows",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getSharedTestSet": {
    method: 'POST',
    path: '/transport/shared-runs/test-set',
    auth: 'none',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'shared_test_set_request',
    responseSchema: 'shared_test_set_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Retrieve test set metadata used by a public run view.",
    resource: "shared-runs-test-set",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getSharedTestSet",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getSharedTestSet",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getSharedMetrics": {
    method: 'POST',
    path: '/transport/shared-runs/metrics',
    auth: 'none',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'shared_metrics_request',
    responseSchema: 'shared_metrics_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Retrieve metric records used by public run/report views.",
    resource: "shared-runs-metrics",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getSharedMetrics",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getSharedMetrics",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getSharedRunTestSet": {
    method: 'POST',
    path: '/transport/shared-runs/run-test-set',
    auth: 'none',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'shared_run_password_request',
    responseSchema: 'shared_test_set_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Retrieve the test set for a public run after password validation.",
    resource: "shared-runs-run-test-set",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getSharedRunTestSet",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getSharedRunTestSet",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getSharedMultiRunMetadata": {
    method: 'POST',
    path: '/transport/shared-runs/multi-run-metadata',
    auth: 'none',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'shared_run_ids_request',
    responseSchema: 'shared_multi_run_metadata_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Retrieve public run metadata and display names for shared reports.",
    resource: "shared-runs-multi-run-metadata",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getSharedMultiRunMetadata",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getSharedMultiRunMetadata",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getSharedMultiRunRows": {
    method: 'POST',
    path: '/transport/shared-runs/multi-run-rows',
    auth: 'none',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'shared_run_ids_request',
    responseSchema: 'shared_run_rows_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Retrieve public rows for multiple public runs in a shared report.",
    resource: "shared-runs-multi-run-rows",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getSharedMultiRunRows",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getSharedMultiRunRows",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getSharedSimulationOutputRow": {
    method: 'POST',
    path: '/transport/shared-runs/simulation-output-row',
    auth: 'none',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'shared_simulation_output_row_request',
    responseSchema: 'shared_simulation_output_row_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Retrieve a single public simulation output row after password validation.",
    resource: "shared-runs-simulation-output-row",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getSharedSimulationOutputRow",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getSharedSimulationOutputRow",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listSharedSimulationTraces": {
    method: 'POST',
    path: '/transport/shared-runs/simulation-traces',
    auth: 'none',
    databaseAccess: 'read',
    organizationRequired: false,
    requestLocation: 'json_body',
    requestSchema: 'shared_simulation_traces_request',
    responseSchema: 'simulation_traces_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List trace spans for a public simulation whose run is password-protected, after password validation.",
    resource: "shared-runs-simulation-traces",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listSharedSimulationTraces",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listSharedSimulationTraces",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getMaestroSimulationOutputCount": {
    method: 'POST',
    path: '/transport/maestro/simulation-output-count',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'maestro_simulation_output_count_request',
    responseSchema: 'maestro_simulation_output_count_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Count rerunnable simulation outputs for Maestro bulk-rerun filters.",
    resource: "maestro-simulation-output-count",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getMaestroSimulationOutputCount",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getMaestroSimulationOutputCount",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listMaestroSimulationOutputIds": {
    method: 'POST',
    path: '/transport/maestro/simulation-output-ids',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'maestro_simulation_output_ids_request',
    responseSchema: 'maestro_simulation_output_ids_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List rerunnable simulation output ids for Maestro bulk-rerun filters.",
    resource: "maestro-simulation-output-ids",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listMaestroSimulationOutputIds",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listMaestroSimulationOutputIds",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listMaestroExistingMetrics": {
    method: 'POST',
    path: '/transport/maestro/existing-metrics',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'maestro_base_filter_request',
    responseSchema: 'maestro_existing_metrics_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List metrics already present in Maestro-filtered simulation output rows.",
    resource: "maestro-existing-metrics",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listMaestroExistingMetrics",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listMaestroExistingMetrics",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listMaestroMetadataKeys": {
    method: 'POST',
    path: '/transport/maestro/metadata-keys',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'maestro_base_filter_request',
    responseSchema: 'maestro_metadata_keys_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List customer metadata keys present in Maestro-filtered rows.",
    resource: "maestro-metadata-keys",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listMaestroMetadataKeys",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listMaestroMetadataKeys",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listMaestroMetadataValues": {
    method: 'POST',
    path: '/transport/maestro/metadata-values',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'maestro_metadata_values_request',
    responseSchema: 'maestro_metadata_values_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List customer metadata values for one key in Maestro-filtered rows.",
    resource: "maestro-metadata-values",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listMaestroMetadataValues",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listMaestroMetadataValues",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "hasSimulationTraces": {
    method: 'GET',
    path: '/transport/traces/simulation/presence',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'simulation_trace_request',
    responseSchema: 'simulation_trace_presence_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Check whether a simulation output has external trace spans.",
    resource: "simulation-traces",
    cacheTags: ["traces", "simulation-traces"],
    pagination: null,
    action: 'query',
    versionGroup: "hasSimulationTraces",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "hasSimulationTraces",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listSimulationTraces": {
    method: 'GET',
    path: '/transport/traces/simulation',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'simulation_trace_request',
    responseSchema: 'simulation_traces_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List external trace spans for a simulation output.",
    resource: "simulation-traces",
    cacheTags: ["traces", "simulation-traces"],
    pagination: null,
    action: 'list',
    versionGroup: "listSimulationTraces",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listSimulationTraces",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getSimulationTraceDetail": {
    method: 'GET',
    path: '/transport/traces/simulation/detail',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'simulation_trace_request',
    responseSchema: 'simulation_trace_detail_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch the full trace detail tree for a simulation output.",
    resource: "simulation-traces",
    cacheTags: ["traces", "simulation-traces"],
    pagination: null,
    action: 'get',
    versionGroup: "getSimulationTraceDetail",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getSimulationTraceDetail",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "hasRunTraces": {
    method: 'GET',
    path: '/transport/traces/run/presence',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'run_trace_presence_request',
    responseSchema: 'run_trace_presence_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Check whether a run has external trace spans.",
    resource: "run-traces",
    cacheTags: ["traces", "run-traces"],
    pagination: null,
    action: 'get',
    versionGroup: "hasRunTraces",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "hasRunTraces",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getTraceAudioContext": {
    method: 'GET',
    path: '/transport/traces/simulation/audio-context',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'simulation_trace_request',
    responseSchema: 'trace_audio_context_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch simulation audio context for trace playback.",
    resource: "simulation-trace-audio-context",
    cacheTags: ["traces", "simulation-traces"],
    pagination: null,
    action: 'get',
    versionGroup: "getTraceAudioContext",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getTraceAudioContext",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "searchTraceCalls": {
    method: 'POST',
    path: '/transport/traces/search',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'trace_search_request',
    responseSchema: 'trace_search_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Search simulation calls by matching trace spans.",
    resource: "traces",
    cacheTags: ["traces"],
    pagination: { itemKey: "items", requestTokenKey: "cursor", responseTokenKey: "next_cursor" },
    action: 'query',
    versionGroup: "searchTraceCalls",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "searchTraceCalls",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getTraceTransitionHotspots": {
    method: 'GET',
    path: '/transport/traces/run/transition-hotspots',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'run_transition_hotspots_request',
    responseSchema: 'trace_transition_matrix_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Build transition hotspot matrix for a traced run.",
    resource: "run-trace-transition-hotspots",
    cacheTags: ["traces", "run-traces"],
    pagination: null,
    action: 'query',
    versionGroup: "getTraceTransitionHotspots",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getTraceTransitionHotspots",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getTraceTransitionHotspotsForSearch": {
    method: 'POST',
    path: '/transport/traces/search/transition-hotspots',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'search_transition_hotspots_request',
    responseSchema: 'trace_transition_matrix_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Build transition hotspot matrix for trace search results.",
    resource: "trace-search-transition-hotspots",
    cacheTags: ["traces"],
    pagination: null,
    action: 'query',
    versionGroup: "getTraceTransitionHotspotsForSearch",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getTraceTransitionHotspotsForSearch",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getTraceFilterSuggestions": {
    method: 'GET',
    path: '/transport/traces/filter-suggestions',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'trace_filter_suggestions_request',
    responseSchema: 'trace_filter_suggestions_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List trace filter suggestion values for custom trace metrics.",
    resource: "traces",
    cacheTags: ["traces"],
    pagination: null,
    action: 'list',
    versionGroup: "getTraceFilterSuggestions",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getTraceFilterSuggestions",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "previewCustomTraceMetric": {
    method: 'POST',
    path: '/transport/traces/custom-metric-preview',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'custom_trace_metric_preview_request',
    responseSchema: 'custom_trace_metric_preview_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Preview custom trace metric extraction against recent trace spans.",
    resource: "traces-custom-metric-preview",
    cacheTags: ["traces"],
    pagination: null,
    action: 'query',
    versionGroup: "previewCustomTraceMetric",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "previewCustomTraceMetric",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getPersona": {
    method: 'GET',
    path: '/transport/personas/{persona_id}',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'get_persona_request',
    responseSchema: 'get_persona_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['persona_id'],
    summary: "Fetch one persona available to the current organization.",
    resource: "personas",
    cacheTags: ["personas"],
    pagination: null,
    action: 'get',
    versionGroup: "getPersona",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getPersona",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getPersonaVersions": {
    method: 'GET',
    path: '/transport/personas/versions',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_persona_versions_request',
    responseSchema: 'get_persona_versions_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List the prior-version history for a persona visible to the current organization.",
    resource: "persona-versions",
    cacheTags: ["personas"],
    pagination: null,
    action: 'list',
    versionGroup: "getPersonaVersions",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getPersonaVersions",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "revertPersonaVersion": {
    method: 'POST',
    path: '/transport/personas/versions/revert',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'revert_persona_version_request',
    responseSchema: 'revert_persona_version_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Revert a persona to one of its prior versions.",
    resource: "persona-versions",
    cacheTags: ["personas"],
    pagination: null,
    action: 'update',
    versionGroup: "revertPersonaVersion",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "revertPersonaVersion",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createPersona": {
    method: 'POST',
    path: '/transport/personas/create',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_persona_transport_request',
    responseSchema: 'create_persona_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a persona for the current organization.",
    resource: "personas",
    cacheTags: ["personas"],
    pagination: null,
    action: 'create',
    versionGroup: "createPersona",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createPersona",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createBackgroundSound": {
    method: 'POST',
    path: '/transport/personas/background-sounds/create',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_background_sound_transport_request',
    responseSchema: 'create_background_sound_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a pending background sound upload for the current organization.",
    resource: "background-sounds",
    cacheTags: ["background-sounds", "personas"],
    pagination: null,
    action: 'create',
    versionGroup: "createBackgroundSound",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createBackgroundSound",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "completeBackgroundSound": {
    method: 'POST',
    path: '/transport/personas/background-sounds/{background_sound_id}/complete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'complete_background_sound_transport_request',
    responseSchema: 'complete_background_sound_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['background_sound_id'],
    summary: "Complete a background sound upload after the object reaches S3.",
    resource: "background-sounds",
    cacheTags: ["background-sounds", "personas"],
    pagination: null,
    action: 'update',
    versionGroup: "completeBackgroundSound",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "completeBackgroundSound",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updatePersona": {
    method: 'PATCH',
    path: '/transport/personas/update',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_persona_transport_request',
    responseSchema: 'update_persona_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update a persona for the current organization.",
    resource: "personas",
    cacheTags: ["personas"],
    pagination: null,
    action: 'update',
    versionGroup: "updatePersona",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updatePersona",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateBackgroundSound": {
    method: 'PATCH',
    path: '/transport/personas/background-sounds/{background_sound_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_background_sound_transport_request',
    responseSchema: 'update_background_sound_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['background_sound_id'],
    summary: "Rename, set default volume, archive, or unarchive a custom background sound.",
    resource: "background-sounds-update-background-sound",
    cacheTags: ["background-sounds", "personas"],
    pagination: null,
    action: 'update',
    versionGroup: "updateBackgroundSound",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateBackgroundSound",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deletePersona": {
    method: 'POST',
    path: '/transport/personas/delete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'delete_persona_transport_request',
    responseSchema: 'delete_persona_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Delete a persona for the current organization.",
    resource: "personas",
    cacheTags: ["personas"],
    pagination: null,
    action: 'delete',
    versionGroup: "deletePersona",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deletePersona",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deletePersonas": {
    method: 'POST',
    path: '/transport/personas:batchDelete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'delete_personas_request',
    responseSchema: 'delete_personas_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Delete up to 100 personas independently and return per-ID outcomes.",
    resource: "personas-batch",
    cacheTags: ["personas"],
    pagination: null,
    action: 'delete',
    versionGroup: "deletePersonas",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deletePersonas",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "duplicatePersona": {
    method: 'POST',
    path: '/transport/personas/duplicate',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'duplicate_persona_transport_request',
    responseSchema: 'duplicate_persona_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Duplicate a visible persona into the current organization.",
    resource: "personas",
    cacheTags: ["personas"],
    pagination: null,
    action: 'duplicate',
    versionGroup: "duplicatePersona",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "duplicatePersona",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "restorePersona": {
    method: 'POST',
    path: '/transport/personas/restore',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'restore_persona_request',
    responseSchema: 'restore_persona_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Restore a workspace persona; default includes legacy NULL-workspace rows; unresolved returns 404.",
    resource: "personas-restore-persona",
    cacheTags: ["personas"],
    pagination: null,
    action: 'update',
    versionGroup: "restorePersona",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "restorePersona",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "generatePersonaVoiceCandidates": {
    method: 'POST',
    path: '/transport/personas/voice-candidates/generate',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'generate_persona_voice_candidates_transport_request',
    responseSchema: 'generate_persona_voice_candidates_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Generate Gradium voice candidates from a text description for the current organization.",
    resource: "personas-generate-persona-voice-candidates",
    cacheTags: ["personas"],
    pagination: null,
    action: 'create',
    versionGroup: "generatePersonaVoiceCandidates",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "generatePersonaVoiceCandidates",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "previewPersonaVoiceCandidate": {
    method: 'POST',
    path: '/transport/personas/voice-candidates/preview',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'preview_persona_voice_candidate_transport_request',
    responseSchema: 'preview_persona_voice_candidate_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Render a short WAV audition of a Gradium voice candidate.",
    resource: "personas",
    cacheTags: ["personas"],
    pagination: null,
    action: 'query',
    versionGroup: "previewPersonaVoiceCandidate",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "previewPersonaVoiceCandidate",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "keepPersonaVoiceCandidate": {
    method: 'POST',
    path: '/transport/personas/voice-candidates/keep',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'keep_persona_voice_candidate_transport_request',
    responseSchema: 'keep_persona_voice_candidate_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Keep a Gradium voice candidate as a permanent voice for the current organization.",
    resource: "personas-keep-persona-voice-candidate",
    cacheTags: ["personas"],
    pagination: null,
    action: 'create',
    versionGroup: "keepPersonaVoiceCandidate",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "keepPersonaVoiceCandidate",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listWebhooks": {
    method: 'GET',
    path: '/transport/webhooks',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'list_webhooks_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List webhooks for the current organization.",
    resource: "webhooks",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listWebhooks",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listWebhooks",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createWebhook": {
    method: 'POST',
    path: '/transport/webhooks/create',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_webhook_transport_request',
    responseSchema: 'create_webhook_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a webhook for the current organization.",
    resource: "webhooks",
    cacheTags: [],
    pagination: null,
    action: 'create',
    versionGroup: "createWebhook",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createWebhook",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateWebhook": {
    method: 'PATCH',
    path: '/transport/webhooks/update',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_webhook_transport_request',
    responseSchema: 'update_webhook_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Update a webhook for the current organization.",
    resource: "webhooks",
    cacheTags: [],
    pagination: null,
    action: 'update',
    versionGroup: "updateWebhook",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateWebhook",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteWebhook": {
    method: 'POST',
    path: '/transport/webhooks/delete',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'delete_webhook_transport_request',
    responseSchema: 'delete_webhook_transport_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Delete a webhook for the current organization.",
    resource: "webhooks",
    cacheTags: [],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteWebhook",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteWebhook",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listExternalAgentCandidates": {
    method: 'GET',
    path: '/transport/external-agents/candidates',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_external_agent_candidates_request',
    responseSchema: 'list_external_agent_candidates_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List importable agents resolved from an external provider.",
    resource: "external-agents-candidates",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listExternalAgentCandidates",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listExternalAgentCandidates",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "importExternalAgents": {
    method: 'POST',
    path: '/transport/external-agents/import',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'import_external_agents_request',
    responseSchema: 'import_external_agents_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Import selected external provider agents into Coval.",
    resource: "external-agents-import",
    cacheTags: ["agents"],
    pagination: null,
    action: 'run',
    versionGroup: "importExternalAgents",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "importExternalAgents",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listSavedViews": {
    method: 'GET',
    path: '/transport/saved-views',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_saved_views_request',
    responseSchema: 'list_saved_views_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List saved views visible to the current user in the current organization.",
    resource: "saved-views",
    cacheTags: ["saved-views"],
    pagination: null,
    action: 'list',
    versionGroup: "listSavedViews",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listSavedViews",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getSavedView": {
    method: 'GET',
    path: '/transport/saved-views/{ulid}',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_saved_view_request',
    responseSchema: 'get_saved_view_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['ulid'],
    summary: "Fetch a visible saved view by id for the current user.",
    resource: "saved-views",
    cacheTags: ["saved-views"],
    pagination: null,
    action: 'get',
    versionGroup: "getSavedView",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getSavedView",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createSavedView": {
    method: 'POST',
    path: '/transport/saved-views',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_saved_view_request',
    responseSchema: 'create_saved_view_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create a saved view for the current user and organization.",
    resource: "saved-views",
    cacheTags: ["saved-views"],
    pagination: null,
    action: 'create',
    versionGroup: "createSavedView",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createSavedView",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateSavedView": {
    method: 'PATCH',
    path: '/transport/saved-views/{ulid}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_saved_view_request',
    responseSchema: 'update_saved_view_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['ulid'],
    summary: "Update a saved view owned by the current user (or a shared org view when the caller is an org admin).",
    resource: "saved-views",
    cacheTags: ["saved-views"],
    pagination: null,
    action: 'update',
    versionGroup: "updateSavedView",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateSavedView",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteSavedView": {
    method: 'DELETE',
    path: '/transport/saved-views/{ulid}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'delete_saved_view_request',
    responseSchema: 'saved_view_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['ulid'],
    summary: "Delete a saved view owned by the current user (or a shared org view when the caller is an org admin).",
    resource: "saved-views",
    cacheTags: ["saved-views"],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteSavedView",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteSavedView",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "getUserDefaultSavedView": {
    method: 'GET',
    path: '/transport/saved-views/default',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'get_user_default_saved_view_request',
    responseSchema: 'user_default_saved_view_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Fetch the current user's default saved view for a scope.",
    resource: "saved-views-default",
    cacheTags: [],
    pagination: null,
    action: 'get',
    versionGroup: "getUserDefaultSavedView",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "getUserDefaultSavedView",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "setUserDefaultSavedView": {
    method: 'POST',
    path: '/transport/saved-views/default',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'set_user_default_saved_view_request',
    responseSchema: 'saved_view_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Set the current user's default saved view for a scope.",
    resource: "saved-views",
    cacheTags: ["saved-views"],
    pagination: null,
    action: 'set',
    versionGroup: "setUserDefaultSavedView",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "setUserDefaultSavedView",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "clearUserDefaultSavedView": {
    method: 'POST',
    path: '/transport/saved-views/default/clear',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'clear_user_default_saved_view_request',
    responseSchema: 'saved_view_mutation_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Clear the current user's default saved view for a scope.",
    resource: "saved-views-default-clear",
    cacheTags: ["saved-views"],
    pagination: null,
    action: 'delete',
    versionGroup: "clearUserDefaultSavedView",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "clearUserDefaultSavedView",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listOrganizationTags": {
    method: 'GET',
    path: '/transport/tags',
    auth: 'session',
    databaseAccess: 'read',
    organizationRequired: true,
    requestLocation: 'none',
    requestSchema: null,
    responseSchema: 'list_organization_tags_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List the first 200 active tags for workspace resource pickers.",
    resource: "tags",
    cacheTags: [],
    pagination: null,
    action: 'list',
    versionGroup: "listOrganizationTags",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listOrganizationTags",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "listWorkspaceTags": {
    method: 'GET',
    path: '/transport/tags/catalog',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'query',
    requestSchema: 'list_organization_tags_request',
    responseSchema: 'list_organization_tags_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "List active tags in the current workspace, with optional usage counts.",
    resource: "tags-catalog",
    cacheTags: [],
    pagination: { itemKey: "tags", requestTokenKey: "page_token", responseTokenKey: "next_page_token" },
    action: 'list',
    versionGroup: "listWorkspaceTags",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "listWorkspaceTags",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "createOrganizationTag": {
    method: 'POST',
    path: '/transport/tags',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'create_organization_tag_request',
    responseSchema: 'create_organization_tag_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: [],
    summary: "Create or reactivate an organization-scoped tag.",
    resource: "tags",
    cacheTags: ["tags", "runs", "agents", "personas", "test-sets", "metrics", "run-templates"],
    pagination: null,
    action: 'create',
    versionGroup: "createOrganizationTag",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "createOrganizationTag",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "updateOrganizationTag": {
    method: 'PATCH',
    path: '/transport/tags/{tag_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'json_body',
    requestSchema: 'update_organization_tag_request',
    responseSchema: 'update_organization_tag_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['tag_id'],
    summary: "Rename or recolor an organization tag.",
    resource: "tags",
    cacheTags: ["tags", "runs", "agents", "personas", "test-sets", "metrics", "run-templates"],
    pagination: null,
    action: 'update',
    versionGroup: "updateOrganizationTag",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "updateOrganizationTag",
    deprecationMessage: null,
    replacementOperation: null,
  },
  "deleteOrganizationTag": {
    method: 'DELETE',
    path: '/transport/tags/{tag_id}',
    auth: 'session',
    databaseAccess: 'write',
    organizationRequired: true,
    requestLocation: 'path',
    requestSchema: 'delete_organization_tag_request',
    responseSchema: 'delete_organization_tag_response',
    requestByAlias: false,
    responseByAlias: false,
    pathParams: ['tag_id'],
    summary: "Delete a workspace tag and remove all resource assignments.",
    resource: "tags",
    cacheTags: ["tags", "runs", "agents", "personas", "test-sets", "metrics", "run-templates"],
    pagination: null,
    action: 'delete',
    versionGroup: "deleteOrganizationTag",
    version: 1,
    isDefaultVersion: true,
    canonicalOperation: "deleteOrganizationTag",
    deprecationMessage: null,
    replacementOperation: null,
  },
} as const satisfies Record<string, TransportOperationDefinition>;

export type TransportOperationName = keyof typeof transportOperations;
export type TransportOperationDefinitions = typeof transportOperations;

export interface TransportOperationDescriptor<Name extends TransportOperationName = TransportOperationName> {
  readonly name: Name;
  readonly definition: TransportOperationDefinitions[Name];
}

export const transportOperationDescriptors = {
  "createPythonMetricDraft": {
    name: "createPythonMetricDraft",
    definition: transportOperations["createPythonMetricDraft"],
  },
  "getPythonMetricDraft": {
    name: "getPythonMetricDraft",
    definition: transportOperations["getPythonMetricDraft"],
  },
  "previewPythonMetric": {
    name: "previewPythonMetric",
    definition: transportOperations["previewPythonMetric"],
  },
  "getPythonMetricPreview": {
    name: "getPythonMetricPreview",
    definition: transportOperations["getPythonMetricPreview"],
  },
  "cancelPythonMetricPreview": {
    name: "cancelPythonMetricPreview",
    definition: transportOperations["cancelPythonMetricPreview"],
  },
  "publishPythonMetric": {
    name: "publishPythonMetric",
    definition: transportOperations["publishPythonMetric"],
  },
  "listIvrTrees": {
    name: "listIvrTrees",
    definition: transportOperations["listIvrTrees"],
  },
  "createIvrTree": {
    name: "createIvrTree",
    definition: transportOperations["createIvrTree"],
  },
  "getIvrTree": {
    name: "getIvrTree",
    definition: transportOperations["getIvrTree"],
  },
  "updateIvrTree": {
    name: "updateIvrTree",
    definition: transportOperations["updateIvrTree"],
  },
  "deleteIvrTree": {
    name: "deleteIvrTree",
    definition: transportOperations["deleteIvrTree"],
  },
  "health": {
    name: "health",
    definition: transportOperations["health"],
  },
  "getHealthStatus": {
    name: "getHealthStatus",
    definition: transportOperations["getHealthStatus"],
  },
  "getSystemStatus": {
    name: "getSystemStatus",
    definition: transportOperations["getSystemStatus"],
  },
  "getFdeSupportStatus": {
    name: "getFdeSupportStatus",
    definition: transportOperations["getFdeSupportStatus"],
  },
  "pageFdeSupport": {
    name: "pageFdeSupport",
    definition: transportOperations["pageFdeSupport"],
  },
  "bootstrap": {
    name: "bootstrap",
    definition: transportOperations["bootstrap"],
  },
  "getAccountDeletionImpact": {
    name: "getAccountDeletionImpact",
    definition: transportOperations["getAccountDeletionImpact"],
  },
  "deleteAccount": {
    name: "deleteAccount",
    definition: transportOperations["deleteAccount"],
  },
  "adminListOrganizations": {
    name: "adminListOrganizations",
    definition: transportOperations["adminListOrganizations"],
  },
  "listAdminDataFrames": {
    name: "listAdminDataFrames",
    definition: transportOperations["listAdminDataFrames"],
  },
  /** @deprecated Use listSimulationDataFrames; this compatibility alias remains supported. Use listSimulationDataFrames instead. */
  "listAdminSimulationDataFrames": {
    name: "listAdminSimulationDataFrames",
    definition: transportOperations["listAdminSimulationDataFrames"],
  },
  "listSimulationDataFrames": {
    name: "listSimulationDataFrames",
    definition: transportOperations["listSimulationDataFrames"],
  },
  "adminListOrganizationPlans": {
    name: "adminListOrganizationPlans",
    definition: transportOperations["adminListOrganizationPlans"],
  },
  "adminGetOrganization": {
    name: "adminGetOrganization",
    definition: transportOperations["adminGetOrganization"],
  },
  "adminGetOrganizationUsage": {
    name: "adminGetOrganizationUsage",
    definition: transportOperations["adminGetOrganizationUsage"],
  },
  "adminGetCustomerHealthOverview": {
    name: "adminGetCustomerHealthOverview",
    definition: transportOperations["adminGetCustomerHealthOverview"],
  },
  "adminGetCustomerHealthDetail": {
    name: "adminGetCustomerHealthDetail",
    definition: transportOperations["adminGetCustomerHealthDetail"],
  },
  "adminGetCustomerHealthExternalSignals": {
    name: "adminGetCustomerHealthExternalSignals",
    definition: transportOperations["adminGetCustomerHealthExternalSignals"],
  },
  "adminGetCustomerHealthSlackSummary": {
    name: "adminGetCustomerHealthSlackSummary",
    definition: transportOperations["adminGetCustomerHealthSlackSummary"],
  },
  "adminListCustomerHealthAccounts": {
    name: "adminListCustomerHealthAccounts",
    definition: transportOperations["adminListCustomerHealthAccounts"],
  },
  "adminGetSelfServeUsageRoundup": {
    name: "adminGetSelfServeUsageRoundup",
    definition: transportOperations["adminGetSelfServeUsageRoundup"],
  },
  "adminListOrganizationApiKeys": {
    name: "adminListOrganizationApiKeys",
    definition: transportOperations["adminListOrganizationApiKeys"],
  },
  "adminCreateOrganizationApiKey": {
    name: "adminCreateOrganizationApiKey",
    definition: transportOperations["adminCreateOrganizationApiKey"],
  },
  "adminUpdateOrganizationApiKeyStatus": {
    name: "adminUpdateOrganizationApiKeyStatus",
    definition: transportOperations["adminUpdateOrganizationApiKeyStatus"],
  },
  "adminDeleteOrganizationApiKey": {
    name: "adminDeleteOrganizationApiKey",
    definition: transportOperations["adminDeleteOrganizationApiKey"],
  },
  "adminProvisionOrganization": {
    name: "adminProvisionOrganization",
    definition: transportOperations["adminProvisionOrganization"],
  },
  "adminPreviewOrganizationReconciliation": {
    name: "adminPreviewOrganizationReconciliation",
    definition: transportOperations["adminPreviewOrganizationReconciliation"],
  },
  "adminUpdateSimulationTimeout": {
    name: "adminUpdateSimulationTimeout",
    definition: transportOperations["adminUpdateSimulationTimeout"],
  },
  "adminGetEmailRecipientAllowlist": {
    name: "adminGetEmailRecipientAllowlist",
    definition: transportOperations["adminGetEmailRecipientAllowlist"],
  },
  "adminUpdateEmailRecipientAllowlist": {
    name: "adminUpdateEmailRecipientAllowlist",
    definition: transportOperations["adminUpdateEmailRecipientAllowlist"],
  },
  "adminUpdateTelephonyProvider": {
    name: "adminUpdateTelephonyProvider",
    definition: transportOperations["adminUpdateTelephonyProvider"],
  },
  "adminUpdateSofiaModel": {
    name: "adminUpdateSofiaModel",
    definition: transportOperations["adminUpdateSofiaModel"],
  },
  "adminUpdateMaxSimulationAttempts": {
    name: "adminUpdateMaxSimulationAttempts",
    definition: transportOperations["adminUpdateMaxSimulationAttempts"],
  },
  "adminUpdatePipelinePriority": {
    name: "adminUpdatePipelinePriority",
    definition: transportOperations["adminUpdatePipelinePriority"],
  },
  "adminUpdateOrganizationWideConcurrency": {
    name: "adminUpdateOrganizationWideConcurrency",
    definition: transportOperations["adminUpdateOrganizationWideConcurrency"],
  },
  "adminUpdateMaxJobConcurrency": {
    name: "adminUpdateMaxJobConcurrency",
    definition: transportOperations["adminUpdateMaxJobConcurrency"],
  },
  "getWorkOSSetupInfo": {
    name: "getWorkOSSetupInfo",
    definition: transportOperations["getWorkOSSetupInfo"],
  },
  "configureWorkOSMapping": {
    name: "configureWorkOSMapping",
    definition: transportOperations["configureWorkOSMapping"],
  },
  "listAgents": {
    name: "listAgents",
    definition: transportOperations["listAgents"],
  },
  "listAllAgents": {
    name: "listAllAgents",
    definition: transportOperations["listAllAgents"],
  },
  "getAgent": {
    name: "getAgent",
    definition: transportOperations["getAgent"],
  },
  "getAgentNames": {
    name: "getAgentNames",
    definition: transportOperations["getAgentNames"],
  },
  "getAgentVersions": {
    name: "getAgentVersions",
    definition: transportOperations["getAgentVersions"],
  },
  "revertAgentVersion": {
    name: "revertAgentVersion",
    definition: transportOperations["revertAgentVersion"],
  },
  "createAgent": {
    name: "createAgent",
    definition: transportOperations["createAgent"],
  },
  "duplicateAgent": {
    name: "duplicateAgent",
    definition: transportOperations["duplicateAgent"],
  },
  "testAgentConnection": {
    name: "testAgentConnection",
    definition: transportOperations["testAgentConnection"],
  },
  "updateAgent": {
    name: "updateAgent",
    definition: transportOperations["updateAgent"],
  },
  "deleteAgent": {
    name: "deleteAgent",
    definition: transportOperations["deleteAgent"],
  },
  "deleteAgents": {
    name: "deleteAgents",
    definition: transportOperations["deleteAgents"],
  },
  "addAgentMetrics": {
    name: "addAgentMetrics",
    definition: transportOperations["addAgentMetrics"],
  },
  "removeAgentMetric": {
    name: "removeAgentMetric",
    definition: transportOperations["removeAgentMetric"],
  },
  "setAgentMetrics": {
    name: "setAgentMetrics",
    definition: transportOperations["setAgentMetrics"],
  },
  "addAgentWorkflow": {
    name: "addAgentWorkflow",
    definition: transportOperations["addAgentWorkflow"],
  },
  "removeAgentWorkflow": {
    name: "removeAgentWorkflow",
    definition: transportOperations["removeAgentWorkflow"],
  },
  "listRecentlyDeletedAgents": {
    name: "listRecentlyDeletedAgents",
    definition: transportOperations["listRecentlyDeletedAgents"],
  },
  "restoreAgent": {
    name: "restoreAgent",
    definition: transportOperations["restoreAgent"],
  },
  "listAgentMutations": {
    name: "listAgentMutations",
    definition: transportOperations["listAgentMutations"],
  },
  "listAllAgentMutations": {
    name: "listAllAgentMutations",
    definition: transportOperations["listAllAgentMutations"],
  },
  "getAgentMutation": {
    name: "getAgentMutation",
    definition: transportOperations["getAgentMutation"],
  },
  "createAgentMutation": {
    name: "createAgentMutation",
    definition: transportOperations["createAgentMutation"],
  },
  "updateAgentMutation": {
    name: "updateAgentMutation",
    definition: transportOperations["updateAgentMutation"],
  },
  "archiveAgentMutation": {
    name: "archiveAgentMutation",
    definition: transportOperations["archiveAgentMutation"],
  },
  "listBaselines": {
    name: "listBaselines",
    definition: transportOperations["listBaselines"],
  },
  "getBaseline": {
    name: "getBaseline",
    definition: transportOperations["getBaseline"],
  },
  "createBaseline": {
    name: "createBaseline",
    definition: transportOperations["createBaseline"],
  },
  "updateBaseline": {
    name: "updateBaseline",
    definition: transportOperations["updateBaseline"],
  },
  "archiveBaseline": {
    name: "archiveBaseline",
    definition: transportOperations["archiveBaseline"],
  },
  "getBaselineHistory": {
    name: "getBaselineHistory",
    definition: transportOperations["getBaselineHistory"],
  },
  "getBaselineDeviationsBySimulation": {
    name: "getBaselineDeviationsBySimulation",
    definition: transportOperations["getBaselineDeviationsBySimulation"],
  },
  "listBenchmarkDatasets": {
    name: "listBenchmarkDatasets",
    definition: transportOperations["listBenchmarkDatasets"],
  },
  "getBenchmarkDataset": {
    name: "getBenchmarkDataset",
    definition: transportOperations["getBenchmarkDataset"],
  },
  "createBenchmarkDataset": {
    name: "createBenchmarkDataset",
    definition: transportOperations["createBenchmarkDataset"],
  },
  "updateBenchmarkDataset": {
    name: "updateBenchmarkDataset",
    definition: transportOperations["updateBenchmarkDataset"],
  },
  "deleteBenchmarkDataset": {
    name: "deleteBenchmarkDataset",
    definition: transportOperations["deleteBenchmarkDataset"],
  },
  "getBenchmarkDatasetUploadUrl": {
    name: "getBenchmarkDatasetUploadUrl",
    definition: transportOperations["getBenchmarkDatasetUploadUrl"],
  },
  "listBenchmarkDatasetItems": {
    name: "listBenchmarkDatasetItems",
    definition: transportOperations["listBenchmarkDatasetItems"],
  },
  "getBenchmarkDatasetItem": {
    name: "getBenchmarkDatasetItem",
    definition: transportOperations["getBenchmarkDatasetItem"],
  },
  "addBenchmarkDatasetItem": {
    name: "addBenchmarkDatasetItem",
    definition: transportOperations["addBenchmarkDatasetItem"],
  },
  "updateBenchmarkDatasetItem": {
    name: "updateBenchmarkDatasetItem",
    definition: transportOperations["updateBenchmarkDatasetItem"],
  },
  "deleteBenchmarkDatasetItem": {
    name: "deleteBenchmarkDatasetItem",
    definition: transportOperations["deleteBenchmarkDatasetItem"],
  },
  "listBenchmarkEndpoints": {
    name: "listBenchmarkEndpoints",
    definition: transportOperations["listBenchmarkEndpoints"],
  },
  "getBenchmarkEndpoint": {
    name: "getBenchmarkEndpoint",
    definition: transportOperations["getBenchmarkEndpoint"],
  },
  "getBenchmarkEndpointsByIds": {
    name: "getBenchmarkEndpointsByIds",
    definition: transportOperations["getBenchmarkEndpointsByIds"],
  },
  "createBenchmarkEndpoint": {
    name: "createBenchmarkEndpoint",
    definition: transportOperations["createBenchmarkEndpoint"],
  },
  "updateBenchmarkEndpoint": {
    name: "updateBenchmarkEndpoint",
    definition: transportOperations["updateBenchmarkEndpoint"],
  },
  "deleteBenchmarkEndpoint": {
    name: "deleteBenchmarkEndpoint",
    definition: transportOperations["deleteBenchmarkEndpoint"],
  },
  "testBenchmarkEndpoint": {
    name: "testBenchmarkEndpoint",
    definition: transportOperations["testBenchmarkEndpoint"],
  },
  "listBenchmarkRuns": {
    name: "listBenchmarkRuns",
    definition: transportOperations["listBenchmarkRuns"],
  },
  "getBenchmarkRun": {
    name: "getBenchmarkRun",
    definition: transportOperations["getBenchmarkRun"],
  },
  "createBenchmarkRun": {
    name: "createBenchmarkRun",
    definition: transportOperations["createBenchmarkRun"],
  },
  "cancelBenchmarkRun": {
    name: "cancelBenchmarkRun",
    definition: transportOperations["cancelBenchmarkRun"],
  },
  "listBenchmarkResults": {
    name: "listBenchmarkResults",
    definition: transportOperations["listBenchmarkResults"],
  },
  "getBenchmarkAudioSignedUrl": {
    name: "getBenchmarkAudioSignedUrl",
    definition: transportOperations["getBenchmarkAudioSignedUrl"],
  },
  "listApiKeys": {
    name: "listApiKeys",
    definition: transportOperations["listApiKeys"],
  },
  "createApiKey": {
    name: "createApiKey",
    definition: transportOperations["createApiKey"],
  },
  "createGithubFixIntent": {
    name: "createGithubFixIntent",
    definition: transportOperations["createGithubFixIntent"],
  },
  "updateApiKeyStatus": {
    name: "updateApiKeyStatus",
    definition: transportOperations["updateApiKeyStatus"],
  },
  "deleteApiKey": {
    name: "deleteApiKey",
    definition: transportOperations["deleteApiKey"],
  },
  "getAudioSignedUrl": {
    name: "getAudioSignedUrl",
    definition: transportOperations["getAudioSignedUrl"],
  },
  "getPublicAudioSignedUrl": {
    name: "getPublicAudioSignedUrl",
    definition: transportOperations["getPublicAudioSignedUrl"],
  },
  "uploadAudio": {
    name: "uploadAudio",
    definition: transportOperations["uploadAudio"],
  },
  "processAudio": {
    name: "processAudio",
    definition: transportOperations["processAudio"],
  },
  "createOnboardingAudioJob": {
    name: "createOnboardingAudioJob",
    definition: transportOperations["createOnboardingAudioJob"],
  },
  "startOnboardingAudioJob": {
    name: "startOnboardingAudioJob",
    definition: transportOperations["startOnboardingAudioJob"],
  },
  "getOnboardingAudioJob": {
    name: "getOnboardingAudioJob",
    definition: transportOperations["getOnboardingAudioJob"],
  },
  "submitUploadedConversation": {
    name: "submitUploadedConversation",
    definition: transportOperations["submitUploadedConversation"],
  },
  "uploadTracesForUploadedConversation": {
    name: "uploadTracesForUploadedConversation",
    definition: transportOperations["uploadTracesForUploadedConversation"],
  },
  "queryUploadedConversationKeyset": {
    name: "queryUploadedConversationKeyset",
    definition: transportOperations["queryUploadedConversationKeyset"],
  },
  "getUploadedConversationMetadata": {
    name: "getUploadedConversationMetadata",
    definition: transportOperations["getUploadedConversationMetadata"],
  },
  "getUploadedConversationMetricStringValues": {
    name: "getUploadedConversationMetricStringValues",
    definition: transportOperations["getUploadedConversationMetricStringValues"],
  },
  "getUploadedConversationNavigationContext": {
    name: "getUploadedConversationNavigationContext",
    definition: transportOperations["getUploadedConversationNavigationContext"],
  },
  "getUploadedConversationReportRows": {
    name: "getUploadedConversationReportRows",
    definition: transportOperations["getUploadedConversationReportRows"],
  },
  "findUploadedConversationRecordingFile": {
    name: "findUploadedConversationRecordingFile",
    definition: transportOperations["findUploadedConversationRecordingFile"],
  },
  "getAudioPeaksUrl": {
    name: "getAudioPeaksUrl",
    definition: transportOperations["getAudioPeaksUrl"],
  },
  "getAudioUploadUrl": {
    name: "getAudioUploadUrl",
    definition: transportOperations["getAudioUploadUrl"],
  },
  "homeActivation": {
    name: "homeActivation",
    definition: transportOperations["homeActivation"],
  },
  "homeDigest": {
    name: "homeDigest",
    definition: transportOperations["homeDigest"],
  },
  "listKnowledgeBaseEntries": {
    name: "listKnowledgeBaseEntries",
    definition: transportOperations["listKnowledgeBaseEntries"],
  },
  "listKnowledgeBaseEntriesByTestSet": {
    name: "listKnowledgeBaseEntriesByTestSet",
    definition: transportOperations["listKnowledgeBaseEntriesByTestSet"],
  },
  "createKnowledgeBaseEntry": {
    name: "createKnowledgeBaseEntry",
    definition: transportOperations["createKnowledgeBaseEntry"],
  },
  "createTestSetFromKnowledgeBaseScenarios": {
    name: "createTestSetFromKnowledgeBaseScenarios",
    definition: transportOperations["createTestSetFromKnowledgeBaseScenarios"],
  },
  "updateKnowledgeBaseEntry": {
    name: "updateKnowledgeBaseEntry",
    definition: transportOperations["updateKnowledgeBaseEntry"],
  },
  "deleteKnowledgeBaseEntry": {
    name: "deleteKnowledgeBaseEntry",
    definition: transportOperations["deleteKnowledgeBaseEntry"],
  },
  "getKnowledgeBaseUploadUrl": {
    name: "getKnowledgeBaseUploadUrl",
    definition: transportOperations["getKnowledgeBaseUploadUrl"],
  },
  "getKnowledgeBaseSignedUrl": {
    name: "getKnowledgeBaseSignedUrl",
    definition: transportOperations["getKnowledgeBaseSignedUrl"],
  },
  "getKnowledgeBaseFileContent": {
    name: "getKnowledgeBaseFileContent",
    definition: transportOperations["getKnowledgeBaseFileContent"],
  },
  "getOrganizationSettings": {
    name: "getOrganizationSettings",
    definition: transportOperations["getOrganizationSettings"],
  },
  "getBillingOverageSettings": {
    name: "getBillingOverageSettings",
    definition: transportOperations["getBillingOverageSettings"],
  },
  "updateBillingOverageSettings": {
    name: "updateBillingOverageSettings",
    definition: transportOperations["updateBillingOverageSettings"],
  },
  "getBillingOverageAcceptanceReceipt": {
    name: "getBillingOverageAcceptanceReceipt",
    definition: transportOperations["getBillingOverageAcceptanceReceipt"],
  },
  "getBillingOverageAcceptanceOffer": {
    name: "getBillingOverageAcceptanceOffer",
    definition: transportOperations["getBillingOverageAcceptanceOffer"],
  },
  "createBillingOverageAcceptance": {
    name: "createBillingOverageAcceptance",
    definition: transportOperations["createBillingOverageAcceptance"],
  },
  "getOrganizationRecord": {
    name: "getOrganizationRecord",
    definition: transportOperations["getOrganizationRecord"],
  },
  "getOrganizationUsers": {
    name: "getOrganizationUsers",
    definition: transportOperations["getOrganizationUsers"],
  },
  "updateOrganizationSettings": {
    name: "updateOrganizationSettings",
    definition: transportOperations["updateOrganizationSettings"],
  },
  "listWorkspaces": {
    name: "listWorkspaces",
    definition: transportOperations["listWorkspaces"],
  },
  "getWorkspaceSettings": {
    name: "getWorkspaceSettings",
    definition: transportOperations["getWorkspaceSettings"],
  },
  "updateWorkspaceSettings": {
    name: "updateWorkspaceSettings",
    definition: transportOperations["updateWorkspaceSettings"],
  },
  "createWorkspace": {
    name: "createWorkspace",
    definition: transportOperations["createWorkspace"],
  },
  "updateWorkspace": {
    name: "updateWorkspace",
    definition: transportOperations["updateWorkspace"],
  },
  "archiveWorkspace": {
    name: "archiveWorkspace",
    definition: transportOperations["archiveWorkspace"],
  },
  "deleteWorkspace": {
    name: "deleteWorkspace",
    definition: transportOperations["deleteWorkspace"],
  },
  "listWorkspaceMembers": {
    name: "listWorkspaceMembers",
    definition: transportOperations["listWorkspaceMembers"],
  },
  "addWorkspaceMember": {
    name: "addWorkspaceMember",
    definition: transportOperations["addWorkspaceMember"],
  },
  "removeWorkspaceMember": {
    name: "removeWorkspaceMember",
    definition: transportOperations["removeWorkspaceMember"],
  },
  "getLinearIntegrationStatus": {
    name: "getLinearIntegrationStatus",
    definition: transportOperations["getLinearIntegrationStatus"],
  },
  "getLinearAuthorizationUrl": {
    name: "getLinearAuthorizationUrl",
    definition: transportOperations["getLinearAuthorizationUrl"],
  },
  "connectLinearIntegration": {
    name: "connectLinearIntegration",
    definition: transportOperations["connectLinearIntegration"],
  },
  "disconnectLinearIntegration": {
    name: "disconnectLinearIntegration",
    definition: transportOperations["disconnectLinearIntegration"],
  },
  "listLinearTeams": {
    name: "listLinearTeams",
    definition: transportOperations["listLinearTeams"],
  },
  "listLinearProjects": {
    name: "listLinearProjects",
    definition: transportOperations["listLinearProjects"],
  },
  "createLinearIssue": {
    name: "createLinearIssue",
    definition: transportOperations["createLinearIssue"],
  },
  "requestSimulationRoom": {
    name: "requestSimulationRoom",
    definition: transportOperations["requestSimulationRoom"],
  },
  "getSlackStatus": {
    name: "getSlackStatus",
    definition: transportOperations["getSlackStatus"],
  },
  "connectSlack": {
    name: "connectSlack",
    definition: transportOperations["connectSlack"],
  },
  "disconnectSlack": {
    name: "disconnectSlack",
    definition: transportOperations["disconnectSlack"],
  },
  "listDashboardMetadata": {
    name: "listDashboardMetadata",
    definition: transportOperations["listDashboardMetadata"],
  },
  "getDashboardLayout": {
    name: "getDashboardLayout",
    definition: transportOperations["getDashboardLayout"],
  },
  "queryDashboardBatch": {
    name: "queryDashboardBatch",
    definition: transportOperations["queryDashboardBatch"],
  },
  "flexibleDashboardDrilldown": {
    name: "flexibleDashboardDrilldown",
    definition: transportOperations["flexibleDashboardDrilldown"],
  },
  "humanReviewDashboardDrilldown": {
    name: "humanReviewDashboardDrilldown",
    definition: transportOperations["humanReviewDashboardDrilldown"],
  },
  "metricValuesBySimulation": {
    name: "metricValuesBySimulation",
    definition: transportOperations["metricValuesBySimulation"],
  },
  "createDashboard": {
    name: "createDashboard",
    definition: transportOperations["createDashboard"],
  },
  "updateDashboard": {
    name: "updateDashboard",
    definition: transportOperations["updateDashboard"],
  },
  "deleteDashboard": {
    name: "deleteDashboard",
    definition: transportOperations["deleteDashboard"],
  },
  "replaceDashboardWidgets": {
    name: "replaceDashboardWidgets",
    definition: transportOperations["replaceDashboardWidgets"],
  },
  "clearDashboardWidgets": {
    name: "clearDashboardWidgets",
    definition: transportOperations["clearDashboardWidgets"],
  },
  "duplicateDashboardWidget": {
    name: "duplicateDashboardWidget",
    definition: transportOperations["duplicateDashboardWidget"],
  },
  "listMetricCatalogEntries": {
    name: "listMetricCatalogEntries",
    definition: transportOperations["listMetricCatalogEntries"],
  },
  "copyMetricCatalogEntry": {
    name: "copyMetricCatalogEntry",
    definition: transportOperations["copyMetricCatalogEntry"],
  },
  "listAdminMetricCatalogEntries": {
    name: "listAdminMetricCatalogEntries",
    definition: transportOperations["listAdminMetricCatalogEntries"],
  },
  "getAdminMetricCatalogEntry": {
    name: "getAdminMetricCatalogEntry",
    definition: transportOperations["getAdminMetricCatalogEntry"],
  },
  "createAdminMetricCatalogEntry": {
    name: "createAdminMetricCatalogEntry",
    definition: transportOperations["createAdminMetricCatalogEntry"],
  },
  "updateAdminMetricCatalogEntry": {
    name: "updateAdminMetricCatalogEntry",
    definition: transportOperations["updateAdminMetricCatalogEntry"],
  },
  "deleteAdminMetricCatalogEntry": {
    name: "deleteAdminMetricCatalogEntry",
    definition: transportOperations["deleteAdminMetricCatalogEntry"],
  },
  "listPersonaCatalogEntries": {
    name: "listPersonaCatalogEntries",
    definition: transportOperations["listPersonaCatalogEntries"],
  },
  "copyPersonaCatalogEntry": {
    name: "copyPersonaCatalogEntry",
    definition: transportOperations["copyPersonaCatalogEntry"],
  },
  "listAdminPersonaCatalogEntries": {
    name: "listAdminPersonaCatalogEntries",
    definition: transportOperations["listAdminPersonaCatalogEntries"],
  },
  "getAdminPersonaCatalogEntry": {
    name: "getAdminPersonaCatalogEntry",
    definition: transportOperations["getAdminPersonaCatalogEntry"],
  },
  "createAdminPersonaCatalogEntry": {
    name: "createAdminPersonaCatalogEntry",
    definition: transportOperations["createAdminPersonaCatalogEntry"],
  },
  "updateAdminPersonaCatalogEntry": {
    name: "updateAdminPersonaCatalogEntry",
    definition: transportOperations["updateAdminPersonaCatalogEntry"],
  },
  "deleteAdminPersonaCatalogEntry": {
    name: "deleteAdminPersonaCatalogEntry",
    definition: transportOperations["deleteAdminPersonaCatalogEntry"],
  },
  "listMetricDirectory": {
    name: "listMetricDirectory",
    definition: transportOperations["listMetricDirectory"],
  },
  "createMetricAudit": {
    name: "createMetricAudit",
    definition: transportOperations["createMetricAudit"],
  },
  "getMetricAudit": {
    name: "getMetricAudit",
    definition: transportOperations["getMetricAudit"],
  },
  "cancelMetricAudit": {
    name: "cancelMetricAudit",
    definition: transportOperations["cancelMetricAudit"],
  },
  "listMetricAuditGroups": {
    name: "listMetricAuditGroups",
    definition: transportOperations["listMetricAuditGroups"],
  },
  "getMetricAuditPair": {
    name: "getMetricAuditPair",
    definition: transportOperations["getMetricAuditPair"],
  },
  "getMetricAuditPromptProposal": {
    name: "getMetricAuditPromptProposal",
    definition: transportOperations["getMetricAuditPromptProposal"],
  },
  "getSimulationDataFramesSchema": {
    name: "getSimulationDataFramesSchema",
    definition: transportOperations["getSimulationDataFramesSchema"],
  },
  "testSqlMetric": {
    name: "testSqlMetric",
    definition: transportOperations["testSqlMetric"],
  },
  "getMetricThreshold": {
    name: "getMetricThreshold",
    definition: transportOperations["getMetricThreshold"],
  },
  "updateMetricThreshold": {
    name: "updateMetricThreshold",
    definition: transportOperations["updateMetricThreshold"],
  },
  "listComments": {
    name: "listComments",
    definition: transportOperations["listComments"],
  },
  "createComment": {
    name: "createComment",
    definition: transportOperations["createComment"],
  },
  "updateComment": {
    name: "updateComment",
    definition: transportOperations["updateComment"],
  },
  "deleteComment": {
    name: "deleteComment",
    definition: transportOperations["deleteComment"],
  },
  "getSettingsCredentialIntegrations": {
    name: "getSettingsCredentialIntegrations",
    definition: transportOperations["getSettingsCredentialIntegrations"],
  },
  "updateLangfuseIntegration": {
    name: "updateLangfuseIntegration",
    definition: transportOperations["updateLangfuseIntegration"],
  },
  "updateArizeIntegration": {
    name: "updateArizeIntegration",
    definition: transportOperations["updateArizeIntegration"],
  },
  "updateZendeskIntegration": {
    name: "updateZendeskIntegration",
    definition: transportOperations["updateZendeskIntegration"],
  },
  "updateShelfIntegration": {
    name: "updateShelfIntegration",
    definition: transportOperations["updateShelfIntegration"],
  },
  "getTelnyxIntegrationStatus": {
    name: "getTelnyxIntegrationStatus",
    definition: transportOperations["getTelnyxIntegrationStatus"],
  },
  "updateTelnyxApiKey": {
    name: "updateTelnyxApiKey",
    definition: transportOperations["updateTelnyxApiKey"],
  },
  "removeTelnyxApiKey": {
    name: "removeTelnyxApiKey",
    definition: transportOperations["removeTelnyxApiKey"],
  },
  "discoverGenesysQueues": {
    name: "discoverGenesysQueues",
    definition: transportOperations["discoverGenesysQueues"],
  },
  "listConversationImportConnections": {
    name: "listConversationImportConnections",
    definition: transportOperations["listConversationImportConnections"],
  },
  "createGenesysConnection": {
    name: "createGenesysConnection",
    definition: transportOperations["createGenesysConnection"],
  },
  "pauseConversationImportConnection": {
    name: "pauseConversationImportConnection",
    definition: transportOperations["pauseConversationImportConnection"],
  },
  "resumeConversationImportConnection": {
    name: "resumeConversationImportConnection",
    definition: transportOperations["resumeConversationImportConnection"],
  },
  "disconnectConversationImportConnection": {
    name: "disconnectConversationImportConnection",
    definition: transportOperations["disconnectConversationImportConnection"],
  },
  "listAdminMetrics": {
    name: "listAdminMetrics",
    definition: transportOperations["listAdminMetrics"],
  },
  "listMetricAdminOrganizations": {
    name: "listMetricAdminOrganizations",
    definition: transportOperations["listMetricAdminOrganizations"],
  },
  "createAdminMetric": {
    name: "createAdminMetric",
    definition: transportOperations["createAdminMetric"],
  },
  "updateAdminMetric": {
    name: "updateAdminMetric",
    definition: transportOperations["updateAdminMetric"],
  },
  "updateMetricActiveStatus": {
    name: "updateMetricActiveStatus",
    definition: transportOperations["updateMetricActiveStatus"],
  },
  "listMetrics": {
    name: "listMetrics",
    definition: transportOperations["listMetrics"],
  },
  "listMetricTags": {
    name: "listMetricTags",
    definition: transportOperations["listMetricTags"],
  },
  "getMetricLabels": {
    name: "getMetricLabels",
    definition: transportOperations["getMetricLabels"],
  },
  "queryMetricAuthors": {
    name: "queryMetricAuthors",
    definition: transportOperations["queryMetricAuthors"],
  },
  "queryAdminMetricAuthors": {
    name: "queryAdminMetricAuthors",
    definition: transportOperations["queryAdminMetricAuthors"],
  },
  "getMetric": {
    name: "getMetric",
    definition: transportOperations["getMetric"],
  },
  "getMetricVersions": {
    name: "getMetricVersions",
    definition: transportOperations["getMetricVersions"],
  },
  "revertMetricVersion": {
    name: "revertMetricVersion",
    definition: transportOperations["revertMetricVersion"],
  },
  "getMetricsMetadata": {
    name: "getMetricsMetadata",
    definition: transportOperations["getMetricsMetadata"],
  },
  "getMetricMetadataKeys": {
    name: "getMetricMetadataKeys",
    definition: transportOperations["getMetricMetadataKeys"],
  },
  "getMetricMetadataValues": {
    name: "getMetricMetadataValues",
    definition: transportOperations["getMetricMetadataValues"],
  },
  "listMetricFlows": {
    name: "listMetricFlows",
    definition: transportOperations["listMetricFlows"],
  },
  "createMetricFlow": {
    name: "createMetricFlow",
    definition: transportOperations["createMetricFlow"],
  },
  "updateMetricFlow": {
    name: "updateMetricFlow",
    definition: transportOperations["updateMetricFlow"],
  },
  "deleteMetricFlow": {
    name: "deleteMetricFlow",
    definition: transportOperations["deleteMetricFlow"],
  },
  "getMetricOutputsByUlids": {
    name: "getMetricOutputsByUlids",
    definition: transportOperations["getMetricOutputsByUlids"],
  },
  "getAgentJudgeEvidence": {
    name: "getAgentJudgeEvidence",
    definition: transportOperations["getAgentJudgeEvidence"],
  },
  "runTestMetric": {
    name: "runTestMetric",
    definition: transportOperations["runTestMetric"],
  },
  "createMetric": {
    name: "createMetric",
    definition: transportOperations["createMetric"],
  },
  "duplicateMetric": {
    name: "duplicateMetric",
    definition: transportOperations["duplicateMetric"],
  },
  "updateMetric": {
    name: "updateMetric",
    definition: transportOperations["updateMetric"],
  },
  "archiveMetric": {
    name: "archiveMetric",
    definition: transportOperations["archiveMetric"],
  },
  "listRecentlyDeletedMetrics": {
    name: "listRecentlyDeletedMetrics",
    definition: transportOperations["listRecentlyDeletedMetrics"],
  },
  "restoreMetric": {
    name: "restoreMetric",
    definition: transportOperations["restoreMetric"],
  },
  "listAlerts": {
    name: "listAlerts",
    definition: transportOperations["listAlerts"],
  },
  "getAlert": {
    name: "getAlert",
    definition: transportOperations["getAlert"],
  },
  "createAlert": {
    name: "createAlert",
    definition: transportOperations["createAlert"],
  },
  "updateAlert": {
    name: "updateAlert",
    definition: transportOperations["updateAlert"],
  },
  "deleteAlert": {
    name: "deleteAlert",
    definition: transportOperations["deleteAlert"],
  },
  "listAlertEvents": {
    name: "listAlertEvents",
    definition: transportOperations["listAlertEvents"],
  },
  "testEvaluateAlert": {
    name: "testEvaluateAlert",
    definition: transportOperations["testEvaluateAlert"],
  },
  "listScheduledRuns": {
    name: "listScheduledRuns",
    definition: transportOperations["listScheduledRuns"],
  },
  "getScheduledRun": {
    name: "getScheduledRun",
    definition: transportOperations["getScheduledRun"],
  },
  "listScheduledRunHistory": {
    name: "listScheduledRunHistory",
    definition: transportOperations["listScheduledRunHistory"],
  },
  "createScheduledRun": {
    name: "createScheduledRun",
    definition: transportOperations["createScheduledRun"],
  },
  "updateScheduledRun": {
    name: "updateScheduledRun",
    definition: transportOperations["updateScheduledRun"],
  },
  "deleteScheduledRun": {
    name: "deleteScheduledRun",
    definition: transportOperations["deleteScheduledRun"],
  },
  "testSetMetadata": {
    name: "testSetMetadata",
    definition: transportOperations["testSetMetadata"],
  },
  "testSetRecords": {
    name: "testSetRecords",
    definition: transportOperations["testSetRecords"],
  },
  "listTestSets": {
    name: "listTestSets",
    definition: transportOperations["listTestSets"],
  },
  "getTestSetVersions": {
    name: "getTestSetVersions",
    definition: transportOperations["getTestSetVersions"],
  },
  "revertTestSetVersion": {
    name: "revertTestSetVersion",
    definition: transportOperations["revertTestSetVersion"],
  },
  "listTestSetTags": {
    name: "listTestSetTags",
    definition: transportOperations["listTestSetTags"],
  },
  "testSetMetadataKeys": {
    name: "testSetMetadataKeys",
    definition: transportOperations["testSetMetadataKeys"],
  },
  "listTestCases": {
    name: "listTestCases",
    definition: transportOperations["listTestCases"],
  },
  "createTestSet": {
    name: "createTestSet",
    definition: transportOperations["createTestSet"],
  },
  "updateTestCaseRow": {
    name: "updateTestCaseRow",
    definition: transportOperations["updateTestCaseRow"],
  },
  "addTestSetRows": {
    name: "addTestSetRows",
    definition: transportOperations["addTestSetRows"],
  },
  "deleteTestSetRow": {
    name: "deleteTestSetRow",
    definition: transportOperations["deleteTestSetRow"],
  },
  "deleteTestSet": {
    name: "deleteTestSet",
    definition: transportOperations["deleteTestSet"],
  },
  "deleteTestSets": {
    name: "deleteTestSets",
    definition: transportOperations["deleteTestSets"],
  },
  "updateTestSet": {
    name: "updateTestSet",
    definition: transportOperations["updateTestSet"],
  },
  "saveTestSetEditorState": {
    name: "saveTestSetEditorState",
    definition: transportOperations["saveTestSetEditorState"],
  },
  "getTestCaseMediaUploadUrl": {
    name: "getTestCaseMediaUploadUrl",
    definition: transportOperations["getTestCaseMediaUploadUrl"],
  },
  "getTestCaseMediaPreviewUrl": {
    name: "getTestCaseMediaPreviewUrl",
    definition: transportOperations["getTestCaseMediaPreviewUrl"],
  },
  "duplicateTestSet": {
    name: "duplicateTestSet",
    definition: transportOperations["duplicateTestSet"],
  },
  "getTestSetAgentAssociations": {
    name: "getTestSetAgentAssociations",
    definition: transportOperations["getTestSetAgentAssociations"],
  },
  "addTestSetAgentAssociations": {
    name: "addTestSetAgentAssociations",
    definition: transportOperations["addTestSetAgentAssociations"],
  },
  "removeTestSetAgentAssociation": {
    name: "removeTestSetAgentAssociation",
    definition: transportOperations["removeTestSetAgentAssociation"],
  },
  "listRecentlyDeletedTestSets": {
    name: "listRecentlyDeletedTestSets",
    definition: transportOperations["listRecentlyDeletedTestSets"],
  },
  "getTestSetAutoAddRule": {
    name: "getTestSetAutoAddRule",
    definition: transportOperations["getTestSetAutoAddRule"],
  },
  "saveTestSetAutoAddRule": {
    name: "saveTestSetAutoAddRule",
    definition: transportOperations["saveTestSetAutoAddRule"],
  },
  "deleteTestSetAutoAddRule": {
    name: "deleteTestSetAutoAddRule",
    definition: transportOperations["deleteTestSetAutoAddRule"],
  },
  "listTestSetAutoAddPending": {
    name: "listTestSetAutoAddPending",
    definition: transportOperations["listTestSetAutoAddPending"],
  },
  "acceptTestSetAutoAddSuggestion": {
    name: "acceptTestSetAutoAddSuggestion",
    definition: transportOperations["acceptTestSetAutoAddSuggestion"],
  },
  "rejectTestSetAutoAddSuggestion": {
    name: "rejectTestSetAutoAddSuggestion",
    definition: transportOperations["rejectTestSetAutoAddSuggestion"],
  },
  "getTestSetAutoAddSummary": {
    name: "getTestSetAutoAddSummary",
    definition: transportOperations["getTestSetAutoAddSummary"],
  },
  "listTestSetAutoAddPendingCounts": {
    name: "listTestSetAutoAddPendingCounts",
    definition: transportOperations["listTestSetAutoAddPendingCounts"],
  },
  "restoreTestSet": {
    name: "restoreTestSet",
    definition: transportOperations["restoreTestSet"],
  },
  "listPersonas": {
    name: "listPersonas",
    definition: transportOperations["listPersonas"],
  },
  "listPersonaTags": {
    name: "listPersonaTags",
    definition: transportOperations["listPersonaTags"],
  },
  "listRecentlyDeletedPersonas": {
    name: "listRecentlyDeletedPersonas",
    definition: transportOperations["listRecentlyDeletedPersonas"],
  },
  "listBackgroundSounds": {
    name: "listBackgroundSounds",
    definition: transportOperations["listBackgroundSounds"],
  },
  "listRunTemplates": {
    name: "listRunTemplates",
    definition: transportOperations["listRunTemplates"],
  },
  "getRunTemplate": {
    name: "getRunTemplate",
    definition: transportOperations["getRunTemplate"],
  },
  "createRunTemplate": {
    name: "createRunTemplate",
    definition: transportOperations["createRunTemplate"],
  },
  "updateRunTemplate": {
    name: "updateRunTemplate",
    definition: transportOperations["updateRunTemplate"],
  },
  "deleteRunTemplate": {
    name: "deleteRunTemplate",
    definition: transportOperations["deleteRunTemplate"],
  },
  "duplicateRunTemplate": {
    name: "duplicateRunTemplate",
    definition: transportOperations["duplicateRunTemplate"],
  },
  "listReports": {
    name: "listReports",
    definition: transportOperations["listReports"],
  },
  "getReport": {
    name: "getReport",
    definition: transportOperations["getReport"],
  },
  "getPublicReport": {
    name: "getPublicReport",
    definition: transportOperations["getPublicReport"],
  },
  "getReportRows": {
    name: "getReportRows",
    definition: transportOperations["getReportRows"],
  },
  "getPublicReportRows": {
    name: "getPublicReportRows",
    definition: transportOperations["getPublicReportRows"],
  },
  "getCohortOutliers": {
    name: "getCohortOutliers",
    definition: transportOperations["getCohortOutliers"],
  },
  "saveReport": {
    name: "saveReport",
    definition: transportOperations["saveReport"],
  },
  "updateReport": {
    name: "updateReport",
    definition: transportOperations["updateReport"],
  },
  "setReportVisibility": {
    name: "setReportVisibility",
    definition: transportOperations["setReportVisibility"],
  },
  "deleteReport": {
    name: "deleteReport",
    definition: transportOperations["deleteReport"],
  },
  "getReviewOverview": {
    name: "getReviewOverview",
    definition: transportOperations["getReviewOverview"],
  },
  /** @deprecated Use getReviewOverview.v2 for explicit lightweight payload controls. Use getReviewOverview.v2 instead. */
  "getReviewOverview.v1": {
    name: "getReviewOverview.v1",
    definition: transportOperations["getReviewOverview.v1"],
  },
  "getReviewOverview.v2": {
    name: "getReviewOverview.v2",
    definition: transportOperations["getReviewOverview.v2"],
  },
  "queryHumanReviewProjectAnnotationsTable": {
    name: "queryHumanReviewProjectAnnotationsTable",
    definition: transportOperations["queryHumanReviewProjectAnnotationsTable"],
  },
  "queryHumanReviewProjectTriageMembership": {
    name: "queryHumanReviewProjectTriageMembership",
    definition: transportOperations["queryHumanReviewProjectTriageMembership"],
  },
  "listReviewMetricSkips": {
    name: "listReviewMetricSkips",
    definition: transportOperations["listReviewMetricSkips"],
  },
  "skipReviewMetric": {
    name: "skipReviewMetric",
    definition: transportOperations["skipReviewMetric"],
  },
  "unskipReviewMetric": {
    name: "unskipReviewMetric",
    definition: transportOperations["unskipReviewMetric"],
  },
  "getHumanReviewProjectAnnotationDetails": {
    name: "getHumanReviewProjectAnnotationDetails",
    definition: transportOperations["getHumanReviewProjectAnnotationDetails"],
  },
  "getReviewProjectSimulationCompletions": {
    name: "getReviewProjectSimulationCompletions",
    definition: transportOperations["getReviewProjectSimulationCompletions"],
  },
  "batchGetReviewProjectConversationStates": {
    name: "batchGetReviewProjectConversationStates",
    definition: transportOperations["batchGetReviewProjectConversationStates"],
  },
  "getMetricHealthStats": {
    name: "getMetricHealthStats",
    definition: transportOperations["getMetricHealthStats"],
  },
  "getMetricAgreementHistory": {
    name: "getMetricAgreementHistory",
    definition: transportOperations["getMetricAgreementHistory"],
  },
  "getHumanReviewProjectInsights": {
    name: "getHumanReviewProjectInsights",
    definition: transportOperations["getHumanReviewProjectInsights"],
  },
  "getHumanReviewProjectInsightSlice": {
    name: "getHumanReviewProjectInsightSlice",
    definition: transportOperations["getHumanReviewProjectInsightSlice"],
  },
  "getHumanReviewProjectDateDensity": {
    name: "getHumanReviewProjectDateDensity",
    definition: transportOperations["getHumanReviewProjectDateDensity"],
  },
  "getHumanReviewProjectLayout": {
    name: "getHumanReviewProjectLayout",
    definition: transportOperations["getHumanReviewProjectLayout"],
  },
  "saveHumanReviewProjectLayout": {
    name: "saveHumanReviewProjectLayout",
    definition: transportOperations["saveHumanReviewProjectLayout"],
  },
  "getReviewDisagreementState": {
    name: "getReviewDisagreementState",
    definition: transportOperations["getReviewDisagreementState"],
  },
  "getAnnotationsWithMetricOutputs": {
    name: "getAnnotationsWithMetricOutputs",
    definition: transportOperations["getAnnotationsWithMetricOutputs"],
  },
  "getFeedbackForSimulationOutput": {
    name: "getFeedbackForSimulationOutput",
    definition: transportOperations["getFeedbackForSimulationOutput"],
  },
  "getAllAnnotationsByOrg": {
    name: "getAllAnnotationsByOrg",
    definition: transportOperations["getAllAnnotationsByOrg"],
  },
  "listHumanReviewAlerts": {
    name: "listHumanReviewAlerts",
    definition: transportOperations["listHumanReviewAlerts"],
  },
  "deleteHumanReviewAlert": {
    name: "deleteHumanReviewAlert",
    definition: transportOperations["deleteHumanReviewAlert"],
  },
  "getReviewLabelsForSimulation": {
    name: "getReviewLabelsForSimulation",
    definition: transportOperations["getReviewLabelsForSimulation"],
  },
  "saveReviewLabelsForSimulation": {
    name: "saveReviewLabelsForSimulation",
    definition: transportOperations["saveReviewLabelsForSimulation"],
  },
  "listReviewProjects": {
    name: "listReviewProjects",
    definition: transportOperations["listReviewProjects"],
  },
  "getReviewProject": {
    name: "getReviewProject",
    definition: transportOperations["getReviewProject"],
  },
  "createReviewProject": {
    name: "createReviewProject",
    definition: transportOperations["createReviewProject"],
  },
  "duplicateReviewProject": {
    name: "duplicateReviewProject",
    definition: transportOperations["duplicateReviewProject"],
  },
  "getProjectMetricAgreement": {
    name: "getProjectMetricAgreement",
    definition: transportOperations["getProjectMetricAgreement"],
  },
  "getReviewProjectRerunContext": {
    name: "getReviewProjectRerunContext",
    definition: transportOperations["getReviewProjectRerunContext"],
  },
  "listReviewProjectMembershipLogs": {
    name: "listReviewProjectMembershipLogs",
    definition: transportOperations["listReviewProjectMembershipLogs"],
  },
  "listReviewProjectMembers": {
    name: "listReviewProjectMembers",
    definition: transportOperations["listReviewProjectMembers"],
  },
  "setReviewProjectMemberRole": {
    name: "setReviewProjectMemberRole",
    definition: transportOperations["setReviewProjectMemberRole"],
  },
  "sendProjectAssignmentEmail": {
    name: "sendProjectAssignmentEmail",
    definition: transportOperations["sendProjectAssignmentEmail"],
  },
  "completeReviewConversation": {
    name: "completeReviewConversation",
    definition: transportOperations["completeReviewConversation"],
  },
  "claimConversation": {
    name: "claimConversation",
    definition: transportOperations["claimConversation"],
  },
  "releaseConversation": {
    name: "releaseConversation",
    definition: transportOperations["releaseConversation"],
  },
  "forceReleaseConversation": {
    name: "forceReleaseConversation",
    definition: transportOperations["forceReleaseConversation"],
  },
  "startReviewBatch": {
    name: "startReviewBatch",
    definition: transportOperations["startReviewBatch"],
  },
  "getCurrentReviewBatch": {
    name: "getCurrentReviewBatch",
    definition: transportOperations["getCurrentReviewBatch"],
  },
  "stopReviewBatch": {
    name: "stopReviewBatch",
    definition: transportOperations["stopReviewBatch"],
  },
  "assignReviewBatches": {
    name: "assignReviewBatches",
    definition: transportOperations["assignReviewBatches"],
  },
  "releaseReviewBatch": {
    name: "releaseReviewBatch",
    definition: transportOperations["releaseReviewBatch"],
  },
  "listReviewBatches": {
    name: "listReviewBatches",
    definition: transportOperations["listReviewBatches"],
  },
  "updateReviewProject": {
    name: "updateReviewProject",
    definition: transportOperations["updateReviewProject"],
  },
  "deleteReviewProject": {
    name: "deleteReviewProject",
    definition: transportOperations["deleteReviewProject"],
  },
  "listReviewAnnotations": {
    name: "listReviewAnnotations",
    definition: transportOperations["listReviewAnnotations"],
  },
  "getReviewAnnotation": {
    name: "getReviewAnnotation",
    definition: transportOperations["getReviewAnnotation"],
  },
  "createReviewAnnotation": {
    name: "createReviewAnnotation",
    definition: transportOperations["createReviewAnnotation"],
  },
  "updateReviewAnnotation": {
    name: "updateReviewAnnotation",
    definition: transportOperations["updateReviewAnnotation"],
  },
  "deleteReviewAnnotation": {
    name: "deleteReviewAnnotation",
    definition: transportOperations["deleteReviewAnnotation"],
  },
  "updateProjectReviewAnnotation": {
    name: "updateProjectReviewAnnotation",
    definition: transportOperations["updateProjectReviewAnnotation"],
  },
  "deleteProjectReviewAnnotation": {
    name: "deleteProjectReviewAnnotation",
    definition: transportOperations["deleteProjectReviewAnnotation"],
  },
  "launchRun": {
    name: "launchRun",
    definition: transportOperations["launchRun"],
  },
  "rerunMetrics": {
    name: "rerunMetrics",
    definition: transportOperations["rerunMetrics"],
  },
  "listRunsKeyset": {
    name: "listRunsKeyset",
    definition: transportOperations["listRunsKeyset"],
  },
  "listSimulatedConversationsKeyset": {
    name: "listSimulatedConversationsKeyset",
    definition: transportOperations["listSimulatedConversationsKeyset"],
  },
  "getRunsPageInsights": {
    name: "getRunsPageInsights",
    definition: transportOperations["getRunsPageInsights"],
  },
  "getRunMetadata": {
    name: "getRunMetadata",
    definition: transportOperations["getRunMetadata"],
  },
  "getMultiRunMetadata": {
    name: "getMultiRunMetadata",
    definition: transportOperations["getMultiRunMetadata"],
  },
  "getRunRows": {
    name: "getRunRows",
    definition: transportOperations["getRunRows"],
  },
  "getRunOutliers": {
    name: "getRunOutliers",
    definition: transportOperations["getRunOutliers"],
  },
  "getMultiRunRows": {
    name: "getMultiRunRows",
    definition: transportOperations["getMultiRunRows"],
  },
  "getLatestRun": {
    name: "getLatestRun",
    definition: transportOperations["getLatestRun"],
  },
  "importSessionMappingFromCsv": {
    name: "importSessionMappingFromCsv",
    definition: transportOperations["importSessionMappingFromCsv"],
  },
  "updateRunNotes": {
    name: "updateRunNotes",
    definition: transportOperations["updateRunNotes"],
  },
  "deleteRun": {
    name: "deleteRun",
    definition: transportOperations["deleteRun"],
  },
  "setRunPublic": {
    name: "setRunPublic",
    definition: transportOperations["setRunPublic"],
  },
  "updateRunDisplayName": {
    name: "updateRunDisplayName",
    definition: transportOperations["updateRunDisplayName"],
  },
  "cancelRun": {
    name: "cancelRun",
    definition: transportOperations["cancelRun"],
  },
  "getLatestFailurePatternRunOutput": {
    name: "getLatestFailurePatternRunOutput",
    definition: transportOperations["getLatestFailurePatternRunOutput"],
  },
  "getLatestConversationClusteringRunOutput": {
    name: "getLatestConversationClusteringRunOutput",
    definition: transportOperations["getLatestConversationClusteringRunOutput"],
  },
  "listRunTags": {
    name: "listRunTags",
    definition: transportOperations["listRunTags"],
  },
  "updateRunTags": {
    name: "updateRunTags",
    definition: transportOperations["updateRunTags"],
  },
  "getSimulationOutput": {
    name: "getSimulationOutput",
    definition: transportOperations["getSimulationOutput"],
  },
  "listSimulationOutputIds": {
    name: "listSimulationOutputIds",
    definition: transportOperations["listSimulationOutputIds"],
  },
  "getSimulationOutputTimeWindow": {
    name: "getSimulationOutputTimeWindow",
    definition: transportOperations["getSimulationOutputTimeWindow"],
  },
  "getSimulationOutputSpeakingSegments": {
    name: "getSimulationOutputSpeakingSegments",
    definition: transportOperations["getSimulationOutputSpeakingSegments"],
  },
  "setSimulationOutputPublic": {
    name: "setSimulationOutputPublic",
    definition: transportOperations["setSimulationOutputPublic"],
  },
  "deleteSimulationOutput": {
    name: "deleteSimulationOutput",
    definition: transportOperations["deleteSimulationOutput"],
  },
  "resimulateSimulationOutputs": {
    name: "resimulateSimulationOutputs",
    definition: transportOperations["resimulateSimulationOutputs"],
  },
  "getSharedRunRecord": {
    name: "getSharedRunRecord",
    definition: transportOperations["getSharedRunRecord"],
  },
  "verifySharedRunPassword": {
    name: "verifySharedRunPassword",
    definition: transportOperations["verifySharedRunPassword"],
  },
  "getSharedRunRows": {
    name: "getSharedRunRows",
    definition: transportOperations["getSharedRunRows"],
  },
  "getSharedTestSet": {
    name: "getSharedTestSet",
    definition: transportOperations["getSharedTestSet"],
  },
  "getSharedMetrics": {
    name: "getSharedMetrics",
    definition: transportOperations["getSharedMetrics"],
  },
  "getSharedRunTestSet": {
    name: "getSharedRunTestSet",
    definition: transportOperations["getSharedRunTestSet"],
  },
  "getSharedMultiRunMetadata": {
    name: "getSharedMultiRunMetadata",
    definition: transportOperations["getSharedMultiRunMetadata"],
  },
  "getSharedMultiRunRows": {
    name: "getSharedMultiRunRows",
    definition: transportOperations["getSharedMultiRunRows"],
  },
  "getSharedSimulationOutputRow": {
    name: "getSharedSimulationOutputRow",
    definition: transportOperations["getSharedSimulationOutputRow"],
  },
  "listSharedSimulationTraces": {
    name: "listSharedSimulationTraces",
    definition: transportOperations["listSharedSimulationTraces"],
  },
  "getMaestroSimulationOutputCount": {
    name: "getMaestroSimulationOutputCount",
    definition: transportOperations["getMaestroSimulationOutputCount"],
  },
  "listMaestroSimulationOutputIds": {
    name: "listMaestroSimulationOutputIds",
    definition: transportOperations["listMaestroSimulationOutputIds"],
  },
  "listMaestroExistingMetrics": {
    name: "listMaestroExistingMetrics",
    definition: transportOperations["listMaestroExistingMetrics"],
  },
  "listMaestroMetadataKeys": {
    name: "listMaestroMetadataKeys",
    definition: transportOperations["listMaestroMetadataKeys"],
  },
  "listMaestroMetadataValues": {
    name: "listMaestroMetadataValues",
    definition: transportOperations["listMaestroMetadataValues"],
  },
  "hasSimulationTraces": {
    name: "hasSimulationTraces",
    definition: transportOperations["hasSimulationTraces"],
  },
  "listSimulationTraces": {
    name: "listSimulationTraces",
    definition: transportOperations["listSimulationTraces"],
  },
  "getSimulationTraceDetail": {
    name: "getSimulationTraceDetail",
    definition: transportOperations["getSimulationTraceDetail"],
  },
  "hasRunTraces": {
    name: "hasRunTraces",
    definition: transportOperations["hasRunTraces"],
  },
  "getTraceAudioContext": {
    name: "getTraceAudioContext",
    definition: transportOperations["getTraceAudioContext"],
  },
  "searchTraceCalls": {
    name: "searchTraceCalls",
    definition: transportOperations["searchTraceCalls"],
  },
  "getTraceTransitionHotspots": {
    name: "getTraceTransitionHotspots",
    definition: transportOperations["getTraceTransitionHotspots"],
  },
  "getTraceTransitionHotspotsForSearch": {
    name: "getTraceTransitionHotspotsForSearch",
    definition: transportOperations["getTraceTransitionHotspotsForSearch"],
  },
  "getTraceFilterSuggestions": {
    name: "getTraceFilterSuggestions",
    definition: transportOperations["getTraceFilterSuggestions"],
  },
  "previewCustomTraceMetric": {
    name: "previewCustomTraceMetric",
    definition: transportOperations["previewCustomTraceMetric"],
  },
  "getPersona": {
    name: "getPersona",
    definition: transportOperations["getPersona"],
  },
  "getPersonaVersions": {
    name: "getPersonaVersions",
    definition: transportOperations["getPersonaVersions"],
  },
  "revertPersonaVersion": {
    name: "revertPersonaVersion",
    definition: transportOperations["revertPersonaVersion"],
  },
  "createPersona": {
    name: "createPersona",
    definition: transportOperations["createPersona"],
  },
  "createBackgroundSound": {
    name: "createBackgroundSound",
    definition: transportOperations["createBackgroundSound"],
  },
  "completeBackgroundSound": {
    name: "completeBackgroundSound",
    definition: transportOperations["completeBackgroundSound"],
  },
  "updatePersona": {
    name: "updatePersona",
    definition: transportOperations["updatePersona"],
  },
  "updateBackgroundSound": {
    name: "updateBackgroundSound",
    definition: transportOperations["updateBackgroundSound"],
  },
  "deletePersona": {
    name: "deletePersona",
    definition: transportOperations["deletePersona"],
  },
  "deletePersonas": {
    name: "deletePersonas",
    definition: transportOperations["deletePersonas"],
  },
  "duplicatePersona": {
    name: "duplicatePersona",
    definition: transportOperations["duplicatePersona"],
  },
  "restorePersona": {
    name: "restorePersona",
    definition: transportOperations["restorePersona"],
  },
  "generatePersonaVoiceCandidates": {
    name: "generatePersonaVoiceCandidates",
    definition: transportOperations["generatePersonaVoiceCandidates"],
  },
  "previewPersonaVoiceCandidate": {
    name: "previewPersonaVoiceCandidate",
    definition: transportOperations["previewPersonaVoiceCandidate"],
  },
  "keepPersonaVoiceCandidate": {
    name: "keepPersonaVoiceCandidate",
    definition: transportOperations["keepPersonaVoiceCandidate"],
  },
  "listWebhooks": {
    name: "listWebhooks",
    definition: transportOperations["listWebhooks"],
  },
  "createWebhook": {
    name: "createWebhook",
    definition: transportOperations["createWebhook"],
  },
  "updateWebhook": {
    name: "updateWebhook",
    definition: transportOperations["updateWebhook"],
  },
  "deleteWebhook": {
    name: "deleteWebhook",
    definition: transportOperations["deleteWebhook"],
  },
  "listExternalAgentCandidates": {
    name: "listExternalAgentCandidates",
    definition: transportOperations["listExternalAgentCandidates"],
  },
  "importExternalAgents": {
    name: "importExternalAgents",
    definition: transportOperations["importExternalAgents"],
  },
  "listSavedViews": {
    name: "listSavedViews",
    definition: transportOperations["listSavedViews"],
  },
  "getSavedView": {
    name: "getSavedView",
    definition: transportOperations["getSavedView"],
  },
  "createSavedView": {
    name: "createSavedView",
    definition: transportOperations["createSavedView"],
  },
  "updateSavedView": {
    name: "updateSavedView",
    definition: transportOperations["updateSavedView"],
  },
  "deleteSavedView": {
    name: "deleteSavedView",
    definition: transportOperations["deleteSavedView"],
  },
  "getUserDefaultSavedView": {
    name: "getUserDefaultSavedView",
    definition: transportOperations["getUserDefaultSavedView"],
  },
  "setUserDefaultSavedView": {
    name: "setUserDefaultSavedView",
    definition: transportOperations["setUserDefaultSavedView"],
  },
  "clearUserDefaultSavedView": {
    name: "clearUserDefaultSavedView",
    definition: transportOperations["clearUserDefaultSavedView"],
  },
  "listOrganizationTags": {
    name: "listOrganizationTags",
    definition: transportOperations["listOrganizationTags"],
  },
  "listWorkspaceTags": {
    name: "listWorkspaceTags",
    definition: transportOperations["listWorkspaceTags"],
  },
  "createOrganizationTag": {
    name: "createOrganizationTag",
    definition: transportOperations["createOrganizationTag"],
  },
  "updateOrganizationTag": {
    name: "updateOrganizationTag",
    definition: transportOperations["updateOrganizationTag"],
  },
  "deleteOrganizationTag": {
    name: "deleteOrganizationTag",
    definition: transportOperations["deleteOrganizationTag"],
  },
} as const satisfies { readonly [Name in TransportOperationName]: TransportOperationDescriptor<Name> };

export const transport = {
  operations: transportOperationDescriptors,
  resources: {
    "python-metrics": {
      name: "python-metrics",
      operations: {
        "createPythonMetricDraft": transportOperationDescriptors["createPythonMetricDraft"],
        "getPythonMetricDraft": transportOperationDescriptors["getPythonMetricDraft"],
        "cancelPythonMetricPreview": transportOperationDescriptors["cancelPythonMetricPreview"],
      },
      actions: {
        "create": transportOperationDescriptors["createPythonMetricDraft"],
        "get": transportOperationDescriptors["getPythonMetricDraft"],
        "update": transportOperationDescriptors["cancelPythonMetricPreview"],
      },
    },
    "python-metrics-preview-python-metric": {
      name: "python-metrics-preview-python-metric",
      operations: {
        "previewPythonMetric": transportOperationDescriptors["previewPythonMetric"],
      },
      actions: {
        "create": transportOperationDescriptors["previewPythonMetric"],
      },
    },
    "python-metrics-get-python-metric-preview": {
      name: "python-metrics-get-python-metric-preview",
      operations: {
        "getPythonMetricPreview": transportOperationDescriptors["getPythonMetricPreview"],
      },
      actions: {
        "get": transportOperationDescriptors["getPythonMetricPreview"],
      },
    },
    "python-metrics-publish-python-metric": {
      name: "python-metrics-publish-python-metric",
      operations: {
        "publishPythonMetric": transportOperationDescriptors["publishPythonMetric"],
      },
      actions: {
        "create": transportOperationDescriptors["publishPythonMetric"],
      },
    },
    "ivr_trees": {
      name: "ivr_trees",
      operations: {
        "listIvrTrees": transportOperationDescriptors["listIvrTrees"],
        "createIvrTree": transportOperationDescriptors["createIvrTree"],
        "getIvrTree": transportOperationDescriptors["getIvrTree"],
        "updateIvrTree": transportOperationDescriptors["updateIvrTree"],
        "deleteIvrTree": transportOperationDescriptors["deleteIvrTree"],
      },
      actions: {
        "list": transportOperationDescriptors["listIvrTrees"],
        "create": transportOperationDescriptors["createIvrTree"],
        "get": transportOperationDescriptors["getIvrTree"],
        "update": transportOperationDescriptors["updateIvrTree"],
        "delete": transportOperationDescriptors["deleteIvrTree"],
      },
    },
    "healthz": {
      name: "healthz",
      operations: {
        "health": transportOperationDescriptors["health"],
      },
      actions: {
        "query": transportOperationDescriptors["health"],
      },
    },
    "health": {
      name: "health",
      operations: {
        "getHealthStatus": transportOperationDescriptors["getHealthStatus"],
      },
      actions: {
        "get": transportOperationDescriptors["getHealthStatus"],
      },
    },
    "system-status": {
      name: "system-status",
      operations: {
        "getSystemStatus": transportOperationDescriptors["getSystemStatus"],
      },
      actions: {
        "get": transportOperationDescriptors["getSystemStatus"],
      },
    },
    "fde-support": {
      name: "fde-support",
      operations: {
        "getFdeSupportStatus": transportOperationDescriptors["getFdeSupportStatus"],
        "pageFdeSupport": transportOperationDescriptors["pageFdeSupport"],
      },
      actions: {
        "get": transportOperationDescriptors["getFdeSupportStatus"],
        "create": transportOperationDescriptors["pageFdeSupport"],
      },
    },
    "bootstrap": {
      name: "bootstrap",
      operations: {
        "bootstrap": transportOperationDescriptors["bootstrap"],
      },
      actions: {
        "query": transportOperationDescriptors["bootstrap"],
      },
    },
    "account": {
      name: "account",
      operations: {
        "getAccountDeletionImpact": transportOperationDescriptors["getAccountDeletionImpact"],
        "deleteAccount": transportOperationDescriptors["deleteAccount"],
      },
      actions: {
        "get": transportOperationDescriptors["getAccountDeletionImpact"],
        "delete": transportOperationDescriptors["deleteAccount"],
      },
    },
    "admin-organizations": {
      name: "admin-organizations",
      operations: {
        "adminListOrganizations": transportOperationDescriptors["adminListOrganizations"],
        "adminGetOrganization": transportOperationDescriptors["adminGetOrganization"],
      },
      actions: {
        "list": transportOperationDescriptors["adminListOrganizations"],
        "get": transportOperationDescriptors["adminGetOrganization"],
      },
    },
    "admin-data-frames": {
      name: "admin-data-frames",
      operations: {
        "listAdminDataFrames": transportOperationDescriptors["listAdminDataFrames"],
      },
      actions: {
        "list": transportOperationDescriptors["listAdminDataFrames"],
      },
    },
    "admin-data-frames-list-admin-simulation-data-frames": {
      name: "admin-data-frames-list-admin-simulation-data-frames",
      operations: {
        "listAdminSimulationDataFrames": transportOperationDescriptors["listAdminSimulationDataFrames"],
      },
      actions: {
        "list": transportOperationDescriptors["listAdminSimulationDataFrames"],
      },
    },
    "simulation-data-frames": {
      name: "simulation-data-frames",
      operations: {
        "listSimulationDataFrames": transportOperationDescriptors["listSimulationDataFrames"],
      },
      actions: {
        "list": transportOperationDescriptors["listSimulationDataFrames"],
      },
    },
    "admin-organization-plans": {
      name: "admin-organization-plans",
      operations: {
        "adminListOrganizationPlans": transportOperationDescriptors["adminListOrganizationPlans"],
      },
      actions: {
        "list": transportOperationDescriptors["adminListOrganizationPlans"],
      },
    },
    "admin-organization-usage": {
      name: "admin-organization-usage",
      operations: {
        "adminGetOrganizationUsage": transportOperationDescriptors["adminGetOrganizationUsage"],
      },
      actions: {
        "get": transportOperationDescriptors["adminGetOrganizationUsage"],
      },
    },
    "admin-customer-health": {
      name: "admin-customer-health",
      operations: {
        "adminGetCustomerHealthOverview": transportOperationDescriptors["adminGetCustomerHealthOverview"],
      },
      actions: {
        "get": transportOperationDescriptors["adminGetCustomerHealthOverview"],
      },
    },
    "admin-customer-health-detail": {
      name: "admin-customer-health-detail",
      operations: {
        "adminGetCustomerHealthDetail": transportOperationDescriptors["adminGetCustomerHealthDetail"],
      },
      actions: {
        "get": transportOperationDescriptors["adminGetCustomerHealthDetail"],
      },
    },
    "admin-customer-health-external-signals": {
      name: "admin-customer-health-external-signals",
      operations: {
        "adminGetCustomerHealthExternalSignals": transportOperationDescriptors["adminGetCustomerHealthExternalSignals"],
      },
      actions: {
        "get": transportOperationDescriptors["adminGetCustomerHealthExternalSignals"],
      },
    },
    "admin-customer-health-slack-summary": {
      name: "admin-customer-health-slack-summary",
      operations: {
        "adminGetCustomerHealthSlackSummary": transportOperationDescriptors["adminGetCustomerHealthSlackSummary"],
      },
      actions: {
        "get": transportOperationDescriptors["adminGetCustomerHealthSlackSummary"],
      },
    },
    "admin-customer-health-account": {
      name: "admin-customer-health-account",
      operations: {
        "adminListCustomerHealthAccounts": transportOperationDescriptors["adminListCustomerHealthAccounts"],
      },
      actions: {
        "list": transportOperationDescriptors["adminListCustomerHealthAccounts"],
      },
    },
    "admin-self-serve-usage-roundup": {
      name: "admin-self-serve-usage-roundup",
      operations: {
        "adminGetSelfServeUsageRoundup": transportOperationDescriptors["adminGetSelfServeUsageRoundup"],
      },
      actions: {
        "get": transportOperationDescriptors["adminGetSelfServeUsageRoundup"],
      },
    },
    "admin-organization-api-keys": {
      name: "admin-organization-api-keys",
      operations: {
        "adminListOrganizationApiKeys": transportOperationDescriptors["adminListOrganizationApiKeys"],
        "adminCreateOrganizationApiKey": transportOperationDescriptors["adminCreateOrganizationApiKey"],
        "adminUpdateOrganizationApiKeyStatus": transportOperationDescriptors["adminUpdateOrganizationApiKeyStatus"],
        "adminDeleteOrganizationApiKey": transportOperationDescriptors["adminDeleteOrganizationApiKey"],
      },
      actions: {
        "list": transportOperationDescriptors["adminListOrganizationApiKeys"],
        "create": transportOperationDescriptors["adminCreateOrganizationApiKey"],
        "update": transportOperationDescriptors["adminUpdateOrganizationApiKeyStatus"],
        "delete": transportOperationDescriptors["adminDeleteOrganizationApiKey"],
      },
    },
    "admin-organization-provisioning": {
      name: "admin-organization-provisioning",
      operations: {
        "adminProvisionOrganization": transportOperationDescriptors["adminProvisionOrganization"],
        "adminPreviewOrganizationReconciliation": transportOperationDescriptors["adminPreviewOrganizationReconciliation"],
      },
      actions: {
        "create": transportOperationDescriptors["adminProvisionOrganization"],
        "get": transportOperationDescriptors["adminPreviewOrganizationReconciliation"],
      },
    },
    "admin-organization-simulation-timeout": {
      name: "admin-organization-simulation-timeout",
      operations: {
        "adminUpdateSimulationTimeout": transportOperationDescriptors["adminUpdateSimulationTimeout"],
      },
      actions: {
        "update": transportOperationDescriptors["adminUpdateSimulationTimeout"],
      },
    },
    "admin-email-recipient-allowlist": {
      name: "admin-email-recipient-allowlist",
      operations: {
        "adminGetEmailRecipientAllowlist": transportOperationDescriptors["adminGetEmailRecipientAllowlist"],
        "adminUpdateEmailRecipientAllowlist": transportOperationDescriptors["adminUpdateEmailRecipientAllowlist"],
      },
      actions: {
        "get": transportOperationDescriptors["adminGetEmailRecipientAllowlist"],
        "update": transportOperationDescriptors["adminUpdateEmailRecipientAllowlist"],
      },
    },
    "admin-organization-telephony-provider": {
      name: "admin-organization-telephony-provider",
      operations: {
        "adminUpdateTelephonyProvider": transportOperationDescriptors["adminUpdateTelephonyProvider"],
      },
      actions: {
        "update": transportOperationDescriptors["adminUpdateTelephonyProvider"],
      },
    },
    "admin-organization-sofia-model": {
      name: "admin-organization-sofia-model",
      operations: {
        "adminUpdateSofiaModel": transportOperationDescriptors["adminUpdateSofiaModel"],
      },
      actions: {
        "update": transportOperationDescriptors["adminUpdateSofiaModel"],
      },
    },
    "admin-organization-max-simulation-attempts": {
      name: "admin-organization-max-simulation-attempts",
      operations: {
        "adminUpdateMaxSimulationAttempts": transportOperationDescriptors["adminUpdateMaxSimulationAttempts"],
      },
      actions: {
        "update": transportOperationDescriptors["adminUpdateMaxSimulationAttempts"],
      },
    },
    "admin-organization-pipeline-priority": {
      name: "admin-organization-pipeline-priority",
      operations: {
        "adminUpdatePipelinePriority": transportOperationDescriptors["adminUpdatePipelinePriority"],
      },
      actions: {
        "update": transportOperationDescriptors["adminUpdatePipelinePriority"],
      },
    },
    "admin-organization-wide-concurrency": {
      name: "admin-organization-wide-concurrency",
      operations: {
        "adminUpdateOrganizationWideConcurrency": transportOperationDescriptors["adminUpdateOrganizationWideConcurrency"],
      },
      actions: {
        "update": transportOperationDescriptors["adminUpdateOrganizationWideConcurrency"],
      },
    },
    "admin-organization-max-job-concurrency": {
      name: "admin-organization-max-job-concurrency",
      operations: {
        "adminUpdateMaxJobConcurrency": transportOperationDescriptors["adminUpdateMaxJobConcurrency"],
      },
      actions: {
        "update": transportOperationDescriptors["adminUpdateMaxJobConcurrency"],
      },
    },
    "workos-setup": {
      name: "workos-setup",
      operations: {
        "getWorkOSSetupInfo": transportOperationDescriptors["getWorkOSSetupInfo"],
      },
      actions: {
        "get": transportOperationDescriptors["getWorkOSSetupInfo"],
      },
    },
    "workos-mapping": {
      name: "workos-mapping",
      operations: {
        "configureWorkOSMapping": transportOperationDescriptors["configureWorkOSMapping"],
      },
      actions: {
        "update": transportOperationDescriptors["configureWorkOSMapping"],
      },
    },
    "agents": {
      name: "agents",
      operations: {
        "listAgents": transportOperationDescriptors["listAgents"],
        "getAgent": transportOperationDescriptors["getAgent"],
        "revertAgentVersion": transportOperationDescriptors["revertAgentVersion"],
        "createAgent": transportOperationDescriptors["createAgent"],
        "duplicateAgent": transportOperationDescriptors["duplicateAgent"],
        "testAgentConnection": transportOperationDescriptors["testAgentConnection"],
        "deleteAgent": transportOperationDescriptors["deleteAgent"],
      },
      actions: {
        "list": transportOperationDescriptors["listAgents"],
        "get": transportOperationDescriptors["getAgent"],
        "update": transportOperationDescriptors["revertAgentVersion"],
        "create": transportOperationDescriptors["createAgent"],
        "duplicate": transportOperationDescriptors["duplicateAgent"],
        "run": transportOperationDescriptors["testAgentConnection"],
        "delete": transportOperationDescriptors["deleteAgent"],
      },
    },
    "agents-all": {
      name: "agents-all",
      operations: {
        "listAllAgents": transportOperationDescriptors["listAllAgents"],
      },
      actions: {
        "list": transportOperationDescriptors["listAllAgents"],
      },
    },
    "agents-names": {
      name: "agents-names",
      operations: {
        "getAgentNames": transportOperationDescriptors["getAgentNames"],
      },
      actions: {
        "get": transportOperationDescriptors["getAgentNames"],
      },
    },
    "agent-versions": {
      name: "agent-versions",
      operations: {
        "getAgentVersions": transportOperationDescriptors["getAgentVersions"],
      },
      actions: {
        "list": transportOperationDescriptors["getAgentVersions"],
      },
    },
    "agents-update-agent": {
      name: "agents-update-agent",
      operations: {
        "updateAgent": transportOperationDescriptors["updateAgent"],
      },
      actions: {
        "update": transportOperationDescriptors["updateAgent"],
      },
    },
    "agents-batch": {
      name: "agents-batch",
      operations: {
        "deleteAgents": transportOperationDescriptors["deleteAgents"],
      },
      actions: {
        "delete": transportOperationDescriptors["deleteAgents"],
      },
    },
    "agents-metrics": {
      name: "agents-metrics",
      operations: {
        "addAgentMetrics": transportOperationDescriptors["addAgentMetrics"],
        "removeAgentMetric": transportOperationDescriptors["removeAgentMetric"],
      },
      actions: {
        "set": transportOperationDescriptors["addAgentMetrics"],
        "delete": transportOperationDescriptors["removeAgentMetric"],
      },
    },
    "agents-metrics-set-agent-metrics": {
      name: "agents-metrics-set-agent-metrics",
      operations: {
        "setAgentMetrics": transportOperationDescriptors["setAgentMetrics"],
      },
      actions: {
        "set": transportOperationDescriptors["setAgentMetrics"],
      },
    },
    "agents-workflows": {
      name: "agents-workflows",
      operations: {
        "addAgentWorkflow": transportOperationDescriptors["addAgentWorkflow"],
        "removeAgentWorkflow": transportOperationDescriptors["removeAgentWorkflow"],
      },
      actions: {
        "set": transportOperationDescriptors["addAgentWorkflow"],
        "delete": transportOperationDescriptors["removeAgentWorkflow"],
      },
    },
    "agents-list-recently-deleted-agents": {
      name: "agents-list-recently-deleted-agents",
      operations: {
        "listRecentlyDeletedAgents": transportOperationDescriptors["listRecentlyDeletedAgents"],
      },
      actions: {
        "list": transportOperationDescriptors["listRecentlyDeletedAgents"],
      },
    },
    "agents-restore-agent": {
      name: "agents-restore-agent",
      operations: {
        "restoreAgent": transportOperationDescriptors["restoreAgent"],
      },
      actions: {
        "update": transportOperationDescriptors["restoreAgent"],
      },
    },
    "agent-mutations": {
      name: "agent-mutations",
      operations: {
        "listAgentMutations": transportOperationDescriptors["listAgentMutations"],
        "getAgentMutation": transportOperationDescriptors["getAgentMutation"],
        "createAgentMutation": transportOperationDescriptors["createAgentMutation"],
        "updateAgentMutation": transportOperationDescriptors["updateAgentMutation"],
        "archiveAgentMutation": transportOperationDescriptors["archiveAgentMutation"],
      },
      actions: {
        "list": transportOperationDescriptors["listAgentMutations"],
        "get": transportOperationDescriptors["getAgentMutation"],
        "create": transportOperationDescriptors["createAgentMutation"],
        "update": transportOperationDescriptors["updateAgentMutation"],
        "archive": transportOperationDescriptors["archiveAgentMutation"],
      },
    },
    "agent-mutations-all": {
      name: "agent-mutations-all",
      operations: {
        "listAllAgentMutations": transportOperationDescriptors["listAllAgentMutations"],
      },
      actions: {
        "list": transportOperationDescriptors["listAllAgentMutations"],
      },
    },
    "baselines": {
      name: "baselines",
      operations: {
        "listBaselines": transportOperationDescriptors["listBaselines"],
        "getBaseline": transportOperationDescriptors["getBaseline"],
        "createBaseline": transportOperationDescriptors["createBaseline"],
        "updateBaseline": transportOperationDescriptors["updateBaseline"],
        "archiveBaseline": transportOperationDescriptors["archiveBaseline"],
      },
      actions: {
        "list": transportOperationDescriptors["listBaselines"],
        "get": transportOperationDescriptors["getBaseline"],
        "create": transportOperationDescriptors["createBaseline"],
        "update": transportOperationDescriptors["updateBaseline"],
        "archive": transportOperationDescriptors["archiveBaseline"],
      },
    },
    "baselines-history": {
      name: "baselines-history",
      operations: {
        "getBaselineHistory": transportOperationDescriptors["getBaselineHistory"],
      },
      actions: {
        "get": transportOperationDescriptors["getBaselineHistory"],
      },
    },
    "baselines-deviations-by-simulation": {
      name: "baselines-deviations-by-simulation",
      operations: {
        "getBaselineDeviationsBySimulation": transportOperationDescriptors["getBaselineDeviationsBySimulation"],
      },
      actions: {
        "get": transportOperationDescriptors["getBaselineDeviationsBySimulation"],
      },
    },
    "benchmarks-datasets": {
      name: "benchmarks-datasets",
      operations: {
        "listBenchmarkDatasets": transportOperationDescriptors["listBenchmarkDatasets"],
        "getBenchmarkDataset": transportOperationDescriptors["getBenchmarkDataset"],
        "createBenchmarkDataset": transportOperationDescriptors["createBenchmarkDataset"],
        "updateBenchmarkDataset": transportOperationDescriptors["updateBenchmarkDataset"],
        "deleteBenchmarkDataset": transportOperationDescriptors["deleteBenchmarkDataset"],
      },
      actions: {
        "list": transportOperationDescriptors["listBenchmarkDatasets"],
        "get": transportOperationDescriptors["getBenchmarkDataset"],
        "create": transportOperationDescriptors["createBenchmarkDataset"],
        "update": transportOperationDescriptors["updateBenchmarkDataset"],
        "delete": transportOperationDescriptors["deleteBenchmarkDataset"],
      },
    },
    "benchmarks-datasets-items": {
      name: "benchmarks-datasets-items",
      operations: {
        "getBenchmarkDatasetUploadUrl": transportOperationDescriptors["getBenchmarkDatasetUploadUrl"],
        "listBenchmarkDatasetItems": transportOperationDescriptors["listBenchmarkDatasetItems"],
        "addBenchmarkDatasetItem": transportOperationDescriptors["addBenchmarkDatasetItem"],
        "deleteBenchmarkDatasetItem": transportOperationDescriptors["deleteBenchmarkDatasetItem"],
      },
      actions: {
        "get": transportOperationDescriptors["getBenchmarkDatasetUploadUrl"],
        "list": transportOperationDescriptors["listBenchmarkDatasetItems"],
        "set": transportOperationDescriptors["addBenchmarkDatasetItem"],
        "delete": transportOperationDescriptors["deleteBenchmarkDatasetItem"],
      },
    },
    "benchmarks-dataset-items": {
      name: "benchmarks-dataset-items",
      operations: {
        "getBenchmarkDatasetItem": transportOperationDescriptors["getBenchmarkDatasetItem"],
        "updateBenchmarkDatasetItem": transportOperationDescriptors["updateBenchmarkDatasetItem"],
      },
      actions: {
        "get": transportOperationDescriptors["getBenchmarkDatasetItem"],
        "update": transportOperationDescriptors["updateBenchmarkDatasetItem"],
      },
    },
    "benchmarks-provider-endpoints": {
      name: "benchmarks-provider-endpoints",
      operations: {
        "listBenchmarkEndpoints": transportOperationDescriptors["listBenchmarkEndpoints"],
        "getBenchmarkEndpoint": transportOperationDescriptors["getBenchmarkEndpoint"],
        "createBenchmarkEndpoint": transportOperationDescriptors["createBenchmarkEndpoint"],
        "updateBenchmarkEndpoint": transportOperationDescriptors["updateBenchmarkEndpoint"],
        "deleteBenchmarkEndpoint": transportOperationDescriptors["deleteBenchmarkEndpoint"],
        "testBenchmarkEndpoint": transportOperationDescriptors["testBenchmarkEndpoint"],
      },
      actions: {
        "list": transportOperationDescriptors["listBenchmarkEndpoints"],
        "get": transportOperationDescriptors["getBenchmarkEndpoint"],
        "create": transportOperationDescriptors["createBenchmarkEndpoint"],
        "update": transportOperationDescriptors["updateBenchmarkEndpoint"],
        "delete": transportOperationDescriptors["deleteBenchmarkEndpoint"],
        "run": transportOperationDescriptors["testBenchmarkEndpoint"],
      },
    },
    "benchmarks-provider-endpoints-by-ids": {
      name: "benchmarks-provider-endpoints-by-ids",
      operations: {
        "getBenchmarkEndpointsByIds": transportOperationDescriptors["getBenchmarkEndpointsByIds"],
      },
      actions: {
        "get": transportOperationDescriptors["getBenchmarkEndpointsByIds"],
      },
    },
    "benchmarks-runs": {
      name: "benchmarks-runs",
      operations: {
        "listBenchmarkRuns": transportOperationDescriptors["listBenchmarkRuns"],
        "getBenchmarkRun": transportOperationDescriptors["getBenchmarkRun"],
        "createBenchmarkRun": transportOperationDescriptors["createBenchmarkRun"],
        "cancelBenchmarkRun": transportOperationDescriptors["cancelBenchmarkRun"],
      },
      actions: {
        "list": transportOperationDescriptors["listBenchmarkRuns"],
        "get": transportOperationDescriptors["getBenchmarkRun"],
        "create": transportOperationDescriptors["createBenchmarkRun"],
        "update": transportOperationDescriptors["cancelBenchmarkRun"],
      },
    },
    "benchmarks-runs-results": {
      name: "benchmarks-runs-results",
      operations: {
        "listBenchmarkResults": transportOperationDescriptors["listBenchmarkResults"],
      },
      actions: {
        "list": transportOperationDescriptors["listBenchmarkResults"],
      },
    },
    "benchmarks-audio-signed-url": {
      name: "benchmarks-audio-signed-url",
      operations: {
        "getBenchmarkAudioSignedUrl": transportOperationDescriptors["getBenchmarkAudioSignedUrl"],
      },
      actions: {
        "get": transportOperationDescriptors["getBenchmarkAudioSignedUrl"],
      },
    },
    "api-keys": {
      name: "api-keys",
      operations: {
        "listApiKeys": transportOperationDescriptors["listApiKeys"],
        "createApiKey": transportOperationDescriptors["createApiKey"],
        "deleteApiKey": transportOperationDescriptors["deleteApiKey"],
      },
      actions: {
        "list": transportOperationDescriptors["listApiKeys"],
        "create": transportOperationDescriptors["createApiKey"],
        "delete": transportOperationDescriptors["deleteApiKey"],
      },
    },
    "github-fix-intents": {
      name: "github-fix-intents",
      operations: {
        "createGithubFixIntent": transportOperationDescriptors["createGithubFixIntent"],
      },
      actions: {
        "create": transportOperationDescriptors["createGithubFixIntent"],
      },
    },
    "api-keys-update-status": {
      name: "api-keys-update-status",
      operations: {
        "updateApiKeyStatus": transportOperationDescriptors["updateApiKeyStatus"],
      },
      actions: {
        "update": transportOperationDescriptors["updateApiKeyStatus"],
      },
    },
    "audio-signed-url": {
      name: "audio-signed-url",
      operations: {
        "getAudioSignedUrl": transportOperationDescriptors["getAudioSignedUrl"],
      },
      actions: {
        "get": transportOperationDescriptors["getAudioSignedUrl"],
      },
    },
    "audio-public-signed-url": {
      name: "audio-public-signed-url",
      operations: {
        "getPublicAudioSignedUrl": transportOperationDescriptors["getPublicAudioSignedUrl"],
      },
      actions: {
        "get": transportOperationDescriptors["getPublicAudioSignedUrl"],
      },
    },
    "audio": {
      name: "audio",
      operations: {
        "uploadAudio": transportOperationDescriptors["uploadAudio"],
      },
      actions: {
        "upload": transportOperationDescriptors["uploadAudio"],
      },
    },
    "audio-process": {
      name: "audio-process",
      operations: {
        "processAudio": transportOperationDescriptors["processAudio"],
      },
      actions: {
        "run": transportOperationDescriptors["processAudio"],
      },
    },
    "onboarding-audio-job": {
      name: "onboarding-audio-job",
      operations: {
        "createOnboardingAudioJob": transportOperationDescriptors["createOnboardingAudioJob"],
        "startOnboardingAudioJob": transportOperationDescriptors["startOnboardingAudioJob"],
        "getOnboardingAudioJob": transportOperationDescriptors["getOnboardingAudioJob"],
      },
      actions: {
        "create": transportOperationDescriptors["createOnboardingAudioJob"],
        "run": transportOperationDescriptors["startOnboardingAudioJob"],
        "get": transportOperationDescriptors["getOnboardingAudioJob"],
      },
    },
    "uploaded-conversation": {
      name: "uploaded-conversation",
      operations: {
        "submitUploadedConversation": transportOperationDescriptors["submitUploadedConversation"],
      },
      actions: {
        "create": transportOperationDescriptors["submitUploadedConversation"],
      },
    },
    "uploaded-conversation-traces": {
      name: "uploaded-conversation-traces",
      operations: {
        "uploadTracesForUploadedConversation": transportOperationDescriptors["uploadTracesForUploadedConversation"],
      },
      actions: {
        "create": transportOperationDescriptors["uploadTracesForUploadedConversation"],
      },
    },
    "uploaded-conversation-results": {
      name: "uploaded-conversation-results",
      operations: {
        "queryUploadedConversationKeyset": transportOperationDescriptors["queryUploadedConversationKeyset"],
      },
      actions: {
        "list": transportOperationDescriptors["queryUploadedConversationKeyset"],
      },
    },
    "uploaded-conversations-metadata": {
      name: "uploaded-conversations-metadata",
      operations: {
        "getUploadedConversationMetadata": transportOperationDescriptors["getUploadedConversationMetadata"],
      },
      actions: {
        "get": transportOperationDescriptors["getUploadedConversationMetadata"],
      },
    },
    "uploaded-conversations-metric-string-values": {
      name: "uploaded-conversations-metric-string-values",
      operations: {
        "getUploadedConversationMetricStringValues": transportOperationDescriptors["getUploadedConversationMetricStringValues"],
      },
      actions: {
        "get": transportOperationDescriptors["getUploadedConversationMetricStringValues"],
      },
    },
    "uploaded-conversations-navigation-context": {
      name: "uploaded-conversations-navigation-context",
      operations: {
        "getUploadedConversationNavigationContext": transportOperationDescriptors["getUploadedConversationNavigationContext"],
      },
      actions: {
        "get": transportOperationDescriptors["getUploadedConversationNavigationContext"],
      },
    },
    "uploaded-conversations-report-rows": {
      name: "uploaded-conversations-report-rows",
      operations: {
        "getUploadedConversationReportRows": transportOperationDescriptors["getUploadedConversationReportRows"],
      },
      actions: {
        "get": transportOperationDescriptors["getUploadedConversationReportRows"],
      },
    },
    "uploaded-conversation-recordings": {
      name: "uploaded-conversation-recordings",
      operations: {
        "findUploadedConversationRecordingFile": transportOperationDescriptors["findUploadedConversationRecordingFile"],
      },
      actions: {
        "get": transportOperationDescriptors["findUploadedConversationRecordingFile"],
      },
    },
    "audio-peaks-url": {
      name: "audio-peaks-url",
      operations: {
        "getAudioPeaksUrl": transportOperationDescriptors["getAudioPeaksUrl"],
      },
      actions: {
        "get": transportOperationDescriptors["getAudioPeaksUrl"],
      },
    },
    "audio-upload-url": {
      name: "audio-upload-url",
      operations: {
        "getAudioUploadUrl": transportOperationDescriptors["getAudioUploadUrl"],
      },
      actions: {
        "get": transportOperationDescriptors["getAudioUploadUrl"],
      },
    },
    "home-activation": {
      name: "home-activation",
      operations: {
        "homeActivation": transportOperationDescriptors["homeActivation"],
      },
      actions: {
        "query": transportOperationDescriptors["homeActivation"],
      },
    },
    "home-digest": {
      name: "home-digest",
      operations: {
        "homeDigest": transportOperationDescriptors["homeDigest"],
      },
      actions: {
        "query": transportOperationDescriptors["homeDigest"],
      },
    },
    "knowledge-base": {
      name: "knowledge-base",
      operations: {
        "listKnowledgeBaseEntries": transportOperationDescriptors["listKnowledgeBaseEntries"],
        "createKnowledgeBaseEntry": transportOperationDescriptors["createKnowledgeBaseEntry"],
        "updateKnowledgeBaseEntry": transportOperationDescriptors["updateKnowledgeBaseEntry"],
        "deleteKnowledgeBaseEntry": transportOperationDescriptors["deleteKnowledgeBaseEntry"],
      },
      actions: {
        "list": transportOperationDescriptors["listKnowledgeBaseEntries"],
        "create": transportOperationDescriptors["createKnowledgeBaseEntry"],
        "update": transportOperationDescriptors["updateKnowledgeBaseEntry"],
        "delete": transportOperationDescriptors["deleteKnowledgeBaseEntry"],
      },
    },
    "knowledge-base-by-test-set": {
      name: "knowledge-base-by-test-set",
      operations: {
        "listKnowledgeBaseEntriesByTestSet": transportOperationDescriptors["listKnowledgeBaseEntriesByTestSet"],
      },
      actions: {
        "list": transportOperationDescriptors["listKnowledgeBaseEntriesByTestSet"],
      },
    },
    "knowledge-base-create-test-set-from-scenarios": {
      name: "knowledge-base-create-test-set-from-scenarios",
      operations: {
        "createTestSetFromKnowledgeBaseScenarios": transportOperationDescriptors["createTestSetFromKnowledgeBaseScenarios"],
      },
      actions: {
        "create": transportOperationDescriptors["createTestSetFromKnowledgeBaseScenarios"],
      },
    },
    "knowledge-base-upload-url": {
      name: "knowledge-base-upload-url",
      operations: {
        "getKnowledgeBaseUploadUrl": transportOperationDescriptors["getKnowledgeBaseUploadUrl"],
      },
      actions: {
        "get": transportOperationDescriptors["getKnowledgeBaseUploadUrl"],
      },
    },
    "knowledge-base-signed-url": {
      name: "knowledge-base-signed-url",
      operations: {
        "getKnowledgeBaseSignedUrl": transportOperationDescriptors["getKnowledgeBaseSignedUrl"],
      },
      actions: {
        "get": transportOperationDescriptors["getKnowledgeBaseSignedUrl"],
      },
    },
    "knowledge-base-file-content": {
      name: "knowledge-base-file-content",
      operations: {
        "getKnowledgeBaseFileContent": transportOperationDescriptors["getKnowledgeBaseFileContent"],
      },
      actions: {
        "get": transportOperationDescriptors["getKnowledgeBaseFileContent"],
      },
    },
    "organization-settings": {
      name: "organization-settings",
      operations: {
        "getOrganizationSettings": transportOperationDescriptors["getOrganizationSettings"],
        "updateOrganizationSettings": transportOperationDescriptors["updateOrganizationSettings"],
      },
      actions: {
        "get": transportOperationDescriptors["getOrganizationSettings"],
        "update": transportOperationDescriptors["updateOrganizationSettings"],
      },
    },
    "billing-overage-settings": {
      name: "billing-overage-settings",
      operations: {
        "getBillingOverageSettings": transportOperationDescriptors["getBillingOverageSettings"],
        "updateBillingOverageSettings": transportOperationDescriptors["updateBillingOverageSettings"],
      },
      actions: {
        "get": transportOperationDescriptors["getBillingOverageSettings"],
        "update": transportOperationDescriptors["updateBillingOverageSettings"],
      },
    },
    "billing-overage-acceptance-receipt": {
      name: "billing-overage-acceptance-receipt",
      operations: {
        "getBillingOverageAcceptanceReceipt": transportOperationDescriptors["getBillingOverageAcceptanceReceipt"],
      },
      actions: {
        "get": transportOperationDescriptors["getBillingOverageAcceptanceReceipt"],
      },
    },
    "billing-overage-acceptance": {
      name: "billing-overage-acceptance",
      operations: {
        "getBillingOverageAcceptanceOffer": transportOperationDescriptors["getBillingOverageAcceptanceOffer"],
        "createBillingOverageAcceptance": transportOperationDescriptors["createBillingOverageAcceptance"],
      },
      actions: {
        "get": transportOperationDescriptors["getBillingOverageAcceptanceOffer"],
        "create": transportOperationDescriptors["createBillingOverageAcceptance"],
      },
    },
    "organization-current": {
      name: "organization-current",
      operations: {
        "getOrganizationRecord": transportOperationDescriptors["getOrganizationRecord"],
      },
      actions: {
        "get": transportOperationDescriptors["getOrganizationRecord"],
      },
    },
    "organization-users": {
      name: "organization-users",
      operations: {
        "getOrganizationUsers": transportOperationDescriptors["getOrganizationUsers"],
      },
      actions: {
        "get": transportOperationDescriptors["getOrganizationUsers"],
      },
    },
    "workspaces": {
      name: "workspaces",
      operations: {
        "listWorkspaces": transportOperationDescriptors["listWorkspaces"],
        "createWorkspace": transportOperationDescriptors["createWorkspace"],
        "updateWorkspace": transportOperationDescriptors["updateWorkspace"],
        "archiveWorkspace": transportOperationDescriptors["archiveWorkspace"],
        "deleteWorkspace": transportOperationDescriptors["deleteWorkspace"],
      },
      actions: {
        "list": transportOperationDescriptors["listWorkspaces"],
        "create": transportOperationDescriptors["createWorkspace"],
        "update": transportOperationDescriptors["updateWorkspace"],
        "archive": transportOperationDescriptors["archiveWorkspace"],
        "delete": transportOperationDescriptors["deleteWorkspace"],
      },
    },
    "workspace-settings": {
      name: "workspace-settings",
      operations: {
        "getWorkspaceSettings": transportOperationDescriptors["getWorkspaceSettings"],
        "updateWorkspaceSettings": transportOperationDescriptors["updateWorkspaceSettings"],
      },
      actions: {
        "get": transportOperationDescriptors["getWorkspaceSettings"],
        "update": transportOperationDescriptors["updateWorkspaceSettings"],
      },
    },
    "workspace-members": {
      name: "workspace-members",
      operations: {
        "listWorkspaceMembers": transportOperationDescriptors["listWorkspaceMembers"],
        "addWorkspaceMember": transportOperationDescriptors["addWorkspaceMember"],
        "removeWorkspaceMember": transportOperationDescriptors["removeWorkspaceMember"],
      },
      actions: {
        "list": transportOperationDescriptors["listWorkspaceMembers"],
        "create": transportOperationDescriptors["addWorkspaceMember"],
        "delete": transportOperationDescriptors["removeWorkspaceMember"],
      },
    },
    "linear-status": {
      name: "linear-status",
      operations: {
        "getLinearIntegrationStatus": transportOperationDescriptors["getLinearIntegrationStatus"],
      },
      actions: {
        "get": transportOperationDescriptors["getLinearIntegrationStatus"],
      },
    },
    "linear-authorization-url": {
      name: "linear-authorization-url",
      operations: {
        "getLinearAuthorizationUrl": transportOperationDescriptors["getLinearAuthorizationUrl"],
      },
      actions: {
        "get": transportOperationDescriptors["getLinearAuthorizationUrl"],
      },
    },
    "linear": {
      name: "linear",
      operations: {
        "connectLinearIntegration": transportOperationDescriptors["connectLinearIntegration"],
        "disconnectLinearIntegration": transportOperationDescriptors["disconnectLinearIntegration"],
      },
      actions: {
        "connect": transportOperationDescriptors["connectLinearIntegration"],
        "disconnect": transportOperationDescriptors["disconnectLinearIntegration"],
      },
    },
    "linear-teams": {
      name: "linear-teams",
      operations: {
        "listLinearTeams": transportOperationDescriptors["listLinearTeams"],
      },
      actions: {
        "list": transportOperationDescriptors["listLinearTeams"],
      },
    },
    "linear-projects": {
      name: "linear-projects",
      operations: {
        "listLinearProjects": transportOperationDescriptors["listLinearProjects"],
      },
      actions: {
        "list": transportOperationDescriptors["listLinearProjects"],
      },
    },
    "linear-issues": {
      name: "linear-issues",
      operations: {
        "createLinearIssue": transportOperationDescriptors["createLinearIssue"],
      },
      actions: {
        "create": transportOperationDescriptors["createLinearIssue"],
      },
    },
    "simulation-rooms-request": {
      name: "simulation-rooms-request",
      operations: {
        "requestSimulationRoom": transportOperationDescriptors["requestSimulationRoom"],
      },
      actions: {
        "run": transportOperationDescriptors["requestSimulationRoom"],
      },
    },
    "slack-status": {
      name: "slack-status",
      operations: {
        "getSlackStatus": transportOperationDescriptors["getSlackStatus"],
      },
      actions: {
        "get": transportOperationDescriptors["getSlackStatus"],
      },
    },
    "slack": {
      name: "slack",
      operations: {
        "connectSlack": transportOperationDescriptors["connectSlack"],
        "disconnectSlack": transportOperationDescriptors["disconnectSlack"],
      },
      actions: {
        "connect": transportOperationDescriptors["connectSlack"],
        "disconnect": transportOperationDescriptors["disconnectSlack"],
      },
    },
    "dashboards-metadata": {
      name: "dashboards-metadata",
      operations: {
        "listDashboardMetadata": transportOperationDescriptors["listDashboardMetadata"],
      },
      actions: {
        "list": transportOperationDescriptors["listDashboardMetadata"],
      },
    },
    "dashboards-layout": {
      name: "dashboards-layout",
      operations: {
        "getDashboardLayout": transportOperationDescriptors["getDashboardLayout"],
      },
      actions: {
        "get": transportOperationDescriptors["getDashboardLayout"],
      },
    },
    "dashboards": {
      name: "dashboards",
      operations: {
        "queryDashboardBatch": transportOperationDescriptors["queryDashboardBatch"],
        "createDashboard": transportOperationDescriptors["createDashboard"],
        "updateDashboard": transportOperationDescriptors["updateDashboard"],
        "deleteDashboard": transportOperationDescriptors["deleteDashboard"],
        "duplicateDashboardWidget": transportOperationDescriptors["duplicateDashboardWidget"],
      },
      actions: {
        "query": transportOperationDescriptors["queryDashboardBatch"],
        "create": transportOperationDescriptors["createDashboard"],
        "update": transportOperationDescriptors["updateDashboard"],
        "delete": transportOperationDescriptors["deleteDashboard"],
        "duplicate": transportOperationDescriptors["duplicateDashboardWidget"],
      },
    },
    "dashboards-drilldown-flexible": {
      name: "dashboards-drilldown-flexible",
      operations: {
        "flexibleDashboardDrilldown": transportOperationDescriptors["flexibleDashboardDrilldown"],
      },
      actions: {
        "query": transportOperationDescriptors["flexibleDashboardDrilldown"],
      },
    },
    "dashboards-drilldown-human-review": {
      name: "dashboards-drilldown-human-review",
      operations: {
        "humanReviewDashboardDrilldown": transportOperationDescriptors["humanReviewDashboardDrilldown"],
      },
      actions: {
        "query": transportOperationDescriptors["humanReviewDashboardDrilldown"],
      },
    },
    "dashboards-drilldown-metric-values": {
      name: "dashboards-drilldown-metric-values",
      operations: {
        "metricValuesBySimulation": transportOperationDescriptors["metricValuesBySimulation"],
      },
      actions: {
        "query": transportOperationDescriptors["metricValuesBySimulation"],
      },
    },
    "dashboards-widgets": {
      name: "dashboards-widgets",
      operations: {
        "replaceDashboardWidgets": transportOperationDescriptors["replaceDashboardWidgets"],
      },
      actions: {
        "set": transportOperationDescriptors["replaceDashboardWidgets"],
      },
    },
    "dashboards-widgets-clear": {
      name: "dashboards-widgets-clear",
      operations: {
        "clearDashboardWidgets": transportOperationDescriptors["clearDashboardWidgets"],
      },
      actions: {
        "delete": transportOperationDescriptors["clearDashboardWidgets"],
      },
    },
    "metric-catalog": {
      name: "metric-catalog",
      operations: {
        "listMetricCatalogEntries": transportOperationDescriptors["listMetricCatalogEntries"],
        "copyMetricCatalogEntry": transportOperationDescriptors["copyMetricCatalogEntry"],
      },
      actions: {
        "list": transportOperationDescriptors["listMetricCatalogEntries"],
        "create": transportOperationDescriptors["copyMetricCatalogEntry"],
      },
    },
    "admin-metric-catalog": {
      name: "admin-metric-catalog",
      operations: {
        "listAdminMetricCatalogEntries": transportOperationDescriptors["listAdminMetricCatalogEntries"],
        "getAdminMetricCatalogEntry": transportOperationDescriptors["getAdminMetricCatalogEntry"],
        "createAdminMetricCatalogEntry": transportOperationDescriptors["createAdminMetricCatalogEntry"],
        "updateAdminMetricCatalogEntry": transportOperationDescriptors["updateAdminMetricCatalogEntry"],
        "deleteAdminMetricCatalogEntry": transportOperationDescriptors["deleteAdminMetricCatalogEntry"],
      },
      actions: {
        "list": transportOperationDescriptors["listAdminMetricCatalogEntries"],
        "get": transportOperationDescriptors["getAdminMetricCatalogEntry"],
        "create": transportOperationDescriptors["createAdminMetricCatalogEntry"],
        "update": transportOperationDescriptors["updateAdminMetricCatalogEntry"],
        "delete": transportOperationDescriptors["deleteAdminMetricCatalogEntry"],
      },
    },
    "persona-catalog": {
      name: "persona-catalog",
      operations: {
        "listPersonaCatalogEntries": transportOperationDescriptors["listPersonaCatalogEntries"],
        "copyPersonaCatalogEntry": transportOperationDescriptors["copyPersonaCatalogEntry"],
      },
      actions: {
        "list": transportOperationDescriptors["listPersonaCatalogEntries"],
        "create": transportOperationDescriptors["copyPersonaCatalogEntry"],
      },
    },
    "admin-persona-catalog": {
      name: "admin-persona-catalog",
      operations: {
        "listAdminPersonaCatalogEntries": transportOperationDescriptors["listAdminPersonaCatalogEntries"],
        "getAdminPersonaCatalogEntry": transportOperationDescriptors["getAdminPersonaCatalogEntry"],
        "createAdminPersonaCatalogEntry": transportOperationDescriptors["createAdminPersonaCatalogEntry"],
        "updateAdminPersonaCatalogEntry": transportOperationDescriptors["updateAdminPersonaCatalogEntry"],
        "deleteAdminPersonaCatalogEntry": transportOperationDescriptors["deleteAdminPersonaCatalogEntry"],
      },
      actions: {
        "list": transportOperationDescriptors["listAdminPersonaCatalogEntries"],
        "get": transportOperationDescriptors["getAdminPersonaCatalogEntry"],
        "create": transportOperationDescriptors["createAdminPersonaCatalogEntry"],
        "update": transportOperationDescriptors["updateAdminPersonaCatalogEntry"],
        "delete": transportOperationDescriptors["deleteAdminPersonaCatalogEntry"],
      },
    },
    "metric-directory": {
      name: "metric-directory",
      operations: {
        "listMetricDirectory": transportOperationDescriptors["listMetricDirectory"],
      },
      actions: {
        "list": transportOperationDescriptors["listMetricDirectory"],
      },
    },
    "metric-audits": {
      name: "metric-audits",
      operations: {
        "createMetricAudit": transportOperationDescriptors["createMetricAudit"],
        "getMetricAudit": transportOperationDescriptors["getMetricAudit"],
        "cancelMetricAudit": transportOperationDescriptors["cancelMetricAudit"],
        "listMetricAuditGroups": transportOperationDescriptors["listMetricAuditGroups"],
      },
      actions: {
        "create": transportOperationDescriptors["createMetricAudit"],
        "get": transportOperationDescriptors["getMetricAudit"],
        "update": transportOperationDescriptors["cancelMetricAudit"],
        "list": transportOperationDescriptors["listMetricAuditGroups"],
      },
    },
    "metric-audits-get-metric-audit-pair": {
      name: "metric-audits-get-metric-audit-pair",
      operations: {
        "getMetricAuditPair": transportOperationDescriptors["getMetricAuditPair"],
      },
      actions: {
        "get": transportOperationDescriptors["getMetricAuditPair"],
      },
    },
    "metric-audits-get-metric-audit-prompt-proposal": {
      name: "metric-audits-get-metric-audit-prompt-proposal",
      operations: {
        "getMetricAuditPromptProposal": transportOperationDescriptors["getMetricAuditPromptProposal"],
      },
      actions: {
        "get": transportOperationDescriptors["getMetricAuditPromptProposal"],
      },
    },
    "simulation-data-frames-schema": {
      name: "simulation-data-frames-schema",
      operations: {
        "getSimulationDataFramesSchema": transportOperationDescriptors["getSimulationDataFramesSchema"],
      },
      actions: {
        "get": transportOperationDescriptors["getSimulationDataFramesSchema"],
      },
    },
    "sql-metric": {
      name: "sql-metric",
      operations: {
        "testSqlMetric": transportOperationDescriptors["testSqlMetric"],
      },
      actions: {
        "run": transportOperationDescriptors["testSqlMetric"],
      },
    },
    "metric-thresholds": {
      name: "metric-thresholds",
      operations: {
        "getMetricThreshold": transportOperationDescriptors["getMetricThreshold"],
        "updateMetricThreshold": transportOperationDescriptors["updateMetricThreshold"],
      },
      actions: {
        "get": transportOperationDescriptors["getMetricThreshold"],
        "update": transportOperationDescriptors["updateMetricThreshold"],
      },
    },
    "comments": {
      name: "comments",
      operations: {
        "listComments": transportOperationDescriptors["listComments"],
        "createComment": transportOperationDescriptors["createComment"],
        "updateComment": transportOperationDescriptors["updateComment"],
        "deleteComment": transportOperationDescriptors["deleteComment"],
      },
      actions: {
        "list": transportOperationDescriptors["listComments"],
        "create": transportOperationDescriptors["createComment"],
        "update": transportOperationDescriptors["updateComment"],
        "delete": transportOperationDescriptors["deleteComment"],
      },
    },
    "settings-integrations": {
      name: "settings-integrations",
      operations: {
        "getSettingsCredentialIntegrations": transportOperationDescriptors["getSettingsCredentialIntegrations"],
      },
      actions: {
        "get": transportOperationDescriptors["getSettingsCredentialIntegrations"],
      },
    },
    "settings-integrations-langfuse": {
      name: "settings-integrations-langfuse",
      operations: {
        "updateLangfuseIntegration": transportOperationDescriptors["updateLangfuseIntegration"],
      },
      actions: {
        "update": transportOperationDescriptors["updateLangfuseIntegration"],
      },
    },
    "settings-integrations-arize": {
      name: "settings-integrations-arize",
      operations: {
        "updateArizeIntegration": transportOperationDescriptors["updateArizeIntegration"],
      },
      actions: {
        "update": transportOperationDescriptors["updateArizeIntegration"],
      },
    },
    "settings-integrations-zendesk": {
      name: "settings-integrations-zendesk",
      operations: {
        "updateZendeskIntegration": transportOperationDescriptors["updateZendeskIntegration"],
      },
      actions: {
        "update": transportOperationDescriptors["updateZendeskIntegration"],
      },
    },
    "settings-integrations-shelf": {
      name: "settings-integrations-shelf",
      operations: {
        "updateShelfIntegration": transportOperationDescriptors["updateShelfIntegration"],
      },
      actions: {
        "update": transportOperationDescriptors["updateShelfIntegration"],
      },
    },
    "settings-integrations-telnyx": {
      name: "settings-integrations-telnyx",
      operations: {
        "getTelnyxIntegrationStatus": transportOperationDescriptors["getTelnyxIntegrationStatus"],
        "removeTelnyxApiKey": transportOperationDescriptors["removeTelnyxApiKey"],
      },
      actions: {
        "get": transportOperationDescriptors["getTelnyxIntegrationStatus"],
        "delete": transportOperationDescriptors["removeTelnyxApiKey"],
      },
    },
    "settings-integrations-telnyx-api-key": {
      name: "settings-integrations-telnyx-api-key",
      operations: {
        "updateTelnyxApiKey": transportOperationDescriptors["updateTelnyxApiKey"],
      },
      actions: {
        "update": transportOperationDescriptors["updateTelnyxApiKey"],
      },
    },
    "conversation_import_connection": {
      name: "conversation_import_connection",
      operations: {
        "discoverGenesysQueues": transportOperationDescriptors["discoverGenesysQueues"],
        "listConversationImportConnections": transportOperationDescriptors["listConversationImportConnections"],
        "createGenesysConnection": transportOperationDescriptors["createGenesysConnection"],
        "pauseConversationImportConnection": transportOperationDescriptors["pauseConversationImportConnection"],
        "disconnectConversationImportConnection": transportOperationDescriptors["disconnectConversationImportConnection"],
      },
      actions: {
        "connect": transportOperationDescriptors["discoverGenesysQueues"],
        "list": transportOperationDescriptors["listConversationImportConnections"],
        "create": transportOperationDescriptors["createGenesysConnection"],
        "update": transportOperationDescriptors["pauseConversationImportConnection"],
        "disconnect": transportOperationDescriptors["disconnectConversationImportConnection"],
      },
    },
    "conversation_import_connection-resume-conversation-import-connection": {
      name: "conversation_import_connection-resume-conversation-import-connection",
      operations: {
        "resumeConversationImportConnection": transportOperationDescriptors["resumeConversationImportConnection"],
      },
      actions: {
        "update": transportOperationDescriptors["resumeConversationImportConnection"],
      },
    },
    "metrics-admin": {
      name: "metrics-admin",
      operations: {
        "listAdminMetrics": transportOperationDescriptors["listAdminMetrics"],
        "createAdminMetric": transportOperationDescriptors["createAdminMetric"],
        "updateAdminMetric": transportOperationDescriptors["updateAdminMetric"],
      },
      actions: {
        "list": transportOperationDescriptors["listAdminMetrics"],
        "create": transportOperationDescriptors["createAdminMetric"],
        "update": transportOperationDescriptors["updateAdminMetric"],
      },
    },
    "metrics-admin-organizations": {
      name: "metrics-admin-organizations",
      operations: {
        "listMetricAdminOrganizations": transportOperationDescriptors["listMetricAdminOrganizations"],
      },
      actions: {
        "list": transportOperationDescriptors["listMetricAdminOrganizations"],
      },
    },
    "metrics-admin-active-status": {
      name: "metrics-admin-active-status",
      operations: {
        "updateMetricActiveStatus": transportOperationDescriptors["updateMetricActiveStatus"],
      },
      actions: {
        "update": transportOperationDescriptors["updateMetricActiveStatus"],
      },
    },
    "metrics": {
      name: "metrics",
      operations: {
        "listMetrics": transportOperationDescriptors["listMetrics"],
        "getMetric": transportOperationDescriptors["getMetric"],
        "runTestMetric": transportOperationDescriptors["runTestMetric"],
        "createMetric": transportOperationDescriptors["createMetric"],
        "duplicateMetric": transportOperationDescriptors["duplicateMetric"],
        "updateMetric": transportOperationDescriptors["updateMetric"],
        "archiveMetric": transportOperationDescriptors["archiveMetric"],
      },
      actions: {
        "list": transportOperationDescriptors["listMetrics"],
        "get": transportOperationDescriptors["getMetric"],
        "run": transportOperationDescriptors["runTestMetric"],
        "create": transportOperationDescriptors["createMetric"],
        "duplicate": transportOperationDescriptors["duplicateMetric"],
        "update": transportOperationDescriptors["updateMetric"],
        "archive": transportOperationDescriptors["archiveMetric"],
      },
    },
    "metrics-tags": {
      name: "metrics-tags",
      operations: {
        "listMetricTags": transportOperationDescriptors["listMetricTags"],
      },
      actions: {
        "list": transportOperationDescriptors["listMetricTags"],
      },
    },
    "metric-labels": {
      name: "metric-labels",
      operations: {
        "getMetricLabels": transportOperationDescriptors["getMetricLabels"],
      },
      actions: {
        "list": transportOperationDescriptors["getMetricLabels"],
      },
    },
    "metric-authors": {
      name: "metric-authors",
      operations: {
        "queryMetricAuthors": transportOperationDescriptors["queryMetricAuthors"],
      },
      actions: {
        "query": transportOperationDescriptors["queryMetricAuthors"],
      },
    },
    "metric-authors-query-admin-metric-authors": {
      name: "metric-authors-query-admin-metric-authors",
      operations: {
        "queryAdminMetricAuthors": transportOperationDescriptors["queryAdminMetricAuthors"],
      },
      actions: {
        "query": transportOperationDescriptors["queryAdminMetricAuthors"],
      },
    },
    "metric-versions": {
      name: "metric-versions",
      operations: {
        "getMetricVersions": transportOperationDescriptors["getMetricVersions"],
        "revertMetricVersion": transportOperationDescriptors["revertMetricVersion"],
      },
      actions: {
        "list": transportOperationDescriptors["getMetricVersions"],
        "update": transportOperationDescriptors["revertMetricVersion"],
      },
    },
    "metrics-metadata": {
      name: "metrics-metadata",
      operations: {
        "getMetricsMetadata": transportOperationDescriptors["getMetricsMetadata"],
      },
      actions: {
        "get": transportOperationDescriptors["getMetricsMetadata"],
      },
    },
    "metrics-metadata-keys": {
      name: "metrics-metadata-keys",
      operations: {
        "getMetricMetadataKeys": transportOperationDescriptors["getMetricMetadataKeys"],
      },
      actions: {
        "get": transportOperationDescriptors["getMetricMetadataKeys"],
      },
    },
    "metrics-metadata-values": {
      name: "metrics-metadata-values",
      operations: {
        "getMetricMetadataValues": transportOperationDescriptors["getMetricMetadataValues"],
      },
      actions: {
        "get": transportOperationDescriptors["getMetricMetadataValues"],
      },
    },
    "metric-flows": {
      name: "metric-flows",
      operations: {
        "listMetricFlows": transportOperationDescriptors["listMetricFlows"],
        "createMetricFlow": transportOperationDescriptors["createMetricFlow"],
        "updateMetricFlow": transportOperationDescriptors["updateMetricFlow"],
        "deleteMetricFlow": transportOperationDescriptors["deleteMetricFlow"],
      },
      actions: {
        "list": transportOperationDescriptors["listMetricFlows"],
        "create": transportOperationDescriptors["createMetricFlow"],
        "update": transportOperationDescriptors["updateMetricFlow"],
        "delete": transportOperationDescriptors["deleteMetricFlow"],
      },
    },
    "metrics-outputs-by-ulids": {
      name: "metrics-outputs-by-ulids",
      operations: {
        "getMetricOutputsByUlids": transportOperationDescriptors["getMetricOutputsByUlids"],
      },
      actions: {
        "get": transportOperationDescriptors["getMetricOutputsByUlids"],
      },
    },
    "metrics-outputs-evidence": {
      name: "metrics-outputs-evidence",
      operations: {
        "getAgentJudgeEvidence": transportOperationDescriptors["getAgentJudgeEvidence"],
      },
      actions: {
        "get": transportOperationDescriptors["getAgentJudgeEvidence"],
      },
    },
    "metrics-list-recently-deleted-metrics": {
      name: "metrics-list-recently-deleted-metrics",
      operations: {
        "listRecentlyDeletedMetrics": transportOperationDescriptors["listRecentlyDeletedMetrics"],
      },
      actions: {
        "list": transportOperationDescriptors["listRecentlyDeletedMetrics"],
      },
    },
    "metrics-restore-metric": {
      name: "metrics-restore-metric",
      operations: {
        "restoreMetric": transportOperationDescriptors["restoreMetric"],
      },
      actions: {
        "update": transportOperationDescriptors["restoreMetric"],
      },
    },
    "alerts": {
      name: "alerts",
      operations: {
        "listAlerts": transportOperationDescriptors["listAlerts"],
        "getAlert": transportOperationDescriptors["getAlert"],
        "createAlert": transportOperationDescriptors["createAlert"],
        "updateAlert": transportOperationDescriptors["updateAlert"],
        "deleteAlert": transportOperationDescriptors["deleteAlert"],
      },
      actions: {
        "list": transportOperationDescriptors["listAlerts"],
        "get": transportOperationDescriptors["getAlert"],
        "create": transportOperationDescriptors["createAlert"],
        "update": transportOperationDescriptors["updateAlert"],
        "delete": transportOperationDescriptors["deleteAlert"],
      },
    },
    "alerts-events": {
      name: "alerts-events",
      operations: {
        "listAlertEvents": transportOperationDescriptors["listAlertEvents"],
      },
      actions: {
        "list": transportOperationDescriptors["listAlertEvents"],
      },
    },
    "alerts-test-evaluate": {
      name: "alerts-test-evaluate",
      operations: {
        "testEvaluateAlert": transportOperationDescriptors["testEvaluateAlert"],
      },
      actions: {
        "run": transportOperationDescriptors["testEvaluateAlert"],
      },
    },
    "scheduled-runs": {
      name: "scheduled-runs",
      operations: {
        "listScheduledRuns": transportOperationDescriptors["listScheduledRuns"],
        "getScheduledRun": transportOperationDescriptors["getScheduledRun"],
        "createScheduledRun": transportOperationDescriptors["createScheduledRun"],
        "updateScheduledRun": transportOperationDescriptors["updateScheduledRun"],
        "deleteScheduledRun": transportOperationDescriptors["deleteScheduledRun"],
      },
      actions: {
        "list": transportOperationDescriptors["listScheduledRuns"],
        "get": transportOperationDescriptors["getScheduledRun"],
        "create": transportOperationDescriptors["createScheduledRun"],
        "update": transportOperationDescriptors["updateScheduledRun"],
        "delete": transportOperationDescriptors["deleteScheduledRun"],
      },
    },
    "scheduled-runs-runs": {
      name: "scheduled-runs-runs",
      operations: {
        "listScheduledRunHistory": transportOperationDescriptors["listScheduledRunHistory"],
      },
      actions: {
        "list": transportOperationDescriptors["listScheduledRunHistory"],
      },
    },
    "test-sets-metadata": {
      name: "test-sets-metadata",
      operations: {
        "testSetMetadata": transportOperationDescriptors["testSetMetadata"],
      },
      actions: {
        "run": transportOperationDescriptors["testSetMetadata"],
      },
    },
    "test-sets-records": {
      name: "test-sets-records",
      operations: {
        "testSetRecords": transportOperationDescriptors["testSetRecords"],
      },
      actions: {
        "run": transportOperationDescriptors["testSetRecords"],
      },
    },
    "test-sets-list": {
      name: "test-sets-list",
      operations: {
        "listTestSets": transportOperationDescriptors["listTestSets"],
      },
      actions: {
        "list": transportOperationDescriptors["listTestSets"],
      },
    },
    "test-sets-versions": {
      name: "test-sets-versions",
      operations: {
        "getTestSetVersions": transportOperationDescriptors["getTestSetVersions"],
      },
      actions: {
        "get": transportOperationDescriptors["getTestSetVersions"],
      },
    },
    "test-set-versions": {
      name: "test-set-versions",
      operations: {
        "revertTestSetVersion": transportOperationDescriptors["revertTestSetVersion"],
      },
      actions: {
        "update": transportOperationDescriptors["revertTestSetVersion"],
      },
    },
    "test-sets-tags": {
      name: "test-sets-tags",
      operations: {
        "listTestSetTags": transportOperationDescriptors["listTestSetTags"],
      },
      actions: {
        "list": transportOperationDescriptors["listTestSetTags"],
      },
    },
    "test-sets-metadata-keys": {
      name: "test-sets-metadata-keys",
      operations: {
        "testSetMetadataKeys": transportOperationDescriptors["testSetMetadataKeys"],
      },
      actions: {
        "run": transportOperationDescriptors["testSetMetadataKeys"],
      },
    },
    "test-sets-test-cases": {
      name: "test-sets-test-cases",
      operations: {
        "listTestCases": transportOperationDescriptors["listTestCases"],
      },
      actions: {
        "list": transportOperationDescriptors["listTestCases"],
      },
    },
    "test-sets": {
      name: "test-sets",
      operations: {
        "createTestSet": transportOperationDescriptors["createTestSet"],
        "deleteTestSet": transportOperationDescriptors["deleteTestSet"],
        "updateTestSet": transportOperationDescriptors["updateTestSet"],
        "duplicateTestSet": transportOperationDescriptors["duplicateTestSet"],
        "listRecentlyDeletedTestSets": transportOperationDescriptors["listRecentlyDeletedTestSets"],
      },
      actions: {
        "create": transportOperationDescriptors["createTestSet"],
        "delete": transportOperationDescriptors["deleteTestSet"],
        "update": transportOperationDescriptors["updateTestSet"],
        "duplicate": transportOperationDescriptors["duplicateTestSet"],
        "list": transportOperationDescriptors["listRecentlyDeletedTestSets"],
      },
    },
    "test-sets-rows": {
      name: "test-sets-rows",
      operations: {
        "updateTestCaseRow": transportOperationDescriptors["updateTestCaseRow"],
        "addTestSetRows": transportOperationDescriptors["addTestSetRows"],
        "deleteTestSetRow": transportOperationDescriptors["deleteTestSetRow"],
      },
      actions: {
        "update": transportOperationDescriptors["updateTestCaseRow"],
        "set": transportOperationDescriptors["addTestSetRows"],
        "delete": transportOperationDescriptors["deleteTestSetRow"],
      },
    },
    "test-sets-batch": {
      name: "test-sets-batch",
      operations: {
        "deleteTestSets": transportOperationDescriptors["deleteTestSets"],
      },
      actions: {
        "delete": transportOperationDescriptors["deleteTestSets"],
      },
    },
    "test-sets-editor": {
      name: "test-sets-editor",
      operations: {
        "saveTestSetEditorState": transportOperationDescriptors["saveTestSetEditorState"],
      },
      actions: {
        "set": transportOperationDescriptors["saveTestSetEditorState"],
      },
    },
    "test-sets-media-upload-url": {
      name: "test-sets-media-upload-url",
      operations: {
        "getTestCaseMediaUploadUrl": transportOperationDescriptors["getTestCaseMediaUploadUrl"],
      },
      actions: {
        "get": transportOperationDescriptors["getTestCaseMediaUploadUrl"],
      },
    },
    "test-sets-media-preview-url": {
      name: "test-sets-media-preview-url",
      operations: {
        "getTestCaseMediaPreviewUrl": transportOperationDescriptors["getTestCaseMediaPreviewUrl"],
      },
      actions: {
        "get": transportOperationDescriptors["getTestCaseMediaPreviewUrl"],
      },
    },
    "test-sets-agent-associations": {
      name: "test-sets-agent-associations",
      operations: {
        "getTestSetAgentAssociations": transportOperationDescriptors["getTestSetAgentAssociations"],
        "addTestSetAgentAssociations": transportOperationDescriptors["addTestSetAgentAssociations"],
        "removeTestSetAgentAssociation": transportOperationDescriptors["removeTestSetAgentAssociation"],
      },
      actions: {
        "get": transportOperationDescriptors["getTestSetAgentAssociations"],
        "set": transportOperationDescriptors["addTestSetAgentAssociations"],
        "delete": transportOperationDescriptors["removeTestSetAgentAssociation"],
      },
    },
    "test-sets-auto-add-rule": {
      name: "test-sets-auto-add-rule",
      operations: {
        "getTestSetAutoAddRule": transportOperationDescriptors["getTestSetAutoAddRule"],
        "saveTestSetAutoAddRule": transportOperationDescriptors["saveTestSetAutoAddRule"],
        "deleteTestSetAutoAddRule": transportOperationDescriptors["deleteTestSetAutoAddRule"],
      },
      actions: {
        "get": transportOperationDescriptors["getTestSetAutoAddRule"],
        "set": transportOperationDescriptors["saveTestSetAutoAddRule"],
        "delete": transportOperationDescriptors["deleteTestSetAutoAddRule"],
      },
    },
    "test-sets-auto-add-pending": {
      name: "test-sets-auto-add-pending",
      operations: {
        "listTestSetAutoAddPending": transportOperationDescriptors["listTestSetAutoAddPending"],
      },
      actions: {
        "list": transportOperationDescriptors["listTestSetAutoAddPending"],
      },
    },
    "test-sets-auto-add-pending-accept": {
      name: "test-sets-auto-add-pending-accept",
      operations: {
        "acceptTestSetAutoAddSuggestion": transportOperationDescriptors["acceptTestSetAutoAddSuggestion"],
      },
      actions: {
        "run": transportOperationDescriptors["acceptTestSetAutoAddSuggestion"],
      },
    },
    "test-sets-auto-add-pending-reject": {
      name: "test-sets-auto-add-pending-reject",
      operations: {
        "rejectTestSetAutoAddSuggestion": transportOperationDescriptors["rejectTestSetAutoAddSuggestion"],
      },
      actions: {
        "run": transportOperationDescriptors["rejectTestSetAutoAddSuggestion"],
      },
    },
    "test-sets-auto-add-summary": {
      name: "test-sets-auto-add-summary",
      operations: {
        "getTestSetAutoAddSummary": transportOperationDescriptors["getTestSetAutoAddSummary"],
      },
      actions: {
        "get": transportOperationDescriptors["getTestSetAutoAddSummary"],
      },
    },
    "test-sets-auto-add-pending-counts": {
      name: "test-sets-auto-add-pending-counts",
      operations: {
        "listTestSetAutoAddPendingCounts": transportOperationDescriptors["listTestSetAutoAddPendingCounts"],
      },
      actions: {
        "list": transportOperationDescriptors["listTestSetAutoAddPendingCounts"],
      },
    },
    "test-sets-restore-test-set": {
      name: "test-sets-restore-test-set",
      operations: {
        "restoreTestSet": transportOperationDescriptors["restoreTestSet"],
      },
      actions: {
        "update": transportOperationDescriptors["restoreTestSet"],
      },
    },
    "personas": {
      name: "personas",
      operations: {
        "listPersonas": transportOperationDescriptors["listPersonas"],
        "getPersona": transportOperationDescriptors["getPersona"],
        "createPersona": transportOperationDescriptors["createPersona"],
        "updatePersona": transportOperationDescriptors["updatePersona"],
        "deletePersona": transportOperationDescriptors["deletePersona"],
        "duplicatePersona": transportOperationDescriptors["duplicatePersona"],
        "previewPersonaVoiceCandidate": transportOperationDescriptors["previewPersonaVoiceCandidate"],
      },
      actions: {
        "list": transportOperationDescriptors["listPersonas"],
        "get": transportOperationDescriptors["getPersona"],
        "create": transportOperationDescriptors["createPersona"],
        "update": transportOperationDescriptors["updatePersona"],
        "delete": transportOperationDescriptors["deletePersona"],
        "duplicate": transportOperationDescriptors["duplicatePersona"],
        "query": transportOperationDescriptors["previewPersonaVoiceCandidate"],
      },
    },
    "personas-tags": {
      name: "personas-tags",
      operations: {
        "listPersonaTags": transportOperationDescriptors["listPersonaTags"],
      },
      actions: {
        "list": transportOperationDescriptors["listPersonaTags"],
      },
    },
    "personas-list-recently-deleted-personas": {
      name: "personas-list-recently-deleted-personas",
      operations: {
        "listRecentlyDeletedPersonas": transportOperationDescriptors["listRecentlyDeletedPersonas"],
      },
      actions: {
        "list": transportOperationDescriptors["listRecentlyDeletedPersonas"],
      },
    },
    "background-sounds": {
      name: "background-sounds",
      operations: {
        "listBackgroundSounds": transportOperationDescriptors["listBackgroundSounds"],
        "createBackgroundSound": transportOperationDescriptors["createBackgroundSound"],
        "completeBackgroundSound": transportOperationDescriptors["completeBackgroundSound"],
      },
      actions: {
        "list": transportOperationDescriptors["listBackgroundSounds"],
        "create": transportOperationDescriptors["createBackgroundSound"],
        "update": transportOperationDescriptors["completeBackgroundSound"],
      },
    },
    "run-templates": {
      name: "run-templates",
      operations: {
        "listRunTemplates": transportOperationDescriptors["listRunTemplates"],
        "getRunTemplate": transportOperationDescriptors["getRunTemplate"],
        "createRunTemplate": transportOperationDescriptors["createRunTemplate"],
        "updateRunTemplate": transportOperationDescriptors["updateRunTemplate"],
        "deleteRunTemplate": transportOperationDescriptors["deleteRunTemplate"],
        "duplicateRunTemplate": transportOperationDescriptors["duplicateRunTemplate"],
      },
      actions: {
        "list": transportOperationDescriptors["listRunTemplates"],
        "get": transportOperationDescriptors["getRunTemplate"],
        "create": transportOperationDescriptors["createRunTemplate"],
        "update": transportOperationDescriptors["updateRunTemplate"],
        "delete": transportOperationDescriptors["deleteRunTemplate"],
        "duplicate": transportOperationDescriptors["duplicateRunTemplate"],
      },
    },
    "reports": {
      name: "reports",
      operations: {
        "listReports": transportOperationDescriptors["listReports"],
        "getReport": transportOperationDescriptors["getReport"],
        "saveReport": transportOperationDescriptors["saveReport"],
        "updateReport": transportOperationDescriptors["updateReport"],
        "setReportVisibility": transportOperationDescriptors["setReportVisibility"],
        "deleteReport": transportOperationDescriptors["deleteReport"],
      },
      actions: {
        "list": transportOperationDescriptors["listReports"],
        "get": transportOperationDescriptors["getReport"],
        "create": transportOperationDescriptors["saveReport"],
        "update": transportOperationDescriptors["updateReport"],
        "set": transportOperationDescriptors["setReportVisibility"],
        "delete": transportOperationDescriptors["deleteReport"],
      },
    },
    "reports-public": {
      name: "reports-public",
      operations: {
        "getPublicReport": transportOperationDescriptors["getPublicReport"],
      },
      actions: {
        "get": transportOperationDescriptors["getPublicReport"],
      },
    },
    "reports-rows": {
      name: "reports-rows",
      operations: {
        "getReportRows": transportOperationDescriptors["getReportRows"],
      },
      actions: {
        "get": transportOperationDescriptors["getReportRows"],
      },
    },
    "reports-public-rows": {
      name: "reports-public-rows",
      operations: {
        "getPublicReportRows": transportOperationDescriptors["getPublicReportRows"],
      },
      actions: {
        "get": transportOperationDescriptors["getPublicReportRows"],
      },
    },
    "reports-outliers": {
      name: "reports-outliers",
      operations: {
        "getCohortOutliers": transportOperationDescriptors["getCohortOutliers"],
      },
      actions: {
        "get": transportOperationDescriptors["getCohortOutliers"],
      },
    },
    "reviews-overview-v2": {
      name: "reviews-overview-v2",
      operations: {
        "getReviewOverview": transportOperationDescriptors["getReviewOverview"],
        "getReviewOverview.v2": transportOperationDescriptors["getReviewOverview.v2"],
      },
      actions: {
        "get": transportOperationDescriptors["getReviewOverview"],
      },
    },
    "reviews-overview": {
      name: "reviews-overview",
      operations: {
        "getReviewOverview.v1": transportOperationDescriptors["getReviewOverview.v1"],
      },
      actions: {
      },
    },
    "review-project-annotations-table": {
      name: "review-project-annotations-table",
      operations: {
        "queryHumanReviewProjectAnnotationsTable": transportOperationDescriptors["queryHumanReviewProjectAnnotationsTable"],
      },
      actions: {
        "list": transportOperationDescriptors["queryHumanReviewProjectAnnotationsTable"],
      },
    },
    "review-project-triage-membership": {
      name: "review-project-triage-membership",
      operations: {
        "queryHumanReviewProjectTriageMembership": transportOperationDescriptors["queryHumanReviewProjectTriageMembership"],
      },
      actions: {
        "query": transportOperationDescriptors["queryHumanReviewProjectTriageMembership"],
      },
    },
    "review-metric-skips": {
      name: "review-metric-skips",
      operations: {
        "listReviewMetricSkips": transportOperationDescriptors["listReviewMetricSkips"],
        "skipReviewMetric": transportOperationDescriptors["skipReviewMetric"],
        "unskipReviewMetric": transportOperationDescriptors["unskipReviewMetric"],
      },
      actions: {
        "list": transportOperationDescriptors["listReviewMetricSkips"],
        "create": transportOperationDescriptors["skipReviewMetric"],
        "update": transportOperationDescriptors["unskipReviewMetric"],
      },
    },
    "review-project-annotation-details": {
      name: "review-project-annotation-details",
      operations: {
        "getHumanReviewProjectAnnotationDetails": transportOperationDescriptors["getHumanReviewProjectAnnotationDetails"],
      },
      actions: {
        "get": transportOperationDescriptors["getHumanReviewProjectAnnotationDetails"],
      },
    },
    "review-project-simulation-completions": {
      name: "review-project-simulation-completions",
      operations: {
        "getReviewProjectSimulationCompletions": transportOperationDescriptors["getReviewProjectSimulationCompletions"],
      },
      actions: {
        "get": transportOperationDescriptors["getReviewProjectSimulationCompletions"],
      },
    },
    "review-project-conversation-states": {
      name: "review-project-conversation-states",
      operations: {
        "batchGetReviewProjectConversationStates": transportOperationDescriptors["batchGetReviewProjectConversationStates"],
      },
      actions: {
        "run": transportOperationDescriptors["batchGetReviewProjectConversationStates"],
      },
    },
    "review-metric-health": {
      name: "review-metric-health",
      operations: {
        "getMetricHealthStats": transportOperationDescriptors["getMetricHealthStats"],
      },
      actions: {
        "get": transportOperationDescriptors["getMetricHealthStats"],
      },
    },
    "review-metric-agreement-history": {
      name: "review-metric-agreement-history",
      operations: {
        "getMetricAgreementHistory": transportOperationDescriptors["getMetricAgreementHistory"],
      },
      actions: {
        "get": transportOperationDescriptors["getMetricAgreementHistory"],
      },
    },
    "review-project-insights": {
      name: "review-project-insights",
      operations: {
        "getHumanReviewProjectInsights": transportOperationDescriptors["getHumanReviewProjectInsights"],
      },
      actions: {
        "get": transportOperationDescriptors["getHumanReviewProjectInsights"],
      },
    },
    "review-project-insight-slice": {
      name: "review-project-insight-slice",
      operations: {
        "getHumanReviewProjectInsightSlice": transportOperationDescriptors["getHumanReviewProjectInsightSlice"],
      },
      actions: {
        "get": transportOperationDescriptors["getHumanReviewProjectInsightSlice"],
      },
    },
    "review-project-date-density": {
      name: "review-project-date-density",
      operations: {
        "getHumanReviewProjectDateDensity": transportOperationDescriptors["getHumanReviewProjectDateDensity"],
      },
      actions: {
        "get": transportOperationDescriptors["getHumanReviewProjectDateDensity"],
      },
    },
    "review-project-layout": {
      name: "review-project-layout",
      operations: {
        "getHumanReviewProjectLayout": transportOperationDescriptors["getHumanReviewProjectLayout"],
        "saveHumanReviewProjectLayout": transportOperationDescriptors["saveHumanReviewProjectLayout"],
      },
      actions: {
        "get": transportOperationDescriptors["getHumanReviewProjectLayout"],
        "update": transportOperationDescriptors["saveHumanReviewProjectLayout"],
      },
    },
    "review-disagreement-state": {
      name: "review-disagreement-state",
      operations: {
        "getReviewDisagreementState": transportOperationDescriptors["getReviewDisagreementState"],
      },
      actions: {
        "get": transportOperationDescriptors["getReviewDisagreementState"],
      },
    },
    "review-annotations": {
      name: "review-annotations",
      operations: {
        "getAnnotationsWithMetricOutputs": transportOperationDescriptors["getAnnotationsWithMetricOutputs"],
        "listReviewAnnotations": transportOperationDescriptors["listReviewAnnotations"],
        "createReviewAnnotation": transportOperationDescriptors["createReviewAnnotation"],
        "updateReviewAnnotation": transportOperationDescriptors["updateReviewAnnotation"],
        "deleteReviewAnnotation": transportOperationDescriptors["deleteReviewAnnotation"],
      },
      actions: {
        "get": transportOperationDescriptors["getAnnotationsWithMetricOutputs"],
        "list": transportOperationDescriptors["listReviewAnnotations"],
        "create": transportOperationDescriptors["createReviewAnnotation"],
        "update": transportOperationDescriptors["updateReviewAnnotation"],
        "delete": transportOperationDescriptors["deleteReviewAnnotation"],
      },
    },
    "reviews-annotations-by-simulation-output": {
      name: "reviews-annotations-by-simulation-output",
      operations: {
        "getFeedbackForSimulationOutput": transportOperationDescriptors["getFeedbackForSimulationOutput"],
      },
      actions: {
        "get": transportOperationDescriptors["getFeedbackForSimulationOutput"],
      },
    },
    "reviews-annotations-by-org": {
      name: "reviews-annotations-by-org",
      operations: {
        "getAllAnnotationsByOrg": transportOperationDescriptors["getAllAnnotationsByOrg"],
      },
      actions: {
        "get": transportOperationDescriptors["getAllAnnotationsByOrg"],
      },
    },
    "review-alerts": {
      name: "review-alerts",
      operations: {
        "listHumanReviewAlerts": transportOperationDescriptors["listHumanReviewAlerts"],
        "deleteHumanReviewAlert": transportOperationDescriptors["deleteHumanReviewAlert"],
      },
      actions: {
        "list": transportOperationDescriptors["listHumanReviewAlerts"],
        "delete": transportOperationDescriptors["deleteHumanReviewAlert"],
      },
    },
    "review-labels": {
      name: "review-labels",
      operations: {
        "getReviewLabelsForSimulation": transportOperationDescriptors["getReviewLabelsForSimulation"],
        "saveReviewLabelsForSimulation": transportOperationDescriptors["saveReviewLabelsForSimulation"],
      },
      actions: {
        "get": transportOperationDescriptors["getReviewLabelsForSimulation"],
        "set": transportOperationDescriptors["saveReviewLabelsForSimulation"],
      },
    },
    "review-projects": {
      name: "review-projects",
      operations: {
        "listReviewProjects": transportOperationDescriptors["listReviewProjects"],
        "getReviewProject": transportOperationDescriptors["getReviewProject"],
        "createReviewProject": transportOperationDescriptors["createReviewProject"],
        "duplicateReviewProject": transportOperationDescriptors["duplicateReviewProject"],
        "sendProjectAssignmentEmail": transportOperationDescriptors["sendProjectAssignmentEmail"],
        "assignReviewBatches": transportOperationDescriptors["assignReviewBatches"],
        "updateReviewProject": transportOperationDescriptors["updateReviewProject"],
        "deleteReviewProject": transportOperationDescriptors["deleteReviewProject"],
      },
      actions: {
        "list": transportOperationDescriptors["listReviewProjects"],
        "get": transportOperationDescriptors["getReviewProject"],
        "create": transportOperationDescriptors["createReviewProject"],
        "duplicate": transportOperationDescriptors["duplicateReviewProject"],
        "run": transportOperationDescriptors["sendProjectAssignmentEmail"],
        "set": transportOperationDescriptors["assignReviewBatches"],
        "update": transportOperationDescriptors["updateReviewProject"],
        "delete": transportOperationDescriptors["deleteReviewProject"],
      },
    },
    "review-metric-agreements": {
      name: "review-metric-agreements",
      operations: {
        "getProjectMetricAgreement": transportOperationDescriptors["getProjectMetricAgreement"],
      },
      actions: {
        "get": transportOperationDescriptors["getProjectMetricAgreement"],
      },
    },
    "review-project-rerun-context": {
      name: "review-project-rerun-context",
      operations: {
        "getReviewProjectRerunContext": transportOperationDescriptors["getReviewProjectRerunContext"],
      },
      actions: {
        "get": transportOperationDescriptors["getReviewProjectRerunContext"],
      },
    },
    "review-project-membership-logs": {
      name: "review-project-membership-logs",
      operations: {
        "listReviewProjectMembershipLogs": transportOperationDescriptors["listReviewProjectMembershipLogs"],
      },
      actions: {
        "list": transportOperationDescriptors["listReviewProjectMembershipLogs"],
      },
    },
    "review-project-members": {
      name: "review-project-members",
      operations: {
        "listReviewProjectMembers": transportOperationDescriptors["listReviewProjectMembers"],
        "setReviewProjectMemberRole": transportOperationDescriptors["setReviewProjectMemberRole"],
      },
      actions: {
        "list": transportOperationDescriptors["listReviewProjectMembers"],
        "update": transportOperationDescriptors["setReviewProjectMemberRole"],
      },
    },
    "reviews-projects-complete-conversation": {
      name: "reviews-projects-complete-conversation",
      operations: {
        "completeReviewConversation": transportOperationDescriptors["completeReviewConversation"],
      },
      actions: {
        "run": transportOperationDescriptors["completeReviewConversation"],
      },
    },
    "reviews-projects-claim": {
      name: "reviews-projects-claim",
      operations: {
        "claimConversation": transportOperationDescriptors["claimConversation"],
      },
      actions: {
        "run": transportOperationDescriptors["claimConversation"],
      },
    },
    "reviews-projects-release": {
      name: "reviews-projects-release",
      operations: {
        "releaseConversation": transportOperationDescriptors["releaseConversation"],
      },
      actions: {
        "run": transportOperationDescriptors["releaseConversation"],
      },
    },
    "reviews-projects-force-release": {
      name: "reviews-projects-force-release",
      operations: {
        "forceReleaseConversation": transportOperationDescriptors["forceReleaseConversation"],
      },
      actions: {
        "run": transportOperationDescriptors["forceReleaseConversation"],
      },
    },
    "reviews-projects-batches:start": {
      name: "reviews-projects-batches:start",
      operations: {
        "startReviewBatch": transportOperationDescriptors["startReviewBatch"],
      },
      actions: {
        "run": transportOperationDescriptors["startReviewBatch"],
      },
    },
    "reviews-projects-batches:current": {
      name: "reviews-projects-batches:current",
      operations: {
        "getCurrentReviewBatch": transportOperationDescriptors["getCurrentReviewBatch"],
      },
      actions: {
        "get": transportOperationDescriptors["getCurrentReviewBatch"],
      },
    },
    "reviews-projects-batches:stop": {
      name: "reviews-projects-batches:stop",
      operations: {
        "stopReviewBatch": transportOperationDescriptors["stopReviewBatch"],
      },
      actions: {
        "run": transportOperationDescriptors["stopReviewBatch"],
      },
    },
    "reviews-projects-batches:release": {
      name: "reviews-projects-batches:release",
      operations: {
        "releaseReviewBatch": transportOperationDescriptors["releaseReviewBatch"],
      },
      actions: {
        "run": transportOperationDescriptors["releaseReviewBatch"],
      },
    },
    "reviews-projects-batches": {
      name: "reviews-projects-batches",
      operations: {
        "listReviewBatches": transportOperationDescriptors["listReviewBatches"],
      },
      actions: {
        "list": transportOperationDescriptors["listReviewBatches"],
      },
    },
    "review-annotations-get-review-annotation": {
      name: "review-annotations-get-review-annotation",
      operations: {
        "getReviewAnnotation": transportOperationDescriptors["getReviewAnnotation"],
      },
      actions: {
        "get": transportOperationDescriptors["getReviewAnnotation"],
      },
    },
    "review-annotations-update-project-review-annotation": {
      name: "review-annotations-update-project-review-annotation",
      operations: {
        "updateProjectReviewAnnotation": transportOperationDescriptors["updateProjectReviewAnnotation"],
      },
      actions: {
        "update": transportOperationDescriptors["updateProjectReviewAnnotation"],
      },
    },
    "review-annotations-delete-project-review-annotation": {
      name: "review-annotations-delete-project-review-annotation",
      operations: {
        "deleteProjectReviewAnnotation": transportOperationDescriptors["deleteProjectReviewAnnotation"],
      },
      actions: {
        "delete": transportOperationDescriptors["deleteProjectReviewAnnotation"],
      },
    },
    "runs": {
      name: "runs",
      operations: {
        "launchRun": transportOperationDescriptors["launchRun"],
        "listRunsKeyset": transportOperationDescriptors["listRunsKeyset"],
        "getRunOutliers": transportOperationDescriptors["getRunOutliers"],
        "deleteRun": transportOperationDescriptors["deleteRun"],
        "cancelRun": transportOperationDescriptors["cancelRun"],
      },
      actions: {
        "run": transportOperationDescriptors["launchRun"],
        "list": transportOperationDescriptors["listRunsKeyset"],
        "get": transportOperationDescriptors["getRunOutliers"],
        "delete": transportOperationDescriptors["deleteRun"],
        "update": transportOperationDescriptors["cancelRun"],
      },
    },
    "runs-rerun-metrics": {
      name: "runs-rerun-metrics",
      operations: {
        "rerunMetrics": transportOperationDescriptors["rerunMetrics"],
      },
      actions: {
        "run": transportOperationDescriptors["rerunMetrics"],
      },
    },
    "simulated-conversations": {
      name: "simulated-conversations",
      operations: {
        "listSimulatedConversationsKeyset": transportOperationDescriptors["listSimulatedConversationsKeyset"],
      },
      actions: {
        "list": transportOperationDescriptors["listSimulatedConversationsKeyset"],
      },
    },
    "runs-insights": {
      name: "runs-insights",
      operations: {
        "getRunsPageInsights": transportOperationDescriptors["getRunsPageInsights"],
      },
      actions: {
        "get": transportOperationDescriptors["getRunsPageInsights"],
      },
    },
    "runs-metadata": {
      name: "runs-metadata",
      operations: {
        "getRunMetadata": transportOperationDescriptors["getRunMetadata"],
      },
      actions: {
        "get": transportOperationDescriptors["getRunMetadata"],
      },
    },
    "runs-metadata-batch": {
      name: "runs-metadata-batch",
      operations: {
        "getMultiRunMetadata": transportOperationDescriptors["getMultiRunMetadata"],
      },
      actions: {
        "get": transportOperationDescriptors["getMultiRunMetadata"],
      },
    },
    "runs-rows": {
      name: "runs-rows",
      operations: {
        "getRunRows": transportOperationDescriptors["getRunRows"],
      },
      actions: {
        "get": transportOperationDescriptors["getRunRows"],
      },
    },
    "runs-rows-batch": {
      name: "runs-rows-batch",
      operations: {
        "getMultiRunRows": transportOperationDescriptors["getMultiRunRows"],
      },
      actions: {
        "get": transportOperationDescriptors["getMultiRunRows"],
      },
    },
    "runs-latest": {
      name: "runs-latest",
      operations: {
        "getLatestRun": transportOperationDescriptors["getLatestRun"],
      },
      actions: {
        "get": transportOperationDescriptors["getLatestRun"],
      },
    },
    "runs-session-mapping-import": {
      name: "runs-session-mapping-import",
      operations: {
        "importSessionMappingFromCsv": transportOperationDescriptors["importSessionMappingFromCsv"],
      },
      actions: {
        "run": transportOperationDescriptors["importSessionMappingFromCsv"],
      },
    },
    "runs-notes": {
      name: "runs-notes",
      operations: {
        "updateRunNotes": transportOperationDescriptors["updateRunNotes"],
      },
      actions: {
        "update": transportOperationDescriptors["updateRunNotes"],
      },
    },
    "runs-public": {
      name: "runs-public",
      operations: {
        "setRunPublic": transportOperationDescriptors["setRunPublic"],
      },
      actions: {
        "set": transportOperationDescriptors["setRunPublic"],
      },
    },
    "runs-display-name": {
      name: "runs-display-name",
      operations: {
        "updateRunDisplayName": transportOperationDescriptors["updateRunDisplayName"],
      },
      actions: {
        "update": transportOperationDescriptors["updateRunDisplayName"],
      },
    },
    "conversation-clustering-runs-failure-patterns-output-latest": {
      name: "conversation-clustering-runs-failure-patterns-output-latest",
      operations: {
        "getLatestFailurePatternRunOutput": transportOperationDescriptors["getLatestFailurePatternRunOutput"],
      },
      actions: {
        "get": transportOperationDescriptors["getLatestFailurePatternRunOutput"],
      },
    },
    "conversation-clustering-runs-output-latest": {
      name: "conversation-clustering-runs-output-latest",
      operations: {
        "getLatestConversationClusteringRunOutput": transportOperationDescriptors["getLatestConversationClusteringRunOutput"],
      },
      actions: {
        "get": transportOperationDescriptors["getLatestConversationClusteringRunOutput"],
      },
    },
    "runs-tags": {
      name: "runs-tags",
      operations: {
        "listRunTags": transportOperationDescriptors["listRunTags"],
      },
      actions: {
        "list": transportOperationDescriptors["listRunTags"],
      },
    },
    "runs-update-run-tags": {
      name: "runs-update-run-tags",
      operations: {
        "updateRunTags": transportOperationDescriptors["updateRunTags"],
      },
      actions: {
        "update": transportOperationDescriptors["updateRunTags"],
      },
    },
    "simulation-outputs": {
      name: "simulation-outputs",
      operations: {
        "getSimulationOutput": transportOperationDescriptors["getSimulationOutput"],
        "deleteSimulationOutput": transportOperationDescriptors["deleteSimulationOutput"],
      },
      actions: {
        "get": transportOperationDescriptors["getSimulationOutput"],
        "delete": transportOperationDescriptors["deleteSimulationOutput"],
      },
    },
    "simulation-outputs-ids": {
      name: "simulation-outputs-ids",
      operations: {
        "listSimulationOutputIds": transportOperationDescriptors["listSimulationOutputIds"],
      },
      actions: {
        "list": transportOperationDescriptors["listSimulationOutputIds"],
      },
    },
    "simulation-outputs-time-window": {
      name: "simulation-outputs-time-window",
      operations: {
        "getSimulationOutputTimeWindow": transportOperationDescriptors["getSimulationOutputTimeWindow"],
      },
      actions: {
        "get": transportOperationDescriptors["getSimulationOutputTimeWindow"],
      },
    },
    "simulation-outputs-speaking-segments": {
      name: "simulation-outputs-speaking-segments",
      operations: {
        "getSimulationOutputSpeakingSegments": transportOperationDescriptors["getSimulationOutputSpeakingSegments"],
      },
      actions: {
        "get": transportOperationDescriptors["getSimulationOutputSpeakingSegments"],
      },
    },
    "simulation-outputs-public": {
      name: "simulation-outputs-public",
      operations: {
        "setSimulationOutputPublic": transportOperationDescriptors["setSimulationOutputPublic"],
      },
      actions: {
        "set": transportOperationDescriptors["setSimulationOutputPublic"],
      },
    },
    "simulation-outputs-resimulate": {
      name: "simulation-outputs-resimulate",
      operations: {
        "resimulateSimulationOutputs": transportOperationDescriptors["resimulateSimulationOutputs"],
      },
      actions: {
        "run": transportOperationDescriptors["resimulateSimulationOutputs"],
      },
    },
    "shared-runs-run-record": {
      name: "shared-runs-run-record",
      operations: {
        "getSharedRunRecord": transportOperationDescriptors["getSharedRunRecord"],
      },
      actions: {
        "get": transportOperationDescriptors["getSharedRunRecord"],
      },
    },
    "shared-runs-verify-password": {
      name: "shared-runs-verify-password",
      operations: {
        "verifySharedRunPassword": transportOperationDescriptors["verifySharedRunPassword"],
      },
      actions: {
        "get": transportOperationDescriptors["verifySharedRunPassword"],
      },
    },
    "shared-runs-run-rows": {
      name: "shared-runs-run-rows",
      operations: {
        "getSharedRunRows": transportOperationDescriptors["getSharedRunRows"],
      },
      actions: {
        "get": transportOperationDescriptors["getSharedRunRows"],
      },
    },
    "shared-runs-test-set": {
      name: "shared-runs-test-set",
      operations: {
        "getSharedTestSet": transportOperationDescriptors["getSharedTestSet"],
      },
      actions: {
        "get": transportOperationDescriptors["getSharedTestSet"],
      },
    },
    "shared-runs-metrics": {
      name: "shared-runs-metrics",
      operations: {
        "getSharedMetrics": transportOperationDescriptors["getSharedMetrics"],
      },
      actions: {
        "get": transportOperationDescriptors["getSharedMetrics"],
      },
    },
    "shared-runs-run-test-set": {
      name: "shared-runs-run-test-set",
      operations: {
        "getSharedRunTestSet": transportOperationDescriptors["getSharedRunTestSet"],
      },
      actions: {
        "get": transportOperationDescriptors["getSharedRunTestSet"],
      },
    },
    "shared-runs-multi-run-metadata": {
      name: "shared-runs-multi-run-metadata",
      operations: {
        "getSharedMultiRunMetadata": transportOperationDescriptors["getSharedMultiRunMetadata"],
      },
      actions: {
        "get": transportOperationDescriptors["getSharedMultiRunMetadata"],
      },
    },
    "shared-runs-multi-run-rows": {
      name: "shared-runs-multi-run-rows",
      operations: {
        "getSharedMultiRunRows": transportOperationDescriptors["getSharedMultiRunRows"],
      },
      actions: {
        "get": transportOperationDescriptors["getSharedMultiRunRows"],
      },
    },
    "shared-runs-simulation-output-row": {
      name: "shared-runs-simulation-output-row",
      operations: {
        "getSharedSimulationOutputRow": transportOperationDescriptors["getSharedSimulationOutputRow"],
      },
      actions: {
        "get": transportOperationDescriptors["getSharedSimulationOutputRow"],
      },
    },
    "shared-runs-simulation-traces": {
      name: "shared-runs-simulation-traces",
      operations: {
        "listSharedSimulationTraces": transportOperationDescriptors["listSharedSimulationTraces"],
      },
      actions: {
        "list": transportOperationDescriptors["listSharedSimulationTraces"],
      },
    },
    "maestro-simulation-output-count": {
      name: "maestro-simulation-output-count",
      operations: {
        "getMaestroSimulationOutputCount": transportOperationDescriptors["getMaestroSimulationOutputCount"],
      },
      actions: {
        "get": transportOperationDescriptors["getMaestroSimulationOutputCount"],
      },
    },
    "maestro-simulation-output-ids": {
      name: "maestro-simulation-output-ids",
      operations: {
        "listMaestroSimulationOutputIds": transportOperationDescriptors["listMaestroSimulationOutputIds"],
      },
      actions: {
        "list": transportOperationDescriptors["listMaestroSimulationOutputIds"],
      },
    },
    "maestro-existing-metrics": {
      name: "maestro-existing-metrics",
      operations: {
        "listMaestroExistingMetrics": transportOperationDescriptors["listMaestroExistingMetrics"],
      },
      actions: {
        "list": transportOperationDescriptors["listMaestroExistingMetrics"],
      },
    },
    "maestro-metadata-keys": {
      name: "maestro-metadata-keys",
      operations: {
        "listMaestroMetadataKeys": transportOperationDescriptors["listMaestroMetadataKeys"],
      },
      actions: {
        "list": transportOperationDescriptors["listMaestroMetadataKeys"],
      },
    },
    "maestro-metadata-values": {
      name: "maestro-metadata-values",
      operations: {
        "listMaestroMetadataValues": transportOperationDescriptors["listMaestroMetadataValues"],
      },
      actions: {
        "list": transportOperationDescriptors["listMaestroMetadataValues"],
      },
    },
    "simulation-traces": {
      name: "simulation-traces",
      operations: {
        "hasSimulationTraces": transportOperationDescriptors["hasSimulationTraces"],
        "listSimulationTraces": transportOperationDescriptors["listSimulationTraces"],
        "getSimulationTraceDetail": transportOperationDescriptors["getSimulationTraceDetail"],
      },
      actions: {
        "query": transportOperationDescriptors["hasSimulationTraces"],
        "list": transportOperationDescriptors["listSimulationTraces"],
        "get": transportOperationDescriptors["getSimulationTraceDetail"],
      },
    },
    "run-traces": {
      name: "run-traces",
      operations: {
        "hasRunTraces": transportOperationDescriptors["hasRunTraces"],
      },
      actions: {
        "get": transportOperationDescriptors["hasRunTraces"],
      },
    },
    "simulation-trace-audio-context": {
      name: "simulation-trace-audio-context",
      operations: {
        "getTraceAudioContext": transportOperationDescriptors["getTraceAudioContext"],
      },
      actions: {
        "get": transportOperationDescriptors["getTraceAudioContext"],
      },
    },
    "traces": {
      name: "traces",
      operations: {
        "searchTraceCalls": transportOperationDescriptors["searchTraceCalls"],
        "getTraceFilterSuggestions": transportOperationDescriptors["getTraceFilterSuggestions"],
      },
      actions: {
        "query": transportOperationDescriptors["searchTraceCalls"],
        "list": transportOperationDescriptors["getTraceFilterSuggestions"],
      },
    },
    "run-trace-transition-hotspots": {
      name: "run-trace-transition-hotspots",
      operations: {
        "getTraceTransitionHotspots": transportOperationDescriptors["getTraceTransitionHotspots"],
      },
      actions: {
        "query": transportOperationDescriptors["getTraceTransitionHotspots"],
      },
    },
    "trace-search-transition-hotspots": {
      name: "trace-search-transition-hotspots",
      operations: {
        "getTraceTransitionHotspotsForSearch": transportOperationDescriptors["getTraceTransitionHotspotsForSearch"],
      },
      actions: {
        "query": transportOperationDescriptors["getTraceTransitionHotspotsForSearch"],
      },
    },
    "traces-custom-metric-preview": {
      name: "traces-custom-metric-preview",
      operations: {
        "previewCustomTraceMetric": transportOperationDescriptors["previewCustomTraceMetric"],
      },
      actions: {
        "query": transportOperationDescriptors["previewCustomTraceMetric"],
      },
    },
    "persona-versions": {
      name: "persona-versions",
      operations: {
        "getPersonaVersions": transportOperationDescriptors["getPersonaVersions"],
        "revertPersonaVersion": transportOperationDescriptors["revertPersonaVersion"],
      },
      actions: {
        "list": transportOperationDescriptors["getPersonaVersions"],
        "update": transportOperationDescriptors["revertPersonaVersion"],
      },
    },
    "background-sounds-update-background-sound": {
      name: "background-sounds-update-background-sound",
      operations: {
        "updateBackgroundSound": transportOperationDescriptors["updateBackgroundSound"],
      },
      actions: {
        "update": transportOperationDescriptors["updateBackgroundSound"],
      },
    },
    "personas-batch": {
      name: "personas-batch",
      operations: {
        "deletePersonas": transportOperationDescriptors["deletePersonas"],
      },
      actions: {
        "delete": transportOperationDescriptors["deletePersonas"],
      },
    },
    "personas-restore-persona": {
      name: "personas-restore-persona",
      operations: {
        "restorePersona": transportOperationDescriptors["restorePersona"],
      },
      actions: {
        "update": transportOperationDescriptors["restorePersona"],
      },
    },
    "personas-generate-persona-voice-candidates": {
      name: "personas-generate-persona-voice-candidates",
      operations: {
        "generatePersonaVoiceCandidates": transportOperationDescriptors["generatePersonaVoiceCandidates"],
      },
      actions: {
        "create": transportOperationDescriptors["generatePersonaVoiceCandidates"],
      },
    },
    "personas-keep-persona-voice-candidate": {
      name: "personas-keep-persona-voice-candidate",
      operations: {
        "keepPersonaVoiceCandidate": transportOperationDescriptors["keepPersonaVoiceCandidate"],
      },
      actions: {
        "create": transportOperationDescriptors["keepPersonaVoiceCandidate"],
      },
    },
    "webhooks": {
      name: "webhooks",
      operations: {
        "listWebhooks": transportOperationDescriptors["listWebhooks"],
        "createWebhook": transportOperationDescriptors["createWebhook"],
        "updateWebhook": transportOperationDescriptors["updateWebhook"],
        "deleteWebhook": transportOperationDescriptors["deleteWebhook"],
      },
      actions: {
        "list": transportOperationDescriptors["listWebhooks"],
        "create": transportOperationDescriptors["createWebhook"],
        "update": transportOperationDescriptors["updateWebhook"],
        "delete": transportOperationDescriptors["deleteWebhook"],
      },
    },
    "external-agents-candidates": {
      name: "external-agents-candidates",
      operations: {
        "listExternalAgentCandidates": transportOperationDescriptors["listExternalAgentCandidates"],
      },
      actions: {
        "list": transportOperationDescriptors["listExternalAgentCandidates"],
      },
    },
    "external-agents-import": {
      name: "external-agents-import",
      operations: {
        "importExternalAgents": transportOperationDescriptors["importExternalAgents"],
      },
      actions: {
        "run": transportOperationDescriptors["importExternalAgents"],
      },
    },
    "saved-views": {
      name: "saved-views",
      operations: {
        "listSavedViews": transportOperationDescriptors["listSavedViews"],
        "getSavedView": transportOperationDescriptors["getSavedView"],
        "createSavedView": transportOperationDescriptors["createSavedView"],
        "updateSavedView": transportOperationDescriptors["updateSavedView"],
        "deleteSavedView": transportOperationDescriptors["deleteSavedView"],
        "setUserDefaultSavedView": transportOperationDescriptors["setUserDefaultSavedView"],
      },
      actions: {
        "list": transportOperationDescriptors["listSavedViews"],
        "get": transportOperationDescriptors["getSavedView"],
        "create": transportOperationDescriptors["createSavedView"],
        "update": transportOperationDescriptors["updateSavedView"],
        "delete": transportOperationDescriptors["deleteSavedView"],
        "set": transportOperationDescriptors["setUserDefaultSavedView"],
      },
    },
    "saved-views-default": {
      name: "saved-views-default",
      operations: {
        "getUserDefaultSavedView": transportOperationDescriptors["getUserDefaultSavedView"],
      },
      actions: {
        "get": transportOperationDescriptors["getUserDefaultSavedView"],
      },
    },
    "saved-views-default-clear": {
      name: "saved-views-default-clear",
      operations: {
        "clearUserDefaultSavedView": transportOperationDescriptors["clearUserDefaultSavedView"],
      },
      actions: {
        "delete": transportOperationDescriptors["clearUserDefaultSavedView"],
      },
    },
    "tags": {
      name: "tags",
      operations: {
        "listOrganizationTags": transportOperationDescriptors["listOrganizationTags"],
        "createOrganizationTag": transportOperationDescriptors["createOrganizationTag"],
        "updateOrganizationTag": transportOperationDescriptors["updateOrganizationTag"],
        "deleteOrganizationTag": transportOperationDescriptors["deleteOrganizationTag"],
      },
      actions: {
        "list": transportOperationDescriptors["listOrganizationTags"],
        "create": transportOperationDescriptors["createOrganizationTag"],
        "update": transportOperationDescriptors["updateOrganizationTag"],
        "delete": transportOperationDescriptors["deleteOrganizationTag"],
      },
    },
    "tags-catalog": {
      name: "tags-catalog",
      operations: {
        "listWorkspaceTags": transportOperationDescriptors["listWorkspaceTags"],
      },
      actions: {
        "list": transportOperationDescriptors["listWorkspaceTags"],
      },
    },
  },
  cacheTags: {
    "python-metrics": {
      name: "python-metrics",
      operations: {
        "createPythonMetricDraft": transportOperationDescriptors["createPythonMetricDraft"],
        "getPythonMetricDraft": transportOperationDescriptors["getPythonMetricDraft"],
        "previewPythonMetric": transportOperationDescriptors["previewPythonMetric"],
        "getPythonMetricPreview": transportOperationDescriptors["getPythonMetricPreview"],
        "cancelPythonMetricPreview": transportOperationDescriptors["cancelPythonMetricPreview"],
        "publishPythonMetric": transportOperationDescriptors["publishPythonMetric"],
      },
    },
    "metrics": {
      name: "metrics",
      operations: {
        "createPythonMetricDraft": transportOperationDescriptors["createPythonMetricDraft"],
        "getPythonMetricDraft": transportOperationDescriptors["getPythonMetricDraft"],
        "previewPythonMetric": transportOperationDescriptors["previewPythonMetric"],
        "getPythonMetricPreview": transportOperationDescriptors["getPythonMetricPreview"],
        "cancelPythonMetricPreview": transportOperationDescriptors["cancelPythonMetricPreview"],
        "publishPythonMetric": transportOperationDescriptors["publishPythonMetric"],
        "copyMetricCatalogEntry": transportOperationDescriptors["copyMetricCatalogEntry"],
        "listMetrics": transportOperationDescriptors["listMetrics"],
        "getMetricLabels": transportOperationDescriptors["getMetricLabels"],
        "queryMetricAuthors": transportOperationDescriptors["queryMetricAuthors"],
        "queryAdminMetricAuthors": transportOperationDescriptors["queryAdminMetricAuthors"],
        "getMetric": transportOperationDescriptors["getMetric"],
        "getMetricVersions": transportOperationDescriptors["getMetricVersions"],
        "revertMetricVersion": transportOperationDescriptors["revertMetricVersion"],
        "createMetric": transportOperationDescriptors["createMetric"],
        "duplicateMetric": transportOperationDescriptors["duplicateMetric"],
        "updateMetric": transportOperationDescriptors["updateMetric"],
        "archiveMetric": transportOperationDescriptors["archiveMetric"],
        "listRecentlyDeletedMetrics": transportOperationDescriptors["listRecentlyDeletedMetrics"],
        "restoreMetric": transportOperationDescriptors["restoreMetric"],
        "createOrganizationTag": transportOperationDescriptors["createOrganizationTag"],
        "updateOrganizationTag": transportOperationDescriptors["updateOrganizationTag"],
        "deleteOrganizationTag": transportOperationDescriptors["deleteOrganizationTag"],
      },
    },
    "ivr_trees": {
      name: "ivr_trees",
      operations: {
        "listIvrTrees": transportOperationDescriptors["listIvrTrees"],
        "createIvrTree": transportOperationDescriptors["createIvrTree"],
        "getIvrTree": transportOperationDescriptors["getIvrTree"],
        "updateIvrTree": transportOperationDescriptors["updateIvrTree"],
        "deleteIvrTree": transportOperationDescriptors["deleteIvrTree"],
      },
    },
    "health": {
      name: "health",
      operations: {
        "getHealthStatus": transportOperationDescriptors["getHealthStatus"],
      },
    },
    "system-status": {
      name: "system-status",
      operations: {
        "getSystemStatus": transportOperationDescriptors["getSystemStatus"],
      },
    },
    "admin-organization-api-keys": {
      name: "admin-organization-api-keys",
      operations: {
        "adminCreateOrganizationApiKey": transportOperationDescriptors["adminCreateOrganizationApiKey"],
        "adminUpdateOrganizationApiKeyStatus": transportOperationDescriptors["adminUpdateOrganizationApiKeyStatus"],
        "adminDeleteOrganizationApiKey": transportOperationDescriptors["adminDeleteOrganizationApiKey"],
      },
    },
    "admin-email-recipient-allowlist": {
      name: "admin-email-recipient-allowlist",
      operations: {
        "adminUpdateEmailRecipientAllowlist": transportOperationDescriptors["adminUpdateEmailRecipientAllowlist"],
      },
    },
    "agents": {
      name: "agents",
      operations: {
        "listAgents": transportOperationDescriptors["listAgents"],
        "listAllAgents": transportOperationDescriptors["listAllAgents"],
        "getAgentVersions": transportOperationDescriptors["getAgentVersions"],
        "revertAgentVersion": transportOperationDescriptors["revertAgentVersion"],
        "duplicateAgent": transportOperationDescriptors["duplicateAgent"],
        "deleteAgents": transportOperationDescriptors["deleteAgents"],
        "listRecentlyDeletedAgents": transportOperationDescriptors["listRecentlyDeletedAgents"],
        "restoreAgent": transportOperationDescriptors["restoreAgent"],
        "importExternalAgents": transportOperationDescriptors["importExternalAgents"],
        "createOrganizationTag": transportOperationDescriptors["createOrganizationTag"],
        "updateOrganizationTag": transportOperationDescriptors["updateOrganizationTag"],
        "deleteOrganizationTag": transportOperationDescriptors["deleteOrganizationTag"],
      },
    },
    "onboarding-audio-job": {
      name: "onboarding-audio-job",
      operations: {
        "createOnboardingAudioJob": transportOperationDescriptors["createOnboardingAudioJob"],
        "startOnboardingAudioJob": transportOperationDescriptors["startOnboardingAudioJob"],
      },
    },
    "uploaded-conversation": {
      name: "uploaded-conversation",
      operations: {
        "startOnboardingAudioJob": transportOperationDescriptors["startOnboardingAudioJob"],
      },
    },
    "test-set": {
      name: "test-set",
      operations: {
        "startOnboardingAudioJob": transportOperationDescriptors["startOnboardingAudioJob"],
      },
    },
    "conversation-results": {
      name: "conversation-results",
      operations: {
        "queryUploadedConversationKeyset": transportOperationDescriptors["queryUploadedConversationKeyset"],
      },
    },
    "billing-overage-settings": {
      name: "billing-overage-settings",
      operations: {
        "updateBillingOverageSettings": transportOperationDescriptors["updateBillingOverageSettings"],
        "createBillingOverageAcceptance": transportOperationDescriptors["createBillingOverageAcceptance"],
      },
    },
    "billing-overage-acceptance": {
      name: "billing-overage-acceptance",
      operations: {
        "createBillingOverageAcceptance": transportOperationDescriptors["createBillingOverageAcceptance"],
      },
    },
    "organization-settings": {
      name: "organization-settings",
      operations: {
        "updateOrganizationSettings": transportOperationDescriptors["updateOrganizationSettings"],
      },
    },
    "workspaces": {
      name: "workspaces",
      operations: {
        "listWorkspaces": transportOperationDescriptors["listWorkspaces"],
        "createWorkspace": transportOperationDescriptors["createWorkspace"],
        "updateWorkspace": transportOperationDescriptors["updateWorkspace"],
        "archiveWorkspace": transportOperationDescriptors["archiveWorkspace"],
        "deleteWorkspace": transportOperationDescriptors["deleteWorkspace"],
      },
    },
    "workspace-settings": {
      name: "workspace-settings",
      operations: {
        "getWorkspaceSettings": transportOperationDescriptors["getWorkspaceSettings"],
        "updateWorkspaceSettings": transportOperationDescriptors["updateWorkspaceSettings"],
      },
    },
    "workspace-members": {
      name: "workspace-members",
      operations: {
        "listWorkspaceMembers": transportOperationDescriptors["listWorkspaceMembers"],
        "addWorkspaceMember": transportOperationDescriptors["addWorkspaceMember"],
        "removeWorkspaceMember": transportOperationDescriptors["removeWorkspaceMember"],
      },
    },
    "dashboards": {
      name: "dashboards",
      operations: {
        "duplicateDashboardWidget": transportOperationDescriptors["duplicateDashboardWidget"],
      },
    },
    "metric-catalog": {
      name: "metric-catalog",
      operations: {
        "listMetricCatalogEntries": transportOperationDescriptors["listMetricCatalogEntries"],
        "createAdminMetricCatalogEntry": transportOperationDescriptors["createAdminMetricCatalogEntry"],
        "updateAdminMetricCatalogEntry": transportOperationDescriptors["updateAdminMetricCatalogEntry"],
        "deleteAdminMetricCatalogEntry": transportOperationDescriptors["deleteAdminMetricCatalogEntry"],
      },
    },
    "persona-catalog": {
      name: "persona-catalog",
      operations: {
        "listPersonaCatalogEntries": transportOperationDescriptors["listPersonaCatalogEntries"],
        "createAdminPersonaCatalogEntry": transportOperationDescriptors["createAdminPersonaCatalogEntry"],
        "updateAdminPersonaCatalogEntry": transportOperationDescriptors["updateAdminPersonaCatalogEntry"],
        "deleteAdminPersonaCatalogEntry": transportOperationDescriptors["deleteAdminPersonaCatalogEntry"],
      },
    },
    "personas": {
      name: "personas",
      operations: {
        "copyPersonaCatalogEntry": transportOperationDescriptors["copyPersonaCatalogEntry"],
        "listPersonas": transportOperationDescriptors["listPersonas"],
        "listRecentlyDeletedPersonas": transportOperationDescriptors["listRecentlyDeletedPersonas"],
        "listBackgroundSounds": transportOperationDescriptors["listBackgroundSounds"],
        "getPersona": transportOperationDescriptors["getPersona"],
        "getPersonaVersions": transportOperationDescriptors["getPersonaVersions"],
        "revertPersonaVersion": transportOperationDescriptors["revertPersonaVersion"],
        "createPersona": transportOperationDescriptors["createPersona"],
        "createBackgroundSound": transportOperationDescriptors["createBackgroundSound"],
        "completeBackgroundSound": transportOperationDescriptors["completeBackgroundSound"],
        "updatePersona": transportOperationDescriptors["updatePersona"],
        "updateBackgroundSound": transportOperationDescriptors["updateBackgroundSound"],
        "deletePersona": transportOperationDescriptors["deletePersona"],
        "deletePersonas": transportOperationDescriptors["deletePersonas"],
        "duplicatePersona": transportOperationDescriptors["duplicatePersona"],
        "restorePersona": transportOperationDescriptors["restorePersona"],
        "generatePersonaVoiceCandidates": transportOperationDescriptors["generatePersonaVoiceCandidates"],
        "previewPersonaVoiceCandidate": transportOperationDescriptors["previewPersonaVoiceCandidate"],
        "keepPersonaVoiceCandidate": transportOperationDescriptors["keepPersonaVoiceCandidate"],
        "createOrganizationTag": transportOperationDescriptors["createOrganizationTag"],
        "updateOrganizationTag": transportOperationDescriptors["updateOrganizationTag"],
        "deleteOrganizationTag": transportOperationDescriptors["deleteOrganizationTag"],
      },
    },
    "metric-audits": {
      name: "metric-audits",
      operations: {
        "createMetricAudit": transportOperationDescriptors["createMetricAudit"],
        "getMetricAudit": transportOperationDescriptors["getMetricAudit"],
        "cancelMetricAudit": transportOperationDescriptors["cancelMetricAudit"],
        "listMetricAuditGroups": transportOperationDescriptors["listMetricAuditGroups"],
        "getMetricAuditPair": transportOperationDescriptors["getMetricAuditPair"],
        "getMetricAuditPromptProposal": transportOperationDescriptors["getMetricAuditPromptProposal"],
      },
    },
    "conversation-import-connections": {
      name: "conversation-import-connections",
      operations: {
        "discoverGenesysQueues": transportOperationDescriptors["discoverGenesysQueues"],
        "listConversationImportConnections": transportOperationDescriptors["listConversationImportConnections"],
        "createGenesysConnection": transportOperationDescriptors["createGenesysConnection"],
        "pauseConversationImportConnection": transportOperationDescriptors["pauseConversationImportConnection"],
        "resumeConversationImportConnection": transportOperationDescriptors["resumeConversationImportConnection"],
        "disconnectConversationImportConnection": transportOperationDescriptors["disconnectConversationImportConnection"],
      },
    },
    "metric-flows": {
      name: "metric-flows",
      operations: {
        "listMetricFlows": transportOperationDescriptors["listMetricFlows"],
        "createMetricFlow": transportOperationDescriptors["createMetricFlow"],
        "updateMetricFlow": transportOperationDescriptors["updateMetricFlow"],
        "deleteMetricFlow": transportOperationDescriptors["deleteMetricFlow"],
      },
    },
    "alerts": {
      name: "alerts",
      operations: {
        "listAlerts": transportOperationDescriptors["listAlerts"],
        "getAlert": transportOperationDescriptors["getAlert"],
        "createAlert": transportOperationDescriptors["createAlert"],
        "updateAlert": transportOperationDescriptors["updateAlert"],
        "deleteAlert": transportOperationDescriptors["deleteAlert"],
      },
    },
    "test-sets": {
      name: "test-sets",
      operations: {
        "revertTestSetVersion": transportOperationDescriptors["revertTestSetVersion"],
        "deleteTestSets": transportOperationDescriptors["deleteTestSets"],
        "listRecentlyDeletedTestSets": transportOperationDescriptors["listRecentlyDeletedTestSets"],
        "restoreTestSet": transportOperationDescriptors["restoreTestSet"],
        "createOrganizationTag": transportOperationDescriptors["createOrganizationTag"],
        "updateOrganizationTag": transportOperationDescriptors["updateOrganizationTag"],
        "deleteOrganizationTag": transportOperationDescriptors["deleteOrganizationTag"],
      },
    },
    "test_sets": {
      name: "test_sets",
      operations: {
        "saveTestSetAutoAddRule": transportOperationDescriptors["saveTestSetAutoAddRule"],
        "deleteTestSetAutoAddRule": transportOperationDescriptors["deleteTestSetAutoAddRule"],
        "acceptTestSetAutoAddSuggestion": transportOperationDescriptors["acceptTestSetAutoAddSuggestion"],
        "rejectTestSetAutoAddSuggestion": transportOperationDescriptors["rejectTestSetAutoAddSuggestion"],
      },
    },
    "test_set_auto_add": {
      name: "test_set_auto_add",
      operations: {
        "saveTestSetAutoAddRule": transportOperationDescriptors["saveTestSetAutoAddRule"],
        "deleteTestSetAutoAddRule": transportOperationDescriptors["deleteTestSetAutoAddRule"],
        "acceptTestSetAutoAddSuggestion": transportOperationDescriptors["acceptTestSetAutoAddSuggestion"],
        "rejectTestSetAutoAddSuggestion": transportOperationDescriptors["rejectTestSetAutoAddSuggestion"],
      },
    },
    "background-sounds": {
      name: "background-sounds",
      operations: {
        "listBackgroundSounds": transportOperationDescriptors["listBackgroundSounds"],
        "createBackgroundSound": transportOperationDescriptors["createBackgroundSound"],
        "completeBackgroundSound": transportOperationDescriptors["completeBackgroundSound"],
        "updateBackgroundSound": transportOperationDescriptors["updateBackgroundSound"],
      },
    },
    "run-templates": {
      name: "run-templates",
      operations: {
        "duplicateRunTemplate": transportOperationDescriptors["duplicateRunTemplate"],
        "createOrganizationTag": transportOperationDescriptors["createOrganizationTag"],
        "updateOrganizationTag": transportOperationDescriptors["updateOrganizationTag"],
        "deleteOrganizationTag": transportOperationDescriptors["deleteOrganizationTag"],
      },
    },
    "reports": {
      name: "reports",
      operations: {
        "listReports": transportOperationDescriptors["listReports"],
        "getReport": transportOperationDescriptors["getReport"],
        "saveReport": transportOperationDescriptors["saveReport"],
        "updateReport": transportOperationDescriptors["updateReport"],
        "setReportVisibility": transportOperationDescriptors["setReportVisibility"],
        "deleteReport": transportOperationDescriptors["deleteReport"],
      },
    },
    "review-overview": {
      name: "review-overview",
      operations: {
        "getReviewOverview": transportOperationDescriptors["getReviewOverview"],
        "getReviewOverview.v1": transportOperationDescriptors["getReviewOverview.v1"],
        "getReviewOverview.v2": transportOperationDescriptors["getReviewOverview.v2"],
        "skipReviewMetric": transportOperationDescriptors["skipReviewMetric"],
        "unskipReviewMetric": transportOperationDescriptors["unskipReviewMetric"],
        "getReviewProjectSimulationCompletions": transportOperationDescriptors["getReviewProjectSimulationCompletions"],
        "batchGetReviewProjectConversationStates": transportOperationDescriptors["batchGetReviewProjectConversationStates"],
        "saveReviewLabelsForSimulation": transportOperationDescriptors["saveReviewLabelsForSimulation"],
        "createReviewProject": transportOperationDescriptors["createReviewProject"],
        "duplicateReviewProject": transportOperationDescriptors["duplicateReviewProject"],
        "sendProjectAssignmentEmail": transportOperationDescriptors["sendProjectAssignmentEmail"],
        "completeReviewConversation": transportOperationDescriptors["completeReviewConversation"],
        "claimConversation": transportOperationDescriptors["claimConversation"],
        "releaseConversation": transportOperationDescriptors["releaseConversation"],
        "forceReleaseConversation": transportOperationDescriptors["forceReleaseConversation"],
        "startReviewBatch": transportOperationDescriptors["startReviewBatch"],
        "getCurrentReviewBatch": transportOperationDescriptors["getCurrentReviewBatch"],
        "stopReviewBatch": transportOperationDescriptors["stopReviewBatch"],
        "assignReviewBatches": transportOperationDescriptors["assignReviewBatches"],
        "releaseReviewBatch": transportOperationDescriptors["releaseReviewBatch"],
        "listReviewBatches": transportOperationDescriptors["listReviewBatches"],
        "updateReviewProject": transportOperationDescriptors["updateReviewProject"],
        "deleteReviewProject": transportOperationDescriptors["deleteReviewProject"],
        "updateProjectReviewAnnotation": transportOperationDescriptors["updateProjectReviewAnnotation"],
        "deleteProjectReviewAnnotation": transportOperationDescriptors["deleteProjectReviewAnnotation"],
      },
    },
    "review-projects": {
      name: "review-projects",
      operations: {
        "queryHumanReviewProjectAnnotationsTable": transportOperationDescriptors["queryHumanReviewProjectAnnotationsTable"],
        "queryHumanReviewProjectTriageMembership": transportOperationDescriptors["queryHumanReviewProjectTriageMembership"],
        "listReviewMetricSkips": transportOperationDescriptors["listReviewMetricSkips"],
        "skipReviewMetric": transportOperationDescriptors["skipReviewMetric"],
        "unskipReviewMetric": transportOperationDescriptors["unskipReviewMetric"],
        "getHumanReviewProjectAnnotationDetails": transportOperationDescriptors["getHumanReviewProjectAnnotationDetails"],
        "getReviewProjectSimulationCompletions": transportOperationDescriptors["getReviewProjectSimulationCompletions"],
        "batchGetReviewProjectConversationStates": transportOperationDescriptors["batchGetReviewProjectConversationStates"],
        "getHumanReviewProjectInsights": transportOperationDescriptors["getHumanReviewProjectInsights"],
        "getHumanReviewProjectInsightSlice": transportOperationDescriptors["getHumanReviewProjectInsightSlice"],
        "getHumanReviewProjectDateDensity": transportOperationDescriptors["getHumanReviewProjectDateDensity"],
        "getReviewLabelsForSimulation": transportOperationDescriptors["getReviewLabelsForSimulation"],
        "saveReviewLabelsForSimulation": transportOperationDescriptors["saveReviewLabelsForSimulation"],
        "listReviewProjects": transportOperationDescriptors["listReviewProjects"],
        "getReviewProject": transportOperationDescriptors["getReviewProject"],
        "createReviewProject": transportOperationDescriptors["createReviewProject"],
        "duplicateReviewProject": transportOperationDescriptors["duplicateReviewProject"],
        "listReviewProjectMembershipLogs": transportOperationDescriptors["listReviewProjectMembershipLogs"],
        "listReviewProjectMembers": transportOperationDescriptors["listReviewProjectMembers"],
        "sendProjectAssignmentEmail": transportOperationDescriptors["sendProjectAssignmentEmail"],
        "completeReviewConversation": transportOperationDescriptors["completeReviewConversation"],
        "claimConversation": transportOperationDescriptors["claimConversation"],
        "releaseConversation": transportOperationDescriptors["releaseConversation"],
        "forceReleaseConversation": transportOperationDescriptors["forceReleaseConversation"],
        "startReviewBatch": transportOperationDescriptors["startReviewBatch"],
        "getCurrentReviewBatch": transportOperationDescriptors["getCurrentReviewBatch"],
        "stopReviewBatch": transportOperationDescriptors["stopReviewBatch"],
        "assignReviewBatches": transportOperationDescriptors["assignReviewBatches"],
        "releaseReviewBatch": transportOperationDescriptors["releaseReviewBatch"],
        "listReviewBatches": transportOperationDescriptors["listReviewBatches"],
        "updateReviewProject": transportOperationDescriptors["updateReviewProject"],
        "deleteReviewProject": transportOperationDescriptors["deleteReviewProject"],
        "updateProjectReviewAnnotation": transportOperationDescriptors["updateProjectReviewAnnotation"],
        "deleteProjectReviewAnnotation": transportOperationDescriptors["deleteProjectReviewAnnotation"],
      },
    },
    "review-annotations": {
      name: "review-annotations",
      operations: {
        "queryHumanReviewProjectAnnotationsTable": transportOperationDescriptors["queryHumanReviewProjectAnnotationsTable"],
        "skipReviewMetric": transportOperationDescriptors["skipReviewMetric"],
        "unskipReviewMetric": transportOperationDescriptors["unskipReviewMetric"],
        "getHumanReviewProjectAnnotationDetails": transportOperationDescriptors["getHumanReviewProjectAnnotationDetails"],
        "getReviewProjectSimulationCompletions": transportOperationDescriptors["getReviewProjectSimulationCompletions"],
        "batchGetReviewProjectConversationStates": transportOperationDescriptors["batchGetReviewProjectConversationStates"],
        "getMetricHealthStats": transportOperationDescriptors["getMetricHealthStats"],
        "getMetricAgreementHistory": transportOperationDescriptors["getMetricAgreementHistory"],
        "getHumanReviewProjectInsights": transportOperationDescriptors["getHumanReviewProjectInsights"],
        "getHumanReviewProjectInsightSlice": transportOperationDescriptors["getHumanReviewProjectInsightSlice"],
        "getHumanReviewProjectDateDensity": transportOperationDescriptors["getHumanReviewProjectDateDensity"],
        "getAnnotationsWithMetricOutputs": transportOperationDescriptors["getAnnotationsWithMetricOutputs"],
        "getFeedbackForSimulationOutput": transportOperationDescriptors["getFeedbackForSimulationOutput"],
        "getAllAnnotationsByOrg": transportOperationDescriptors["getAllAnnotationsByOrg"],
        "listReviewAnnotations": transportOperationDescriptors["listReviewAnnotations"],
        "getReviewAnnotation": transportOperationDescriptors["getReviewAnnotation"],
        "createReviewAnnotation": transportOperationDescriptors["createReviewAnnotation"],
        "updateReviewAnnotation": transportOperationDescriptors["updateReviewAnnotation"],
        "deleteReviewAnnotation": transportOperationDescriptors["deleteReviewAnnotation"],
        "updateProjectReviewAnnotation": transportOperationDescriptors["updateProjectReviewAnnotation"],
        "deleteProjectReviewAnnotation": transportOperationDescriptors["deleteProjectReviewAnnotation"],
      },
    },
    "review-metric-outputs": {
      name: "review-metric-outputs",
      operations: {
        "queryHumanReviewProjectAnnotationsTable": transportOperationDescriptors["queryHumanReviewProjectAnnotationsTable"],
        "getHumanReviewProjectAnnotationDetails": transportOperationDescriptors["getHumanReviewProjectAnnotationDetails"],
        "getReviewDisagreementState": transportOperationDescriptors["getReviewDisagreementState"],
        "getAnnotationsWithMetricOutputs": transportOperationDescriptors["getAnnotationsWithMetricOutputs"],
      },
    },
    "review-labels": {
      name: "review-labels",
      operations: {
        "queryHumanReviewProjectAnnotationsTable": transportOperationDescriptors["queryHumanReviewProjectAnnotationsTable"],
        "queryHumanReviewProjectTriageMembership": transportOperationDescriptors["queryHumanReviewProjectTriageMembership"],
        "getHumanReviewProjectAnnotationDetails": transportOperationDescriptors["getHumanReviewProjectAnnotationDetails"],
        "getReviewProjectSimulationCompletions": transportOperationDescriptors["getReviewProjectSimulationCompletions"],
        "batchGetReviewProjectConversationStates": transportOperationDescriptors["batchGetReviewProjectConversationStates"],
        "getHumanReviewProjectInsights": transportOperationDescriptors["getHumanReviewProjectInsights"],
        "getHumanReviewProjectInsightSlice": transportOperationDescriptors["getHumanReviewProjectInsightSlice"],
        "getHumanReviewProjectDateDensity": transportOperationDescriptors["getHumanReviewProjectDateDensity"],
        "getReviewLabelsForSimulation": transportOperationDescriptors["getReviewLabelsForSimulation"],
        "saveReviewLabelsForSimulation": transportOperationDescriptors["saveReviewLabelsForSimulation"],
      },
    },
    "review-metric-skips": {
      name: "review-metric-skips",
      operations: {
        "listReviewMetricSkips": transportOperationDescriptors["listReviewMetricSkips"],
        "skipReviewMetric": transportOperationDescriptors["skipReviewMetric"],
        "unskipReviewMetric": transportOperationDescriptors["unskipReviewMetric"],
      },
    },
    "review-metric-agreements": {
      name: "review-metric-agreements",
      operations: {
        "skipReviewMetric": transportOperationDescriptors["skipReviewMetric"],
        "unskipReviewMetric": transportOperationDescriptors["unskipReviewMetric"],
        "getProjectMetricAgreement": transportOperationDescriptors["getProjectMetricAgreement"],
      },
    },
    "review-project-rerun-context": {
      name: "review-project-rerun-context",
      operations: {
        "skipReviewMetric": transportOperationDescriptors["skipReviewMetric"],
        "unskipReviewMetric": transportOperationDescriptors["unskipReviewMetric"],
        "getReviewProjectRerunContext": transportOperationDescriptors["getReviewProjectRerunContext"],
      },
    },
    "review-metric-health": {
      name: "review-metric-health",
      operations: {
        "getMetricHealthStats": transportOperationDescriptors["getMetricHealthStats"],
      },
    },
    "review-metric-agreement-history": {
      name: "review-metric-agreement-history",
      operations: {
        "getMetricAgreementHistory": transportOperationDescriptors["getMetricAgreementHistory"],
      },
    },
    "review-project-layout": {
      name: "review-project-layout",
      operations: {
        "getHumanReviewProjectLayout": transportOperationDescriptors["getHumanReviewProjectLayout"],
        "saveHumanReviewProjectLayout": transportOperationDescriptors["saveHumanReviewProjectLayout"],
      },
    },
    "review-alerts": {
      name: "review-alerts",
      operations: {
        "listHumanReviewAlerts": transportOperationDescriptors["listHumanReviewAlerts"],
        "deleteHumanReviewAlert": transportOperationDescriptors["deleteHumanReviewAlert"],
      },
    },
    "review-project-membership-logs": {
      name: "review-project-membership-logs",
      operations: {
        "listReviewProjectMembershipLogs": transportOperationDescriptors["listReviewProjectMembershipLogs"],
      },
    },
    "review-project-members": {
      name: "review-project-members",
      operations: {
        "listReviewProjectMembers": transportOperationDescriptors["listReviewProjectMembers"],
        "setReviewProjectMemberRole": transportOperationDescriptors["setReviewProjectMemberRole"],
      },
    },
    "runs": {
      name: "runs",
      operations: {
        "launchRun": transportOperationDescriptors["launchRun"],
        "rerunMetrics": transportOperationDescriptors["rerunMetrics"],
        "listRunsKeyset": transportOperationDescriptors["listRunsKeyset"],
        "getRunOutliers": transportOperationDescriptors["getRunOutliers"],
        "updateRunTags": transportOperationDescriptors["updateRunTags"],
        "createOrganizationTag": transportOperationDescriptors["createOrganizationTag"],
        "updateOrganizationTag": transportOperationDescriptors["updateOrganizationTag"],
        "deleteOrganizationTag": transportOperationDescriptors["deleteOrganizationTag"],
      },
    },
    "run-simulations": {
      name: "run-simulations",
      operations: {
        "listSimulatedConversationsKeyset": transportOperationDescriptors["listSimulatedConversationsKeyset"],
      },
    },
    "traces": {
      name: "traces",
      operations: {
        "hasSimulationTraces": transportOperationDescriptors["hasSimulationTraces"],
        "listSimulationTraces": transportOperationDescriptors["listSimulationTraces"],
        "getSimulationTraceDetail": transportOperationDescriptors["getSimulationTraceDetail"],
        "hasRunTraces": transportOperationDescriptors["hasRunTraces"],
        "getTraceAudioContext": transportOperationDescriptors["getTraceAudioContext"],
        "searchTraceCalls": transportOperationDescriptors["searchTraceCalls"],
        "getTraceTransitionHotspots": transportOperationDescriptors["getTraceTransitionHotspots"],
        "getTraceTransitionHotspotsForSearch": transportOperationDescriptors["getTraceTransitionHotspotsForSearch"],
        "getTraceFilterSuggestions": transportOperationDescriptors["getTraceFilterSuggestions"],
        "previewCustomTraceMetric": transportOperationDescriptors["previewCustomTraceMetric"],
      },
    },
    "simulation-traces": {
      name: "simulation-traces",
      operations: {
        "hasSimulationTraces": transportOperationDescriptors["hasSimulationTraces"],
        "listSimulationTraces": transportOperationDescriptors["listSimulationTraces"],
        "getSimulationTraceDetail": transportOperationDescriptors["getSimulationTraceDetail"],
        "getTraceAudioContext": transportOperationDescriptors["getTraceAudioContext"],
      },
    },
    "run-traces": {
      name: "run-traces",
      operations: {
        "hasRunTraces": transportOperationDescriptors["hasRunTraces"],
        "getTraceTransitionHotspots": transportOperationDescriptors["getTraceTransitionHotspots"],
      },
    },
    "saved-views": {
      name: "saved-views",
      operations: {
        "listSavedViews": transportOperationDescriptors["listSavedViews"],
        "getSavedView": transportOperationDescriptors["getSavedView"],
        "createSavedView": transportOperationDescriptors["createSavedView"],
        "updateSavedView": transportOperationDescriptors["updateSavedView"],
        "deleteSavedView": transportOperationDescriptors["deleteSavedView"],
        "setUserDefaultSavedView": transportOperationDescriptors["setUserDefaultSavedView"],
        "clearUserDefaultSavedView": transportOperationDescriptors["clearUserDefaultSavedView"],
      },
    },
    "tags": {
      name: "tags",
      operations: {
        "createOrganizationTag": transportOperationDescriptors["createOrganizationTag"],
        "updateOrganizationTag": transportOperationDescriptors["updateOrganizationTag"],
        "deleteOrganizationTag": transportOperationDescriptors["deleteOrganizationTag"],
      },
    },
  },
  collections: {
    "listIvrTrees": transportOperationDescriptors["listIvrTrees"],
    "listAdminDataFrames": transportOperationDescriptors["listAdminDataFrames"],
    "listAdminSimulationDataFrames": transportOperationDescriptors["listAdminSimulationDataFrames"],
    "listSimulationDataFrames": transportOperationDescriptors["listSimulationDataFrames"],
    "listAgents": transportOperationDescriptors["listAgents"],
    "listAllAgents": transportOperationDescriptors["listAllAgents"],
    "queryUploadedConversationKeyset": transportOperationDescriptors["queryUploadedConversationKeyset"],
    "getUploadedConversationReportRows": transportOperationDescriptors["getUploadedConversationReportRows"],
    "listAdminMetricCatalogEntries": transportOperationDescriptors["listAdminMetricCatalogEntries"],
    "listAdminPersonaCatalogEntries": transportOperationDescriptors["listAdminPersonaCatalogEntries"],
    "listMetricAuditGroups": transportOperationDescriptors["listMetricAuditGroups"],
    "listConversationImportConnections": transportOperationDescriptors["listConversationImportConnections"],
    "listMetrics": transportOperationDescriptors["listMetrics"],
    "listAlerts": transportOperationDescriptors["listAlerts"],
    "listPersonas": transportOperationDescriptors["listPersonas"],
    "listReports": transportOperationDescriptors["listReports"],
    "queryHumanReviewProjectAnnotationsTable": transportOperationDescriptors["queryHumanReviewProjectAnnotationsTable"],
    "queryHumanReviewProjectTriageMembership": transportOperationDescriptors["queryHumanReviewProjectTriageMembership"],
    "getAnnotationsWithMetricOutputs": transportOperationDescriptors["getAnnotationsWithMetricOutputs"],
    "listReviewProjects": transportOperationDescriptors["listReviewProjects"],
    "listReviewAnnotations": transportOperationDescriptors["listReviewAnnotations"],
    "listRunsKeyset": transportOperationDescriptors["listRunsKeyset"],
    "listSimulatedConversationsKeyset": transportOperationDescriptors["listSimulatedConversationsKeyset"],
    "searchTraceCalls": transportOperationDescriptors["searchTraceCalls"],
    "listWorkspaceTags": transportOperationDescriptors["listWorkspaceTags"],
  },
  operationVersions: {
    "getReviewOverview": {
      name: "getReviewOverview",
      default: transportOperationDescriptors["getReviewOverview"],
      1: transportOperationDescriptors["getReviewOverview.v1"],
      v1: transportOperationDescriptors["getReviewOverview.v1"],
      2: transportOperationDescriptors["getReviewOverview.v2"],
      v2: transportOperationDescriptors["getReviewOverview.v2"],
    },
  },
} as const;

export interface TransportOperationTypes {
  "createPythonMetricDraft": {
    request: CreatePythonMetricDraftRequest;
    response: PythonMetricDraftResponse;
  };
  "getPythonMetricDraft": {
    request: GetPythonMetricDraftRequest;
    response: PythonMetricDraftResponse;
  };
  "previewPythonMetric": {
    request: PreviewPythonMetricRequest;
    response: PythonMetricPreviewsResponse;
  };
  "getPythonMetricPreview": {
    request: GetPythonMetricPreviewRequest;
    response: PythonMetricPreviewsResponse;
  };
  "cancelPythonMetricPreview": {
    request: CancelPythonMetricPreviewRequest;
    response: PythonMetricPreviewsResponse;
  };
  "publishPythonMetric": {
    request: PublishPythonMetricRequest;
    response: PublishPythonMetricResponse;
  };
  "listIvrTrees": {
    request: ListIvrTreesRequest;
    response: ListIvrTreesResponse;
  };
  "createIvrTree": {
    request: CreateIvrTreeRequest;
    response: IvrTreeResponse;
  };
  "getIvrTree": {
    request: never;
    response: IvrTreeResponse;
  };
  "updateIvrTree": {
    request: UpdateIvrTreeRequest;
    response: IvrTreeResponse;
  };
  "deleteIvrTree": {
    request: never;
    response: DeleteIvrTreeResponse;
  };
  "health": {
    request: never;
    response: TransportHealthResponse;
  };
  "getHealthStatus": {
    request: never;
    response: GetHealthStatusResponse;
  };
  "getSystemStatus": {
    request: never;
    response: GetSystemStatusResponse;
  };
  "getFdeSupportStatus": {
    request: never;
    response: GetFdeSupportStatusResponse;
  };
  "pageFdeSupport": {
    request: PageFdeSupportRequest;
    response: PageFdeSupportResponse;
  };
  "bootstrap": {
    request: never;
    response: TransportBootstrapResponse;
  };
  "getAccountDeletionImpact": {
    request: never;
    response: GetAccountDeletionImpactResponse;
  };
  "deleteAccount": {
    request: DeleteAccountRequest;
    response: DeleteAccountResponse;
  };
  "adminListOrganizations": {
    request: AdminListOrganizationsRequest;
    response: AdminListOrganizationsResponse;
  };
  "listAdminDataFrames": {
    request: AdminListDataFramesRequest;
    response: AdminListDataFramesResponse;
  };
  "listAdminSimulationDataFrames": {
    request: AdminListSimulationDataFramesRequest;
    response: AdminListSimulationDataFramesResponse;
  };
  "listSimulationDataFrames": {
    request: ListSimulationDataFramesRequest;
    response: ListSimulationDataFramesResponse;
  };
  "adminListOrganizationPlans": {
    request: never;
    response: AdminListOrganizationPlansResponse;
  };
  "adminGetOrganization": {
    request: AdminGetOrganizationRequest;
    response: AdminGetOrganizationResponse;
  };
  "adminGetOrganizationUsage": {
    request: AdminGetOrganizationUsageRequest;
    response: AdminGetOrganizationUsageResponse;
  };
  "adminGetCustomerHealthOverview": {
    request: AdminCustomerHealthOverviewRequest;
    response: AdminCustomerHealthOverviewResponse;
  };
  "adminGetCustomerHealthDetail": {
    request: AdminGetCustomerHealthDetailRequest;
    response: AdminGetCustomerHealthDetailResponse;
  };
  "adminGetCustomerHealthExternalSignals": {
    request: AdminGetCustomerHealthExternalSignalsRequest;
    response: AdminGetCustomerHealthExternalSignalsResponse;
  };
  "adminGetCustomerHealthSlackSummary": {
    request: AdminGetCustomerHealthSlackSummaryRequest;
    response: AdminGetCustomerHealthSlackSummaryResponse;
  };
  "adminListCustomerHealthAccounts": {
    request: AdminListCustomerHealthAccountsRequest;
    response: AdminListCustomerHealthAccountsResponse;
  };
  "adminGetSelfServeUsageRoundup": {
    request: AdminSelfServeUsageRoundupRequest;
    response: AdminSelfServeUsageRoundupResponse;
  };
  "adminListOrganizationApiKeys": {
    request: AdminListOrganizationApiKeysRequest;
    response: AdminListOrganizationApiKeysResponse;
  };
  "adminCreateOrganizationApiKey": {
    request: AdminCreateOrganizationApiKeyRequest;
    response: AdminCreateOrganizationApiKeyResponse;
  };
  "adminUpdateOrganizationApiKeyStatus": {
    request: AdminUpdateOrganizationApiKeyStatusRequest;
    response: AdminUpdateOrganizationApiKeyStatusResponse;
  };
  "adminDeleteOrganizationApiKey": {
    request: AdminDeleteOrganizationApiKeyRequest;
    response: AdminDeleteOrganizationApiKeyResponse;
  };
  "adminProvisionOrganization": {
    request: AdminProvisionOrganizationRequest;
    response: AdminProvisionOrganizationResponse;
  };
  "adminPreviewOrganizationReconciliation": {
    request: AdminProvisionOrganizationRequest;
    response: AdminPreviewOrganizationReconciliationResponse;
  };
  "adminUpdateSimulationTimeout": {
    request: AdminUpdateSimulationTimeoutRequest;
    response: AdminMutationResponse;
  };
  "adminGetEmailRecipientAllowlist": {
    request: AdminGetEmailRecipientAllowlistRequest;
    response: AdminEmailRecipientAllowlistResponse;
  };
  "adminUpdateEmailRecipientAllowlist": {
    request: AdminUpdateEmailRecipientAllowlistRequest;
    response: AdminEmailRecipientAllowlistResponse;
  };
  "adminUpdateTelephonyProvider": {
    request: AdminUpdateTelephonyProviderRequest;
    response: AdminMutationResponse;
  };
  "adminUpdateSofiaModel": {
    request: AdminUpdateSofiaModelRequest;
    response: AdminMutationResponse;
  };
  "adminUpdateMaxSimulationAttempts": {
    request: AdminUpdateMaxSimulationAttemptsRequest;
    response: AdminMutationResponse;
  };
  "adminUpdatePipelinePriority": {
    request: AdminUpdatePipelinePriorityRequest;
    response: AdminMutationResponse;
  };
  "adminUpdateOrganizationWideConcurrency": {
    request: AdminUpdateOrganizationWideConcurrencyRequest;
    response: AdminMutationResponse;
  };
  "adminUpdateMaxJobConcurrency": {
    request: AdminUpdateMaxJobConcurrencyRequest;
    response: AdminMutationResponse;
  };
  "getWorkOSSetupInfo": {
    request: never;
    response: WorkOSSetupInfoResponse;
  };
  "configureWorkOSMapping": {
    request: ConfigureWorkOSMappingRequest;
    response: ConfigureWorkOSMappingResponse;
  };
  "listAgents": {
    request: ListAgentsRequest;
    response: ListAgentsResponse;
  };
  "listAllAgents": {
    request: ListAgentsRequest;
    response: ListAgentsResponse;
  };
  "getAgent": {
    request: GetAgentRequest;
    response: GetAgentResponse;
  };
  "getAgentNames": {
    request: AgentNamesRequest;
    response: AgentNamesResponse;
  };
  "getAgentVersions": {
    request: GetAgentVersionsRequest;
    response: GetAgentVersionsResponse;
  };
  "revertAgentVersion": {
    request: RevertAgentVersionRequest;
    response: RevertAgentVersionResponse;
  };
  "createAgent": {
    request: CreateAgentRequest;
    response: CreateAgentResponse;
  };
  "duplicateAgent": {
    request: DuplicateAgentRequest;
    response: DuplicateAgentResponse;
  };
  "testAgentConnection": {
    request: TestAgentConnectionRequest;
    response: TestAgentConnectionResponse;
  };
  "updateAgent": {
    request: UpdateAgentRequest;
    response: UpdateAgentResponse;
  };
  "deleteAgent": {
    request: DeleteAgentRequest;
    response: DeleteAgentResponse;
  };
  "deleteAgents": {
    request: DeleteAgentsRequest;
    response: DeleteAgentsResponse;
  };
  "addAgentMetrics": {
    request: AddAgentMetricsRequest;
    response: AgentMutationResponse;
  };
  "removeAgentMetric": {
    request: RemoveAgentMetricRequest;
    response: AgentMutationResponse;
  };
  "setAgentMetrics": {
    request: SetAgentMetricsRequest;
    response: AgentMutationResponse;
  };
  "addAgentWorkflow": {
    request: AddAgentWorkflowRequest;
    response: AgentMutationResponse;
  };
  "removeAgentWorkflow": {
    request: RemoveAgentWorkflowRequest;
    response: AgentMutationResponse;
  };
  "listRecentlyDeletedAgents": {
    request: never;
    response: ListRecentlyDeletedAgentsResponse;
  };
  "restoreAgent": {
    request: RestoreAgentRequest;
    response: RestoreAgentResponse;
  };
  "listAgentMutations": {
    request: ListAgentMutationsRequest;
    response: ListAgentMutationsResponse;
  };
  "listAllAgentMutations": {
    request: never;
    response: ListAllAgentMutationsResponse;
  };
  "getAgentMutation": {
    request: GetAgentMutationRequest;
    response: GetAgentMutationResponse;
  };
  "createAgentMutation": {
    request: CreateAgentMutationRequest;
    response: CreateAgentMutationResponse;
  };
  "updateAgentMutation": {
    request: UpdateAgentMutationRequest;
    response: UpdateAgentMutationResponse;
  };
  "archiveAgentMutation": {
    request: ArchiveAgentMutationRequest;
    response: ArchiveAgentMutationResponse;
  };
  "listBaselines": {
    request: ListBaselinesRequest;
    response: ListBaselinesResponse;
  };
  "getBaseline": {
    request: GetBaselineRequest;
    response: GetBaselineResponse;
  };
  "createBaseline": {
    request: CreateBaselineRequest;
    response: CreateBaselineResponse;
  };
  "updateBaseline": {
    request: UpdateBaselineRequest;
    response: UpdateBaselineResponse;
  };
  "archiveBaseline": {
    request: ArchiveBaselineRequest;
    response: ArchiveBaselineResponse;
  };
  "getBaselineHistory": {
    request: BaselineHistoryRequest;
    response: BaselineHistoryResponse;
  };
  "getBaselineDeviationsBySimulation": {
    request: BaselineDeviationsBySimulationRequest;
    response: BaselineDeviationsBySimulationResponse;
  };
  "listBenchmarkDatasets": {
    request: ListBenchmarkDatasetsRequest;
    response: ListBenchmarkDatasetsResponse;
  };
  "getBenchmarkDataset": {
    request: GetBenchmarkDatasetRequest;
    response: BenchmarkDatasetResponse;
  };
  "createBenchmarkDataset": {
    request: CreateBenchmarkDatasetRequest;
    response: BenchmarkDatasetResponse;
  };
  "updateBenchmarkDataset": {
    request: UpdateBenchmarkDatasetRequest;
    response: BenchmarkDatasetResponse;
  };
  "deleteBenchmarkDataset": {
    request: DeleteBenchmarkDatasetRequest;
    response: BenchmarkDatasetMutationResponse;
  };
  "getBenchmarkDatasetUploadUrl": {
    request: BenchmarkDatasetUploadUrlRequest;
    response: BenchmarkDatasetUploadUrlResponse;
  };
  "listBenchmarkDatasetItems": {
    request: ListBenchmarkDatasetItemsRequest;
    response: ListBenchmarkDatasetItemsResponse;
  };
  "getBenchmarkDatasetItem": {
    request: GetBenchmarkDatasetItemRequest;
    response: BenchmarkDatasetItemResponse;
  };
  "addBenchmarkDatasetItem": {
    request: AddBenchmarkDatasetItemRequest;
    response: BenchmarkDatasetItemResponse;
  };
  "updateBenchmarkDatasetItem": {
    request: UpdateBenchmarkDatasetItemRequest;
    response: BenchmarkDatasetItemResponse;
  };
  "deleteBenchmarkDatasetItem": {
    request: DeleteBenchmarkDatasetItemRequest;
    response: BenchmarkDatasetItemMutationResponse;
  };
  "listBenchmarkEndpoints": {
    request: ListBenchmarkEndpointsRequest;
    response: ListBenchmarkEndpointsResponse;
  };
  "getBenchmarkEndpoint": {
    request: GetBenchmarkEndpointRequest;
    response: BenchmarkEndpointResponse;
  };
  "getBenchmarkEndpointsByIds": {
    request: GetBenchmarkEndpointsByIdsRequest;
    response: BenchmarkEndpointsByIdsResponse;
  };
  "createBenchmarkEndpoint": {
    request: CreateBenchmarkEndpointRequest;
    response: BenchmarkEndpointResponse;
  };
  "updateBenchmarkEndpoint": {
    request: UpdateBenchmarkEndpointRequest;
    response: BenchmarkEndpointResponse;
  };
  "deleteBenchmarkEndpoint": {
    request: DeleteBenchmarkEndpointRequest;
    response: BenchmarkEndpointMutationResponse;
  };
  "testBenchmarkEndpoint": {
    request: GetBenchmarkEndpointRequest;
    response: BenchmarkEndpointTestResponse;
  };
  "listBenchmarkRuns": {
    request: ListBenchmarkRunsRequest;
    response: ListBenchmarkRunsResponse;
  };
  "getBenchmarkRun": {
    request: GetBenchmarkRunRequest;
    response: BenchmarkRunResponse;
  };
  "createBenchmarkRun": {
    request: CreateBenchmarkRunRequest;
    response: BenchmarkRunResponse;
  };
  "cancelBenchmarkRun": {
    request: CancelBenchmarkRunRequest;
    response: BenchmarkRunResponse;
  };
  "listBenchmarkResults": {
    request: ListBenchmarkResultsRequest;
    response: ListBenchmarkResultsResponse;
  };
  "getBenchmarkAudioSignedUrl": {
    request: BenchmarkAudioSignedUrlRequest;
    response: BenchmarkAudioSignedUrlResponse;
  };
  "listApiKeys": {
    request: ListApiKeysRequest;
    response: ListApiKeysResponse;
  };
  "createApiKey": {
    request: CreateApiKeyRequest;
    response: CreateApiKeyResponse;
  };
  "createGithubFixIntent": {
    request: CreateGithubFixIntentRequest;
    response: CreateGithubFixIntentResponse;
  };
  "updateApiKeyStatus": {
    request: UpdateApiKeyStatusRequest;
    response: UpdateApiKeyStatusResponse;
  };
  "deleteApiKey": {
    request: DeleteApiKeyRequest;
    response: DeleteApiKeyResponse;
  };
  "getAudioSignedUrl": {
    request: AudioSignedUrlRequest;
    response: AudioSignedUrlResponse;
  };
  "getPublicAudioSignedUrl": {
    request: PublicAudioSignedUrlRequest;
    response: AudioSignedUrlResponse;
  };
  "uploadAudio": {
    request: UploadAudioRequest;
    response: UploadAudioResponse;
  };
  "processAudio": {
    request: ProcessAudioRequest;
    response: ProcessAudioResponse;
  };
  "createOnboardingAudioJob": {
    request: CreateOnboardingAudioJobRequest;
    response: CreateOnboardingAudioJobResponse;
  };
  "startOnboardingAudioJob": {
    request: OnboardingAudioJobRequest;
    response: OnboardingAudioJobResponse;
  };
  "getOnboardingAudioJob": {
    request: OnboardingAudioJobRequest;
    response: OnboardingAudioJobResponse;
  };
  "submitUploadedConversation": {
    request: SubmitUploadedConversationRequest;
    response: SubmitUploadedConversationResponse;
  };
  "uploadTracesForUploadedConversation": {
    request: UploadTracesForUploadedConversationRequest;
    response: UploadTracesForUploadedConversationResponse;
  };
  "queryUploadedConversationKeyset": {
    request: UploadedConversationKeysetRequest;
    response: UploadedConversationKeysetResponse;
  };
  "getUploadedConversationMetadata": {
    request: never;
    response: UploadedConversationMetadataResponse;
  };
  "getUploadedConversationMetricStringValues": {
    request: UploadedConversationMetricStringValuesRequest;
    response: UploadedConversationMetricStringValuesResponse;
  };
  "getUploadedConversationNavigationContext": {
    request: UploadedConversationNavigationRequest;
    response: UploadedConversationNavigationResponse;
  };
  "getUploadedConversationReportRows": {
    request: UploadedConversationReportRowsRequest;
    response: UploadedConversationReportRowsResponse;
  };
  "findUploadedConversationRecordingFile": {
    request: FindUploadedConversationRecordingFileRequest;
    response: FindUploadedConversationRecordingFileResponse;
  };
  "getAudioPeaksUrl": {
    request: AudioSignedUrlRequest;
    response: AudioSignedUrlResponse;
  };
  "getAudioUploadUrl": {
    request: GetAudioUploadUrlRequest;
    response: GetAudioUploadUrlResponse;
  };
  "homeActivation": {
    request: never;
    response: HomeActivationResponse;
  };
  "homeDigest": {
    request: never;
    response: HomeDigestResponse;
  };
  "listKnowledgeBaseEntries": {
    request: ListKnowledgeBaseEntriesRequest;
    response: ListKnowledgeBaseEntriesResponse;
  };
  "listKnowledgeBaseEntriesByTestSet": {
    request: ListKnowledgeBaseEntriesByTestSetRequest;
    response: ListKnowledgeBaseEntriesResponse;
  };
  "createKnowledgeBaseEntry": {
    request: KnowledgeBaseEntryRequest;
    response: KnowledgeBaseMutationResponse;
  };
  "createTestSetFromKnowledgeBaseScenarios": {
    request: CreateTestSetFromKnowledgeBaseScenariosRequest;
    response: CreateTestSetFromKnowledgeBaseScenariosResponse;
  };
  "updateKnowledgeBaseEntry": {
    request: KnowledgeBaseEntryUpdateRequest;
    response: KnowledgeBaseMutationResponse;
  };
  "deleteKnowledgeBaseEntry": {
    request: DeleteKnowledgeBaseEntryRequest;
    response: KnowledgeBaseMutationResponse;
  };
  "getKnowledgeBaseUploadUrl": {
    request: KnowledgeBaseUploadUrlRequest;
    response: KnowledgeBaseUploadUrlResponse;
  };
  "getKnowledgeBaseSignedUrl": {
    request: KnowledgeBaseS3ObjectRequest;
    response: KnowledgeBaseSignedUrlResponse;
  };
  "getKnowledgeBaseFileContent": {
    request: KnowledgeBaseS3ObjectRequest;
    response: KnowledgeBaseFileContentResponse;
  };
  "getOrganizationSettings": {
    request: never;
    response: GetOrganizationSettingsResponse;
  };
  "getBillingOverageSettings": {
    request: never;
    response: OverageSettingsResponse;
  };
  "updateBillingOverageSettings": {
    request: OverageSettingsUpdate;
    response: OverageSettingsResponse;
  };
  "getBillingOverageAcceptanceReceipt": {
    request: OverageAcceptanceReceiptRequest;
    response: OverageAcceptanceReceiptResponse;
  };
  "getBillingOverageAcceptanceOffer": {
    request: never;
    response: OverageAcceptanceOfferResponse;
  };
  "createBillingOverageAcceptance": {
    request: OverageAcceptanceRequest;
    response: OverageAcceptanceResponse;
  };
  "getOrganizationRecord": {
    request: GetOrganizationRecordRequest;
    response: GetOrganizationRecordResponse;
  };
  "getOrganizationUsers": {
    request: never;
    response: GetOrganizationUsersResponse;
  };
  "updateOrganizationSettings": {
    request: UpdateOrganizationSettingsRequest;
    response: UpdateOrganizationSettingsResponse;
  };
  "listWorkspaces": {
    request: never;
    response: ListWorkspacesResponse;
  };
  "getWorkspaceSettings": {
    request: GetWorkspaceSettingsRequest;
    response: WorkspaceSettings;
  };
  "updateWorkspaceSettings": {
    request: UpdateWorkspaceSettingsRequest;
    response: WorkspaceSettings;
  };
  "createWorkspace": {
    request: CreateWorkspaceRequest;
    response: WorkspaceResponse;
  };
  "updateWorkspace": {
    request: UpdateWorkspaceRequest;
    response: WorkspaceResponse;
  };
  "archiveWorkspace": {
    request: ArchiveWorkspaceRequest;
    response: WorkspaceResponse;
  };
  "deleteWorkspace": {
    request: DeleteWorkspaceRequest;
    response: WorkspaceResponse;
  };
  "listWorkspaceMembers": {
    request: ListWorkspaceMembersRequest;
    response: ListWorkspaceMembersResponse;
  };
  "addWorkspaceMember": {
    request: AddWorkspaceMemberRequest;
    response: AddWorkspaceMemberResponse;
  };
  "removeWorkspaceMember": {
    request: RemoveWorkspaceMemberRequest;
    response: RemoveWorkspaceMemberResponse;
  };
  "getLinearIntegrationStatus": {
    request: never;
    response: LinearIntegrationStatusResponse;
  };
  "getLinearAuthorizationUrl": {
    request: never;
    response: LinearAuthorizationUrlResponse;
  };
  "connectLinearIntegration": {
    request: ConnectLinearIntegrationRequest;
    response: ConnectLinearIntegrationResponse;
  };
  "disconnectLinearIntegration": {
    request: never;
    response: DisconnectLinearIntegrationResponse;
  };
  "listLinearTeams": {
    request: never;
    response: ListLinearTeamsResponse;
  };
  "listLinearProjects": {
    request: ListLinearProjectsRequest;
    response: ListLinearProjectsResponse;
  };
  "createLinearIssue": {
    request: CreateLinearIssueRequest;
    response: CreateLinearIssueResponse;
  };
  "requestSimulationRoom": {
    request: SimulationRoomRequest;
    response: SimulationRoomResponse;
  };
  "getSlackStatus": {
    request: never;
    response: SlackStatusResponse;
  };
  "connectSlack": {
    request: ConnectSlackRequest;
    response: ConnectSlackResponse;
  };
  "disconnectSlack": {
    request: never;
    response: DisconnectSlackResponse;
  };
  "listDashboardMetadata": {
    request: never;
    response: ListDashboardMetadataResponse;
  };
  "getDashboardLayout": {
    request: GetDashboardLayoutRequest;
    response: DashboardLayoutResponse;
  };
  "queryDashboardBatch": {
    request: QueryDashboardBatchRequest;
    response: QueryDashboardBatchResponse;
  };
  "flexibleDashboardDrilldown": {
    request: FlexibleDashboardDrilldownRequest;
    response: FlexibleDashboardDrilldownResponse;
  };
  "humanReviewDashboardDrilldown": {
    request: HumanReviewDrilldownRequest;
    response: HumanReviewDashboardDrilldownResponse;
  };
  "metricValuesBySimulation": {
    request: MetricValuesBySimulationRequest;
    response: MetricValuesBySimulationResponse;
  };
  "createDashboard": {
    request: CreateDashboardRequest;
    response: CreateDashboardResponse;
  };
  "updateDashboard": {
    request: UpdateDashboardRequest;
    response: UpdateDashboardResponse;
  };
  "deleteDashboard": {
    request: DeleteDashboardRequest;
    response: DeleteDashboardResponse;
  };
  "replaceDashboardWidgets": {
    request: ReplaceDashboardWidgetsRequest;
    response: ReplaceDashboardWidgetsResponse;
  };
  "clearDashboardWidgets": {
    request: ClearDashboardWidgetsRequest;
    response: ClearDashboardWidgetsResponse;
  };
  "duplicateDashboardWidget": {
    request: DuplicateDashboardWidgetRequest;
    response: DuplicateDashboardWidgetResponse;
  };
  "listMetricCatalogEntries": {
    request: never;
    response: ListMetricCatalogEntriesResponse;
  };
  "copyMetricCatalogEntry": {
    request: CopyMetricCatalogEntryRequest;
    response: CreateMetricResponse;
  };
  "listAdminMetricCatalogEntries": {
    request: ListAdminMetricCatalogEntriesRequest;
    response: ListAdminMetricCatalogEntriesResponse;
  };
  "getAdminMetricCatalogEntry": {
    request: GetAdminMetricCatalogEntryRequest;
    response: GetAdminMetricCatalogEntryResponse;
  };
  "createAdminMetricCatalogEntry": {
    request: CreateAdminMetricCatalogEntryRequest;
    response: MetricCatalogEntryResource;
  };
  "updateAdminMetricCatalogEntry": {
    request: UpdateAdminMetricCatalogEntryRequest;
    response: MetricCatalogEntryResource;
  };
  "deleteAdminMetricCatalogEntry": {
    request: DeleteAdminMetricCatalogEntryRequest;
    response: DeleteAdminMetricCatalogEntryResponse;
  };
  "listPersonaCatalogEntries": {
    request: never;
    response: ListPersonaCatalogEntriesResponse;
  };
  "copyPersonaCatalogEntry": {
    request: CopyPersonaCatalogEntryRequest;
    response: CreatePersonaResponse;
  };
  "listAdminPersonaCatalogEntries": {
    request: ListAdminPersonaCatalogEntriesRequest;
    response: ListAdminPersonaCatalogEntriesResponse;
  };
  "getAdminPersonaCatalogEntry": {
    request: GetAdminPersonaCatalogEntryRequest;
    response: GetAdminPersonaCatalogEntryResponse;
  };
  "createAdminPersonaCatalogEntry": {
    request: CreateAdminPersonaCatalogEntryRequest;
    response: PersonaCatalogEntryResource;
  };
  "updateAdminPersonaCatalogEntry": {
    request: UpdateAdminPersonaCatalogEntryRequest;
    response: PersonaCatalogEntryResource;
  };
  "deleteAdminPersonaCatalogEntry": {
    request: DeleteAdminPersonaCatalogEntryRequest;
    response: DeleteAdminPersonaCatalogEntryResponse;
  };
  "listMetricDirectory": {
    request: never;
    response: ListMetricDirectoryResponse;
  };
  "createMetricAudit": {
    request: CreateMetricAuditRequest;
    response: CreateMetricAuditResponse;
  };
  "getMetricAudit": {
    request: GetMetricAuditRequest;
    response: GetMetricAuditResponse;
  };
  "cancelMetricAudit": {
    request: CancelMetricAuditRequest;
    response: CancelMetricAuditResponse;
  };
  "listMetricAuditGroups": {
    request: ListMetricAuditGroupsRequest;
    response: ListMetricAuditGroupsResponse;
  };
  "getMetricAuditPair": {
    request: GetMetricAuditPairRequest;
    response: GetMetricAuditPairResponse;
  };
  "getMetricAuditPromptProposal": {
    request: GetMetricAuditPromptProposalRequest;
    response: GetMetricAuditPromptProposalResponse;
  };
  "getSimulationDataFramesSchema": {
    request: never;
    response: SimulationDataFramesSchemaResponse;
  };
  "testSqlMetric": {
    request: TestSqlMetricRequest;
    response: TestRecentSqlMetricResponse;
  };
  "getMetricThreshold": {
    request: GetMetricThresholdRequest;
    response: GetMetricThresholdResponse;
  };
  "updateMetricThreshold": {
    request: UpdateMetricThresholdRequest;
    response: UpdateMetricThresholdResponse;
  };
  "listComments": {
    request: ListCommentsRequest;
    response: ListCommentsResponse;
  };
  "createComment": {
    request: CreateCommentRequest;
    response: CreateCommentResponse;
  };
  "updateComment": {
    request: UpdateCommentRequest;
    response: UpdateCommentResponse;
  };
  "deleteComment": {
    request: DeleteCommentRequest;
    response: DeleteCommentResponse;
  };
  "getSettingsCredentialIntegrations": {
    request: never;
    response: SettingsCredentialIntegrationsResponse;
  };
  "updateLangfuseIntegration": {
    request: UpdateLangfuseIntegrationRequest;
    response: UpdateLangfuseIntegrationResponse;
  };
  "updateArizeIntegration": {
    request: UpdateArizeIntegrationRequest;
    response: UpdateArizeIntegrationResponse;
  };
  "updateZendeskIntegration": {
    request: UpdateZendeskIntegrationRequest;
    response: UpdateZendeskIntegrationResponse;
  };
  "updateShelfIntegration": {
    request: UpdateShelfIntegrationRequest;
    response: UpdateShelfIntegrationResponse;
  };
  "getTelnyxIntegrationStatus": {
    request: never;
    response: TelnyxIntegrationResource;
  };
  "updateTelnyxApiKey": {
    request: UpdateTelnyxApiKeyRequest;
    response: UpdateTelnyxApiKeyResponse;
  };
  "removeTelnyxApiKey": {
    request: never;
    response: RemoveTelnyxApiKeyResponse;
  };
  "discoverGenesysQueues": {
    request: DiscoverGenesysQueuesRequest;
    response: DiscoverGenesysQueuesResponse;
  };
  "listConversationImportConnections": {
    request: ListConversationImportConnectionsRequest;
    response: ListConversationImportConnectionsResponse;
  };
  "createGenesysConnection": {
    request: CreateGenesysConnectionRequest;
    response: CreateGenesysConnectionResponse;
  };
  "pauseConversationImportConnection": {
    request: ConversationImportConnectionActionRequest;
    response: ConversationImportConnectionActionResponse;
  };
  "resumeConversationImportConnection": {
    request: ConversationImportConnectionActionRequest;
    response: ConversationImportConnectionActionResponse;
  };
  "disconnectConversationImportConnection": {
    request: ConversationImportConnectionActionRequest;
    response: ConversationImportConnectionActionResponse;
  };
  "listAdminMetrics": {
    request: ListAdminMetricsRequest;
    response: ListAdminMetricsResponse;
  };
  "listMetricAdminOrganizations": {
    request: never;
    response: ListMetricAdminOrganizationsResponse;
  };
  "createAdminMetric": {
    request: CreateAdminMetricRequest;
    response: CreateAdminMetricResponse;
  };
  "updateAdminMetric": {
    request: UpdateAdminMetricRequest;
    response: UpdateAdminMetricResponse;
  };
  "updateMetricActiveStatus": {
    request: UpdateMetricActiveStatusRequest;
    response: MetricAdminMutationResponse;
  };
  "listMetrics": {
    request: ListMetricsRequest;
    response: ListMetricsResponse;
  };
  "listMetricTags": {
    request: never;
    response: ListMetricTagsResponse;
  };
  "getMetricLabels": {
    request: GetMetricLabelsRequest;
    response: GetMetricLabelsResponse;
  };
  "queryMetricAuthors": {
    request: QueryMetricAuthorsRequest;
    response: QueryMetricAuthorsResponse;
  };
  "queryAdminMetricAuthors": {
    request: QueryMetricAuthorsRequest;
    response: QueryMetricAuthorsResponse;
  };
  "getMetric": {
    request: GetMetricRequest;
    response: GetMetricResponse;
  };
  "getMetricVersions": {
    request: GetMetricVersionsRequest;
    response: GetMetricVersionsResponse;
  };
  "revertMetricVersion": {
    request: RevertMetricVersionRequest;
    response: RevertMetricVersionResponse;
  };
  "getMetricsMetadata": {
    request: MetricsMetadataRequest;
    response: MetricsMetadataResponse;
  };
  "getMetricMetadataKeys": {
    request: MetricsMetadataRequest;
    response: MetricsMetadataKeysResponse;
  };
  "getMetricMetadataValues": {
    request: MetricMetadataValuesRequest;
    response: MetricMetadataValuesResponse;
  };
  "listMetricFlows": {
    request: ListMetricFlowsRequest;
    response: ListMetricFlowsResponse;
  };
  "createMetricFlow": {
    request: CreateMetricFlowRequest;
    response: MetricFlowMutationResponse;
  };
  "updateMetricFlow": {
    request: UpdateMetricFlowRequest;
    response: MetricFlowMutationResponse;
  };
  "deleteMetricFlow": {
    request: DeleteMetricFlowRequest;
    response: MetricFlowMutationResponse;
  };
  "getMetricOutputsByUlids": {
    request: GetMetricOutputsByUlidsRequest;
    response: GetMetricOutputsByUlidsResponse;
  };
  "getAgentJudgeEvidence": {
    request: GetAgentJudgeEvidenceRequest;
    response: GetAgentJudgeEvidenceResponse;
  };
  "runTestMetric": {
    request: RunTestMetricRequest;
    response: RunTestMetricResponse;
  };
  "createMetric": {
    request: CreateMetricRequest;
    response: CreateMetricResponse;
  };
  "duplicateMetric": {
    request: DuplicateMetricRequest;
    response: DuplicateMetricResponse;
  };
  "updateMetric": {
    request: UpdateMetricRequest;
    response: UpdateMetricResponse;
  };
  "archiveMetric": {
    request: ArchiveMetricRequest;
    response: ArchiveMetricResponse;
  };
  "listRecentlyDeletedMetrics": {
    request: never;
    response: ListRecentlyDeletedMetricsResponse;
  };
  "restoreMetric": {
    request: RestoreMetricRequest;
    response: RestoreMetricResponse;
  };
  "listAlerts": {
    request: ListAlertsRequest;
    response: ListAlertsResponse;
  };
  "getAlert": {
    request: GetAlertRequest;
    response: AlertMutationResponse;
  };
  "createAlert": {
    request: CreateAlertRequest;
    response: AlertMutationResponse;
  };
  "updateAlert": {
    request: UpdateAlertRequest;
    response: AlertMutationResponse;
  };
  "deleteAlert": {
    request: DeleteAlertRequest;
    response: DeleteAlertResponse;
  };
  "listAlertEvents": {
    request: ListAlertEventsRequest;
    response: ListAlertEventsResponse;
  };
  "testEvaluateAlert": {
    request: TestEvaluateAlertRequest;
    response: TestEvaluateAlertResponse;
  };
  "listScheduledRuns": {
    request: ListScheduledRunsRequest;
    response: ListScheduledRunsResponse;
  };
  "getScheduledRun": {
    request: GetScheduledRunRequest;
    response: GetScheduledRunTransportResponse;
  };
  "listScheduledRunHistory": {
    request: ListScheduledRunHistoryRequest;
    response: ListScheduledRunHistoryResponse;
  };
  "createScheduledRun": {
    request: CreateScheduledRunTransportRequest;
    response: CreateScheduledRunTransportResponse;
  };
  "updateScheduledRun": {
    request: UpdateScheduledRunTransportRequest;
    response: UpdateScheduledRunTransportResponse;
  };
  "deleteScheduledRun": {
    request: DeleteScheduledRunRequest;
    response: DeleteScheduledRunTransportResponse;
  };
  "testSetMetadata": {
    request: TestSetMetadataRequest;
    response: TestSetMetadataResponse;
  };
  "testSetRecords": {
    request: TestSetRecordsRequest;
    response: TestSetRecordsResponse;
  };
  "listTestSets": {
    request: never;
    response: ListTestSetsTransportResponse;
  };
  "getTestSetVersions": {
    request: GetTestSetVersionsRequest;
    response: GetTestSetVersionsResponse;
  };
  "revertTestSetVersion": {
    request: RevertTestSetVersionRequest;
    response: RevertTestSetVersionResponse;
  };
  "listTestSetTags": {
    request: never;
    response: ListTestSetTagsResponse;
  };
  "testSetMetadataKeys": {
    request: TestSetMetadataKeysRequest;
    response: TestSetMetadataKeysResponse;
  };
  "listTestCases": {
    request: ListTestCasesTransportRequest;
    response: ListTestCasesTransportResponse;
  };
  "createTestSet": {
    request: CreateTestSetTransportRequest;
    response: CreateTestSetTransportResponse;
  };
  "updateTestCaseRow": {
    request: UpdateTestCaseRowTransportRequest;
    response: SuccessTransportResponse;
  };
  "addTestSetRows": {
    request: AddTestSetRowsTransportRequest;
    response: AddTestSetRowsTransportResponse;
  };
  "deleteTestSetRow": {
    request: DeleteTestSetRowTransportRequest;
    response: SuccessTransportResponse;
  };
  "deleteTestSet": {
    request: DeleteTestSetTransportRequest;
    response: SuccessTransportResponse;
  };
  "deleteTestSets": {
    request: DeleteTestSetsRequest;
    response: DeleteTestSetsResponse;
  };
  "updateTestSet": {
    request: UpdateTestSetTransportRequest;
    response: SuccessTransportResponse;
  };
  "saveTestSetEditorState": {
    request: SaveTestSetEditorStateTransportRequest;
    response: SaveTestSetEditorStateTransportResponse;
  };
  "getTestCaseMediaUploadUrl": {
    request: GetMediaUploadUrlTransportRequest;
    response: MediaUploadUrlTransportResponse;
  };
  "getTestCaseMediaPreviewUrl": {
    request: GetMediaPreviewUrlTransportRequest;
    response: MediaPreviewUrlTransportResponse;
  };
  "duplicateTestSet": {
    request: DuplicateTestSetTransportRequest;
    response: DuplicateTestSetTransportResponse;
  };
  "getTestSetAgentAssociations": {
    request: GetTestSetAgentAssociationsTransportRequest;
    response: GetTestSetAgentAssociationsTransportResponse;
  };
  "addTestSetAgentAssociations": {
    request: AddTestSetAgentAssociationsTransportRequest;
    response: SuccessTransportResponse;
  };
  "removeTestSetAgentAssociation": {
    request: RemoveTestSetAgentAssociationTransportRequest;
    response: SuccessTransportResponse;
  };
  "listRecentlyDeletedTestSets": {
    request: never;
    response: ListRecentlyDeletedTestSetsTransportResponse;
  };
  "getTestSetAutoAddRule": {
    request: GetTestSetAutoAddRuleRequest;
    response: GetTestSetAutoAddRuleResponse;
  };
  "saveTestSetAutoAddRule": {
    request: SaveTestSetAutoAddRuleRequest;
    response: SaveTestSetAutoAddRuleResponse;
  };
  "deleteTestSetAutoAddRule": {
    request: DeleteTestSetAutoAddRuleRequest;
    response: TestSetAutoAddMutationResponse;
  };
  "listTestSetAutoAddPending": {
    request: ListTestSetAutoAddPendingRequest;
    response: ListTestSetAutoAddPendingResponse;
  };
  "acceptTestSetAutoAddSuggestion": {
    request: AcceptTestSetAutoAddSuggestionRequest;
    response: AcceptTestSetAutoAddSuggestionResponse;
  };
  "rejectTestSetAutoAddSuggestion": {
    request: RejectTestSetAutoAddSuggestionRequest;
    response: TestSetAutoAddMutationResponse;
  };
  "getTestSetAutoAddSummary": {
    request: GetTestSetAutoAddSummaryRequest;
    response: GetTestSetAutoAddSummaryResponse;
  };
  "listTestSetAutoAddPendingCounts": {
    request: ListTestSetAutoAddPendingCountsRequest;
    response: ListTestSetAutoAddPendingCountsResponse;
  };
  "restoreTestSet": {
    request: RestoreTestSetTransportRequest;
    response: RestoreTestSetTransportResponse;
  };
  "listPersonas": {
    request: ListPersonasRequest;
    response: ListPersonasResponse;
  };
  "listPersonaTags": {
    request: never;
    response: ListPersonaTagsResponse;
  };
  "listRecentlyDeletedPersonas": {
    request: never;
    response: ListRecentlyDeletedPersonasResponse;
  };
  "listBackgroundSounds": {
    request: ListBackgroundSoundsRequest;
    response: ListBackgroundSoundsResponse;
  };
  "listRunTemplates": {
    request: never;
    response: ListRunTemplatesResponse;
  };
  "getRunTemplate": {
    request: GetRunTemplateTransportRequest;
    response: GetRunTemplateTransportResponse;
  };
  "createRunTemplate": {
    request: CreateRunTemplateTransportRequest;
    response: CreateRunTemplateTransportResponse;
  };
  "updateRunTemplate": {
    request: UpdateRunTemplateTransportRequest;
    response: UpdateRunTemplateTransportResponse;
  };
  "deleteRunTemplate": {
    request: DeleteRunTemplateTransportRequest;
    response: DeleteRunTemplateTransportResponse;
  };
  "duplicateRunTemplate": {
    request: DuplicateRunTemplateRequest;
    response: DuplicateRunTemplateResponse;
  };
  "listReports": {
    request: ListReportsRequest;
    response: ListReportsResponse;
  };
  "getReport": {
    request: GetReportRequest;
    response: GetReportResponse;
  };
  "getPublicReport": {
    request: GetPublicReportRequest;
    response: GetPublicReportResponse;
  };
  "getReportRows": {
    request: ReportRowsRequest;
    response: ReportRowsResponse;
  };
  "getPublicReportRows": {
    request: GetPublicReportRowsRequest;
    response: ReportRowsResponse;
  };
  "getCohortOutliers": {
    request: CohortOutliersRequest;
    response: CohortOutliersResponse;
  };
  "saveReport": {
    request: SaveReportRequest;
    response: SaveReportResponse;
  };
  "updateReport": {
    request: UpdateReportRequest;
    response: UpdateReportResponse;
  };
  "setReportVisibility": {
    request: SetReportVisibilityRequest;
    response: SetReportVisibilityResponse;
  };
  "deleteReport": {
    request: DeleteReportRequest;
    response: DeleteReportResponse;
  };
  "getReviewOverview": {
    request: GetReviewOverviewV2Request;
    response: GetReviewOverviewResponse;
  };
  "getReviewOverview.v1": {
    request: GetReviewOverviewRequest;
    response: GetReviewOverviewResponse;
  };
  "getReviewOverview.v2": {
    request: GetReviewOverviewV2Request;
    response: GetReviewOverviewResponse;
  };
  "queryHumanReviewProjectAnnotationsTable": {
    request: QueryHumanReviewProjectAnnotationsTableRequest;
    response: QueryHumanReviewProjectAnnotationsTableResponse;
  };
  "queryHumanReviewProjectTriageMembership": {
    request: QueryHumanReviewProjectTriageMembershipRequest;
    response: QueryHumanReviewProjectTriageMembershipResponse;
  };
  "listReviewMetricSkips": {
    request: ListReviewMetricSkipsRequest;
    response: ListReviewMetricSkipsResponse;
  };
  "skipReviewMetric": {
    request: SkipReviewMetricRequest;
    response: SkipReviewMetricResponse;
  };
  "unskipReviewMetric": {
    request: UnskipReviewMetricRequest;
    response: UnskipReviewMetricResponse;
  };
  "getHumanReviewProjectAnnotationDetails": {
    request: GetHumanReviewProjectAnnotationDetailsRequest;
    response: GetHumanReviewProjectAnnotationDetailsResponse;
  };
  "getReviewProjectSimulationCompletions": {
    request: GetReviewProjectSimulationCompletionsRequest;
    response: GetReviewProjectSimulationCompletionsResponse;
  };
  "batchGetReviewProjectConversationStates": {
    request: BatchGetReviewProjectConversationStatesRequest;
    response: BatchGetReviewProjectConversationStatesResponse;
  };
  "getMetricHealthStats": {
    request: GetMetricHealthStatsRequest;
    response: GetMetricHealthStatsResponse;
  };
  "getMetricAgreementHistory": {
    request: GetMetricAgreementHistoryRequest;
    response: GetMetricAgreementHistoryResponse;
  };
  "getHumanReviewProjectInsights": {
    request: GetHumanReviewProjectInsightsRequest;
    response: GetHumanReviewProjectInsightsResponse;
  };
  "getHumanReviewProjectInsightSlice": {
    request: GetHumanReviewProjectInsightSliceRequest;
    response: GetHumanReviewProjectInsightSliceResponse;
  };
  "getHumanReviewProjectDateDensity": {
    request: GetHumanReviewProjectDateDensityRequest;
    response: GetHumanReviewProjectDateDensityResponse;
  };
  "getHumanReviewProjectLayout": {
    request: GetHumanReviewProjectLayoutRequest;
    response: GetHumanReviewProjectLayoutResponse;
  };
  "saveHumanReviewProjectLayout": {
    request: SaveHumanReviewProjectLayoutRequest;
    response: SaveHumanReviewProjectLayoutResponse;
  };
  "getReviewDisagreementState": {
    request: GetReviewDisagreementStateRequest;
    response: GetReviewDisagreementStateResponse;
  };
  "getAnnotationsWithMetricOutputs": {
    request: GetAnnotationsWithMetricOutputsRequest;
    response: GetAnnotationsWithMetricOutputsResponse;
  };
  "getFeedbackForSimulationOutput": {
    request: GetFeedbackForSimulationOutputRequest;
    response: ReviewAnnotationsByMetricResponse;
  };
  "getAllAnnotationsByOrg": {
    request: GetAllAnnotationsByOrgRequest;
    response: ReviewAnnotationsByMetricResponse;
  };
  "listHumanReviewAlerts": {
    request: never;
    response: ListHumanReviewAlertsResponse;
  };
  "deleteHumanReviewAlert": {
    request: DeleteHumanReviewAlertRequest;
    response: HumanReviewAlertMutationResponse;
  };
  "getReviewLabelsForSimulation": {
    request: GetReviewLabelsForSimulationRequest;
    response: ReviewLabelsForSimulationResponse;
  };
  "saveReviewLabelsForSimulation": {
    request: SaveReviewLabelsForSimulationRequest;
    response: ReviewLabelsForSimulationResponse;
  };
  "listReviewProjects": {
    request: ListReviewProjectsRequest;
    response: ListReviewProjectsResponse;
  };
  "getReviewProject": {
    request: GetReviewProjectRequest;
    response: GetReviewProjectResponse;
  };
  "createReviewProject": {
    request: CreateReviewProjectRequest;
    response: CreateReviewProjectResponse;
  };
  "duplicateReviewProject": {
    request: DuplicateReviewProjectRequest;
    response: DuplicateReviewProjectResponse;
  };
  "getProjectMetricAgreement": {
    request: GetProjectMetricAgreementRequest;
    response: GetProjectMetricAgreementResponse;
  };
  "getReviewProjectRerunContext": {
    request: GetReviewProjectRerunContextRequest;
    response: GetReviewProjectRerunContextResponse;
  };
  "listReviewProjectMembershipLogs": {
    request: ListReviewProjectMembershipLogsRequest;
    response: ListReviewProjectMembershipLogsResponse;
  };
  "listReviewProjectMembers": {
    request: ListReviewProjectMembersRequest;
    response: ListReviewProjectMembersResponse;
  };
  "setReviewProjectMemberRole": {
    request: SetReviewProjectMemberRoleRequest;
    response: SetReviewProjectMemberRoleResponse;
  };
  "sendProjectAssignmentEmail": {
    request: SendProjectAssignmentEmailRequest;
    response: SendProjectAssignmentEmailResponse;
  };
  "completeReviewConversation": {
    request: CompleteReviewConversationRequest;
    response: CompleteReviewConversationResponse;
  };
  "claimConversation": {
    request: ClaimConversationRequest;
    response: ClaimConversationResponse;
  };
  "releaseConversation": {
    request: ReleaseConversationRequest;
    response: ReleaseConversationResponse;
  };
  "forceReleaseConversation": {
    request: ForceReleaseConversationRequest;
    response: ForceReleaseConversationResponse;
  };
  "startReviewBatch": {
    request: StartReviewBatchRequest;
    response: StartReviewBatchResponse;
  };
  "getCurrentReviewBatch": {
    request: GetCurrentReviewBatchRequest;
    response: GetCurrentReviewBatchResponse;
  };
  "stopReviewBatch": {
    request: StopReviewBatchRequest;
    response: StopReviewBatchResponse;
  };
  "assignReviewBatches": {
    request: AssignReviewBatchesRequest;
    response: AssignReviewBatchesResponse;
  };
  "releaseReviewBatch": {
    request: ReleaseReviewBatchRequest;
    response: ReleaseReviewBatchResponse;
  };
  "listReviewBatches": {
    request: ListReviewBatchesRequest;
    response: ListReviewBatchesResponse;
  };
  "updateReviewProject": {
    request: UpdateReviewProjectRequest;
    response: UpdateReviewProjectResponse;
  };
  "deleteReviewProject": {
    request: DeleteReviewProjectRequest;
    response: ReviewProjectMutationResponse;
  };
  "listReviewAnnotations": {
    request: ListReviewAnnotationsRequest;
    response: ListReviewAnnotationsResponse;
  };
  "getReviewAnnotation": {
    request: GetReviewAnnotationRequest;
    response: GetReviewAnnotationResponse;
  };
  "createReviewAnnotation": {
    request: CreateReviewAnnotationRequest;
    response: CreateReviewAnnotationResponse;
  };
  "updateReviewAnnotation": {
    request: UpdateReviewAnnotationRequest;
    response: UpdateReviewAnnotationResponse;
  };
  "deleteReviewAnnotation": {
    request: DeleteReviewAnnotationRequest;
    response: ReviewAnnotationMutationResponse;
  };
  "updateProjectReviewAnnotation": {
    request: UpdateProjectReviewAnnotationRequest;
    response: UpdateReviewAnnotationResponse;
  };
  "deleteProjectReviewAnnotation": {
    request: DeleteProjectReviewAnnotationRequest;
    response: ReviewAnnotationMutationResponse;
  };
  "launchRun": {
    request: LaunchRunRequest;
    response: LaunchRunResponse;
  };
  "rerunMetrics": {
    request: RerunMetricsRequest;
    response: RerunMetricsResponse;
  };
  "listRunsKeyset": {
    request: RunsKeysetRequest;
    response: RunsKeysetResponse;
  };
  "listSimulatedConversationsKeyset": {
    request: SimulatedConversationsKeysetRequest;
    response: SimulatedConversationsKeysetResponse;
  };
  "getRunsPageInsights": {
    request: RunsPageInsightsRequest;
    response: RunsPageInsightsResponse;
  };
  "getRunMetadata": {
    request: RunMetadataRequest;
    response: RunMetadataResponse;
  };
  "getMultiRunMetadata": {
    request: MultiRunMetadataRequest;
    response: MultiRunMetadataResponse;
  };
  "getRunRows": {
    request: RunRowsRequest;
    response: RunRowsResponse;
  };
  "getRunOutliers": {
    request: RunOutliersRequest;
    response: RunOutliersResponse;
  };
  "getMultiRunRows": {
    request: MultiRunRowsRequest;
    response: MultiRunRowsResponse;
  };
  "getLatestRun": {
    request: never;
    response: LatestRunResponse;
  };
  "importSessionMappingFromCsv": {
    request: ImportSessionMappingRequest;
    response: ImportSessionMappingResponse;
  };
  "updateRunNotes": {
    request: UpdateRunNotesRequest;
    response: UpdateRunNotesResponse;
  };
  "deleteRun": {
    request: DeleteRunRequest;
    response: DeleteRunResponse;
  };
  "setRunPublic": {
    request: SetRunPublicRequest;
    response: SetRunPublicResponse;
  };
  "updateRunDisplayName": {
    request: UpdateRunDisplayNameRequest;
    response: UpdateRunDisplayNameResponse;
  };
  "cancelRun": {
    request: CancelRunRequest;
    response: CancelRunResponse;
  };
  "getLatestFailurePatternRunOutput": {
    request: GetLatestFailurePatternRunOutputRequest;
    response: GetLatestFailurePatternRunOutputResponse;
  };
  "getLatestConversationClusteringRunOutput": {
    request: GetLatestConversationClusteringRunOutputRequest;
    response: GetLatestConversationClusteringRunOutputResponse;
  };
  "listRunTags": {
    request: never;
    response: ListRunTagsResponse;
  };
  "updateRunTags": {
    request: UpdateRunTagsRequest;
    response: UpdateRunTagsResponse;
  };
  "getSimulationOutput": {
    request: SimulationOutputIdRequest;
    response: SimulationOutputResponse;
  };
  "listSimulationOutputIds": {
    request: RunSimulationOutputIdsRequest;
    response: SimulationOutputIdsResponse;
  };
  "getSimulationOutputTimeWindow": {
    request: SimulationOutputIdRequest;
    response: SimulationOutputTimeWindowResponse;
  };
  "getSimulationOutputSpeakingSegments": {
    request: SimulationOutputIdRequest;
    response: SpeakingSegmentsResponse;
  };
  "setSimulationOutputPublic": {
    request: SetSimulationOutputPublicRequest;
    response: SimulationOutputMutationResponse;
  };
  "deleteSimulationOutput": {
    request: SimulationOutputIdRequest;
    response: SimulationOutputMutationResponse;
  };
  "resimulateSimulationOutputs": {
    request: ResimulateSimulationOutputsRequest;
    response: ResimulateSimulationOutputsResponse;
  };
  "getSharedRunRecord": {
    request: SharedRunPasswordRequest;
    response: SharedRunRecordResponse;
  };
  "verifySharedRunPassword": {
    request: VerifySharedRunPasswordRequest;
    response: VerifySharedRunPasswordResponse;
  };
  "getSharedRunRows": {
    request: SharedRunRowsRequest;
    response: SharedRunRowsResponse;
  };
  "getSharedTestSet": {
    request: SharedTestSetRequest;
    response: SharedTestSetResponse;
  };
  "getSharedMetrics": {
    request: SharedMetricsRequest;
    response: SharedMetricsResponse;
  };
  "getSharedRunTestSet": {
    request: SharedRunPasswordRequest;
    response: SharedTestSetResponse;
  };
  "getSharedMultiRunMetadata": {
    request: SharedRunIdsRequest;
    response: SharedMultiRunMetadataResponse;
  };
  "getSharedMultiRunRows": {
    request: SharedRunIdsRequest;
    response: SharedRunRowsResponse;
  };
  "getSharedSimulationOutputRow": {
    request: SharedSimulationOutputRowRequest;
    response: SharedSimulationOutputRowResponse;
  };
  "listSharedSimulationTraces": {
    request: SharedSimulationTracesRequest;
    response: SimulationTracesResponse;
  };
  "getMaestroSimulationOutputCount": {
    request: MaestroSimulationOutputCountRequest;
    response: MaestroSimulationOutputCountResponse;
  };
  "listMaestroSimulationOutputIds": {
    request: MaestroSimulationOutputIdsRequest;
    response: MaestroSimulationOutputIdsResponse;
  };
  "listMaestroExistingMetrics": {
    request: MaestroBaseFilterRequest;
    response: MaestroExistingMetricsResponse;
  };
  "listMaestroMetadataKeys": {
    request: MaestroBaseFilterRequest;
    response: MaestroMetadataKeysResponse;
  };
  "listMaestroMetadataValues": {
    request: MaestroMetadataValuesRequest;
    response: MaestroMetadataValuesResponse;
  };
  "hasSimulationTraces": {
    request: SimulationTraceRequest;
    response: SimulationTracePresenceResponse;
  };
  "listSimulationTraces": {
    request: SimulationTraceRequest;
    response: SimulationTracesResponse;
  };
  "getSimulationTraceDetail": {
    request: SimulationTraceRequest;
    response: SimulationTraceDetailResponse;
  };
  "hasRunTraces": {
    request: RunTracePresenceRequest;
    response: RunTracePresenceResponse;
  };
  "getTraceAudioContext": {
    request: SimulationTraceRequest;
    response: TraceAudioContextResponse;
  };
  "searchTraceCalls": {
    request: TraceSearchRequest;
    response: TraceSearchResponse;
  };
  "getTraceTransitionHotspots": {
    request: RunTransitionHotspotsRequest;
    response: TraceTransitionMatrixResponse;
  };
  "getTraceTransitionHotspotsForSearch": {
    request: SearchTransitionHotspotsRequest;
    response: TraceTransitionMatrixResponse;
  };
  "getTraceFilterSuggestions": {
    request: TraceFilterSuggestionsRequest;
    response: TraceFilterSuggestionsResponse;
  };
  "previewCustomTraceMetric": {
    request: CustomTraceMetricPreviewRequest;
    response: CustomTraceMetricPreviewResponse;
  };
  "getPersona": {
    request: GetPersonaRequest;
    response: GetPersonaResponse;
  };
  "getPersonaVersions": {
    request: GetPersonaVersionsRequest;
    response: GetPersonaVersionsResponse;
  };
  "revertPersonaVersion": {
    request: RevertPersonaVersionRequest;
    response: RevertPersonaVersionResponse;
  };
  "createPersona": {
    request: CreatePersonaRequest;
    response: CreatePersonaResponse;
  };
  "createBackgroundSound": {
    request: CreateBackgroundSoundRequest;
    response: CreateBackgroundSoundResponse;
  };
  "completeBackgroundSound": {
    request: CompleteBackgroundSoundRequest;
    response: CompleteBackgroundSoundResponse;
  };
  "updatePersona": {
    request: UpdatePersonaRequest;
    response: UpdatePersonaResponse;
  };
  "updateBackgroundSound": {
    request: UpdateBackgroundSoundRequest;
    response: UpdateBackgroundSoundResponse;
  };
  "deletePersona": {
    request: DeletePersonaRequest;
    response: DeletePersonaResponse;
  };
  "deletePersonas": {
    request: DeletePersonasRequest;
    response: DeletePersonasResponse;
  };
  "duplicatePersona": {
    request: DuplicatePersonaRequest;
    response: DuplicatePersonaResponse;
  };
  "restorePersona": {
    request: RestorePersonaRequest;
    response: RestorePersonaResponse;
  };
  "generatePersonaVoiceCandidates": {
    request: GeneratePersonaVoiceCandidatesRequest;
    response: GeneratePersonaVoiceCandidatesResponse;
  };
  "previewPersonaVoiceCandidate": {
    request: PreviewPersonaVoiceCandidateRequest;
    response: PreviewPersonaVoiceCandidateResponse;
  };
  "keepPersonaVoiceCandidate": {
    request: KeepPersonaVoiceCandidateRequest;
    response: KeepPersonaVoiceCandidateResponse;
  };
  "listWebhooks": {
    request: never;
    response: ListWebhooksResponse;
  };
  "createWebhook": {
    request: CreateWebhookRequest;
    response: CreateWebhookResponse;
  };
  "updateWebhook": {
    request: UpdateWebhookRequest;
    response: UpdateWebhookResponse;
  };
  "deleteWebhook": {
    request: DeleteWebhookRequest;
    response: DeleteWebhookResponse;
  };
  "listExternalAgentCandidates": {
    request: ListExternalAgentCandidatesRequest;
    response: ListExternalAgentCandidatesResponse;
  };
  "importExternalAgents": {
    request: ImportExternalAgentsRequest;
    response: ImportExternalAgentsResponse;
  };
  "listSavedViews": {
    request: ListSavedViewsRequest;
    response: ListSavedViewsResponse;
  };
  "getSavedView": {
    request: GetSavedViewRequest;
    response: GetSavedViewResponse;
  };
  "createSavedView": {
    request: CreateSavedViewRequest;
    response: CreateSavedViewResponse;
  };
  "updateSavedView": {
    request: UpdateSavedViewRequest;
    response: UpdateSavedViewResponse;
  };
  "deleteSavedView": {
    request: DeleteSavedViewRequest;
    response: SavedViewMutationResponse;
  };
  "getUserDefaultSavedView": {
    request: GetUserDefaultSavedViewRequest;
    response: UserDefaultSavedViewResponse;
  };
  "setUserDefaultSavedView": {
    request: SetUserDefaultSavedViewRequest;
    response: SavedViewMutationResponse;
  };
  "clearUserDefaultSavedView": {
    request: ClearUserDefaultSavedViewRequest;
    response: SavedViewMutationResponse;
  };
  "listOrganizationTags": {
    request: never;
    response: ListOrganizationTagsResponse;
  };
  "listWorkspaceTags": {
    request: ListOrganizationTagsRequest;
    response: ListOrganizationTagsResponse;
  };
  "createOrganizationTag": {
    request: CreateOrganizationTagRequest;
    response: CreateOrganizationTagResponse;
  };
  "updateOrganizationTag": {
    request: UpdateOrganizationTagRequest;
    response: UpdateOrganizationTagResponse;
  };
  "deleteOrganizationTag": {
    request: DeleteOrganizationTagRequest;
    response: DeleteOrganizationTagResponse;
  };
}

export type TransportOperationRequest<Name extends TransportOperationName> = TransportOperationTypes[Name]['request'];
export type TransportOperationResponse<Name extends TransportOperationName> = TransportOperationTypes[Name]['response'];

export type TransportPathParamValue = boolean | number | string;

export type TransportOperationPathParamKey<Name extends TransportOperationName> = TransportOperationDefinitions[Name]['pathParams'][number];

export type TransportOperationPathParams<Name extends TransportOperationName> = [TransportOperationPathParamKey<Name>] extends [never]
  ? never
  : {
      [Key in TransportOperationPathParamKey<Name>]: TransportPathParamValue;
    };

export type TransportResolvedRequest<Name extends TransportOperationName> = TransportOperationPathParams<Name> extends never
  ? TransportOperationRequest<Name>
  : TransportOperationRequest<Name> extends never
    ? TransportOperationPathParams<Name>
    : TransportOperationRequest<Name> & TransportOperationPathParams<Name>;

export type TransportMutationVariables<Name extends TransportOperationName> = TransportResolvedRequest<Name> extends never
  ? undefined
  : TransportResolvedRequest<Name>;

export type TransportPaginatedOperationName = {
  [Name in TransportOperationName]: TransportOperationDefinitions[Name]['pagination'] extends null
    ? never
    : Name;
}[TransportOperationName];

export type TransportOperationPagination<Name extends TransportPaginatedOperationName> = NonNullable<TransportOperationDefinitions[Name]['pagination']>;

export type TransportOperationCollectionPagination<Name extends TransportPaginatedOperationName> = TransportOperationPagination<Name> & {
  itemKey: string;
};

export type TransportOperationResourceName = Exclude<TransportOperationDefinitions[TransportOperationName]['resource'], null>;

export type TransportOperationCacheTag = TransportOperationDefinitions[TransportOperationName]['cacheTags'][number];

export type TransportRequest<Name extends TransportOperationName> = TransportResolvedRequest<Name>;
export type TransportResponse<Name extends TransportOperationName> = TransportOperationResponse<Name>;
export type TransportActionName = TransportOperationAction;
export type TransportResourceName = keyof typeof transport.resources;
export type TransportOperationVersionGroup = keyof typeof transport.operationVersions;
export type TransportOperationVersionNumber<Group extends TransportOperationVersionGroup> = Extract<keyof (typeof transport.operationVersions)[Group], number>;
export type TransportOperationVersionAlias<Group extends TransportOperationVersionGroup> = Exclude<keyof (typeof transport.operationVersions)[Group], 'default' | 'name'>;
export type TransportOperationVersionDescriptor<Group extends TransportOperationVersionGroup, Version extends TransportOperationVersionNumber<Group>> = (typeof transport.operationVersions)[Group][Version] extends TransportOperationDescriptor<infer Name>
  ? TransportOperationDescriptor<Name>
  : never;
export type TransportOperationVersionName<Group extends TransportOperationVersionGroup, Version extends TransportOperationVersionNumber<Group>> = TransportOperationVersionDescriptor<Group, Version>['name'];
export type TransportOperationsForResource<Resource extends TransportResourceName> = keyof (typeof transport.resources)[Resource]['operations'] & TransportOperationName;
export type TransportOperationForResourceAction<Resource extends TransportResourceName, Action extends TransportActionName> = Action extends keyof (typeof transport.resources)[Resource]['actions']
  ? (typeof transport.resources)[Resource]['actions'][Action] extends TransportOperationDescriptor<infer Name>
    ? Name
    : never
  : never;
export type TransportCollectionOperationName = keyof typeof transport.collections & TransportOperationName;
export type TransportCollectionItem<Name extends TransportCollectionOperationName> = TransportOperationDefinitions[Name]['pagination'] extends { itemKey: infer ItemKey extends keyof TransportOperationResponse<Name> }
  ? TransportOperationResponse<Name>[ItemKey] extends readonly (infer Item)[]
    ? Item
    : never
  : never;

export type TransportOperationInput<Name extends TransportOperationName> =
  | Name
  | TransportOperationDescriptor<Name>;

export type TransportResourceDescriptor =
  (typeof transport.resources)[keyof typeof transport.resources];

export type TransportCacheTagDescriptor =
  (typeof transport.cacheTags)[keyof typeof transport.cacheTags];

export type TransportInvalidationTarget =
  | TransportCacheTagDescriptor
  | TransportResourceDescriptor;

export type TransportResourceInput =
  | TransportResourceName
  | TransportResourceDescriptor;

export type TransportCacheTagInput =
  | TransportCacheTagDescriptor
  | TransportOperationCacheTag;

const transportOperationNames = Object.keys(transportOperations) as TransportOperationName[];

export function getTransportOperationName<Name extends TransportOperationName>(
  operation: TransportOperationInput<Name>,
): Name {
  return typeof operation === 'string' ? operation : operation.name;
}

export function getTransportCanonicalOperationName<Name extends TransportOperationName>(
  operation: TransportOperationInput<Name>,
): TransportOperationName {
  const operationName = getTransportOperationName(operation);

  return transportOperations[operationName].canonicalOperation as TransportOperationName;
}

export function getTransportOperationVersion<
  Group extends TransportOperationVersionGroup,
  Version extends TransportOperationVersionNumber<Group>,
>(
  group: Group,
  version: Version,
): TransportOperationVersionDescriptor<Group, Version> {
  return transport.operationVersions[group][version] as TransportOperationVersionDescriptor<Group, Version>;
}

export function getTransportOperationMetadata<Name extends TransportOperationName>(
  operation: TransportOperationInput<Name>,
): TransportOperationDefinitions[Name] {
  return transportOperations[getTransportOperationName(operation)];
}

export function isTransportInvalidationTarget(
  value: unknown,
): value is TransportInvalidationTarget {
  return (
    typeof value === 'object' &&
    value !== null &&
    'operations' in value &&
    !('definition' in value)
  );
}

export function getTransportInvalidationTargetOperations(
  target: TransportInvalidationTarget,
): TransportOperationName[] {
  return Object.keys(target.operations) as TransportOperationName[];
}

function getTransportResourceName(
  resource: TransportResourceInput,
): TransportResourceName {
  return typeof resource === 'string'
    ? resource
    : (resource.name as TransportResourceName);
}

function getTransportCacheTagName(
  cacheTag: TransportCacheTagInput,
): TransportOperationCacheTag {
  return typeof cacheTag === 'string'
    ? cacheTag
    : (cacheTag.name as TransportOperationCacheTag);
}

export function getTransportOperationsForResource(
  resource: TransportResourceInput,
): TransportOperationName[] {
  const resourceName = getTransportResourceName(resource);

  return Object.keys(transport.resources[resourceName].operations) as TransportOperationName[];
}

export function getTransportOperationsForCacheTags(
  cacheTags: readonly TransportCacheTagInput[],
): TransportOperationName[] {
  if (cacheTags.length === 0) {
    return [];
  }

  const cacheTagSet = new Set<string>(cacheTags.map(getTransportCacheTagName));

  return transportOperationNames.filter((operation) =>
    transportOperations[operation].cacheTags.some((cacheTag) =>
      cacheTagSet.has(cacheTag),
    ),
  );
}

export function getTransportCollectionPagination<
  Name extends TransportCollectionOperationName,
>(
  operation: TransportOperationInput<Name>,
): TransportOperationCollectionPagination<Name> {
  const operationName = getTransportOperationName(operation);
  const pagination = transportOperations[operationName].pagination;

  if (!pagination?.itemKey) {
    throw new Error(
      `Transport operation "${operationName}" does not expose collection pagination metadata.`,
    );
  }

  return pagination as TransportOperationCollectionPagination<Name>;
}

function getTransportResponseRecord<Name extends TransportOperationName>(
  operation: Name,
  response: TransportOperationResponse<Name>,
): Record<string, unknown> {
  if (
    response === null ||
    typeof response !== 'object' ||
    Array.isArray(response)
  ) {
    throw new Error(
      `Transport operation "${operation}" returned a non-object response.`,
    );
  }

  return response as Record<string, unknown>;
}

export function getTransportCollectionItems<
  Name extends TransportCollectionOperationName,
  TItem = TransportCollectionItem<Name>,
>(
  operation: TransportOperationInput<Name>,
  response: TransportOperationResponse<Name>,
): TItem[] {
  const operationName = getTransportOperationName(operation);
  const pagination = getTransportCollectionPagination(operationName);
  const responseRecord = getTransportResponseRecord(operationName, response);
  const items = responseRecord[pagination.itemKey];

  if (!Array.isArray(items)) {
    throw new Error(
      `Transport operation "${operationName}" response is missing collection field "${pagination.itemKey}".`,
    );
  }

  return items as TItem[];
}

export function getTransportCollectionNextRequest<
  Name extends TransportCollectionOperationName,
>(
  operation: TransportOperationInput<Name>,
  response: TransportOperationResponse<Name>,
  previousRequest: TransportResolvedRequest<Name> | undefined,
): TransportResolvedRequest<Name> | null {
  const operationName = getTransportOperationName(operation);
  const pagination = getTransportCollectionPagination(operationName);
  const responseRecord = getTransportResponseRecord(operationName, response);
  const nextToken = responseRecord[pagination.responseTokenKey];

  if (nextToken === undefined || nextToken === null || nextToken === '') {
    return null;
  }

  if (typeof nextToken !== 'string' && typeof nextToken !== 'number') {
    return null;
  }

  return {
    ...(previousRequest ?? {}),
    [pagination.requestTokenKey]: nextToken,
  } as TransportResolvedRequest<Name>;
}
